export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: { input: string; output: string; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: object; output: object; }
};

export enum AbsenceStatusEnum {
  /** User is currently absent */
  Absent = 'absent',
  /** User is not absent */
  Present = 'present',
  /** Absence is scheduled */
  Upcoming = 'upcoming'
}

export type Account = {
  __typename?: 'Account';
  billingAccounts?: Maybe<Array<BillingAccount>>;
  deals?: Maybe<Array<Deal>>;
  enquiry?: Maybe<Enquiry>;
  incomingInvoices?: Maybe<Array<IncomingInvoice>>;
  orderConfirmation?: Maybe<OrderConfirmation>;
  outcomingInvoice?: Maybe<OutcomingInvoice>;
  payment?: Maybe<Payment>;
  payout?: Maybe<Payout>;
  providerOrder?: Maybe<ProviderOrder>;
  providers?: Maybe<Array<Provider>>;
};

export type AccountRelatedObjects = {
  __typename?: 'AccountRelatedObjects';
  deals?: Maybe<Array<Deal>>;
  enquiries?: Maybe<Array<Enquiry>>;
  incomingInvoices?: Maybe<Array<IncomingInvoice>>;
  orderConfirmations?: Maybe<Array<OrderConfirmation>>;
  outcomingInvoices?: Maybe<Array<OutcomingInvoice>>;
  payments?: Maybe<Array<Payment>>;
  providerOrders?: Maybe<Array<ProviderOrder>>;
};

export type AccountingFieldsType = {
  __typename?: 'AccountingFieldsType';
  id?: Maybe<Scalars['Int']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sachkontoNumber?: Maybe<Scalars['Int']['output']>;
  vatCode?: Maybe<Scalars['Int']['output']>;
  vatPercent?: Maybe<Scalars['Float']['output']>;
  xometryVatNumber?: Maybe<Scalars['JSON']['output']>;
};

export type AccountingRecord = {
  __typename?: 'AccountingRecord';
  account: Scalars['String']['output'];
  amount: Money;
  deal: Deal;
  direction: AccountingRecordDirectionEnum;
  id: Scalars['ID']['output'];
  initiatedById: Scalars['ID']['output'];
  initiatedByType: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  offsetAccount: Scalars['String']['output'];
  outcomingInvoice?: Maybe<OutcomingInvoice>;
  payment?: Maybe<Payment>;
  recordType: AccountingRecordRecordTypeEnum;
};

/** Accounting Records Direction */
export enum AccountingRecordDirectionEnum {
  Credit = 'credit',
  Debit = 'debit'
}

/** Accounting Records Record Type */
export enum AccountingRecordRecordTypeEnum {
  AllocationInvoice = 'allocation_invoice',
  AllocationOverpayment = 'allocation_overpayment',
  AllocationPrepayment = 'allocation_prepayment',
  Invoice = 'invoice',
  PaymentDebtor = 'payment_debtor',
  PaymentFee = 'payment_fee',
  PaymentPrepayment = 'payment_prepayment',
  RefundDebtor = 'refund_debtor',
  RefundPrepayment = 'refund_prepayment'
}

export type ActivityRecord = {
  __typename?: 'ActivityRecord';
  author?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  context?: Maybe<ActivityRecordContext>;
  correlatedActivities: Array<CorrelatedActivityRecord>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  objectId: Scalars['String']['output'];
  objectRecord?: Maybe<ActivityRecordsObjectType>;
  objectType: Scalars['String']['output'];
};

export type ActivityRecordContext = {
  __typename?: 'ActivityRecordContext';
  caller?: Maybe<Array<Scalars['String']['output']>>;
  correlationId?: Maybe<Scalars['String']['output']>;
  operations?: Maybe<Array<Scalars['String']['output']>>;
};

export type ActivityRecordsObjectType = {
  __typename?: 'ActivityRecordsObjectType';
  /** Deal::IncomingInvoice, Deal::OutcomingInvoice */
  creditNote?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Job::Offer */
  jobId?: Maybe<Scalars['String']['output']>;
  /** Deal::IncomingInvoice */
  number?: Maybe<Scalars['String']['output']>;
  /** Deal::QualityControl::Position */
  qualityControlId?: Maybe<Scalars['ID']['output']>;
  /** Rfq::Offer */
  rfqId?: Maybe<Scalars['ID']['output']>;
  /** Deal::IncomingInvoice */
  selfBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Deal::IncomingInvoice */
  state?: Maybe<Scalars['String']['output']>;
  type: ObjectTypeEnum;
  /** Deal::OutcomingInvoice */
  uiNumber?: Maybe<Scalars['String']['output']>;
  xometryNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddBulkLogisticInvoiceAttachedFile */
export type AddBulkLogisticInvoiceAttachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  context: Scalars['String']['input'];
  createMissingInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  logisticInvoiceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  logisticOperatorName: Scalars['String']['input'];
  uuidId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddBulkLogisticInvoiceAttachedFile. */
export type AddBulkLogisticInvoiceAttachedFilePayload = {
  __typename?: 'AddBulkLogisticInvoiceAttachedFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of AddLogisticInvoiceAttachedFile */
export type AddLogisticInvoiceAttachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  context: Scalars['String']['input'];
  logisticInvoiceId: Scalars['ID']['input'];
  uuidId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddLogisticInvoiceAttachedFile. */
export type AddLogisticInvoiceAttachedFilePayload = {
  __typename?: 'AddLogisticInvoiceAttachedFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type AddToMasterShippingValidationErrors = {
  __typename?: 'AddToMasterShippingValidationErrors';
  errors: Array<Scalars['String']['output']>;
  shippingId: Scalars['ID']['output'];
};

export type AdditionalService = {
  __typename?: 'AdditionalService';
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  priceMoney: Money;
  referenceId?: Maybe<Scalars['ID']['output']>;
  referenceType?: Maybe<OmsDealsAdditionalServiceReferenceTypeEnumType>;
  typeName: TypeNameEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Float']['output'];
  valueMoney: Money;
  vatRate?: Maybe<Scalars['Float']['output']>;
};


export type AdditionalServicePriceMoneyArgs = {
  currencyCode?: InputMaybe<CurrencyEnum>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Result of an address check via Google Address Validation API */
export type AddressValidationResult = {
  __typename?: 'AddressValidationResult';
  /** Full address formatted by Google */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** Address component types missing from the input, e.g. street_number */
  missingComponents: Array<Scalars['String']['output']>;
  /** Suggested address mapped to shipping address fields */
  suggestedAddress?: Maybe<AddressValidationSuggestedAddress>;
  /** Address component types Google could not confirm */
  unconfirmedComponents: Array<Scalars['String']['output']>;
  verdict: AddressValidationVerdictEnum;
};

/** Standardized address suggested by Google Address Validation API, mapped to shipping address fields */
export type AddressValidationSuggestedAddress = {
  __typename?: 'AddressValidationSuggestedAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Interpreted verdict of Google Address Validation API check */
export enum AddressValidationVerdictEnum {
  /** Address is complete, but a cleaned up version is suggested — ask the user to accept it */
  Confirm = 'confirm',
  /** Some component is missing or unconfirmed — the user may save as-is or edit the address */
  Incomplete = 'incomplete',
  /** Address was not recognized — suggest the user to make changes */
  Unresolved = 'unresolved',
  /** Address is confirmed, no user interaction needed */
  Valid = 'valid'
}

export type Agg = {
  __typename?: 'Agg';
  docCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** AI response record with annotated validation data */
export type AiResponse = {
  __typename?: 'AiResponse';
  commandName: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  responseData: Scalars['JSON']['output'];
  targetId: Scalars['ID']['output'];
  targetType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of AssignDealTeamspace */
export type AssignDealTeamspaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignDealTeamspace. */
export type AssignDealTeamspacePayload = {
  __typename?: 'AssignDealTeamspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

export type AttachedFile = {
  __typename?: 'AttachedFile';
  cleanedId?: Maybe<Scalars['Int']['output']>;
  context: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCleaned: Scalars['Boolean']['output'];
  isStp?: Maybe<Scalars['Boolean']['output']>;
  largeUrl?: Maybe<Scalars['String']['output']>;
  mediumUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  previewPriority: Scalars['Int']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum AttachedFileContextEnumType {
  Default = 'default',
  VatExemptionCertificate = 'vat_exemption_certificate'
}

/** Autogenerated input type of AttachedFilesBulkSetCleanedFiles */
export type AttachedFilesBulkSetCleanedFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: OmsInputsAttachedFilesCleanedFilesEntityTypeEnumType;
  files: Array<OmsInputsAttachedFilesCleanedFileType>;
};

/** Autogenerated return type of AttachedFilesBulkSetCleanedFiles. */
export type AttachedFilesBulkSetCleanedFilesPayload = {
  __typename?: 'AttachedFilesBulkSetCleanedFilesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AttachedFilesCreateDirect */
export type AttachedFilesCreateDirectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<AttachedFileContextEnumType>;
  fileData: Scalars['JSON']['input'];
};

/** Autogenerated return type of AttachedFilesCreateDirect. */
export type AttachedFilesCreateDirectPayload = {
  __typename?: 'AttachedFilesCreateDirectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  file: AttachedFile;
};

/** Autogenerated input type of AttachedFilesExtractText */
export type AttachedFilesExtractTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AttachedFilesExtractText. */
export type AttachedFilesExtractTextPayload = {
  __typename?: 'AttachedFilesExtractTextPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  previewLargeUrl?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuidId: Scalars['String']['output'];
};

export type AttributesConflict = {
  __typename?: 'AttributesConflict';
  attribute: Scalars['String']['output'];
  databaseValue?: Maybe<GenericSerialized>;
  newValue?: Maybe<GenericSerialized>;
  originalValue?: Maybe<GenericSerialized>;
};

export enum AuthorEnumType {
  /** Represents a Person */
  Client = 'CLIENT',
  /** Represents a ExternalContact */
  ExternalContact = 'EXTERNAL_CONTACT',
  /** Represents a Provider::Contact */
  Partner = 'PARTNER',
  /** Represents a User */
  Xometry = 'XOMETRY'
}

export type Authorization = {
  __typename?: 'Authorization';
  authorized: Scalars['Boolean']['output'];
};

export type AutoAssignmentSettings = {
  __typename?: 'AutoAssignmentSettings';
  customerOrderGrade?: Maybe<Array<CustomerOrderGradeEnum>>;
  languages?: Maybe<Array<LanguageEnum>>;
  maxDeals?: Maybe<Scalars['Int']['output']>;
  overloadPossible?: Maybe<Scalars['Boolean']['output']>;
  technology?: Maybe<Array<Scalars['Int']['output']>>;
};

export enum AutoOrderFromXometryStateEnum {
  /** failed */
  Failed = 'failed',
  /** manual_order */
  ManualOrder = 'manual_order',
  /** not_checked */
  NotChecked = 'not_checked',
  /** ordered */
  Ordered = 'ordered',
  /** quick_book_allowed */
  QuickBookAllowed = 'quick_book_allowed',
  /** skipped */
  Skipped = 'skipped'
}

export type AutocompleteGroup = {
  __typename?: 'AutocompleteGroup';
  docCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  items: Array<SearchItemType>;
  type: Scalars['String']['output'];
};

export type Balance = {
  __typename?: 'Balance';
  brutto: BalanceEntity;
  currency: Scalars['String']['output'];
  netto: BalanceEntity;
};

export type BalanceDetails = {
  __typename?: 'BalanceDetails';
  hasMore: Scalars['Boolean']['output'];
  lines?: Maybe<Array<BalanceLine>>;
};

export type BalanceEntity = {
  __typename?: 'BalanceEntity';
  balance: Scalars['Float']['output'];
  balanceMoney: Money;
  booked: Scalars['Float']['output'];
  bookedMoney: Money;
  completed: Scalars['Float']['output'];
  completedMoney: Money;
  paid: Scalars['Float']['output'];
  paidMoney: Money;
};

export type BalanceLine = {
  __typename?: 'BalanceLine';
  activeTotals?: Maybe<Money>;
  balance?: Maybe<Money>;
  balancedLine?: Maybe<Scalars['Boolean']['output']>;
  billingAccountId?: Maybe<Scalars['ID']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  dealId: Scalars['ID']['output'];
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  invoiced?: Maybe<Money>;
  invoicedInDiffCurrency?: Maybe<Money>;
  level: Scalars['Int']['output'];
  lineObjectId: Scalars['ID']['output'];
  methodDealId?: Maybe<Scalars['ID']['output']>;
  methodName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  objectType: Scalars['String']['output'];
  ocTotalAmountMoney?: Maybe<Money>;
  orderedNotInvoicedMoney?: Maybe<Money>;
  overallStage?: Maybe<Scalars['String']['output']>;
  overdueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  overdueDays?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Money>;
  paidInDiffCurrency?: Maybe<Money>;
};

export type BalanceTotals = {
  __typename?: 'BalanceTotals';
  invoiceBalanceMoney: Money;
  openOrdersSumMoney?: Maybe<Money>;
  orderedNotInvoicedMoney: Money;
  overdueMoney: Money;
  prepaidMoney: Money;
  remainingCreditLimit?: Maybe<Money>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  balance?: Maybe<Scalars['Float']['output']>;
};

export type BankPayment = {
  __typename?: 'BankPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  amountMoney: Money;
  bankPaymentExportStatusCode?: Maybe<Scalars['String']['output']>;
  bankPaymentExportStatusText?: Maybe<Scalars['String']['output']>;
  batchExport?: Maybe<Export>;
  batchImportId?: Maybe<Scalars['ID']['output']>;
  counterparty?: Maybe<Scalars['JSON']['output']>;
  counterpartyId?: Maybe<Scalars['ID']['output']>;
  counterpartyType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  direction: Scalars['String']['output'];
  endToEndId?: Maybe<Scalars['String']['output']>;
  exportRow?: Maybe<ExportRow>;
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  jpmCheckAt?: Maybe<Scalars['ISO8601Date']['output']>;
  jpmStatus?: Maybe<Scalars['String']['output']>;
  outlyingTransactionType?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<Scalars['JSON']['output']>;
  payments?: Maybe<Array<Payment>>;
  payouts?: Maybe<Array<Payout>>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  xometryBankAccount?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of BankPaymentsApprove */
export type BankPaymentsApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsApprove. */
export type BankPaymentsApprovePayload = {
  __typename?: 'BankPaymentsApprovePayload';
  bankPayment: WorkspacesUpdatedBankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsBulkApprove */
export type BankPaymentsBulkApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BankPaymentsBulkApprove. */
export type BankPaymentsBulkApprovePayload = {
  __typename?: 'BankPaymentsBulkApprovePayload';
  bankPayments: Array<WorkspacesUpdatedBankPayment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsBulkRecognizeAs */
export type BankPaymentsBulkRecognizeAsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  recognizeAs: Scalars['String']['input'];
};

/** Autogenerated return type of BankPaymentsBulkRecognizeAs. */
export type BankPaymentsBulkRecognizeAsPayload = {
  __typename?: 'BankPaymentsBulkRecognizeAsPayload';
  bankPayments: Array<WorkspacesUpdatedBankPayment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsBulkSendToBank */
export type BankPaymentsBulkSendToBankInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BankPaymentsBulkSendToBank. */
export type BankPaymentsBulkSendToBankPayload = {
  __typename?: 'BankPaymentsBulkSendToBankPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsBulkSendToBankVerify */
export type BankPaymentsBulkSendToBankVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BankPaymentsBulkSendToBankVerify. */
export type BankPaymentsBulkSendToBankVerifyPayload = {
  __typename?: 'BankPaymentsBulkSendToBankVerifyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsBulkUpdatePartnerInfo */
export type BankPaymentsBulkUpdatePartnerInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BankPaymentsBulkUpdatePartnerInfo. */
export type BankPaymentsBulkUpdatePartnerInfoPayload = {
  __typename?: 'BankPaymentsBulkUpdatePartnerInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of BankPaymentsCreateExportToDatev */
export type BankPaymentsCreateExportToDatevInput = {
  accountingRecords: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationFrom?: InputMaybe<Scalars['String']['input']>;
  durationTo?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  period: Scalars['String']['input'];
  withRegistered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of BankPaymentsCreateExportToDatev. */
export type BankPaymentsCreateExportToDatevPayload = {
  __typename?: 'BankPaymentsCreateExportToDatevPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datevBankPaymentsExport: BankPaymentsExport;
};

/** Autogenerated input type of BankPaymentsCreateFromInvoice */
export type BankPaymentsCreateFromInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumberErp: Scalars['String']['input'];
  payoutAmounts: Scalars['JSON']['input'];
};

/** Autogenerated return type of BankPaymentsCreateFromInvoice. */
export type BankPaymentsCreateFromInvoicePayload = {
  __typename?: 'BankPaymentsCreateFromInvoicePayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsCreateFromPayout */
export type BankPaymentsCreateFromPayoutInput = {
  amount: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payoutId: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsCreateFromPayout. */
export type BankPaymentsCreateFromPayoutPayload = {
  __typename?: 'BankPaymentsCreateFromPayoutPayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsDestroy */
export type BankPaymentsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsDestroy. */
export type BankPaymentsDestroyPayload = {
  __typename?: 'BankPaymentsDestroyPayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsDestroyWithPayouts */
export type BankPaymentsDestroyWithPayoutsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsDestroyWithPayouts. */
export type BankPaymentsDestroyWithPayoutsPayload = {
  __typename?: 'BankPaymentsDestroyWithPayoutsPayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsDraftExport */
export type BankPaymentsDraftExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of BankPaymentsDraftExport. */
export type BankPaymentsDraftExportPayload = {
  __typename?: 'BankPaymentsDraftExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type BankPaymentsExport = {
  __typename?: 'BankPaymentsExport';
  accountingPeriod: Scalars['ISO8601Date']['output'];
  bankPayments?: Maybe<Array<BankPayment>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of BankPaymentsExport */
export type BankPaymentsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of BankPaymentsExport. */
export type BankPaymentsExportPayload = {
  __typename?: 'BankPaymentsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of BankPaymentsLinkToAccount */
export type BankPaymentsLinkToAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  counterpartyId: Scalars['ID']['input'];
  counterpartyType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsLinkToAccount. */
export type BankPaymentsLinkToAccountPayload = {
  __typename?: 'BankPaymentsLinkToAccountPayload';
  bankPayment: WorkspacesUpdatedBankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsPaymentsCreate */
export type BankPaymentsPaymentsCreateInput = {
  attributes: OmsInputsBankPaymentsPaymentsCreateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BankPaymentsPaymentsCreate. */
export type BankPaymentsPaymentsCreatePayload = {
  __typename?: 'BankPaymentsPaymentsCreatePayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsPaymentsLink */
export type BankPaymentsPaymentsLinkInput = {
  bankPaymentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsPaymentsLink. */
export type BankPaymentsPaymentsLinkPayload = {
  __typename?: 'BankPaymentsPaymentsLinkPayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsRecreate */
export type BankPaymentsRecreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsRecreate. */
export type BankPaymentsRecreatePayload = {
  __typename?: 'BankPaymentsRecreatePayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsUnapprove */
export type BankPaymentsUnapproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsUnapprove. */
export type BankPaymentsUnapprovePayload = {
  __typename?: 'BankPaymentsUnapprovePayload';
  bankPayment: WorkspacesUpdatedBankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsUpdate */
export type BankPaymentsUpdateInput = {
  attributes: OmsInputsBankPaymentsUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of BankPaymentsUpdateJpmStatus */
export type BankPaymentsUpdateJpmStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsUpdateJpmStatus. */
export type BankPaymentsUpdateJpmStatusPayload = {
  __typename?: 'BankPaymentsUpdateJpmStatusPayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsUpdateOutlyingType */
export type BankPaymentsUpdateOutlyingTypeInput = {
  attributes: OmsInputsBankPaymentsUpdateOutlyingTypeType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BankPaymentsUpdateOutlyingType. */
export type BankPaymentsUpdateOutlyingTypePayload = {
  __typename?: 'BankPaymentsUpdateOutlyingTypePayload';
  bankPayment: WorkspacesUpdatedBankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of BankPaymentsUpdate. */
export type BankPaymentsUpdatePayload = {
  __typename?: 'BankPaymentsUpdatePayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankPaymentsUpdateRegisteredAt */
export type BankPaymentsUpdateRegisteredAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
  overwrite: Scalars['Boolean']['input'];
  registeredAt: Scalars['String']['input'];
};

/** Autogenerated return type of BankPaymentsUpdateRegisteredAt. */
export type BankPaymentsUpdateRegisteredAtPayload = {
  __typename?: 'BankPaymentsUpdateRegisteredAtPayload';
  bankPayments: Array<BankPayment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Base = {
  __typename?: 'Base';
  conversions: Array<Conversion>;
  documentId: Scalars['ID']['output'];
  documentNumber: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  secondaryAmountCurrency?: Maybe<CurrencyEnum>;
};

export type Base64FileType = {
  __typename?: 'Base64FileType';
  fileBase64Encode: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Batch = {
  __typename?: 'Batch';
  category: BatchCategoryEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  fulfillment: BatchFulfillment;
  id: Scalars['ID']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  invoiceAllocations: Array<BatchInvoice>;
  providerOrderId?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  source: BatchSource;
  type: BatchTypeEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedByAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  valueMoney: Money;
};

export enum BatchBasedTypeEnum {
  /** Represents a Enquiry */
  Enquiry = 'ENQUIRY',
  /** Represents a Deal::OrderConfirmation */
  OrderConfirmation = 'ORDER_CONFIRMATION'
}

export enum BatchCategoryEnum {
  Recycle = 'recycle',
  Repair = 'repair',
  Reproduction = 'reproduction',
  Return = 'return',
  Samples = 'samples',
  Standard = 'standard'
}

/** Reasons for changing or deleting batches */
export enum BatchChangeReasonEnum {
  /** Customer: Clarification of undistributed batches */
  CustomerBatchClarification = 'customer_batch_clarification',
  /** Customer: Client request */
  CustomerRequest = 'customer_request',
  /** Customer: Samples confirmation overdue / Main batch date change */
  CustomerSamplesOverdue = 'customer_samples_overdue',
  /** Partner: Delay */
  PartnerDelay = 'partner_delay',
  /** Xometry: Fix incorrect data input */
  XometryFixInput = 'xometry_fix_input',
  /** Xometry: Sending a batch earlier */
  XometrySendingEarlier = 'xometry_sending_earlier'
}

export type BatchCollection = {
  __typename?: 'BatchCollection';
  batches: Array<Batch>;
  category: BatchCategoryEnum;
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type: BatchTypeEnum;
  valueMoney: Money;
};

export type BatchCreditNote = {
  __typename?: 'BatchCreditNote';
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type BatchFulfillment = {
  __typename?: 'BatchFulfillment';
  fulfilledQuantity: Scalars['Int']['output'];
  remainingQuantity: Scalars['Int']['output'];
  shipments: Array<BatchShipment>;
};

export type BatchGroup = {
  __typename?: 'BatchGroup';
  basedOn: BatchBasedTypeEnum;
  batchCollection: Array<BatchCollection>;
  customerTotalOrdered: Scalars['Int']['output'];
};

export type BatchInvoice = {
  __typename?: 'BatchInvoice';
  amount: Money;
  creditNotes: Array<BatchCreditNote>;
  isPaid: Scalars['Boolean']['output'];
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BatchProviderOrder = {
  __typename?: 'BatchProviderOrder';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BatchShipment = {
  __typename?: 'BatchShipment';
  quantity: Scalars['Int']['output'];
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BatchSource = {
  __typename?: 'BatchSource';
  attachedFiles?: Maybe<Array<AttachedFile>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: BatchSourceEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export enum BatchSourceEnum {
  /** Represents a Deal::Lot */
  DealLot = 'DEAL_LOT',
  /** Represents a Enquiry::Part */
  EnquiryPart = 'ENQUIRY_PART'
}

export enum BatchTypeEnum {
  Contracted = 'contracted',
  Production = 'production'
}

/** Who is billed for carrier shipping charges on the deal */
export enum BillReceiverEnum {
  ThirdParty = 'third_party',
  Xometry = 'xometry'
}

export type BillingAccount = {
  __typename?: 'BillingAccount';
  accountType: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  badPayer: Scalars['Boolean']['output'];
  billingAccountsPersons?: Maybe<Array<BillingAccountsPerson>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditLimitMoney: Money;
  creditLimitRequestMoney: Money;
  creditLimitUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creditLimitUpdatedBy?: Maybe<User>;
  datevId?: Maybe<Scalars['ID']['output']>;
  /** N + 1, don't query for collection */
  dealsCount: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dnbDunsNumber?: Maybe<Scalars['String']['output']>;
  dnbExchangedRecommendation: ExchangedRecommendation;
  dnbHasRecommendation: Scalars['Boolean']['output'];
  dnbRecommendationMoney: DnBMoney;
  einvoiceEnabled: Scalars['Boolean']['output'];
  files: Array<AttachedFile>;
  id: Scalars['ID']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  intacctName?: Maybe<Scalars['String']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  mergedTo?: Maybe<BillingAccount>;
  name: Scalars['String']['output'];
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  paymentTermsType: PaymentTermsTypeEnum;
  paymentTermsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentTermsUpdatedBy?: Maybe<User>;
  payments?: Maybe<Array<Payment>>;
  peppolBuyerReference?: Maybe<Scalars['String']['output']>;
  peppolIdType?: Maybe<Scalars['String']['output']>;
  peppolParticipantId?: Maybe<Scalars['String']['output']>;
  persons: Array<Person>;
  region?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  teamspaceBillingAccounts?: Maybe<Array<TeamspaceBillingAccount>>;
  type: BillingAccountsTypeEnumType;
  updatedAfterRegistered?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** TR */
  vatExempt: Scalars['Boolean']['output'];
  vatExemptionCertificateNumber?: Maybe<Scalars['String']['output']>;
  vatExemptionExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  vatRegistered: Scalars['Boolean']['output'];
  vatRegistrationCountry?: Maybe<Scalars['String']['output']>;
  vatValidationStatus?: Maybe<VatValidationStatusEnumType>;
  vatValidationTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type BillingAccountFilesArgs = {
  context?: InputMaybe<Array<BillingAccountsAttachedFilesContextEnumType>>;
};


export type BillingAccountPaymentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export enum BillingAccountAccountTypeEnum {
  /** Corporate */
  Corporate = 'corporate',
  /** Private Person */
  Private = 'private'
}

/** Autogenerated input type of BillingAccountSendToCheck */
export type BillingAccountSendToCheckInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BillingAccountSendToCheck. */
export type BillingAccountSendToCheckPayload = {
  __typename?: 'BillingAccountSendToCheckPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountXlsxReport */
export type BillingAccountXlsxReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  id: Scalars['ID']['input'];
  showPaid: Scalars['Boolean']['input'];
};

/** Autogenerated return type of BillingAccountXlsxReport. */
export type BillingAccountXlsxReportPayload = {
  __typename?: 'BillingAccountXlsxReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of BillingAccountsAddToPersons */
export type BillingAccountsAddToPersonsInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BillingAccountsAddToPersons. */
export type BillingAccountsAddToPersonsPayload = {
  __typename?: 'BillingAccountsAddToPersonsPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum BillingAccountsAttachedFilesContextEnumType {
  Default = 'default',
  ManualVatValidation = 'manual_vat_validation',
  PaymentTerms = 'payment_terms',
  VatExemptionCertificate = 'vat_exemption_certificate'
}

/** Autogenerated input type of BillingAccountsAttachedFilesDelete */
export type BillingAccountsAttachedFilesDeleteInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsAttachedFilesDelete. */
export type BillingAccountsAttachedFilesDeletePayload = {
  __typename?: 'BillingAccountsAttachedFilesDeletePayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type BillingAccountsCollection = {
  __typename?: 'BillingAccountsCollection';
  collection: Array<TeamspaceBillingAccount>;
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of BillingAccountsCreateAsync */
export type BillingAccountsCreateAsyncInput = {
  attributes: OmsInputsBillingAccountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BillingAccountsCreateAsync. */
export type BillingAccountsCreateAsyncPayload = {
  __typename?: 'BillingAccountsCreateAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsCreate */
export type BillingAccountsCreateInput = {
  attributes: OmsInputsBillingAccountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BillingAccountsCreate. */
export type BillingAccountsCreatePayload = {
  __typename?: 'BillingAccountsCreatePayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsDelete */
export type BillingAccountsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsDelete. */
export type BillingAccountsDeletePayload = {
  __typename?: 'BillingAccountsDeletePayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsExport */
export type BillingAccountsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of BillingAccountsExport. */
export type BillingAccountsExportPayload = {
  __typename?: 'BillingAccountsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of BillingAccountsMerge */
export type BillingAccountsMergeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromBillingAccountId: Scalars['ID']['input'];
  toBillingAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsMerge. */
export type BillingAccountsMergePayload = {
  __typename?: 'BillingAccountsMergePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

export type BillingAccountsOrganization = {
  __typename?: 'BillingAccountsOrganization';
  addBillingAccountToNewPersons: Scalars['Boolean']['output'];
  addCreditLimitToNewPersons: Scalars['Boolean']['output'];
  billingAccount: BillingAccount;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  organization: Organization;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BillingAccountsOrganizationType = {
  addBillingAccountToNewPersons?: InputMaybe<Scalars['Boolean']['input']>;
  addCreditLimitToNewPersons?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of BillingAccountsOrganizations */
export type BillingAccountsOrganizationsInput = {
  attributes: BillingAccountsOrganizationType;
  billingAccountOrganizationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BillingAccountsOrganizations. */
export type BillingAccountsOrganizationsPayload = {
  __typename?: 'BillingAccountsOrganizationsPayload';
  billingAccountOrganization: BillingAccountsOrganization;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsPaymentTermsUpdate */
export type BillingAccountsPaymentTermsUpdateInput = {
  attributes: OmsInputsBillingAccountPaymentTermsType;
  billingAccountId: Scalars['ID']['input'];
  cascade: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BillingAccountsPaymentTermsUpdate. */
export type BillingAccountsPaymentTermsUpdatePayload = {
  __typename?: 'BillingAccountsPaymentTermsUpdatePayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type BillingAccountsPerson = {
  __typename?: 'BillingAccountsPerson';
  billingAccount: BillingAccount;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  person: Person;
  personCreditLimitAccess: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of BillingAccountsRemoveFromPerson */
export type BillingAccountsRemoveFromPersonInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsRemoveFromPerson. */
export type BillingAccountsRemoveFromPersonPayload = {
  __typename?: 'BillingAccountsRemoveFromPersonPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsRemoveFromPersons */
export type BillingAccountsRemoveFromPersonsInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsRemoveFromPersons. */
export type BillingAccountsRemoveFromPersonsPayload = {
  __typename?: 'BillingAccountsRemoveFromPersonsPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsRequestCreditLimit */
export type BillingAccountsRequestCreditLimitInput = {
  attributes: OmsInputsBillingAccountRequestCreditLimitType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsRequestCreditLimit. */
export type BillingAccountsRequestCreditLimitPayload = {
  __typename?: 'BillingAccountsRequestCreditLimitPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsSetAsDefault */
export type BillingAccountsSetAsDefaultInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsSetAsDefault. */
export type BillingAccountsSetAsDefaultPayload = {
  __typename?: 'BillingAccountsSetAsDefaultPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsSuccessManual */
export type BillingAccountsSuccessManualInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<OmsInputsAttachmentType>>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsSuccessManual. */
export type BillingAccountsSuccessManualPayload = {
  __typename?: 'BillingAccountsSuccessManualPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsToggleCreditLimitAccess */
export type BillingAccountsToggleCreditLimitAccessInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enableAccessForAll?: InputMaybe<Scalars['Boolean']['input']>;
  personIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BillingAccountsToggleCreditLimitAccess. */
export type BillingAccountsToggleCreditLimitAccessPayload = {
  __typename?: 'BillingAccountsToggleCreditLimitAccessPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum BillingAccountsTypeEnumType {
  /** customer */
  Customer = 'customer',
  /** partner */
  Partner = 'partner'
}

/** Autogenerated input type of BillingAccountsUpdateAsync */
export type BillingAccountsUpdateAsyncInput = {
  attributes: OmsInputsBillingAccountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsUpdateAsync. */
export type BillingAccountsUpdateAsyncPayload = {
  __typename?: 'BillingAccountsUpdateAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsUpdateCascade */
export type BillingAccountsUpdateCascadeInput = {
  attributes: OmsInputsBillingAccountUpdateCascadeType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsUpdateCascade. */
export type BillingAccountsUpdateCascadePayload = {
  __typename?: 'BillingAccountsUpdateCascadePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsUpdateCreditLimit */
export type BillingAccountsUpdateCreditLimitInput = {
  attributes: OmsInputsBillingAccountCreditLimitType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsUpdateCreditLimit. */
export type BillingAccountsUpdateCreditLimitPayload = {
  __typename?: 'BillingAccountsUpdateCreditLimitPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BillingAccountsUpdate */
export type BillingAccountsUpdateInput = {
  attributes: OmsInputsBillingAccountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BillingAccountsUpdate. */
export type BillingAccountsUpdatePayload = {
  __typename?: 'BillingAccountsUpdatePayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type BillingAddressData = {
  __typename?: 'BillingAddressData';
  address?: Maybe<DataItem>;
  city?: Maybe<DataItem>;
  country?: Maybe<DataItem>;
  zip?: Maybe<DataItem>;
};

export type BillingPreference = {
  __typename?: 'BillingPreference';
  accountNumber?: Maybe<Scalars['String']['output']>;
  billReceiver: BillReceiverEnum;
  billingZip?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<CarrierEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  dealId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type BulkBankPaymentInit = {
  __typename?: 'BulkBankPaymentInit';
  amountLeftMoney: Money;
  amountMoney: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  logisticOperatorBillingAccountName: Scalars['String']['output'];
  number: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of BulkGenerateHsCode */
export type BulkGenerateHsCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkGenerateHsCode. */
export type BulkGenerateHsCodePayload = {
  __typename?: 'BulkGenerateHsCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ByJson = {
  __typename?: 'ByJson';
  at?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Scalars['String']['output']>;
};

export type Calculations = {
  __typename?: 'Calculations';
  loyalty: Loyalty;
};

export type CalendarEvent = ProductionEventType | ProviderOrderLeadtimeEventType | PublicHolidayEventType;

/** Autogenerated input type of CancelLogisticInvoice */
export type CancelLogisticInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelLogisticInvoice. */
export type CancelLogisticInvoicePayload = {
  __typename?: 'CancelLogisticInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

/** Carrier used for third-party billing */
export enum CarrierEnum {
  Dhl = 'DHL',
  Fedex = 'FEDEX',
  Ups = 'UPS'
}

export type CascadeBillingAccountsObjectListType = {
  __typename?: 'CascadeBillingAccountsObjectListType';
  deals?: Maybe<Array<Deal>>;
};

export type CascadeShippingAddressesObjectListType = {
  __typename?: 'CascadeShippingAddressesObjectListType';
  deals?: Maybe<Array<Deal>>;
};

export type Certificate = {
  __typename?: 'Certificate';
  eurValueMoney?: Maybe<Money>;
  gbpValueMoney?: Maybe<Money>;
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  notice?: Maybe<Scalars['String']['output']>;
  sgdValueMoney?: Maybe<Money>;
  title: Scalars['String']['output'];
  tryValueMoney?: Maybe<Money>;
  usdValueMoney?: Maybe<Money>;
};

/** Autogenerated input type of ChangePrimary */
export type ChangePrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newPrimaryContactId: Scalars['ID']['input'];
};

/** Autogenerated return type of ChangePrimary. */
export type ChangePrimaryPayload = {
  __typename?: 'ChangePrimaryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  provider: Provider;
};

export type ChangeRequest = {
  __typename?: 'ChangeRequest';
  attachedFiles: Array<AttachedFile>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  data: Data;
  declineReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy: User;
  /** N + 1, don't query for collection */
  notCheckedInvoices: Array<IncomingInvoice>;
  /** N + 1, don't query for collection */
  notPaidInvoices: Array<IncomingInvoice>;
  processedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  processedBy?: Maybe<User>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  state: ChangeRequestsStateEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ChangeRequestsApprove */
export type ChangeRequestsApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ChangeRequestsApprove. */
export type ChangeRequestsApprovePayload = {
  __typename?: 'ChangeRequestsApprovePayload';
  changeRequest: ChangeRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeRequestsCreateForProvider */
export type ChangeRequestsCreateForProviderInput = {
  attributes: OmsInputsChangeRequestsProviderType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChangeRequestsCreateForProvider. */
export type ChangeRequestsCreateForProviderPayload = {
  __typename?: 'ChangeRequestsCreateForProviderPayload';
  changeRequest: ChangeRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeRequestsDecline */
export type ChangeRequestsDeclineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeRequestsDecline. */
export type ChangeRequestsDeclinePayload = {
  __typename?: 'ChangeRequestsDeclinePayload';
  changeRequest: ChangeRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum ChangeRequestsStateEnumType {
  Approved = 'approved',
  Declined = 'declined',
  Requested = 'requested'
}

export type ChargeableWeightInfo = {
  __typename?: 'ChargeableWeightInfo';
  bruttoWeight: Scalars['Float']['output'];
  totalVolume: Scalars['Float']['output'];
  volumetricWeight: Scalars['Float']['output'];
};

export type City = {
  __typename?: 'City';
  name: Scalars['String']['output'];
};

export type Claim = {
  __typename?: 'Claim';
  claimPositions: Array<ClaimPosition>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerPosition?: Maybe<OmsClaimCustomerPositionEnumType>;
  customerPreferredResolutionComment?: Maybe<Scalars['String']['output']>;
  customerPreferredResolutions?: Maybe<Array<OmsClaimCustomerPreferredResolutionEnumType>>;
  dealId: Scalars['ID']['output'];
  entryPoint?: Maybe<ClaimsEntryPointEnumType>;
  events: Array<Event>;
  id: Scalars['Int']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  primaryIssue?: Maybe<ClaimsIssueEnumType>;
  state: OmsClaimStateEnum;
  typeClaim?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ClaimPosition = {
  __typename?: 'ClaimPosition';
  anotherIssues?: Maybe<Array<ClaimPositionsIssueEnumType>>;
  attachedFiles: Array<AttachedFile>;
  claim: Claim;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerPrice?: Maybe<Scalars['Float']['output']>;
  customerPriceCurrency: CurrencyEnum;
  customerPriceMoney?: Maybe<Money>;
  followingLots: Array<Lot>;
  id: Scalars['Int']['output'];
  lot?: Maybe<Lot>;
  part: Part;
  primaryIssue?: Maybe<ClaimPositionsIssueEnumType>;
  providerOrder?: Maybe<ProviderOrder>;
  providerPrice?: Maybe<Scalars['Float']['output']>;
  providerPriceCurrency: CurrencyEnum;
  providerPriceMoney?: Maybe<Money>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ClaimPositionsIssueEnumType {
  BrokenOrCrackedParts = 'broken_or_cracked_parts',
  Corrosion = 'corrosion',
  DamagedPackaging = 'damaged_packaging',
  IncorrectDimensionsOrTolerances = 'incorrect_dimensions_or_tolerances',
  IncorrectDocuments = 'incorrect_documents',
  IncorrectFeatures = 'incorrect_features',
  IncorrectMaterial = 'incorrect_material',
  IncorrectPartsReceived = 'incorrect_parts_received',
  IncorrectSurfaceFinish = 'incorrect_surface_finish',
  IncorrectThreads = 'incorrect_threads',
  Indentations = 'indentations',
  LostParts = 'lost_parts',
  LostShipment = 'lost_shipment',
  MissingDocuments = 'missing_documents',
  MissingFeatures = 'missing_features',
  MissingThreads = 'missing_threads',
  OtherPartIssues = 'other_part_issues',
  OtherSurfaceIssues = 'other_surface_issues',
  Scratches = 'scratches',
  SurfaceRoughness = 'surface_roughness'
}

export type ClaimsAggregations = {
  __typename?: 'ClaimsAggregations';
  closed: Array<Scalars['ID']['output']>;
  declined: Array<Scalars['ID']['output']>;
  open: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of ClaimsCreate */
export type ClaimsCreateInput = {
  attributes: OmsInputsDealsClaimType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClaimsCreate. */
export type ClaimsCreatePayload = {
  __typename?: 'ClaimsCreatePayload';
  claim: Claim;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ClaimsDestroy */
export type ClaimsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ClaimsDestroy. */
export type ClaimsDestroyPayload = {
  __typename?: 'ClaimsDestroyPayload';
  claim: Claim;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum ClaimsEntryPointEnumType {
  ClaimEmail = 'claim_email',
  ClaimSubmissionWizard = 'claim_submission_wizard',
  HelpEmail = 'help_email',
  MessageCenter = 'message_center',
  Other = 'other',
  OtherEmail = 'other_email',
  PhoneCall = 'phone_call',
  PmEmail = 'pm_email',
  ProductionEmail = 'production_email',
  SaleEmail = 'sale_email',
  SupportTicket = 'support_ticket'
}

/** Autogenerated input type of ClaimsExport */
export type ClaimsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of ClaimsExport. */
export type ClaimsExportPayload = {
  __typename?: 'ClaimsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum ClaimsIssueEnumType {
  Dimensional = 'dimensional',
  Material = 'material',
  MissingFeature = 'missing_feature',
  Others = 'others',
  PackagingCarrierFault = 'packaging_carrier_fault',
  PackagingPartnerFault = 'packaging_partner_fault',
  PaperworkIncorrect = 'paperwork_incorrect',
  PaperworkMissing = 'paperwork_missing',
  Quantity = 'quantity',
  SurfaceFinishesWorkmanship = 'surface_finishes_workmanship',
  Thread = 'thread'
}

/** Autogenerated input type of ClaimsUpdate */
export type ClaimsUpdateInput = {
  attributes: OmsInputsDealsClaimType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ClaimsUpdate. */
export type ClaimsUpdatePayload = {
  __typename?: 'ClaimsUpdatePayload';
  claim: Claim;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Color = {
  __typename?: 'Color';
  background?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CompletedStageEnum {
  /** lost */
  Lost = 'lost',
  /** won */
  Won = 'won'
}

export type ConfirmedHsCodeDataset = {
  __typename?: 'ConfirmedHsCodeDataset';
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmedBy?: Maybe<User>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: HsCodeDatasetsKindEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ContactsCreate */
export type ContactsCreateInput = {
  attributes: OmsInputsContactType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactsCreate. */
export type ContactsCreatePayload = {
  __typename?: 'ContactsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: ProviderContact;
};

/** Autogenerated input type of ContactsDelete */
export type ContactsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactsDelete. */
export type ContactsDeletePayload = {
  __typename?: 'ContactsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContactsMove */
export type ContactsMoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  providerNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ContactsMove. */
export type ContactsMovePayload = {
  __typename?: 'ContactsMovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: ProviderContact;
};

/** Autogenerated input type of ContactsUpdate */
export type ContactsUpdateInput = {
  attributes: OmsInputsContactType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactsUpdate. */
export type ContactsUpdatePayload = {
  __typename?: 'ContactsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: ProviderContact;
};

export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerReplyRequired: Scalars['Boolean']['output'];
  customerReplyRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerReplyRequiredClearedById?: Maybe<Scalars['ID']['output']>;
  dealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  partnerReplyRequired: Scalars['Boolean']['output'];
  partnerReplyRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  partnerReplyRequiredClearedById?: Maybe<Scalars['ID']['output']>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Conversion = {
  __typename?: 'Conversion';
  baseAmountMoney: Money;
  secondaryAmountMoney?: Maybe<Money>;
};

export type CorrectionReference = {
  __typename?: 'CorrectionReference';
  id: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type CorrectionReferences = {
  __typename?: 'CorrectionReferences';
  invCustomer?: Maybe<Array<CorrectionReference>>;
  invPartner?: Maybe<Array<CorrectionReference>>;
  invWriteOff?: Maybe<Array<CorrectionReference>>;
  orderedActual?: Maybe<Array<CorrectionReference>>;
  orderedHold?: Maybe<Array<CorrectionReference>>;
  prodDelivered?: Maybe<Array<CorrectionReference>>;
  prodPlaced?: Maybe<Array<CorrectionReference>>;
  prodPlacing?: Maybe<Array<CorrectionReference>>;
  prodProcessing?: Maybe<Array<CorrectionReference>>;
  prodShipped2c?: Maybe<Array<CorrectionReference>>;
  prodShipped2x?: Maybe<Array<CorrectionReference>>;
  prodWarehouse?: Maybe<Array<CorrectionReference>>;
  qaClaims?: Maybe<Array<CorrectionReference>>;
  qaIssues?: Maybe<Array<CorrectionReference>>;
};

export type CorrelatedActivityRecord = {
  __typename?: 'CorrelatedActivityRecord';
  author?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  objectId: Scalars['String']['output'];
  objectRecord?: Maybe<ActivityRecordsObjectType>;
  objectType: Scalars['String']['output'];
};

export type Counter = {
  __typename?: 'Counter';
  activeTasks: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  personUnreadMessages: Scalars['Int']['output'];
  providerUnreadMessages: Scalars['Int']['output'];
  sources: Array<MessageSource>;
  unreadMessages: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CountersSettings = {
  __typename?: 'CountersSettings';
  id: Scalars['ID']['output'];
  targetCounter: Scalars['String']['output'];
  targetTable: Scalars['String']['output'];
  workspacePresetId?: Maybe<Scalars['ID']['output']>;
};

export type CountryType = {
  __typename?: 'CountryType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
  payoutTransferType?: Maybe<TransferEnum>;
  region?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CouponsExport */
export type CouponsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of CouponsExport. */
export type CouponsExportPayload = {
  __typename?: 'CouponsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of CreateAutomatically */
export type CreateAutomaticallyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateAutomatically. */
export type CreateAutomaticallyPayload = {
  __typename?: 'CreateAutomaticallyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateBillingAccountsExport */
export type CreateBillingAccountsExportInput = {
  accountingPeriod?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  durationTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  exportType?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateBillingAccountsExport. */
export type CreateBillingAccountsExportPayload = {
  __typename?: 'CreateBillingAccountsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exportBillingAccounts: ExportBillingAccountType;
};

export type CreateDhlOrderSteps = {
  __typename?: 'CreateDHLOrderSteps';
  buildCommercialInvoice?: Maybe<CreateOrderStep>;
  createShipment?: Maybe<CreateOrderStep>;
  sendEmail?: Maybe<CreateOrderStep>;
  updateShipping?: Maybe<CreateOrderStep>;
  uploadDhlExportCsv?: Maybe<CreateOrderStep>;
};

/** Autogenerated input type of CreateLogisticInvoice */
export type CreateLogisticInvoiceInput = {
  attributes: OmsInputsLogisticInvoiceType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLogisticInvoice. */
export type CreateLogisticInvoicePayload = {
  __typename?: 'CreateLogisticInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

/** Autogenerated input type of CreateLogisticInvoiceRelatedShippings */
export type CreateLogisticInvoiceRelatedShippingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filterParams: ShippingsFilter;
  id: Scalars['ID']['input'];
  splitParams: Array<ShippingsSplit>;
};

/** Autogenerated return type of CreateLogisticInvoiceRelatedShippings. */
export type CreateLogisticInvoiceRelatedShippingsPayload = {
  __typename?: 'CreateLogisticInvoiceRelatedShippingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of CreateLogisticInvoicesExport */
export type CreateLogisticInvoicesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportType?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateLogisticInvoicesExport. */
export type CreateLogisticInvoicesExportPayload = {
  __typename?: 'CreateLogisticInvoicesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exportLogisticInvoice: ExportLogisticInvoiceType;
};

/** Autogenerated input type of CreateLogisticOperatorBillingAccount */
export type CreateLogisticOperatorBillingAccountInput = {
  attributes: OmsInputsLogisticOperatorBillingAccountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLogisticOperatorBillingAccount. */
export type CreateLogisticOperatorBillingAccountPayload = {
  __typename?: 'CreateLogisticOperatorBillingAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticOperatorBillingAccount?: Maybe<LogisticOperatorBillingAccount>;
};

export type CreateOrderStep = {
  __typename?: 'CreateOrderStep';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateProvidersExport */
export type CreateProvidersExportInput = {
  accountingPeriod?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  durationTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  exportType?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateProvidersExport. */
export type CreateProvidersExportPayload = {
  __typename?: 'CreateProvidersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exportProviders: ExportProviderType;
};

export type CreditNote = {
  __typename?: 'CreditNote';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of CrmForceCreateDeal */
export type CrmForceCreateDealInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CrmForceCreateDeal. */
export type CrmForceCreateDealPayload = {
  __typename?: 'CrmForceCreateDealPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

/** Autogenerated input type of CrmForceCreateOrganization */
export type CrmForceCreateOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CrmForceCreateOrganization. */
export type CrmForceCreateOrganizationPayload = {
  __typename?: 'CrmForceCreateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of CrmForceCreatePerson */
export type CrmForceCreatePersonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CrmForceCreatePerson. */
export type CrmForceCreatePersonPayload = {
  __typename?: 'CrmForceCreatePersonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Available currencies */
export enum CurrenciesEnum {
  /** BGN */
  Bgn = 'BGN',
  /** CAD */
  Cad = 'CAD',
  /** CHF */
  Chf = 'CHF',
  /** CZK */
  Czk = 'CZK',
  /** DKK */
  Dkk = 'DKK',
  /** EUR */
  Eur = 'EUR',
  /** GBP */
  Gbp = 'GBP',
  /** HUF */
  Huf = 'HUF',
  /** INR */
  Inr = 'INR',
  /** ISK */
  Isk = 'ISK',
  /** NOK */
  Nok = 'NOK',
  /** PLN */
  Pln = 'PLN',
  /** RON */
  Ron = 'RON',
  /** SEK */
  Sek = 'SEK',
  /** SGD */
  Sgd = 'SGD',
  /** TRY */
  Try = 'TRY',
  /** USD */
  Usd = 'USD'
}

/** Autogenerated input type of CurrencyConversion */
export type CurrencyConversionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency: CurrenciesEnum;
  currencyType: CurrencyTypeEnum;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  documentId: Scalars['Int']['input'];
  documentType: Scalars['String']['input'];
};

/** Autogenerated return type of CurrencyConversion. */
export type CurrencyConversionPayload = {
  __typename?: 'CurrencyConversionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CurrencyEnum {
  /** BGN */
  Bgn = 'BGN',
  /** CAD */
  Cad = 'CAD',
  /** CHF */
  Chf = 'CHF',
  /** CZK */
  Czk = 'CZK',
  /** DKK */
  Dkk = 'DKK',
  /** EUR */
  Eur = 'EUR',
  /** GBP */
  Gbp = 'GBP',
  /** HUF */
  Huf = 'HUF',
  /** INR */
  Inr = 'INR',
  /** ISK */
  Isk = 'ISK',
  /** NOK */
  Nok = 'NOK',
  /** PLN */
  Pln = 'PLN',
  /** RON */
  Ron = 'RON',
  /** SEK */
  Sek = 'SEK',
  /** SGD */
  Sgd = 'SGD',
  /** TRY */
  Try = 'TRY',
  /** USD */
  Usd = 'USD'
}

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  rate: Scalars['Float']['output'];
};

/** Primary or secondary currency for conversion */
export enum CurrencyTypeEnum {
  /** Convert document's primary currency */
  Primary = 'primary',
  /** Convert document's secondary (for children objects) currency */
  Secondary = 'secondary'
}

export enum CustomerOrderGradeEnum {
  A = 'a',
  B = 'b',
  C = 'c'
}

/** Customer source region */
export enum CustomerSourceRegionEnum {
  Cn = 'CN',
  Eu = 'EU',
  India = 'INDIA',
  Sg = 'SG',
  Tr = 'TR',
  Uk = 'UK'
}

export type CustomsOfficeCode = {
  __typename?: 'CustomsOfficeCode';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Data = ProviderData;

export type DataItem = {
  __typename?: 'DataItem';
  new?: Maybe<Scalars['String']['output']>;
  old?: Maybe<Scalars['String']['output']>;
};

export type DatevFieldsType = {
  __typename?: 'DatevFieldsType';
  extraXometryVatNumber?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sachkontoNumber?: Maybe<Scalars['Int']['output']>;
  vatCode?: Maybe<Scalars['Int']['output']>;
  vatPercent?: Maybe<Scalars['Float']['output']>;
  xometryVatNumber?: Maybe<Scalars['JSON']['output']>;
};

export type Deal = {
  __typename?: 'Deal';
  billingPreference?: Maybe<BillingPreference>;
  certificates?: Maybe<Scalars['JSON']['output']>;
  claims?: Maybe<Array<Claim>>;
  contributors: Array<DealContributor>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  customerProjectNumber?: Maybe<Scalars['String']['output']>;
  deliveryDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  enquiry?: Maybe<Enquiry>;
  externalCrmId?: Maybe<Scalars['String']['output']>;
  externalCrmUrl?: Maybe<Scalars['String']['output']>;
  externalInvoicePlatform?: Maybe<Scalars['String']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  googleDriveUrl?: Maybe<Scalars['String']['output']>;
  grade: Scalars['String']['output'];
  gshDfm: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  injectionMouldingDeferredPayment: Scalars['Boolean']['output'];
  intacctPaymentsSyncEnabled: Scalars['Boolean']['output'];
  intacctPayoutsSyncEnabled: Scalars['Boolean']['output'];
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  intercompanySalesCustomer?: Maybe<IntercompanySalesCustomer>;
  invoiced?: Maybe<Scalars['Float']['output']>;
  isComplex: Scalars['Boolean']['output'];
  isExpress?: Maybe<Scalars['Boolean']['output']>;
  isForSoftwareTesting: Scalars['Boolean']['output'];
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isImportant: Scalars['Boolean']['output'];
  isL2g: Scalars['Boolean']['output'];
  isMcNeeded?: Maybe<Scalars['Boolean']['output']>;
  isNpg: Scalars['Boolean']['output'];
  isOnHold: Scalars['Boolean']['output'];
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedBy?: Maybe<User>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isPreQuoted?: Maybe<Scalars['Boolean']['output']>;
  isSamplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  isTpo: Scalars['Boolean']['output'];
  jobPublicComment: Scalars['String']['output'];
  manualProcessingComment?: Maybe<Scalars['String']['output']>;
  manualProcessingEmails: Scalars['Boolean']['output'];
  manualProcessingFinance: Scalars['Boolean']['output'];
  manualProcessingIncomingInvoices: Scalars['Boolean']['output'];
  manualProcessingJobs: Scalars['Boolean']['output'];
  manualProcessingOrderConfirmation: Scalars['Boolean']['output'];
  manualProcessingOutcomingInvoiceReminders: Scalars['Boolean']['output'];
  manualProcessingOutcomingInvoices: Scalars['Boolean']['output'];
  manualProcessingPhotoReport: Scalars['Boolean']['output'];
  manualProcessingShippings: Scalars['Boolean']['output'];
  manualProcessingStages: Scalars['Boolean']['output'];
  measurementProtocols?: Maybe<Array<Scalars['String']['output']>>;
  moldingDfmEngineer?: Maybe<User>;
  moldingDfmEngineerId?: Maybe<Scalars['ID']['output']>;
  movedTo?: Maybe<IntercompanyObject>;
  number: Scalars['String']['output'];
  orderConfirmation?: Maybe<OrderConfirmation>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  originalDeals: Array<Deal>;
  outcomingInvoices?: Maybe<Array<OutcomingInvoice>>;
  overallStage?: Maybe<OverallStageEnum>;
  owner?: Maybe<PdUser>;
  payments?: Maybe<Array<Payment>>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['ID']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveOrderValue?: Maybe<Scalars['Float']['output']>;
  pipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pipedriveStatusUpdatedBy?: Maybe<User>;
  pipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  pipedriveUrl?: Maybe<Scalars['String']['output']>;
  pmId?: Maybe<Scalars['ID']['output']>;
  productionCompleted: Scalars['Boolean']['output'];
  productionManager?: Maybe<User>;
  productionStage?: Maybe<ProductionStageEnum>;
  purchaseOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  reasonOfLose?: Maybe<Scalars['String']['output']>;
  reasonOfLoseComment?: Maybe<Scalars['String']['output']>;
  reasonOfLoseDetails?: Maybe<Scalars['String']['output']>;
  repetitiveDeals: Array<Deal>;
  salesDealRepetitive: Scalars['Boolean']['output'];
  samplesConfirmationStatus?: Maybe<ProviderOrdersSamplesConfirmationStatusEnum>;
  shippings?: Maybe<Array<Shipping>>;
  slackUrl?: Maybe<Scalars['String']['output']>;
  slackUrlRequested?: Maybe<Scalars['Boolean']['output']>;
  sourcingOwners: Array<Employee>;
  teamspace?: Maybe<Teamspace>;
  teamspaceId?: Maybe<Scalars['ID']['output']>;
  testDeal: Scalars['Boolean']['output'];
  totalPaidNett?: Maybe<Scalars['Float']['output']>;
  transportMode: DealsTransportModeEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  utm?: Maybe<Utm>;
  vat: Scalars['Float']['output'];
};


export type DealContributorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type DealOutcomingInvoicesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type DealPaymentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type DealAggregations = {
  __typename?: 'DealAggregations';
  additionalTags?: Maybe<Array<Scalars['String']['output']>>;
  bagAndTag: Scalars['Boolean']['output'];
  consistencyCheck: Scalars['Boolean']['output'];
  hasCustomerObject: Scalars['Boolean']['output'];
  isBigOrHeavy: Scalars['Boolean']['output'];
  openClaims: ClaimsAggregations;
  partsOrigins?: Maybe<Array<Scalars['String']['output']>>;
  priceMethod?: Maybe<PriceMethodEnum>;
  processes?: Maybe<Array<Scalars['String']['output']>>;
  qualityControlIssues: Array<Scalars['ID']['output']>;
  qualityControlOpenIssues: Array<Scalars['ID']['output']>;
  quoteSource?: Maybe<Scalars['String']['output']>;
  risks?: Maybe<Array<Scalars['String']['output']>>;
  shippingInstructions?: Maybe<Array<Scalars['String']['output']>>;
};

export type DealBalanceRecord = {
  __typename?: 'DealBalanceRecord';
  balanceBrutto: Scalars['Float']['output'];
  balanceBruttoMoney: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  deal: Deal;
  dealId: Scalars['ID']['output'];
  documentReferences: DealBalanceRecordDocumentReferences;
  id: Scalars['Int']['output'];
  invoicedBrutto: Scalars['Float']['output'];
  invoicedBruttoMoney: Money;
  maxOverdueDays: Scalars['Int']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  paidBrutto: Scalars['Float']['output'];
  paidBruttoMoney: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DealBalanceRecordDocumentReference = {
  __typename?: 'DealBalanceRecordDocumentReference';
  date: Scalars['ISO8601Date']['output'];
  displayName: Scalars['String']['output'];
  meta?: Maybe<DealBalanceRecordDocumentReferenceMeta>;
  number?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DealBalanceRecordDocumentReferenceMeta = {
  __typename?: 'DealBalanceRecordDocumentReferenceMeta';
  creditNote?: Maybe<Scalars['Boolean']['output']>;
  isRefund?: Maybe<Scalars['Boolean']['output']>;
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  overdue?: Maybe<Scalars['Int']['output']>;
};

export type DealBalanceRecordDocumentReferences = {
  __typename?: 'DealBalanceRecordDocumentReferences';
  invoiced?: Maybe<Array<DealBalanceRecordDocumentReference>>;
  paid?: Maybe<Array<DealBalanceRecordDocumentReference>>;
};

/** Autogenerated input type of DealBalanceRecordsExportForOrganization */
export type DealBalanceRecordsExportForOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealBalanceRecordsExportForOrganization. */
export type DealBalanceRecordsExportForOrganizationPayload = {
  __typename?: 'DealBalanceRecordsExportForOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type DealContributor = {
  __typename?: 'DealContributor';
  person: Person;
  roleInTeamspace?: Maybe<OmsTeamspaceRoleEnum>;
};

/** Autogenerated input type of DealDocumentsExport */
export type DealDocumentsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of DealDocumentsExport. */
export type DealDocumentsExportPayload = {
  __typename?: 'DealDocumentsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum DealPartDrawingsStateEnum {
  Cleaned = 'cleaned',
  NoFiles = 'no_files',
  NotCleaned = 'not_cleaned',
  PartiallyCleaned = 'partially_cleaned',
  Rework = 'rework'
}

export enum DealParticipantRoleEnum {
  /** Sales Assistant */
  AssignedSa = 'assigned_sa',
  /** Audit Engineer */
  AuditEngineers = 'audit_engineers',
  /** Drafting Engineer */
  DraftingEngineers = 'drafting_engineers',
  /** Job Owner (Placing) */
  JobOwners = 'job_owners',
  /** Key Account Manager (Sales person) */
  Kam = 'kam',
  /** Molding DFM Engineer */
  MoldingDfmEngineer = 'molding_dfm_engineer',
  /** Order Creator */
  OrderedBy = 'ordered_by',
  /** Partner Network Manager */
  PartnerNetworkManagers = 'partner_network_managers',
  /** Pricing Engineer */
  PricingEngineer = 'pricing_engineer',
  /** Production Manager (PM) */
  ProductionManager = 'production_manager',
  /** RFQ Owner */
  RfqOwners = 'rfq_owners',
  /** Shipping Owner (Logistic) */
  ShippingOwners = 'shipping_owners'
}

export type DealParticipantWithRole = {
  __typename?: 'DealParticipantWithRole';
  absence: AbsenceStatusEnum;
  absenceFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  absenceName?: Maybe<Scalars['String']['output']>;
  absenceUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deputyUsers: Array<MessageUser>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  isRobot?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role: DealParticipantRoleEnum;
  teamspaces?: Maybe<Array<TeamspaceMembership>>;
  type: UserEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DealPartsCreateMeasurementTemplates */
export type DealPartsCreateMeasurementTemplatesInput = {
  attributes: Array<OmsInputsDealPartsMeasurementTemplateType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealPartsCreateMeasurementTemplates. */
export type DealPartsCreateMeasurementTemplatesPayload = {
  __typename?: 'DealPartsCreateMeasurementTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  measurements: Array<QualityControlsMeasurementType>;
};

/** Autogenerated input type of DealPartsCreateQualityControlFiles */
export type DealPartsCreateQualityControlFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealPartsCreateQualityControlFiles. */
export type DealPartsCreateQualityControlFilesPayload = {
  __typename?: 'DealPartsCreateQualityControlFilesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files: Array<AttachedFile>;
};

/** Autogenerated input type of DealPartsMoldsCreate */
export type DealPartsMoldsCreateInput = {
  childParts?: InputMaybe<Array<OmsInputsMoldRelatedPart>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealPartsMoldsCreate. */
export type DealPartsMoldsCreatePayload = {
  __typename?: 'DealPartsMoldsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mold: Part;
};

/** Autogenerated input type of DealPartsMoldsUpdate */
export type DealPartsMoldsUpdateInput = {
  attributes: OmsInputsPartMold;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealPartsMoldsUpdate. */
export type DealPartsMoldsUpdatePayload = {
  __typename?: 'DealPartsMoldsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mold: Part;
};

/** Autogenerated input type of DealPartsUpdateInjectionMoldingPipeline */
export type DealPartsUpdateInjectionMoldingPipelineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
  pipelineAttributes: OmsInputsPartInjectionMoldingPipeline;
};

/** Autogenerated return type of DealPartsUpdateInjectionMoldingPipeline. */
export type DealPartsUpdateInjectionMoldingPipelinePayload = {
  __typename?: 'DealPartsUpdateInjectionMoldingPipelinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  part: Part;
};

export type DealShippingAddressType = {
  __typename?: 'DealShippingAddressType';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gstIn?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DealsAddRepetitiveDeal */
export type DealsAddRepetitiveDealInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  originalDealId: Scalars['ID']['input'];
  repetitiveDealId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsAddRepetitiveDeal. */
export type DealsAddRepetitiveDealPayload = {
  __typename?: 'DealsAddRepetitiveDealPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  originalDeal: Deal;
  repetitiveDeal: Deal;
};

/** Autogenerated input type of DealsBillingPreferenceCreateOrUpdate */
export type DealsBillingPreferenceCreateOrUpdateInput = {
  attributes: OmsInputsDealsBillingPreferenceType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsBillingPreferenceCreateOrUpdate. */
export type DealsBillingPreferenceCreateOrUpdatePayload = {
  __typename?: 'DealsBillingPreferenceCreateOrUpdatePayload';
  billingPreference: BillingPreference;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DealsBulkActionsUpdateProductionManager */
export type DealsBulkActionsUpdateProductionManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealIds: Array<Scalars['ID']['input']>;
  pmId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsBulkActionsUpdateProductionManager. */
export type DealsBulkActionsUpdateProductionManagerPayload = {
  __typename?: 'DealsBulkActionsUpdateProductionManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DealsCalcPartsState */
export type DealsCalcPartsStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsCalcPartsState. */
export type DealsCalcPartsStatePayload = {
  __typename?: 'DealsCalcPartsStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of DealsCompleteProduction */
export type DealsCompleteProductionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reasonOfLose?: InputMaybe<Scalars['String']['input']>;
  reasonOfLoseComment?: InputMaybe<Scalars['String']['input']>;
  reasonOfLoseDetails?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DealsCompleteProduction. */
export type DealsCompleteProductionPayload = {
  __typename?: 'DealsCompleteProductionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

/** Autogenerated input type of DealsCreateSlackChannel */
export type DealsCreateSlackChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsCreateSlackChannel. */
export type DealsCreateSlackChannelPayload = {
  __typename?: 'DealsCreateSlackChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

export type DealsDocumentType = {
  __typename?: 'DealsDocumentType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealObject: DealsDocumentsDealObjectType;
  feedback?: Maybe<Scalars['String']['output']>;
  files: Array<AttachedFile>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  parts: Array<Part>;
  type: DealsDocumentsTypeEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verdict: DealsDocumentsVerdictEnumType;
  verdictBy?: Maybe<User>;
  verdictDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  visibleToCustomer: Scalars['Boolean']['output'];
  visibleToPartner: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DealsDocumentsBulkGenerateZip */
export type DealsDocumentsBulkGenerateZipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of DealsDocumentsBulkGenerateZip. */
export type DealsDocumentsBulkGenerateZipPayload = {
  __typename?: 'DealsDocumentsBulkGenerateZipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
};

/** Autogenerated input type of DealsDocumentsBulkUpdate */
export type DealsDocumentsBulkUpdateInput = {
  attributes: OmsInputsDealsDocumentsBulkUpdateAttributesType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of DealsDocumentsBulkUpdate. */
export type DealsDocumentsBulkUpdatePayload = {
  __typename?: 'DealsDocumentsBulkUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DealsDocumentsCreate */
export type DealsDocumentsCreateInput = {
  attributes: OmsInputsDealsDocumentType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DealsDocumentsCreate. */
export type DealsDocumentsCreatePayload = {
  __typename?: 'DealsDocumentsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<DealsDocumentType>;
};

export type DealsDocumentsDealObjectType = {
  __typename?: 'DealsDocumentsDealObjectType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  type: DealsDocumentsDealObjectsTypeEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum DealsDocumentsDealObjectsTypeEnumType {
  OrderConfirmation = 'order_confirmation',
  ProviderOrder = 'provider_order'
}

/** Autogenerated input type of DealsDocumentsDelete */
export type DealsDocumentsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsDocumentsDelete. */
export type DealsDocumentsDeletePayload = {
  __typename?: 'DealsDocumentsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DealsDocumentsGenerateZip */
export type DealsDocumentsGenerateZipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsDocumentsGenerateZip. */
export type DealsDocumentsGenerateZipPayload = {
  __typename?: 'DealsDocumentsGenerateZipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
};

export type DealsDocumentsRequirementByPartsType = {
  __typename?: 'DealsDocumentsRequirementByPartsType';
  constantName: DealsDocumentsRequirementsConstantNameEnumType;
  dealObject: DealsDocumentsDealObjectType;
  document?: Maybe<DealsDocumentType>;
  issueBy: DealsDocumentsRequirementsIssueByEnumType;
  part?: Maybe<Part>;
};

export type DealsDocumentsRequirementType = {
  __typename?: 'DealsDocumentsRequirementType';
  constantName: DealsDocumentsRequirementsConstantNameEnumType;
  issueBy: DealsDocumentsRequirementsIssueByEnumType;
  name: Scalars['String']['output'];
  parts: Array<Part>;
  providerOrder?: Maybe<ProviderOrder>;
};

export enum DealsDocumentsRequirementsConstantNameEnumType {
  /** Certificate 2.1 */
  CertCompliance_2_1 = 'cert_compliance_2_1',
  /** Certificate 2.2 */
  CertCompliance_2_2 = 'cert_compliance_2_2',
  /** Heat treatment protocol */
  CertHeatTreatment = 'cert_heat_treatment',
  /** Raw material certificate (metals) type 3.1 according to EN 10204 */
  CertMaterials_3_1V2 = 'cert_materials_3_1_v2',
  /** Raw material certificate (metal) */
  CertMaterialsMetal = 'cert_materials_metal',
  /** Raw material certificate (plastic) */
  CertMaterialsPlastic = 'cert_materials_plastic',
  /** Certificate of Origin */
  CertOfOrigin = 'cert_of_origin',
  /** REACH */
  CertReach = 'cert_reach',
  /** RoHS */
  CertRohs = 'cert_rohs',
  /** CMM */
  MpCmm = 'mp_cmm',
  /** FAIR */
  MpFair = 'mp_fair',
  /** Measurement report */
  MpStandard = 'mp_standard',
  /** VQC */
  Vqc = 'vqc'
}

export enum DealsDocumentsRequirementsIssueByEnumType {
  /** Partner */
  Partner = 'partner',
  /** Xometry */
  Xometry = 'xometry'
}

export enum DealsDocumentsTypeEnumType {
  CertCompliance_2_1 = 'cert_compliance_2_1',
  CertCompliance_2_2 = 'cert_compliance_2_2',
  CertHeatTreatment = 'cert_heat_treatment',
  CertMaterials_3_1V2 = 'cert_materials_3_1_v2',
  CertMaterialsMetal = 'cert_materials_metal',
  CertMaterialsPlastic = 'cert_materials_plastic',
  CertOfOrigin = 'cert_of_origin',
  CertReach = 'cert_reach',
  CertRohs = 'cert_rohs',
  MpCmm = 'mp_cmm',
  MpFair = 'mp_fair',
  MpStandard = 'mp_standard',
  Vqc = 'vqc'
}

/** Autogenerated input type of DealsDocumentsUpdate */
export type DealsDocumentsUpdateInput = {
  attributes: OmsInputsDealsDocumentType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsDocumentsUpdate. */
export type DealsDocumentsUpdatePayload = {
  __typename?: 'DealsDocumentsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<DealsDocumentType>;
};

export enum DealsDocumentsVerdictEnumType {
  Accepted = 'accepted',
  AcceptedWithWarnings = 'accepted_with_warnings',
  Incomplete = 'incomplete',
  NeedVerdict = 'need_verdict',
  Rejected = 'rejected',
  VerdictNotNeeded = 'verdict_not_needed'
}

/** Autogenerated input type of DealsExport */
export type DealsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of DealsExport. */
export type DealsExportPayload = {
  __typename?: 'DealsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum DealsOrderConfirmationChangeRequestStateEnumType {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Open = 'open',
  Rejected = 'rejected'
}

export type DealsOrderConfirmationChangeRequestType = {
  __typename?: 'DealsOrderConfirmationChangeRequestType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  leadTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  manualProcessingReason?: Maybe<Scalars['String']['output']>;
  state: DealsOrderConfirmationChangeRequestStateEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validTillDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of DealsRemoveRepetitiveDeal */
export type DealsRemoveRepetitiveDealInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  originalDealId: Scalars['ID']['input'];
  repetitiveDealId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsRemoveRepetitiveDeal. */
export type DealsRemoveRepetitiveDealPayload = {
  __typename?: 'DealsRemoveRepetitiveDealPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  originalDeal: Deal;
  repetitiveDeal: Deal;
};

/** Autogenerated input type of DealsReopenProduction */
export type DealsReopenProductionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsReopenProduction. */
export type DealsReopenProductionPayload = {
  __typename?: 'DealsReopenProductionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

/** Autogenerated input type of DealsSendPriceToExternal */
export type DealsSendPriceToExternalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsSendPriceToExternal. */
export type DealsSendPriceToExternalPayload = {
  __typename?: 'DealsSendPriceToExternalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

export type DealsShippings = {
  actualDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  actualShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  logisticOperator?: InputMaybe<Scalars['String']['input']>;
  logisticOperatorId?: InputMaybe<Scalars['ID']['input']>;
  providerOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shippingNumber?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DealsSourceType = {
  __typename?: 'DealsSourceType';
  canceled: Scalars['Boolean']['output'];
  className?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealId: Scalars['Int']['output'];
  files: Array<AttachedFile>;
  id: Scalars['ID']['output'];
  lots?: Maybe<Array<Lot>>;
  sourceId: Scalars['String']['output'];
  sourceName: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum DealsTransportModeEnumType {
  AirRoad = 'AIR_ROAD',
  Rail = 'RAIL',
  Sea = 'SEA'
}

/** Autogenerated input type of DealsUpdate */
export type DealsUpdateInput = {
  attributes: OmsInputsDealsDealType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsUpdate. */
export type DealsUpdatePayload = {
  __typename?: 'DealsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

/** Autogenerated input type of DealsUpdatePerson */
export type DealsUpdatePersonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsUpdatePerson. */
export type DealsUpdatePersonPayload = {
  __typename?: 'DealsUpdatePersonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

/** Autogenerated input type of DealsUpdateProductionManager */
export type DealsUpdateProductionManagerInput = {
  attributes: OmsInputsDealUpdateProductionManager;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DealsUpdateProductionManager. */
export type DealsUpdateProductionManagerPayload = {
  __typename?: 'DealsUpdateProductionManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

/** Autogenerated input type of DealsUpdateTpo */
export type DealsUpdateTpoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isTpo: Scalars['Boolean']['input'];
  rejectRecommendedRfq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DealsUpdateTpo. */
export type DealsUpdateTpoPayload = {
  __typename?: 'DealsUpdateTpoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal: Deal;
};

export type DefaultWorkspacePresets = {
  __typename?: 'DefaultWorkspacePresets';
  globalDefaultPreset?: Maybe<WorkspacePreset>;
  personalDefaultPreset?: Maybe<WorkspacePreset>;
};

/** Autogenerated input type of DeleteLogisticOperatorBillingAccount */
export type DeleteLogisticOperatorBillingAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteLogisticOperatorBillingAccount. */
export type DeleteLogisticOperatorBillingAccountPayload = {
  __typename?: 'DeleteLogisticOperatorBillingAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticOperatorBillingAccount?: Maybe<LogisticOperatorBillingAccount>;
};

/** Autogenerated input type of DeliveriesConvertToShipping */
export type DeliveriesConvertToShippingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveriesConvertToShipping. */
export type DeliveriesConvertToShippingPayload = {
  __typename?: 'DeliveriesConvertToShippingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingId: Scalars['ID']['output'];
};

/** Autogenerated input type of DeliveriesConvertToStorage */
export type DeliveriesConvertToStorageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

/** Autogenerated return type of DeliveriesConvertToStorage. */
export type DeliveriesConvertToStoragePayload = {
  __typename?: 'DeliveriesConvertToStoragePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  storageId: Scalars['ID']['output'];
};

/** Autogenerated input type of DeliveriesUpdateComments */
export type DeliveriesUpdateCommentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveriesUpdateComments. */
export type DeliveriesUpdateCommentsPayload = {
  __typename?: 'DeliveriesUpdateCommentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  delivery: Delivery;
};

export type Delivery = {
  __typename?: 'Delivery';
  actualDeliveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  actualShipmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  attachedFiles?: Maybe<Array<AttachedFile>>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  brutto?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  convertedToId?: Maybe<Scalars['String']['output']>;
  convertedToType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealId: Scalars['ID']['output'];
  deliveryBasis?: Maybe<Scalars['String']['output']>;
  deliveryNoteLink?: Maybe<Scalars['String']['output']>;
  deliveryOrderNumber?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  expectedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expectedShipmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  logisticAggregator?: Maybe<Scalars['String']['output']>;
  logisticOperator?: Maybe<Scalars['String']['output']>;
  lots?: Maybe<Array<Lot>>;
  number: Scalars['String']['output'];
  packagingReportCheck: Scalars['String']['output'];
  partialDelivery?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerOrder?: Maybe<ProviderOrder>;
  receivedDelivery: Scalars['String']['output'];
  shippingAddress?: Maybe<Scalars['String']['output']>;
  shippingCost: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  trackingLink?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export enum DependenceEnum {
  /** claim */
  Claim = 'claim',
  /** enquiry */
  Enquiry = 'enquiry',
  /** order_confirmation */
  OrderConfirmation = 'order_confirmation',
  /** provider_order */
  ProviderOrder = 'provider_order',
  /** quality_control */
  QualityControl = 'quality_control'
}

/** Autogenerated input type of DestroyLogisticInvoiceAttachedFile */
export type DestroyLogisticInvoiceAttachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logisticInvoiceId: Scalars['ID']['input'];
  uuidId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyLogisticInvoiceAttachedFile. */
export type DestroyLogisticInvoiceAttachedFilePayload = {
  __typename?: 'DestroyLogisticInvoiceAttachedFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

export type Dimension = {
  __typename?: 'Dimension';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

/** D&B specific money type with extended currencies */
export type DnBMoney = DnBMoneyInterface & {
  __typename?: 'DnBMoney';
  amount: Scalars['String']['output'];
  amountCents: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

/** Contains price and currency */
export type DnBMoneyInterface = {
  amount: Scalars['String']['output'];
  amountCents: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type DocumentNoteType = {
  __typename?: 'DocumentNoteType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentId?: Maybe<Scalars['ID']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  emotion?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<AttachedFile>>;
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

/** Autogenerated input type of DocumentNotesCreate */
export type DocumentNotesCreateInput = {
  attributes: OmsInputsDocumentNoteType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DocumentNotesCreate. */
export type DocumentNotesCreatePayload = {
  __typename?: 'DocumentNotesCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  note: DocumentNoteType;
};

/** Autogenerated input type of DocumentNotesDelete */
export type DocumentNotesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DocumentNotesDelete. */
export type DocumentNotesDeletePayload = {
  __typename?: 'DocumentNotesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DocumentReference = {
  __typename?: 'DocumentReference';
  count: Scalars['Int']['output'];
  objectId: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
};

export type DocumentReferenceGroup = {
  __typename?: 'DocumentReferenceGroup';
  in?: Maybe<Array<DocumentReference>>;
  out?: Maybe<Array<DocumentReference>>;
};

export type DocumentReferences = {
  __typename?: 'DocumentReferences';
  invCustomer?: Maybe<DocumentReferenceGroup>;
  invPartner?: Maybe<DocumentReferenceGroup>;
  invWriteOff?: Maybe<DocumentReferenceGroup>;
  orderedActual?: Maybe<DocumentReferenceGroup>;
  orderedHold?: Maybe<DocumentReferenceGroup>;
  prodDelivered?: Maybe<DocumentReferenceGroup>;
  prodPlaced?: Maybe<DocumentReferenceGroup>;
  prodPlacing?: Maybe<DocumentReferenceGroup>;
  prodProcessing?: Maybe<DocumentReferenceGroup>;
  prodShipped2c?: Maybe<DocumentReferenceGroup>;
  prodShipped2x?: Maybe<DocumentReferenceGroup>;
  prodWarehouse?: Maybe<DocumentReferenceGroup>;
  qaClaims?: Maybe<DocumentReferenceGroup>;
  qaIssues?: Maybe<DocumentReferenceGroup>;
};

/** Autogenerated input type of DraftingDealPartsExport */
export type DraftingDealPartsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of DraftingDealPartsExport. */
export type DraftingDealPartsExportPayload = {
  __typename?: 'DraftingDealPartsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type DraftingEngineer = {
  __typename?: 'DraftingEngineer';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPartsUntouched12Hrs: DraftingEngineerCounter;
  draftingEngineerId?: Maybe<Scalars['ID']['output']>;
  hasExpressParts: DraftingEngineerCounter;
  id?: Maybe<Scalars['ID']['output']>;
  myStartedDeals: DraftingEngineerCounter;
  newWaitRework: DraftingEngineerCounter;
  podId?: Maybe<Scalars['Int']['output']>;
  requestAfterPoPlaced: DraftingEngineerCounter;
  reworkOrdersUpcoming: DraftingEngineerCounter;
  reworkOrdersVip: DraftingEngineerCounter;
  rfqDrawingsCleaningNeeded: DraftingEngineerCounter;
  tasksMyTeam: DraftingEngineerCounter;
  tasksUntouched12Hrs: DraftingEngineerCounter;
  tasksVip: DraftingEngineerCounter;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DraftingEngineerCounter = {
  __typename?: 'DraftingEngineerCounter';
  dealsCount: Scalars['Int']['output'];
  partsCount: Scalars['Int']['output'];
};

/** Autogenerated input type of DraftingEnquiryPartsExport */
export type DraftingEnquiryPartsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of DraftingEnquiryPartsExport. */
export type DraftingEnquiryPartsExportPayload = {
  __typename?: 'DraftingEnquiryPartsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of E2EPersonCleanup */
export type E2EPersonCleanupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of E2EPersonCleanup. */
export type E2EPersonCleanupPayload = {
  __typename?: 'E2EPersonCleanupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EmailLogin */
export type EmailLoginInput = {
  attributes: OmsInputsUserEmailLogin;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EmailLogin. */
export type EmailLoginPayload = {
  __typename?: 'EmailLoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  user: User;
};

/** Autogenerated input type of EmailMessagesExport */
export type EmailMessagesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of EmailMessagesExport. */
export type EmailMessagesExportPayload = {
  __typename?: 'EmailMessagesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  email?: Maybe<Scalars['String']['output']>;
  externalUid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EnquiriesAdditionalServicesCreateXPoints */
export type EnquiriesAdditionalServicesCreateXPointsInput = {
  attributes: OmsInputsAdditionalServicesXPointsPositionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enquiryId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnquiriesAdditionalServicesCreateXPoints. */
export type EnquiriesAdditionalServicesCreateXPointsPayload = {
  __typename?: 'EnquiriesAdditionalServicesCreateXPointsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnquiriesBulkActionsCreateRfq */
export type EnquiriesBulkActionsCreateRfqInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquiriesBulkActionsCreateRfq. */
export type EnquiriesBulkActionsCreateRfqPayload = {
  __typename?: 'EnquiriesBulkActionsCreateRfqPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

/** Autogenerated input type of EnquiriesBulkActionsPartsRestartWorkflow */
export type EnquiriesBulkActionsPartsRestartWorkflowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquiriesBulkActionsPartsRestartWorkflow. */
export type EnquiriesBulkActionsPartsRestartWorkflowPayload = {
  __typename?: 'EnquiriesBulkActionsPartsRestartWorkflowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnquiriesBulkActionsUpdateRelatedDealLots */
export type EnquiriesBulkActionsUpdateRelatedDealLotsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enquiryId: Scalars['ID']['input'];
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquiriesBulkActionsUpdateRelatedDealLots. */
export type EnquiriesBulkActionsUpdateRelatedDealLotsPayload = {
  __typename?: 'EnquiriesBulkActionsUpdateRelatedDealLotsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnquiriesBulkNotesUpdate */
export type EnquiriesBulkNotesUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquiriesBulkNotesUpdate. */
export type EnquiriesBulkNotesUpdatePayload = {
  __typename?: 'EnquiriesBulkNotesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiriesCancelModeration */
export type EnquiriesCancelModerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enquiryId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnquiriesCancelModeration. */
export type EnquiriesCancelModerationPayload = {
  __typename?: 'EnquiriesCancelModerationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiriesCertificatesUpdate */
export type EnquiriesCertificatesUpdateInput = {
  attributes: OmsInputsEnquiriesCertificatesUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EnquiriesCertificatesUpdate. */
export type EnquiriesCertificatesUpdatePayload = {
  __typename?: 'EnquiriesCertificatesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiriesExport */
export type EnquiriesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of EnquiriesExport. */
export type EnquiriesExportPayload = {
  __typename?: 'EnquiriesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of EnquiriesFillEnquiryStop */
export type EnquiriesFillEnquiryStopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EnquiriesFillEnquiryStop. */
export type EnquiriesFillEnquiryStopPayload = {
  __typename?: 'EnquiriesFillEnquiryStopPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiriesSfCasesExport */
export type EnquiriesSfCasesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of EnquiriesSfCasesExport. */
export type EnquiriesSfCasesExportPayload = {
  __typename?: 'EnquiriesSfCasesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of EnquiriesSfCasesSaveFeedback */
export type EnquiriesSfCasesSaveFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enquiryId: Scalars['ID']['input'];
  feedback: Scalars['JSON']['input'];
  sfCaseId: Scalars['String']['input'];
};

/** Autogenerated return type of EnquiriesSfCasesSaveFeedback. */
export type EnquiriesSfCasesSaveFeedbackPayload = {
  __typename?: 'EnquiriesSfCasesSaveFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnquiriesUpdate */
export type EnquiriesUpdateInput = {
  attributes: OmsInputsEnquiriesEnquiryType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of EnquiriesUpdateKamModeration */
export type EnquiriesUpdateKamModerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kamModerationRequired: Scalars['Boolean']['input'];
};

/** Autogenerated return type of EnquiriesUpdateKamModeration. */
export type EnquiriesUpdateKamModerationPayload = {
  __typename?: 'EnquiriesUpdateKamModerationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated return type of EnquiriesUpdate. */
export type EnquiriesUpdatePayload = {
  __typename?: 'EnquiriesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

export type Enquiry = {
  __typename?: 'Enquiry';
  appliedCouponValue?: Maybe<Scalars['Float']['output']>;
  appliedCouponValueMoney?: Maybe<Money>;
  appliedPromotions: Array<OmsEnquiryAppliedPromotionType>;
  assignedEng?: Maybe<Scalars['ID']['output']>;
  assignedSa?: Maybe<Scalars['ID']['output']>;
  billingAccount?: Maybe<Scalars['JSON']['output']>;
  calculations: Calculations;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  certificateValues: Array<OmsEnquiryCertificateValue>;
  certificates?: Maybe<Scalars['JSON']['output']>;
  certificatesPrice?: Maybe<Scalars['Float']['output']>;
  competitorQuoteLink?: Maybe<Scalars['String']['output']>;
  contributors: Array<Person>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  deal: Deal;
  dealId: Scalars['ID']['output'];
  /** Actual favorite material types of the quote owner (the teamspace, else the person) */
  favoriteMaterialTypes: Array<FavoriteMaterialType>;
  fillEnquiry?: Maybe<OmsEnquiryFillEnquiryType>;
  hidePartsDiscounts: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ignoreMinimumOrderValue: Scalars['Boolean']['output'];
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  isCanceled: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isTpo: Scalars['Boolean']['output'];
  lockQuoteLimit: Scalars['Boolean']['output'];
  manualQuotationRequestExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  minOrderAddition?: Maybe<Scalars['Float']['output']>;
  minOrderAdditionMoney?: Maybe<Money>;
  moderationFinishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  moderationRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  moderationRequestedBy?: Maybe<User>;
  movedTo?: Maybe<IntercompanyObject>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  orderedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  orderedBy?: Maybe<OrderedBy>;
  parts: Array<OmsEnquiryPartType>;
  partsValue?: Maybe<Scalars['Float']['output']>;
  partsValueMoney?: Maybe<Money>;
  prepayDiscount?: Maybe<Scalars['Float']['output']>;
  prepayDiscountMoney?: Maybe<Money>;
  quotationMethod?: Maybe<QuotationMethodEnum>;
  quotingState: QuotingStateEnum;
  rfqAutoassignmentSegment?: Maybe<RfqAutoassignmentSegmentEnum>;
  shippingAddress?: Maybe<Scalars['JSON']['output']>;
  shippingAddressStructured?: Maybe<Scalars['JSON']['output']>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingCostMoney?: Maybe<Money>;
  state: Scalars['String']['output'];
  totalAmountBrut: Scalars['Float']['output'];
  totalAmountBrutMoney: Money;
  totalAmountNet: Scalars['Float']['output'];
  totalAmountNetMoney: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatAmount?: Maybe<Scalars['Float']['output']>;
  vatAmountMoney?: Maybe<Money>;
  vatRate?: Maybe<Scalars['Float']['output']>;
  vatRateIsCustom: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnquiryPartsRequireRfq */
export type EnquiryPartsRequireRfqInput = {
  attributes: OmsInputsEnquiriesPartsRequiredRfqType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquiryPartsRequireRfq. */
export type EnquiryPartsRequireRfqPayload = {
  __typename?: 'EnquiryPartsRequireRfqPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiryPartsRfqClearNeedInfo */
export type EnquiryPartsRfqClearNeedInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquiryPartsRfqClearNeedInfo. */
export type EnquiryPartsRfqClearNeedInfoPayload = {
  __typename?: 'EnquiryPartsRfqClearNeedInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiryPartsUpdateRfqFields */
export type EnquiryPartsUpdateRfqFieldsInput = {
  attributes: OmsInputsEnquiriesPartsRfqType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
  unlinkOffer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EnquiryPartsUpdateRfqFields. */
export type EnquiryPartsUpdateRfqFieldsPayload = {
  __typename?: 'EnquiryPartsUpdateRfqFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiryPromotionsExport */
export type EnquiryPromotionsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of EnquiryPromotionsExport. */
export type EnquiryPromotionsExportPayload = {
  __typename?: 'EnquiryPromotionsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of EnquirySyncForRfq */
export type EnquirySyncForRfqInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnquirySyncForRfq. */
export type EnquirySyncForRfqPayload = {
  __typename?: 'EnquirySyncForRfqPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of EnquiryTransferForRfq */
export type EnquiryTransferForRfqInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
  toRegion: RegionEnum;
};

/** Autogenerated return type of EnquiryTransferForRfq. */
export type EnquiryTransferForRfqPayload = {
  __typename?: 'EnquiryTransferForRfqPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

export type ErpPermission = {
  __typename?: 'ErpPermission';
  action: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  group: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ErpPermissionsGrouped = {
  __typename?: 'ErpPermissionsGrouped';
  erpPermissions: Array<ErpPermission>;
  group: Scalars['String']['output'];
};

export type Error = {
  __typename?: 'Error';
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  active: Scalars['Boolean']['output'];
  author: User;
  content: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: EventType;
  id: Scalars['Int']['output'];
  sourceId: Scalars['Int']['output'];
  sourceType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EventType = {
  __typename?: 'EventType';
  content: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  dependence: DependenceEnum;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum EventsTypeEnum {
  /** Provider Order Event */
  PoLeadtimeEvent = 'po_leadtime_event',
  /** Production Event */
  ProductionEvent = 'production_event',
  /** Public Holiday Event */
  PublicHolidayEvent = 'public_holiday_event'
}

export type ExchangedRecommendation = {
  __typename?: 'ExchangedRecommendation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  recommendationMoney?: Maybe<Money>;
  success: Scalars['Boolean']['output'];
};

export type Export = {
  __typename?: 'Export';
  bankPayments: Array<BankPayment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  exportRows?: Maybe<Array<ExportRow>>;
  id: Scalars['ID']['output'];
  linesProcessed: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ExportBillingAccountType = {
  __typename?: 'ExportBillingAccountType';
  billingAccounts?: Maybe<Array<BillingAccount>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  exportType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  selectedObjects: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type ExportLogisticInvoiceType = {
  __typename?: 'ExportLogisticInvoiceType';
  accountingPeriod?: Maybe<Scalars['ISO8601Date']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  exportType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logisticInvoices?: Maybe<Array<LogisticInvoice>>;
  selectedObjects: Array<Scalars['ID']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type ExportProviderType = {
  __typename?: 'ExportProviderType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  exportType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  providers?: Maybe<Array<Provider>>;
  selectedObjects: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type ExportRow = {
  __typename?: 'ExportRow';
  amount: Scalars['Float']['output'];
  apiJson?: Maybe<Scalars['JSON']['output']>;
  bankPaymentExportId: Scalars['ID']['output'];
  bankPaymentId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentDetails?: Maybe<Scalars['JSON']['output']>;
  state: ExportRowStateEnum;
  transactionId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ExportRowStateEnum {
  /** completed */
  Completed = 'completed',
  /** failed */
  Failed = 'failed',
  /** pending */
  Pending = 'pending'
}

export type ExtendedMatch = {
  __typename?: 'ExtendedMatch';
  candidatesMatchedQuantity?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Error>;
  inquiryDetail?: Maybe<InquiryDetail>;
  matchCandidates?: Maybe<Array<MatchCandidate>>;
  matchDataCriteria?: Maybe<Scalars['String']['output']>;
};

export type FavoriteMaterialType = {
  __typename?: 'FavoriteMaterialType';
  id: Scalars['ID']['output'];
  materialTypeId: Scalars['ID']['output'];
  processId: Scalars['ID']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum FileDownloadStateEnum {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success'
}

/** Available file uploaders */
export enum FileUploadersEnum {
  /** common */
  Common = 'common',
  /** user_avatar */
  UserAvatar = 'user_avatar'
}

export enum FillEnquiryStatusEnum {
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  StoppedManually = 'stopped_manually'
}

export type Finance = {
  __typename?: 'Finance';
  advanceRequests: Scalars['Int']['output'];
  advancesWithOverdue: Scalars['Int']['output'];
  bankPaymentsIncomingNotApproved: Scalars['Int']['output'];
  bankPaymentsIncomingNotRecognized: Scalars['Int']['output'];
  bankPaymentsOutcomingNotAccepted: Scalars['Int']['output'];
  bankPaymentsOutcomingNotRecognized: Scalars['Int']['output'];
  bankPaymentsOutcomingPending: Scalars['Int']['output'];
  dealsWithOverdueGt30Days: Scalars['Int']['output'];
  iiOverpaid: Scalars['Int']['output'];
  iiPublishedNotInDatev: Scalars['Int']['output'];
  iiReadyForCheckAll: Scalars['Int']['output'];
  iiReadyForCheckPod1: Scalars['Int']['output'];
  iiReadyForCheckPod2: Scalars['Int']['output'];
  iiReadyForCheckPod3: Scalars['Int']['output'];
  iiReadyForCheckPod4: Scalars['Int']['output'];
  managerNeedFix: Scalars['Int']['output'];
  oiPublishedNotInDatev: Scalars['Int']['output'];
  oiReadyForCheck: Scalars['Int']['output'];
  ordersWithFailedBaValidation: Scalars['Int']['output'];
  outcomingInvoicesWithOverdue: Scalars['Int']['output'];
  partnerAccountChangeRequests: Scalars['Int']['output'];
  partnersStopPayouts: Scalars['Int']['output'];
  paymentsCompletedNotInDatev: Scalars['Int']['output'];
  payoutsCompletedNotInDatev: Scalars['Int']['output'];
  refundRequests: Scalars['Int']['output'];
  xcnReadyForCheck: Scalars['Int']['output'];
};

export type Finish = {
  __typename?: 'Finish';
  colors?: Maybe<Array<Color>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameVersions: Scalars['JSON']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  priceTag: Scalars['String']['output'];
  processId: Scalars['ID']['output'];
  ralEnabled?: Maybe<Scalars['Boolean']['output']>;
  restrictedMaterials: Array<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ForeignPart = {
  __typename?: 'ForeignPart';
  dealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  region: Scalars['String']['output'];
};

/** Autogenerated input type of FrameworkBatchesDelete */
export type FrameworkBatchesDeleteInput = {
  changeReason: BatchChangeReasonEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupBatchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of FrameworkBatchesDelete. */
export type FrameworkBatchesDeletePayload = {
  __typename?: 'FrameworkBatchesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of FrameworkBatchesExport */
export type FrameworkBatchesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of FrameworkBatchesExport. */
export type FrameworkBatchesExportPayload = {
  __typename?: 'FrameworkBatchesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of FrameworkBatchesGroupCreateOrUpdate */
export type FrameworkBatchesGroupCreateOrUpdateInput = {
  attributes: OmsInputsFrameworkBatchesGroupType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FrameworkBatchesGroupCreateOrUpdate. */
export type FrameworkBatchesGroupCreateOrUpdatePayload = {
  __typename?: 'FrameworkBatchesGroupCreateOrUpdatePayload';
  batchCollection: Array<BatchCollection>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Gauge = {
  __typename?: 'Gauge';
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  i18nKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mm: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Float']['output'];
};

/** Autogenerated input type of GenerateCsvBillingAccountsExport */
export type GenerateCsvBillingAccountsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateCsvBillingAccountsExport. */
export type GenerateCsvBillingAccountsExportPayload = {
  __typename?: 'GenerateCsvBillingAccountsExportPayload';
  base64File: Base64FileType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateCsvLogisticInvoicesExport */
export type GenerateCsvLogisticInvoicesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateCsvLogisticInvoicesExport. */
export type GenerateCsvLogisticInvoicesExportPayload = {
  __typename?: 'GenerateCsvLogisticInvoicesExportPayload';
  base64File: Base64FileType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateCsvProvidersExport */
export type GenerateCsvProvidersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateCsvProvidersExport. */
export type GenerateCsvProvidersExportPayload = {
  __typename?: 'GenerateCsvProvidersExportPayload';
  base64File: Base64FileType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GeneratePresignedUrl */
export type GeneratePresignedUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  type: FileUploadersEnum;
};

/** Autogenerated return type of GeneratePresignedUrl. */
export type GeneratePresignedUrlPayload = {
  __typename?: 'GeneratePresignedUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payload: Scalars['JSON']['output'];
};

export type GenericSerialized = {
  __typename?: 'GenericSerialized';
  type: GenericSerializedTypeEnum;
  value?: Maybe<Scalars['String']['output']>;
};

export enum GenericSerializedTypeEnum {
  /** Boolean */
  Boolean = 'Boolean',
  /** Float */
  Float = 'Float',
  /** ISO8601 Date */
  Iso8601Date = 'ISO8601Date',
  /** ISO8601 DateTime */
  Iso8601DateTime = 'ISO8601DateTime',
  /** Int */
  Int = 'Int',
  /** Arbitrary JSON data */
  Json = 'JSON',
  /** String */
  String = 'String'
}

export enum GerlachExportStateEnum {
  Finished = 'finished',
  Pending = 'pending',
  Processing = 'processing'
}

export type GlobalJobOffer = {
  __typename?: 'GlobalJobOffer';
  counterofferLeadtime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  counterofferLeadtimeWithDap?: Maybe<Scalars['ISO8601DateTime']['output']>;
  counterofferValue?: Maybe<Scalars['Float']['output']>;
  counterofferValueWithDap: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  dapCostsApprox: Scalars['Float']['output'];
  decidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  decisionDaysAgo?: Maybe<Scalars['Int']['output']>;
  decisionState: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leadtime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  leadtimeWithDap?: Maybe<Scalars['ISO8601DateTime']['output']>;
  logisticCostEst: Scalars['Float']['output'];
  provider: GlobalJobOfferProvider;
  region: Scalars['String']['output'];
  respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  responseComment?: Maybe<Scalars['String']['output']>;
  responseDaysAgo?: Maybe<Scalars['Int']['output']>;
  responseState: Scalars['String']['output'];
  totalPriceAfterLogistics: WorkspacesJobOffersTotalPriceType;
  totalPriceBeforeLogistics: WorkspacesJobOffersTotalPriceType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  valueWithDap: Scalars['Float']['output'];
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type GlobalJobOfferProvider = {
  __typename?: 'GlobalJobOfferProvider';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  metricsOrdersInProdCount?: Maybe<Scalars['Int']['output']>;
  metricsOrdersInProdValue?: Maybe<Scalars['Float']['output']>;
  metricsShippedOrdersCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  placingBoardCancellationRatio?: Maybe<Scalars['Float']['output']>;
  rankAne?: Maybe<Scalars['Float']['output']>;
  rankCancelRatio?: Maybe<Scalars['Float']['output']>;
  rankClaimRatio?: Maybe<Scalars['Float']['output']>;
  rankQuality?: Maybe<Scalars['Float']['output']>;
  rankTiming?: Maybe<Scalars['Float']['output']>;
  rankTimingRatio?: Maybe<Scalars['Float']['output']>;
  rankTotal?: Maybe<Scalars['Float']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

export type Grade = {
  __typename?: 'Grade';
  advicesLengthInHours: Scalars['Int']['output'];
  advicesPerMonth: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currencyPerPoint: Scalars['Float']['output'];
  freeCads: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  infinityAdvices: Scalars['Boolean']['output'];
  moneySpentNeeded: Scalars['Int']['output'];
  pointsPerCurrency: Scalars['Int']['output'];
  pointsPerInvite: Scalars['Int']['output'];
  rank: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type HelpLink = {
  __typename?: 'HelpLink';
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HsCodeDataset = {
  __typename?: 'HsCodeDataset';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: HsCodeDatasetsKindEnumType;
  partName?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of HsCodeDatasetsBulkConfirmHsCode */
export type HsCodeDatasetsBulkConfirmHsCodeInput = {
  arrayIds: Array<OmsInputsHsCodeDatasetConfirmType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of HsCodeDatasetsBulkConfirmHsCode. */
export type HsCodeDatasetsBulkConfirmHsCodePayload = {
  __typename?: 'HsCodeDatasetsBulkConfirmHsCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of HsCodeDatasetsBulkUpdate */
export type HsCodeDatasetsBulkUpdateInput = {
  attributesArray: Array<OmsInputsHsCodeDatasetBulkType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of HsCodeDatasetsBulkUpdate. */
export type HsCodeDatasetsBulkUpdatePayload = {
  __typename?: 'HsCodeDatasetsBulkUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  hsCodeDatasets?: Maybe<Array<HsCodeDataset>>;
};

/** Autogenerated input type of HsCodeDatasetsConfirmHsCode */
export type HsCodeDatasetsConfirmHsCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hsCodeDatasetId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
};

/** Autogenerated return type of HsCodeDatasetsConfirmHsCode. */
export type HsCodeDatasetsConfirmHsCodePayload = {
  __typename?: 'HsCodeDatasetsConfirmHsCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of HsCodeDatasetsCreate */
export type HsCodeDatasetsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hsCodeDataset: OmsInputsHsCodeDatasetType;
  partId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of HsCodeDatasetsCreate. */
export type HsCodeDatasetsCreatePayload = {
  __typename?: 'HsCodeDatasetsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  hsCodeDataset: HsCodeDataset;
};

/** Autogenerated input type of HsCodeDatasetsDestroy */
export type HsCodeDatasetsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of HsCodeDatasetsDestroy. */
export type HsCodeDatasetsDestroyPayload = {
  __typename?: 'HsCodeDatasetsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum HsCodeDatasetsKindEnumType {
  Auto = 'auto',
  Customer = 'customer',
  History = 'history',
  Manual = 'manual'
}

/** Autogenerated input type of HsCodeDatasetsRequestAutoDataset */
export type HsCodeDatasetsRequestAutoDatasetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
};

/** Autogenerated return type of HsCodeDatasetsRequestAutoDataset. */
export type HsCodeDatasetsRequestAutoDatasetPayload = {
  __typename?: 'HsCodeDatasetsRequestAutoDatasetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  hsCodeDataset: HsCodeDataset;
};

/** Autogenerated input type of HsCodeDatasetsResetConfirmationHsCode */
export type HsCodeDatasetsResetConfirmationHsCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
};

/** Autogenerated return type of HsCodeDatasetsResetConfirmationHsCode. */
export type HsCodeDatasetsResetConfirmationHsCodePayload = {
  __typename?: 'HsCodeDatasetsResetConfirmationHsCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of HsCodeDatasetsUpdate */
export type HsCodeDatasetsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  params: OmsInputsHsCodeDatasetType;
};

/** Autogenerated return type of HsCodeDatasetsUpdate. */
export type HsCodeDatasetsUpdatePayload = {
  __typename?: 'HsCodeDatasetsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  hsCodeDataset: HsCodeDataset;
};

/** Autogenerated input type of HsCodesExport */
export type HsCodesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of HsCodesExport. */
export type HsCodesExportPayload = {
  __typename?: 'HsCodesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Import = {
  __typename?: 'Import';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  importRows?: Maybe<Array<ImportRow>>;
  linesProcessed: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ImportRow = {
  __typename?: 'ImportRow';
  amount: Scalars['Float']['output'];
  bankPaymentId: Scalars['ID']['output'];
  bankPaymentImportId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentDetails?: Maybe<Scalars['JSON']['output']>;
  state: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IncomingEmail = {
  __typename?: 'IncomingEmail';
  attachments: Array<Attachment>;
  carbonCopyEmails: Array<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mailgunMessageId: Scalars['String']['output'];
  parsedContent?: Maybe<Scalars['String']['output']>;
  recognitionMethod: RecognitionMethodEnum;
  relatedAuthor?: Maybe<MessageUser>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of IncomingEmailCreateMessage */
export type IncomingEmailCreateMessageInput = {
  attributes: OmsInputsIncomingEmailsMessageType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IncomingEmailCreateMessage. */
export type IncomingEmailCreateMessagePayload = {
  __typename?: 'IncomingEmailCreateMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of IncomingEmailCreateSalesforceCase */
export type IncomingEmailCreateSalesforceCaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IncomingEmailCreateSalesforceCase. */
export type IncomingEmailCreateSalesforceCasePayload = {
  __typename?: 'IncomingEmailCreateSalesforceCasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of IncomingEmailDelete */
export type IncomingEmailDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IncomingEmailDelete. */
export type IncomingEmailDeletePayload = {
  __typename?: 'IncomingEmailDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IncomingEmailsSourceType = {
  __typename?: 'IncomingEmailsSourceType';
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IncomingInvoice = {
  __typename?: 'IncomingInvoice';
  allocatedAmountMoney: Money;
  amountLeftMoney: Money;
  attachedFiles: Array<AttachedFile>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNote: Scalars['Boolean']['output'];
  creditNotes?: Maybe<Array<IncomingInvoice>>;
  currency: Scalars['String']['output'];
  datevComment?: Maybe<Scalars['String']['output']>;
  datevVatCode?: Maybe<Scalars['String']['output']>;
  deal: Deal;
  dealId: Scalars['ID']['output'];
  dealProviderOrderId: Scalars['ID']['output'];
  dealValueMoney?: Maybe<Money>;
  displayName: Scalars['String']['output'];
  holdUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  intacctComment?: Maybe<Scalars['String']['output']>;
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  invoiceChecked?: Maybe<Scalars['JSON']['output']>;
  invoicePositions?: Maybe<Array<InvoicePosition>>;
  invoicePrepared?: Maybe<Scalars['JSON']['output']>;
  invoiceReady?: Maybe<Scalars['JSON']['output']>;
  isPartial: Scalars['Boolean']['output'];
  isPublishedInPa?: Maybe<Scalars['Boolean']['output']>;
  isStorno?: Maybe<Scalars['Boolean']['output']>;
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  needFixComment?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  numberErp: Scalars['String']['output'];
  overrideAccountingDataDisabled: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  payouts?: Maybe<Array<Payout>>;
  /** Cached provider data (from Incoming Invoice) */
  provider: IncomingInvoicesProviderType;
  providerActiveChangeRequestId?: Maybe<Scalars['ID']['output']>;
  providerBankDetails?: Maybe<Scalars['JSON']['output']>;
  providerBillingAddress?: Maybe<Scalars['JSON']['output']>;
  providerContact?: Maybe<Scalars['JSON']['output']>;
  providerOrder?: Maybe<ProviderOrder>;
  providerOrderId: Scalars['ID']['output'];
  refInvoice?: Maybe<IncomingInvoice>;
  refInvoiceDated?: Maybe<Scalars['ISO8601Date']['output']>;
  refInvoiceId?: Maybe<Scalars['ID']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  sachkontoNumber?: Maybe<Scalars['String']['output']>;
  selfBilling: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  totalAmountBrutto?: Maybe<Scalars['Float']['output']>;
  totalAmountBruttoMoney: Money;
  totalAmountNetto?: Maybe<Scalars['Float']['output']>;
  totalAmountNettoMoney: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validity?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['Float']['output']>;
  vatAmountMoney: Money;
  vatAvg?: Maybe<Scalars['Float']['output']>;
  vatPdfCorrectionRequired?: Maybe<Scalars['Boolean']['output']>;
  vatRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `self_billing` field */
  xometryIssuedCreditNote: Scalars['Boolean']['output'];
  xometryVatNumber?: Maybe<XometryVatNumber>;
};


export type IncomingInvoiceCreditNotesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type IncomingInvoicePayoutsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type IncomingInvoiceRefInvoiceArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type IncomingInvoiceExport = {
  __typename?: 'IncomingInvoiceExport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  incomingInvoices?: Maybe<Array<IncomingInvoice>>;
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of IncomingInvoicesBulkBankPaymentCreate */
export type IncomingInvoicesBulkBankPaymentCreateInput = {
  attributes: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of IncomingInvoicesBulkBankPaymentCreate. */
export type IncomingInvoicesBulkBankPaymentCreatePayload = {
  __typename?: 'IncomingInvoicesBulkBankPaymentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of IncomingInvoicesBulkDatevExport */
export type IncomingInvoicesBulkDatevExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of IncomingInvoicesBulkDatevExport. */
export type IncomingInvoicesBulkDatevExportPayload = {
  __typename?: 'IncomingInvoicesBulkDatevExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  export: IncomingInvoiceExport;
};

/** Autogenerated input type of IncomingInvoicesBulkGeneratePayouts */
export type IncomingInvoicesBulkGeneratePayoutsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of IncomingInvoicesBulkGeneratePayouts. */
export type IncomingInvoicesBulkGeneratePayoutsPayload = {
  __typename?: 'IncomingInvoicesBulkGeneratePayoutsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of IncomingInvoicesBulkIntacctExport */
export type IncomingInvoicesBulkIntacctExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of IncomingInvoicesBulkIntacctExport. */
export type IncomingInvoicesBulkIntacctExportPayload = {
  __typename?: 'IncomingInvoicesBulkIntacctExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  export: IntacctIncomingInvoiceExportType;
};

/** Autogenerated input type of IncomingInvoicesBulkMarkAsPaid */
export type IncomingInvoicesBulkMarkAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  invoiceIds: Array<Scalars['ID']['input']>;
  markAsRegistered: Scalars['Boolean']['input'];
  paidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  transactionType: Scalars['String']['input'];
};

/** Autogenerated return type of IncomingInvoicesBulkMarkAsPaid. */
export type IncomingInvoicesBulkMarkAsPaidPayload = {
  __typename?: 'IncomingInvoicesBulkMarkAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of IncomingInvoicesExport */
export type IncomingInvoicesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of IncomingInvoicesExport. */
export type IncomingInvoicesExportPayload = {
  __typename?: 'IncomingInvoicesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of IncomingInvoicesOverrideAccountingFields */
export type IncomingInvoicesOverrideAccountingFieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  sachkontoNumber?: InputMaybe<Scalars['String']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
  vatPercent: Scalars['Int']['input'];
  xometryVatCountry?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of IncomingInvoicesOverrideAccountingFields. */
export type IncomingInvoicesOverrideAccountingFieldsPayload = {
  __typename?: 'IncomingInvoicesOverrideAccountingFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: IncomingInvoice;
};

export type IncomingInvoicesProviderType = {
  __typename?: 'IncomingInvoicesProviderType';
  bdoNumber?: Maybe<Scalars['String']['output']>;
  datevKonto?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  notVatPayer?: Maybe<Scalars['Boolean']['output']>;
  payoutTransferType?: Maybe<TransferEnum>;
  vatId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IncomingInvoicesReallocate */
export type IncomingInvoicesReallocateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reallocateTo: Array<OmsInputsIncomingInvoicesReallocateToType>;
};

/** Autogenerated return type of IncomingInvoicesReallocate. */
export type IncomingInvoicesReallocatePayload = {
  __typename?: 'IncomingInvoicesReallocatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payouts: Array<Payout>;
};

/** Autogenerated input type of IncomingInvoicesSendToIntacct */
export type IncomingInvoicesSendToIntacctInput = {
  attributes?: InputMaybe<OmsInputsIncomingInvoiceType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IncomingInvoicesSendToIntacct. */
export type IncomingInvoicesSendToIntacctPayload = {
  __typename?: 'IncomingInvoicesSendToIntacctPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: IncomingInvoice;
};

/** Autogenerated input type of IncomingInvoicesSendToMikrojump */
export type IncomingInvoicesSendToMikrojumpInput = {
  attributes?: InputMaybe<OmsInputsIncomingInvoiceType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IncomingInvoicesSendToMikrojump. */
export type IncomingInvoicesSendToMikrojumpPayload = {
  __typename?: 'IncomingInvoicesSendToMikrojumpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: IncomingInvoice;
};

export type Init = {
  __typename?: 'Init';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payoutTransferType: Scalars['String']['output'];
  providerId: Scalars['ID']['output'];
  providerName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type InputsMessengerMentionType = {
  id: Scalars['ID']['input'];
  type: AuthorEnumType;
};

export type InputsMoneyType = {
  amount: Scalars['String']['input'];
  amountCents: Scalars['String']['input'];
  currencyCode: CurrencyEnum;
};

export type InputsProvidersSearch = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  nameOrId?: InputMaybe<Scalars['String']['input']>;
  onlyResponded?: InputMaybe<Scalars['Boolean']['input']>;
  rfqNumber?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProviderStateEnum>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type InquiryDetail = {
  __typename?: 'InquiryDetail';
  duns?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  registrationNumberType?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IntacctEventsExport */
export type IntacctEventsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of IntacctEventsExport. */
export type IntacctEventsExportPayload = {
  __typename?: 'IntacctEventsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type IntacctIncomingInvoiceExportType = {
  __typename?: 'IntacctIncomingInvoiceExportType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  incomingInvoices?: Maybe<Array<IncomingInvoice>>;
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type IntacctOutcomingInvoiceExportType = {
  __typename?: 'IntacctOutcomingInvoiceExportType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  outcomingInvoices?: Maybe<Array<OutcomingInvoice>>;
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type IntacctZipStateType = {
  __typename?: 'IntacctZipStateType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zipState: ZipStateIntacctEnumType;
};

export type IntercompanyObject = {
  __typename?: 'IntercompanyObject';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealId?: Maybe<Scalars['ID']['output']>;
  foreignDealId?: Maybe<Scalars['ID']['output']>;
  foreignObjectId?: Maybe<Scalars['ID']['output']>;
  foreignObjectNumber?: Maybe<Scalars['String']['output']>;
  foreignObjectType: Scalars['String']['output'];
  foreignRegion: Scalars['String']['output'];
  foreignRole?: Maybe<RoleEnum>;
  id: Scalars['ID']['output'];
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  relationType?: Maybe<RelationEnum>;
  role?: Maybe<RoleEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IntercompanySalesCustomer = {
  __typename?: 'IntercompanySalesCustomer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerProjectNumber?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ID']['output'];
  foreignRegion: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationIsImportant?: Maybe<Scalars['Boolean']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNotes?: Maybe<Scalars['String']['output']>;
  organizationSalesforceId?: Maybe<Scalars['String']['output']>;
  organizationSalesforceUrl?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personLocale?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personSalesforceId?: Maybe<Scalars['String']['output']>;
  personSalesforceUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitee?: Maybe<Person>;
  inviteeEmail: Scalars['String']['output'];
  inviteeId?: Maybe<Scalars['ID']['output']>;
  pendingInvitee?: Maybe<Person>;
  person: Person;
  personId: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teamspaceRole?: Maybe<OmsTeamspaceRoleEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type InvoicePosition = {
  __typename?: 'InvoicePosition';
  accountingCategory: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  pricePerPieceMoney: Money;
  quantity: Scalars['Int']['output'];
  ref?: Maybe<Ref>;
  refId?: Maybe<Scalars['String']['output']>;
  refType?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatRate: Scalars['Float']['output'];
};

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerLotsValue: Scalars['Float']['output'];
  deal: Deal;
  id: Scalars['Int']['output'];
  number?: Maybe<Scalars['String']['output']>;
  providerOrder?: Maybe<ProviderOrder>;
  publicationEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publicationStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Float']['output'];
  valueCurrency: Scalars['String']['output'];
};

export type JobOffer = {
  __typename?: 'JobOffer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  jobId?: Maybe<Scalars['ID']['output']>;
  shipAllowDirectLegal?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectLegalXomSales?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectOrder?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectProvider?: Maybe<Scalars['Boolean']['output']>;
  shipDirection?: Maybe<ProviderOrdersShipDirectionEnum>;
  shipDirectionToEndCustomer?: Maybe<Scalars['Boolean']['output']>;
  shipIncoterms?: Maybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly: Scalars['Boolean']['output'];
  shipIncotermsCity?: Maybe<Scalars['String']['output']>;
  shipIncotermsCountry?: Maybe<Scalars['String']['output']>;
  shipQcRequired?: Maybe<Scalars['Boolean']['output']>;
  shipWarehouse?: Maybe<WarehouseInstructionEnum>;
  shippingInstructionsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingInstructionsUpdatedBy?: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of JobOffersExport */
export type JobOffersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of JobOffersExport. */
export type JobOffersExportPayload = {
  __typename?: 'JobOffersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of JobOffersShippingInstructionUpdates */
export type JobOffersShippingInstructionUpdatesInput = {
  attributes: OmsInputsShippingInstructions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of JobOffersShippingInstructionUpdates. */
export type JobOffersShippingInstructionUpdatesPayload = {
  __typename?: 'JobOffersShippingInstructionUpdatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobOffer: JobOffer;
};

export type JobStatistic = {
  __typename?: 'JobStatistic';
  applicationCount: Scalars['Int']['output'];
  autoAccepted: Scalars['Boolean']['output'];
  counterofferCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  irrelevantCount: Scalars['Int']['output'];
  offersCount: Scalars['Int']['output'];
  seenCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of JobsExport */
export type JobsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of JobsExport. */
export type JobsExportPayload = {
  __typename?: 'JobsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Kind enum type */
export enum KindEnum {
  /** Offer strategy kind job */
  Job = 'job',
  /** Offer strategy kind rfq */
  Rfq = 'rfq'
}

export type LabelsCollection = {
  __typename?: 'LabelsCollection';
  cs?: Maybe<Scalars['String']['output']>;
  da?: Maybe<Scalars['String']['output']>;
  de?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fi?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  it?: Maybe<Scalars['String']['output']>;
  nb?: Maybe<Scalars['String']['output']>;
  nl?: Maybe<Scalars['String']['output']>;
  pl?: Maybe<Scalars['String']['output']>;
  ptPt?: Maybe<Scalars['String']['output']>;
  sv?: Maybe<Scalars['String']['output']>;
  tr?: Maybe<Scalars['String']['output']>;
};

export enum LanguageEnum {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

export type LeadTime = {
  __typename?: 'LeadTime';
  date: Scalars['ISO8601Date']['output'];
};

export type LogisticInvoice = {
  __typename?: 'LogisticInvoice';
  allocatedSuccessfully: Money;
  amountBrutto: Money;
  amountNetto: Money;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<User>;
  creditNote: Scalars['Boolean']['output'];
  deliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  financeCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  financeCheckedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  invoiceFiles: Array<AttachedFile>;
  isImported: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  logisticOperatorBillingAccount?: Maybe<LogisticOperatorBillingAccount>;
  notAllocated: Money;
  notFullyAllocated: Money;
  number: Scalars['String']['output'];
  operationCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  operationCheckedBy?: Maybe<User>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  parentInvoice?: Maybe<LogisticInvoice>;
  paymentDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  positions: Array<LogisticInvoicePosition>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedBy?: Maybe<User>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Get related shippings for Logistic Invoice. */
  relatedShippings: PaginationResult;
  sourceFiles: Array<AttachedFile>;
  state: Scalars['String']['output'];
  totals: Array<LogisticInvoiceTotalItem>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type LogisticInvoiceRelatedShippingsArgs = {
  hideAllocated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of LogisticInvoiceDestroyAllRelatedShippings */
export type LogisticInvoiceDestroyAllRelatedShippingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of LogisticInvoiceDestroyAllRelatedShippings. */
export type LogisticInvoiceDestroyAllRelatedShippingsPayload = {
  __typename?: 'LogisticInvoiceDestroyAllRelatedShippingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of LogisticInvoiceFetchLogisticInvoiceRelatedShippings */
export type LogisticInvoiceFetchLogisticInvoiceRelatedShippingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  parentLogisticInvoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of LogisticInvoiceFetchLogisticInvoiceRelatedShippings. */
export type LogisticInvoiceFetchLogisticInvoiceRelatedShippingsPayload = {
  __typename?: 'LogisticInvoiceFetchLogisticInvoiceRelatedShippingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type LogisticInvoicePosition = {
  __typename?: 'LogisticInvoicePosition';
  amountBrutto: Money;
  amountNetto: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  positionType: LogisticInvoicePositionTypeEnum;
  taxInfo?: Maybe<LogisticInvoicePositionsTaxCode>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatAmount: Money;
  vatRate: Scalars['Float']['output'];
};

export enum LogisticInvoicePositionTypeEnum {
  /** Additional delivery costs */
  AdditionalCosts = 'additional_costs',
  /** Customs duties and import duties */
  CustomsAndImport = 'customs_and_import',
  /** Freight */
  Freight = 'freight',
  /** Import VAT (dummy account) */
  ImportVat = 'import_vat',
  /** Import VAT AT */
  ImportVatAt = 'import_vat_at',
  /** Import VAT BE */
  ImportVatBe = 'import_vat_be',
  /** Import VAT CH */
  ImportVatCh = 'import_vat_ch',
  /** Import VAT CN */
  ImportVatCn = 'import_vat_cn',
  /** Einfuhrumsatzsteuer */
  ImportVatDe = 'import_vat_de',
  /** Import VAT DK */
  ImportVatDk = 'import_vat_dk',
  /** Import VAT ES */
  ImportVatEs = 'import_vat_es',
  /** Import VAT FI */
  ImportVatFi = 'import_vat_fi',
  /** Import VAT FR */
  ImportVatFr = 'import_vat_fr',
  /** Import VAT IE */
  ImportVatIe = 'import_vat_ie',
  /** Import VAT IS */
  ImportVatIs = 'import_vat_is',
  /** Import VAT IT */
  ImportVatIt = 'import_vat_it',
  /** Import VAT NL */
  ImportVatNl = 'import_vat_nl',
  /** Import VAT NO */
  ImportVatNo = 'import_vat_no',
  /** Import VAT PL */
  ImportVatPl = 'import_vat_pl',
  /** Import VAT SE */
  ImportVatSe = 'import_vat_se',
  /** Import VAT UK */
  ImportVatUk = 'import_vat_uk',
  /** Other Operating Expenses */
  OtherOperatingExpenses = 'other_operating_expenses',
  /** Services on customs duties */
  Services = 'services'
}

export type LogisticInvoicePositionsPosition = {
  __typename?: 'LogisticInvoicePositionsPosition';
  datevAccount: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LogisticInvoicePositionsTaxCode = {
  __typename?: 'LogisticInvoicePositionsTaxCode';
  code?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  percent: Scalars['String']['output'];
};

export type LogisticInvoiceRelatedShipping = {
  __typename?: 'LogisticInvoiceRelatedShipping';
  allocatedCharges?: Maybe<Money>;
  allocatedCosts: Array<LogisticInvoiceRelatedShipping>;
  amountBrutto: Money;
  amountNetto: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvDataRaw?: Maybe<Scalars['String']['output']>;
  csvImportId?: Maybe<Scalars['Int']['output']>;
  csvImportLineNumber?: Maybe<Scalars['Int']['output']>;
  expenseType: LogisticInvoicePositionTypeEnum;
  id: Scalars['ID']['output'];
  logisticInvoice?: Maybe<LogisticInvoice>;
  shipping?: Maybe<Shipping>;
  shortExpenseType: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LogisticInvoiceTotalItem = {
  __typename?: 'LogisticInvoiceTotalItem';
  allocated: Money;
  byLines: Money;
  expenseType: LogisticInvoicePositionTypeEnum;
  id: Scalars['ID']['output'];
  notAllocated: Money;
  onInvoice: Money;
};

/** Autogenerated input type of LogisticInvoicesBulkCreateBankPayment */
export type LogisticInvoicesBulkCreateBankPaymentInput = {
  attributes: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of LogisticInvoicesBulkCreateBankPayment. */
export type LogisticInvoicesBulkCreateBankPaymentPayload = {
  __typename?: 'LogisticInvoicesBulkCreateBankPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of LogisticInvoicesBulkMarkAsCanceled */
export type LogisticInvoicesBulkMarkAsCanceledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteRelatedShippings?: InputMaybe<Scalars['Boolean']['input']>;
  logisticInvoicesIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of LogisticInvoicesBulkMarkAsCanceled. */
export type LogisticInvoicesBulkMarkAsCanceledPayload = {
  __typename?: 'LogisticInvoicesBulkMarkAsCanceledPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of LogisticInvoicesBulkMarkAsPaid */
export type LogisticInvoicesBulkMarkAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logisticInvoicesIds: Array<Scalars['ID']['input']>;
  paidAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of LogisticInvoicesBulkMarkAsPaid. */
export type LogisticInvoicesBulkMarkAsPaidPayload = {
  __typename?: 'LogisticInvoicesBulkMarkAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of LogisticInvoicesBulkMarkAsRegistered */
export type LogisticInvoicesBulkMarkAsRegisteredInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logisticInvoicesIds: Array<Scalars['ID']['input']>;
  registeredAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of LogisticInvoicesBulkMarkAsRegistered. */
export type LogisticInvoicesBulkMarkAsRegisteredPayload = {
  __typename?: 'LogisticInvoicesBulkMarkAsRegisteredPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of LogisticInvoicesCreateDatevExport */
export type LogisticInvoicesCreateDatevExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  durationTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  ids: Array<Scalars['ID']['input']>;
  period: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of LogisticInvoicesCreateDatevExport. */
export type LogisticInvoicesCreateDatevExportPayload = {
  __typename?: 'LogisticInvoicesCreateDatevExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  export?: Maybe<ExportLogisticInvoiceType>;
};

/** Autogenerated input type of LogisticInvoicesExport */
export type LogisticInvoicesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of LogisticInvoicesExport. */
export type LogisticInvoicesExportPayload = {
  __typename?: 'LogisticInvoicesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type LogisticOperator = {
  __typename?: 'LogisticOperator';
  createdAt: Scalars['ISO8601DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  kind: LogisticOperatorTypeEnum;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LogisticOperatorBillingAccount = {
  __typename?: 'LogisticOperatorBillingAccount';
  accountType: BillingAccountAccountTypeEnum;
  accountingSystemId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  directDebit: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logisticOperator: LogisticOperator;
  name: Scalars['String']['output'];
  payoutTransferType?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatId?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum LogisticOperatorTypeEnum {
  Aggregator = 'aggregator',
  Operator = 'operator'
}

export type Lot = {
  __typename?: 'Lot';
  claims: Array<Claim>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerPrice: Scalars['Float']['output'];
  customerPriceCurrency: CurrencyEnum;
  customerPriceMoney: Money;
  dealId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isPlaced: Scalars['Boolean']['output'];
  isUsed: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  part: Part;
  partId: Scalars['Int']['output'];
  providerOrder?: Maybe<ProviderOrder>;
  providerPrice: Scalars['Float']['output'];
  providerPriceCurrency: CurrencyEnum;
  providerPriceMoney: Money;
  quantity: Scalars['Int']['output'];
  shipping?: Maybe<Shipping>;
  source?: Maybe<Source>;
  sourceId?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatRate: Scalars['Float']['output'];
};


export type LotCustomerPriceMoneyArgs = {
  currencyCode?: InputMaybe<CurrencyEnum>;
};


export type LotProviderPriceMoneyArgs = {
  currencyCode?: InputMaybe<CurrencyEnum>;
};

export type Loyalty = {
  __typename?: 'Loyalty';
  xPointsCurrencyCoef: Scalars['Float']['output'];
};

export type LoyaltyBalance = {
  __typename?: 'LoyaltyBalance';
  /** depricated, please load grades separately */
  configs?: Maybe<Array<Grade>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  hasPending: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invites?: Maybe<Array<Invite>>;
  level: Grade;
  moneySaved: Scalars['Float']['output'];
  moneySpent: Scalars['Float']['output'];
  points: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
  pointsPending: Scalars['Int']['output'];
  pointsSpent: Scalars['Int']['output'];
  pointsToBeExpired: Scalars['Int']['output'];
  tillNextLevel: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of LoyaltyTransactionsCreate */
export type LoyaltyTransactionsCreateInput = {
  attributes: OmsInputsLoyaltyTransactionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of LoyaltyTransactionsCreate. */
export type LoyaltyTransactionsCreatePayload = {
  __typename?: 'LoyaltyTransactionsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  transaction: Transaction;
};

export enum LoyaltyTransactionsReferenceEnumType {
  Claim = 'Claim',
  Deal = 'Deal',
  Person = 'Person',
  Teamspace = 'Teamspace'
}

export enum LoyaltyTransactionsTriggerEnumType {
  BalanceReset = 'balance_reset',
  Compensation = 'compensation',
  Correction = 'correction',
  Coupon = 'coupon',
  Expiration = 'expiration',
  Invite = 'invite',
  Lost = 'lost',
  Marketing = 'marketing',
  Ordered = 'ordered',
  TeamspaceTransfer = 'teamspace_transfer',
  Transfer = 'transfer'
}

export enum LoyaltyTransactionsTypeEnumType {
  Inflow = 'inflow',
  Outflow = 'outflow'
}

export type ManagerTemplateGroupType = {
  __typename?: 'ManagerTemplateGroupType';
  allowEdit: Scalars['Boolean']['output'];
  /** abbreviated as "BCC" */
  blindCarbonCopy?: Maybe<Array<Scalars['String']['output']>>;
  /** abbreviated as "CC" */
  carbonCopy?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<TemplateCategory>;
  constantName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  direction: TemplateDirectionEnum;
  id: Scalars['ID']['output'];
  messageActionsGroup?: Maybe<MessageActionsGroup>;
  name?: Maybe<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  shared: Scalars['Boolean']['output'];
  templates: Array<Template>;
  type: TemplateTypeEnum;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of MarkAsAccrual */
export type MarkAsAccrualInput = {
  accrualAt: Scalars['ISO8601Date']['input'];
  attributes?: InputMaybe<OmsInputsOutcomingInvoiceType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkAsAccrual. */
export type MarkAsAccrualPayload = {
  __typename?: 'MarkAsAccrualPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

/** Autogenerated input type of MarkAsRegisteredBillingAccountsExport */
export type MarkAsRegisteredBillingAccountsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
  objectIds: Array<Scalars['ID']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  registeredAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of MarkAsRegisteredBillingAccountsExport. */
export type MarkAsRegisteredBillingAccountsExportPayload = {
  __typename?: 'MarkAsRegisteredBillingAccountsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exportBillingAccounts: Array<BillingAccount>;
};

/** Autogenerated input type of MarkAsRegisteredLogisticInvoicesExport */
export type MarkAsRegisteredLogisticInvoicesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  objectIds: Array<Scalars['ID']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  registeredAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of MarkAsRegisteredLogisticInvoicesExport. */
export type MarkAsRegisteredLogisticInvoicesExportPayload = {
  __typename?: 'MarkAsRegisteredLogisticInvoicesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoices: Array<LogisticInvoice>;
};

/** Autogenerated input type of MarkAsRegisteredProvidersExport */
export type MarkAsRegisteredProvidersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
  objectIds: Array<Scalars['ID']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  registeredAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of MarkAsRegisteredProvidersExport. */
export type MarkAsRegisteredProvidersExportPayload = {
  __typename?: 'MarkAsRegisteredProvidersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exportProviders: Array<Provider>;
};

export type MasterShipping = {
  __typename?: 'MasterShipping';
  actualDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  actualShipmentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  allocateDiscountsAndSurcharges: Scalars['Boolean']['output'];
  attachedFiles: Array<AttachedFile>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customsClearanceStatus: ShippingCustomsClearanceStatusEnum;
  customsClearanceStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customsDocumentsStatus: ShippingCustomsDocumentsStatusEnum;
  deliveryBasis?: Maybe<ShippingDeliveryBasisEnum>;
  deliveryType?: Maybe<ShippingDeliveryTypeEnum>;
  destinationAddress?: Maybe<DealShippingAddressType>;
  direction: ShippingDirectionEnum;
  expectedDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expectedShipmentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expectedShipmentTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  gerlachExportState: GerlachExportStateEnum;
  gstInvoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  gstInvoiceNumber?: Maybe<Scalars['String']['output']>;
  holdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  holdBy?: Maybe<User>;
  holdById?: Maybe<Scalars['BigInt']['output']>;
  holdUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  isExport: Scalars['Boolean']['output'];
  isImport: Scalars['Boolean']['output'];
  isImportAndExport: Scalars['Boolean']['output'];
  logisticAggregator?: Maybe<Scalars['String']['output']>;
  logisticAggregatorRef?: Maybe<LogisticOperator>;
  logisticOperator?: Maybe<Scalars['String']['output']>;
  logisticOperatorRef?: Maybe<LogisticOperator>;
  movementReferenceNumber?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  positionNaming: ShippingPositionNamingEnum;
  proofOfDeliveryScheduled: Scalars['Boolean']['output'];
  proofOfDeliverySkipped: Scalars['Boolean']['output'];
  shippingAlertAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingAlertBy?: Maybe<User>;
  shippingAlertById?: Maybe<Scalars['BigInt']['output']>;
  shippingAlertMessage?: Maybe<Scalars['String']['output']>;
  shippingCost: Money;
  shippingOption?: Maybe<Scalars['String']['output']>;
  shippingOrderNumber?: Maybe<Scalars['String']['output']>;
  shippingParameters?: Maybe<Array<ShippingParameters>>;
  shippings: Array<Shipping>;
  sourceAddress?: Maybe<DealShippingAddressType>;
  state: ShippingStateEnum;
  trackingCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  trackingLink?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingRecords: Array<ShippingTrackingRecord>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  weightBruttoKg: Scalars['Float']['output'];
  weightNettoKg: Scalars['Float']['output'];
  xometryNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MasterShippingsCreateFromShipping */
export type MasterShippingsCreateFromShippingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of MasterShippingsCreateFromShipping. */
export type MasterShippingsCreateFromShippingPayload = {
  __typename?: 'MasterShippingsCreateFromShippingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping: MasterShipping;
};

/** Autogenerated input type of MasterShippingsCreate */
export type MasterShippingsCreateInput = {
  attributes: OmsInputsMasterShippingType;
  childrenIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MasterShippingsCreate. */
export type MasterShippingsCreatePayload = {
  __typename?: 'MasterShippingsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping: MasterShipping;
};

/** Autogenerated input type of MasterShippingsShipmentOrderCreateDhlOrder */
export type MasterShippingsShipmentOrderCreateDhlOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  destinationAddress: OmsInputsShipmentOrderDhlAddressType;
  expectedDeliveryDate: Scalars['ISO8601Date']['input'];
  masterShippingId: Scalars['ID']['input'];
  movementReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  operator: Scalars['String']['input'];
  pickupOptions: OmsInputsShipmentOrderPickupOptionsType;
  plannedShippingDate: Scalars['ISO8601DateTime']['input'];
  productCode: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  sourceAddress: OmsInputsShipmentOrderDhlAddressType;
};

/** Autogenerated return type of MasterShippingsShipmentOrderCreateDhlOrder. */
export type MasterShippingsShipmentOrderCreateDhlOrderPayload = {
  __typename?: 'MasterShippingsShipmentOrderCreateDhlOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of MasterShippingsShipmentOrderRequestShippingOptions */
export type MasterShippingsShipmentOrderRequestShippingOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAddress: OmsInputsShipmentOrderAddressType;
  masterShippingId: Scalars['ID']['input'];
  operators: Array<ShipmentOrderOperatorsEnum>;
  packages: Array<OmsInputsShipmentOrderPackageType>;
  plannedShippingDate: Scalars['ISO8601Date']['input'];
  sourceAddress: OmsInputsShipmentOrderAddressType;
};

/** Autogenerated return type of MasterShippingsShipmentOrderRequestShippingOptions. */
export type MasterShippingsShipmentOrderRequestShippingOptionsPayload = {
  __typename?: 'MasterShippingsShipmentOrderRequestShippingOptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of MasterShippingsUpdate */
export type MasterShippingsUpdateInput = {
  attributes: OmsInputsMasterShippingType;
  childrenIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MasterShippingsUpdate. */
export type MasterShippingsUpdatePayload = {
  __typename?: 'MasterShippingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping: MasterShipping;
};

/** Autogenerated input type of MasterShippingsUpdateTracking */
export type MasterShippingsUpdateTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  masterShippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of MasterShippingsUpdateTracking. */
export type MasterShippingsUpdateTrackingPayload = {
  __typename?: 'MasterShippingsUpdateTrackingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping?: Maybe<MasterShipping>;
};

export type MatchCandidate = {
  __typename?: 'MatchCandidate';
  displaySequence: Scalars['Int']['output'];
  organization: OrganizationData;
};

export type Material = {
  __typename?: 'Material';
  active: Scalars['Boolean']['output'];
  customShoreHardness?: Maybe<Scalars['String']['output']>;
  /** moving to dictionaries */
  gauges: Array<MaterialGauge>;
  gaugesNew: Array<Gauge>;
  hardware: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ingredient?: Maybe<Scalars['String']['output']>;
  materialType: MaterialType;
  materialTypeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  partMarkings?: Maybe<Scalars['JSON']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  process: OmsEnquiryProcessType;
  shoreHardnesses: Array<ShoreHardness>;
  /** moving to dictionaries */
  surfaceRoughness?: Maybe<Scalars['JSON']['output']>;
  surfaceRoughnesses: Array<SurfaceRoughness>;
  threading: Scalars['Boolean']['output'];
  /** moving to dictionaries */
  tolerance?: Maybe<Scalars['JSON']['output']>;
  tolerancesNew: Array<Tolerance>;
  weldQuantity: Scalars['Boolean']['output'];
};

export type MaterialGauge = {
  __typename?: 'MaterialGauge';
  default?: Maybe<Scalars['Boolean']['output']>;
  iqeValue?: Maybe<Scalars['String']['output']>;
  mm?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MaterialType = {
  __typename?: 'MaterialType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  process: OmsEnquiryProcessType;
};

export type Member = {
  __typename?: 'Member';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** deprecated, use person.email instead */
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  joinedAt: Scalars['ISO8601DateTime']['output'];
  lastActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** deprecated, use person.name instead */
  name: Scalars['String']['output'];
  person: Person;
  personId: Scalars['ID']['output'];
  role: OmsTeamspaceRoleEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum MembershipTypeEnum {
  Approver = 'approver',
  Intern = 'intern',
  Lead = 'lead',
  Member = 'member',
  Observer = 'observer'
}

/** Mention inside a message (User, Person, Provider, etc.) */
export type MentionType = {
  __typename?: 'MentionType';
  /** ID of the mentioned entity */
  id: Scalars['ID']['output'];
  /** Type of the mentioned entity (e.g. User, Person) */
  type: AuthorEnumType;
};

/** Represents an entity (user or customer) that can be mentioned in a message */
export type MentionableType = {
  __typename?: 'MentionableType';
  /** URL to the avatar image */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Email of the entity */
  email?: Maybe<Scalars['String']['output']>;
  /** ID of the mentionable entity */
  id: Scalars['ID']['output'];
  /** Job title of the entity */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Name of the entity */
  name: Scalars['String']['output'];
  /** Type of the entity (USER, CUSTOMER, etc.) */
  type: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  allowEdit: Scalars['Boolean']['output'];
  attachments: Array<Attachment>;
  author: MessageUser;
  authorId: Scalars['ID']['output'];
  authorType: UserEnum;
  availableActions: Array<MessageAvailableAction>;
  containsUnsafeLink: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  contentRaw?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ID']['output']>;
  dealPage?: Maybe<Scalars['Int']['output']>;
  dealTitle?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  editedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isBookmark: Scalars['Boolean']['output'];
  isVisibleToClient: Scalars['Boolean']['output'];
  isVisibleToPartner: Scalars['Boolean']['output'];
  isWhatsAppMessageError: Scalars['Boolean']['output'];
  mentions: Array<MentionType>;
  pinned: Scalars['Boolean']['output'];
  replyOn?: Maybe<MessageReply>;
  source?: Maybe<MessageSource>;
  sourcePage: Scalars['Int']['output'];
  task?: Maybe<MessageTask>;
  type?: Maybe<MessageTypeEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageAction = {
  __typename?: 'MessageAction';
  action: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  labels: LabelsCollection;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageActionsGroup = {
  __typename?: 'MessageActionsGroup';
  actions: Array<MessageAction>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  templateType?: Maybe<TemplateTypeEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageAvailableAction = {
  __typename?: 'MessageAvailableAction';
  action: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  messageId: Scalars['BigInt']['output'];
  position: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageCollection = {
  __typename?: 'MessageCollection';
  collection: Array<Message>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum MessageDirectionEnum {
  C2X = 'C2X',
  P2X = 'P2X',
  X2C = 'X2C',
  X2P = 'X2P',
  X2X = 'X2X'
}

export type MessageFilter = {
  __typename?: 'MessageFilter';
  authorType?: Maybe<UserEnum>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  direction?: Maybe<MessageDirectionEnum>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ignoreCounters: Scalars['Boolean']['output'];
  messageType?: Maybe<MessageFilterTypeEnum>;
  muteNotifications: Scalars['Boolean']['output'];
  sourceType?: Maybe<MessageSourceTypeEnum>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageFilterGroup = {
  __typename?: 'MessageFilterGroup';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  filters?: Maybe<Array<MessageFilter>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum MessageFilterTypeEnum {
  AiCopilot = 'AI_COPILOT',
  DocumentNote = 'DOCUMENT_NOTE',
  General = 'GENERAL',
  IncomingEmail = 'INCOMING_EMAIL',
  JobSpecialOffer = 'JOB_SPECIAL_OFFER',
  OutcomingEmail = 'OUTCOMING_EMAIL',
  PricingWizard = 'PRICING_WIZARD',
  RfqOfferSubmitComment = 'RFQ_OFFER_SUBMIT_COMMENT',
  RfqProcessComment = 'RFQ_PROCESS_COMMENT',
  Robot = 'ROBOT',
  TaskCall = 'TASK_CALL',
  TaskChangesInDeal = 'TASK_CHANGES_IN_DEAL',
  TaskCheckingMaterialCertificate = 'TASK_CHECKING_MATERIAL_CERTIFICATE',
  TaskCheckingMeasurementProtocol = 'TASK_CHECKING_MEASUREMENT_PROTOCOL',
  TaskCheckpoint = 'TASK_CHECKPOINT',
  TaskCheckStatus = 'TASK_CHECK_STATUS',
  TaskCreateDocument = 'TASK_CREATE_DOCUMENT',
  TaskDiscussIssue = 'TASK_DISCUSS_ISSUE',
  TaskDrawing = 'TASK_DRAWING',
  TaskGeneral = 'TASK_GENERAL',
  TaskInvoiceIssue = 'TASK_INVOICE_ISSUE',
  TaskMolding = 'TASK_MOLDING',
  TaskPlacingIssues = 'TASK_PLACING_ISSUES',
  TaskPlacingRepeatDeal = 'TASK_PLACING_REPEAT_DEAL',
  TaskReplacingRequest = 'TASK_REPLACING_REQUEST',
  TaskRequestApprove = 'TASK_REQUEST_APPROVE',
  TaskRevenueForecastDiff = 'TASK_REVENUE_FORECAST_DIFF',
  TaskShipping = 'TASK_SHIPPING',
  TaskTalkToCustomer = 'TASK_TALK_TO_CUSTOMER',
  TaskTalkToPartner = 'TASK_TALK_TO_PARTNER',
  VqcReport = 'VQC_REPORT',
  Whatsapp = 'WHATSAPP'
}

export type MessageReply = {
  __typename?: 'MessageReply';
  authorId: Scalars['ID']['output'];
  authorType: UserEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  previewText: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageSource = {
  __typename?: 'MessageSource';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerLastReadMessageId?: Maybe<Scalars['ID']['output']>;
  customerWhatsAppStatus?: Maybe<WhatsAppStatusEnum>;
  dealId?: Maybe<Scalars['ID']['output']>;
  dealOrganizationName?: Maybe<Scalars['String']['output']>;
  dealPersonId?: Maybe<Scalars['ID']['output']>;
  dealTitle?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  followingUserIds: Array<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  isOrderConfirmationPublished?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<MessageSource>;
  partnerLastReadMessageId?: Maybe<Scalars['ID']['output']>;
  replyRequired?: Maybe<ReplyRequired>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  teamspaceId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unreadMessagesCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum MessageSourceTypeEnum {
  BillingAccount = 'BILLING_ACCOUNT',
  Deal = 'DEAL',
  DealClaim = 'DEAL_CLAIM',
  DealIncomingInvoice = 'DEAL_INCOMING_INVOICE',
  DealOrderConfirmation = 'DEAL_ORDER_CONFIRMATION',
  DealOutcomingInvoice = 'DEAL_OUTCOMING_INVOICE',
  DealPart = 'DEAL_PART',
  DealPayment = 'DEAL_PAYMENT',
  DealPayout = 'DEAL_PAYOUT',
  DealProviderOrder = 'DEAL_PROVIDER_ORDER',
  DealQualityControl = 'DEAL_QUALITY_CONTROL',
  DealShipping = 'DEAL_SHIPPING',
  DealStorage = 'DEAL_STORAGE',
  Enquiry = 'ENQUIRY',
  EnquiryPart = 'ENQUIRY_PART',
  GshJobOffer = 'GSH_JOB_OFFER',
  Job = 'JOB',
  JobOffer = 'JOB_OFFER',
  MasterShipping = 'MASTER_SHIPPING',
  Person = 'PERSON',
  Provider = 'PROVIDER',
  Rfq = 'RFQ',
  RfqOffer = 'RFQ_OFFER'
}

/** Autogenerated input type of MessageSubscriptionsBulkActionsMarkAllRead */
export type MessageSubscriptionsBulkActionsMarkAllReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MessageSubscriptionsBulkActionsMarkAllRead. */
export type MessageSubscriptionsBulkActionsMarkAllReadPayload = {
  __typename?: 'MessageSubscriptionsBulkActionsMarkAllReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MessageSubscriptionsBulkActionsSubscribe */
export type MessageSubscriptionsBulkActionsSubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriberId: Scalars['ID']['input'];
  subscriptions: Array<OmsInputsMessageSubscriptionsSubscriptionType>;
};

/** Autogenerated return type of MessageSubscriptionsBulkActionsSubscribe. */
export type MessageSubscriptionsBulkActionsSubscribePayload = {
  __typename?: 'MessageSubscriptionsBulkActionsSubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MessageSubscriptionsBulkActionsUnsubscribe */
export type MessageSubscriptionsBulkActionsUnsubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriberId: Scalars['ID']['input'];
  subscriptions: Array<OmsInputsMessageSubscriptionsSubscriptionType>;
};

/** Autogenerated return type of MessageSubscriptionsBulkActionsUnsubscribe. */
export type MessageSubscriptionsBulkActionsUnsubscribePayload = {
  __typename?: 'MessageSubscriptionsBulkActionsUnsubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MessageTask = {
  __typename?: 'MessageTask';
  assignees: Array<Scalars['ID']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use deadline_date instead */
  deadline?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deadlineDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['Int']['output'];
  priority?: Maybe<Priority>;
  setAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  taskStatus?: Maybe<TaskStatusEnum>;
  taskType?: Maybe<TaskType>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageTemplateGroupCollection = {
  __typename?: 'MessageTemplateGroupCollection';
  collection: Array<ManagerTemplateGroupType>;
  total: Scalars['Int']['output'];
};

export enum MessageTypeEnum {
  AiCopilot = 'ai_copilot',
  DocumentNote = 'document_note',
  General = 'general',
  IncomingEmail = 'incoming_email',
  JobSpecialOffer = 'job_special_offer',
  OutcomingEmail = 'outcoming_email',
  PricingWizard = 'pricing_wizard',
  RfqOfferSubmitComment = 'rfq_offer_submit_comment',
  RfqProcessComment = 'rfq_process_comment',
  Robot = 'robot',
  TaskCall = 'task_call',
  TaskChangesInDeal = 'task_changes_in_deal',
  TaskCheckCustomerNotes = 'task_check_customer_notes',
  TaskCheckStatus = 'task_check_status',
  TaskCheckingMaterialCertificate = 'task_checking_material_certificate',
  TaskCheckingMeasurementProtocol = 'task_checking_measurement_protocol',
  TaskCheckpoint = 'task_checkpoint',
  TaskCreateDocument = 'task_create_document',
  TaskDiscussIssue = 'task_discuss_issue',
  TaskDrawing = 'task_drawing',
  TaskGeneral = 'task_general',
  TaskInvoiceIssue = 'task_invoice_issue',
  TaskMolding = 'task_molding',
  TaskPlacingIssues = 'task_placing_issues',
  TaskPlacingRepeatDeal = 'task_placing_repeat_deal',
  TaskReplacingRequest = 'task_replacing_request',
  TaskRequestApprove = 'task_request_approve',
  TaskRevenueForecastDiff = 'task_revenue_forecast_diff',
  TaskShipping = 'task_shipping',
  TaskTalkToCustomer = 'task_talk_to_customer',
  TaskTalkToPartner = 'task_talk_to_partner',
  VqcReport = 'vqc_report',
  Whatsapp = 'whatsapp'
}

export type MessageUser = {
  __typename?: 'MessageUser';
  absence: AbsenceStatusEnum;
  absenceFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  absenceName?: Maybe<Scalars['String']['output']>;
  absenceUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deputyUsers: Array<MessageUser>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  isRobot?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  teamspaces?: Maybe<Array<TeamspaceMembership>>;
  type: UserEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MessagesExport */
export type MessagesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of MessagesExport. */
export type MessagesExportPayload = {
  __typename?: 'MessagesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum MessagesWorkspaceAuthorTypeEnum {
  Client = 'CLIENT',
  ExternalContact = 'EXTERNAL_CONTACT',
  Partner = 'PARTNER',
  Xometry = 'XOMETRY'
}

/** Autogenerated input type of MessengerAttachmentsUpload */
export type MessengerAttachmentsUploadInput = {
  attachments: Array<OmsInputsMessengerAttachmentType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerAttachmentsUpload. */
export type MessengerAttachmentsUploadPayload = {
  __typename?: 'MessengerAttachmentsUploadPayload';
  attachments: Array<Attachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MessengerChannelMarkRead */
export type MessengerChannelMarkReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lastReadMessageId?: InputMaybe<Scalars['ID']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerChannelMarkRead. */
export type MessengerChannelMarkReadPayload = {
  __typename?: 'MessengerChannelMarkReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  source: MessageSource;
};

/** Autogenerated input type of MessengerChannelMarkUnread */
export type MessengerChannelMarkUnreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lastReadMessageId?: InputMaybe<Scalars['ID']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerChannelMarkUnread. */
export type MessengerChannelMarkUnreadPayload = {
  __typename?: 'MessengerChannelMarkUnreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  source: MessageSource;
};

/** Autogenerated input type of MessengerChannelSubscribe */
export type MessengerChannelSubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerChannelSubscribe. */
export type MessengerChannelSubscribePayload = {
  __typename?: 'MessengerChannelSubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  source: MessageSource;
};

/** Autogenerated input type of MessengerChannelUnsubscribe */
export type MessengerChannelUnsubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerChannelUnsubscribe. */
export type MessengerChannelUnsubscribePayload = {
  __typename?: 'MessengerChannelUnsubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  source: MessageSource;
};

/** Autogenerated input type of MessengerConversationClearReplyRequired */
export type MessengerConversationClearReplyRequiredInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  forPartner?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerConversationClearReplyRequired. */
export type MessengerConversationClearReplyRequiredPayload = {
  __typename?: 'MessengerConversationClearReplyRequiredPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation: Conversation;
};

/** Autogenerated input type of MessengerMessageBookmark */
export type MessengerMessageBookmarkInput = {
  bookmark: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageBookmark. */
export type MessengerMessageBookmarkPayload = {
  __typename?: 'MessengerMessageBookmarkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageCreateFromTemplate */
export type MessengerMessageCreateFromTemplateInput = {
  attributes: OmsInputsMessengerTemplatedMessageType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageCreateFromTemplate. */
export type MessengerMessageCreateFromTemplatePayload = {
  __typename?: 'MessengerMessageCreateFromTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageCreate */
export type MessengerMessageCreateInput = {
  attributes: OmsInputsMessengerMessageType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerMessageCreate. */
export type MessengerMessageCreatePayload = {
  __typename?: 'MessengerMessageCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageDelete */
export type MessengerMessageDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageDelete. */
export type MessengerMessageDeletePayload = {
  __typename?: 'MessengerMessageDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageFilterAssignUser */
export type MessengerMessageFilterAssignUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageFilterIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageFilterAssignUser. */
export type MessengerMessageFilterAssignUserPayload = {
  __typename?: 'MessengerMessageFilterAssignUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageFilters: Array<MessageFilter>;
};

/** Autogenerated input type of MessengerMessageFilterCreate */
export type MessengerMessageFilterCreateInput = {
  attributes: OmsInputsMessengerMessageFilterType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerMessageFilterCreate. */
export type MessengerMessageFilterCreatePayload = {
  __typename?: 'MessengerMessageFilterCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageFilter: MessageFilter;
};

/** Autogenerated input type of MessengerMessageFilterDelete */
export type MessengerMessageFilterDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageFilterDelete. */
export type MessengerMessageFilterDeletePayload = {
  __typename?: 'MessengerMessageFilterDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MessengerMessageFilterGroupAssignUser */
export type MessengerMessageFilterGroupAssignUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageFilterGroupIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageFilterGroupAssignUser. */
export type MessengerMessageFilterGroupAssignUserPayload = {
  __typename?: 'MessengerMessageFilterGroupAssignUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageFilterGroups: Array<MessageFilterGroup>;
};

/** Autogenerated input type of MessengerMessageFilterGroupCreate */
export type MessengerMessageFilterGroupCreateInput = {
  attributes: OmsInputsMessengerMessageFilterGroupType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerMessageFilterGroupCreate. */
export type MessengerMessageFilterGroupCreatePayload = {
  __typename?: 'MessengerMessageFilterGroupCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageFilterGroup: MessageFilterGroup;
};

/** Autogenerated input type of MessengerMessageFilterGroupDelete */
export type MessengerMessageFilterGroupDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageFilterGroupDelete. */
export type MessengerMessageFilterGroupDeletePayload = {
  __typename?: 'MessengerMessageFilterGroupDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MessengerMessageFilterGroupUpdate */
export type MessengerMessageFilterGroupUpdateInput = {
  attributes: OmsInputsMessengerMessageFilterGroupType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerMessageFilterGroupUpdate. */
export type MessengerMessageFilterGroupUpdatePayload = {
  __typename?: 'MessengerMessageFilterGroupUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageFilterGroup: MessageFilterGroup;
};

/** Autogenerated input type of MessengerMessageFilterUpdate */
export type MessengerMessageFilterUpdateInput = {
  attributes: OmsInputsMessengerMessageFilterType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerMessageFilterUpdate. */
export type MessengerMessageFilterUpdatePayload = {
  __typename?: 'MessengerMessageFilterUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageFilter: MessageFilter;
};

/** Autogenerated input type of MessengerMessagePin */
export type MessengerMessagePinInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of MessengerMessagePin. */
export type MessengerMessagePinPayload = {
  __typename?: 'MessengerMessagePinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageSendOriginalContent */
export type MessengerMessageSendOriginalContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  toEmail: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerMessageSendOriginalContent. */
export type MessengerMessageSendOriginalContentPayload = {
  __typename?: 'MessengerMessageSendOriginalContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MessengerMessageTaskUpdateAssignees */
export type MessengerMessageTaskUpdateAssigneesInput = {
  assignees: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageTaskUpdateAssignees. */
export type MessengerMessageTaskUpdateAssigneesPayload = {
  __typename?: 'MessengerMessageTaskUpdateAssigneesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageTaskUpdateStatus */
export type MessengerMessageTaskUpdateStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  taskStatus: TaskStatusEnum;
};

/** Autogenerated return type of MessengerMessageTaskUpdateStatus. */
export type MessengerMessageTaskUpdateStatusPayload = {
  __typename?: 'MessengerMessageTaskUpdateStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

/** Autogenerated input type of MessengerMessageUpdate */
export type MessengerMessageUpdateInput = {
  attributes: OmsInputsMessengerMessageType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of MessengerMessageUpdate. */
export type MessengerMessageUpdatePayload = {
  __typename?: 'MessengerMessageUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Message;
};

export enum MessengerTeamspaceRoleEnum {
  Buyer = 'buyer',
  Editor = 'editor',
  Owner = 'owner',
  Viewer = 'viewer'
}

/** Autogenerated input type of MessengerTemplateGroupCreate */
export type MessengerTemplateGroupCreateInput = {
  attributes: OmsInputsMessengerTemplateGroupType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerTemplateGroupCreate. */
export type MessengerTemplateGroupCreatePayload = {
  __typename?: 'MessengerTemplateGroupCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  templateGroup: ManagerTemplateGroupType;
};

/** Autogenerated input type of MessengerTemplateGroupDelete */
export type MessengerTemplateGroupDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  constantName: Scalars['String']['input'];
};

/** Autogenerated return type of MessengerTemplateGroupDelete. */
export type MessengerTemplateGroupDeletePayload = {
  __typename?: 'MessengerTemplateGroupDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MessengerTemplateGroupUpdate */
export type MessengerTemplateGroupUpdateInput = {
  attributes: OmsInputsMessengerTemplateGroupType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MessengerTemplateGroupUpdate. */
export type MessengerTemplateGroupUpdatePayload = {
  __typename?: 'MessengerTemplateGroupUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  templateGroup: ManagerTemplateGroupType;
};

export type Method = BankPayment | Payout;

export type Money = MoneyInterface & {
  __typename?: 'Money';
  amount: Scalars['String']['output'];
  amountCents: Scalars['String']['output'];
  currencyCode: CurrencyEnum;
};

/** Contains price and currency */
export type MoneyInterface = {
  amount: Scalars['String']['output'];
  amountCents: Scalars['String']['output'];
  currencyCode: CurrencyEnum;
};

/** Autogenerated input type of MoveToDraftLogisticInvoice */
export type MoveToDraftLogisticInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MoveToDraftLogisticInvoice. */
export type MoveToDraftLogisticInvoicePayload = {
  __typename?: 'MoveToDraftLogisticInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBulkLogisticInvoiceFile?: Maybe<AddBulkLogisticInvoiceAttachedFilePayload>;
  addLogisticInvoiceFile?: Maybe<AddLogisticInvoiceAttachedFilePayload>;
  /** Mark specific extracted invoice field as disliked by current user */
  aiCopilotDislikeExtractedField?: Maybe<OmsAiCopilotDislikeExtractedFieldPayload>;
  /** Translate text using AI Copilot */
  aiCopilotTranslate?: Maybe<OmsAiCopilotTranslatePayload>;
  attachedFilesCreateDirect?: Maybe<AttachedFilesCreateDirectPayload>;
  attachedFilesExtractText?: Maybe<AttachedFilesExtractTextPayload>;
  bankPaymentsApprove?: Maybe<BankPaymentsApprovePayload>;
  bankPaymentsBulkApprove?: Maybe<BankPaymentsBulkApprovePayload>;
  bankPaymentsBulkRecognizeAs?: Maybe<BankPaymentsBulkRecognizeAsPayload>;
  /** NOT IMPLEMENTED IN UK */
  bankPaymentsBulkSend?: Maybe<BankPaymentsBulkSendToBankPayload>;
  /** NOT IMPLEMENTED IN UK */
  bankPaymentsBulkSendVerify?: Maybe<BankPaymentsBulkSendToBankVerifyPayload>;
  bankPaymentsBulkUpdatePartnerInfo?: Maybe<BankPaymentsBulkUpdatePartnerInfoPayload>;
  /** NOT IMPLEMENTED IN UK */
  bankPaymentsCreateExportToDatev?: Maybe<BankPaymentsCreateExportToDatevPayload>;
  bankPaymentsCreateFromInvoice?: Maybe<BankPaymentsCreateFromInvoicePayload>;
  bankPaymentsCreateFromPayout?: Maybe<BankPaymentsCreateFromPayoutPayload>;
  bankPaymentsDestroy?: Maybe<BankPaymentsDestroyPayload>;
  bankPaymentsDestroyWithPayouts?: Maybe<BankPaymentsDestroyWithPayoutsPayload>;
  bankPaymentsLinkPayment?: Maybe<BankPaymentsPaymentsLinkPayload>;
  bankPaymentsLinkToAccount?: Maybe<BankPaymentsLinkToAccountPayload>;
  bankPaymentsPaymentsCreate?: Maybe<BankPaymentsPaymentsCreatePayload>;
  /** NOT IMPLEMENTED IN UK */
  bankPaymentsRecreate?: Maybe<BankPaymentsRecreatePayload>;
  bankPaymentsUnapprove?: Maybe<BankPaymentsUnapprovePayload>;
  bankPaymentsUpdate?: Maybe<BankPaymentsUpdatePayload>;
  bankPaymentsUpdateJpmStatus?: Maybe<BankPaymentsUpdateJpmStatusPayload>;
  bankPaymentsUpdateOutlyingType?: Maybe<BankPaymentsUpdateOutlyingTypePayload>;
  bankPaymentsUpdateRegisteredAt?: Maybe<BankPaymentsUpdateRegisteredAtPayload>;
  billingAccountXlsxReport?: Maybe<BillingAccountXlsxReportPayload>;
  billingAccountsAddToPersons?: Maybe<BillingAccountsAddToPersonsPayload>;
  billingAccountsAttachedFilesDelete?: Maybe<BillingAccountsAttachedFilesDeletePayload>;
  billingAccountsCreate?: Maybe<BillingAccountsCreatePayload>;
  billingAccountsCreateAsync?: Maybe<BillingAccountsCreateAsyncPayload>;
  billingAccountsDelete?: Maybe<BillingAccountsDeletePayload>;
  billingAccountsMerge?: Maybe<BillingAccountsMergePayload>;
  billingAccountsOrganizationsUpdate?: Maybe<BillingAccountsOrganizationsPayload>;
  billingAccountsPaymentTermsUpdate?: Maybe<BillingAccountsPaymentTermsUpdatePayload>;
  billingAccountsRemoveFromPerson?: Maybe<BillingAccountsRemoveFromPersonPayload>;
  billingAccountsRemoveFromPersons?: Maybe<BillingAccountsRemoveFromPersonsPayload>;
  billingAccountsRequestCreditLimit?: Maybe<BillingAccountsRequestCreditLimitPayload>;
  /** NOT IMPLEMENTED IN UK */
  billingAccountsSendToCheck?: Maybe<BillingAccountSendToCheckPayload>;
  billingAccountsSetAsDefault?: Maybe<BillingAccountsSetAsDefaultPayload>;
  billingAccountsSuccessManual?: Maybe<BillingAccountsSuccessManualPayload>;
  billingAccountsToggleCreditLimitAccess?: Maybe<BillingAccountsToggleCreditLimitAccessPayload>;
  billingAccountsUpdate?: Maybe<BillingAccountsUpdatePayload>;
  billingAccountsUpdateAsync?: Maybe<BillingAccountsUpdateAsyncPayload>;
  billingAccountsUpdateCascade?: Maybe<BillingAccountsUpdateCascadePayload>;
  billingAccountsUpdateCreditLimit?: Maybe<BillingAccountsUpdateCreditLimitPayload>;
  bulkSetCleanedFiles?: Maybe<AttachedFilesBulkSetCleanedFilesPayload>;
  bulkUpdatePriceAndTerms?: Maybe<PartsBulkUpdatePriceAndTermsPayload>;
  cancelLogisticInvoice?: Maybe<CancelLogisticInvoicePayload>;
  changeRequestApprove?: Maybe<ChangeRequestsApprovePayload>;
  changeRequestDecline?: Maybe<ChangeRequestsDeclinePayload>;
  claimsCreate?: Maybe<ClaimsCreatePayload>;
  claimsDestroy?: Maybe<ClaimsDestroyPayload>;
  claimsUpdate?: Maybe<ClaimsUpdatePayload>;
  createLogisticInvoice?: Maybe<CreateLogisticInvoicePayload>;
  createLogisticInvoiceRelatedShippings?: Maybe<CreateLogisticInvoiceRelatedShippingsPayload>;
  createLogisticOperatorBillingAccount?: Maybe<CreateLogisticOperatorBillingAccountPayload>;
  crmForceCreateDeal?: Maybe<CrmForceCreateDealPayload>;
  crmForceCreateOrganization?: Maybe<CrmForceCreateOrganizationPayload>;
  crmForceCreatePerson?: Maybe<CrmForceCreatePersonPayload>;
  currencyConversion?: Maybe<CurrencyConversionPayload>;
  dealBalanceRecordsExportForOrganization?: Maybe<DealBalanceRecordsExportForOrganizationPayload>;
  dealDocumentsBulkGenerateZip?: Maybe<DealsDocumentsBulkGenerateZipPayload>;
  dealDocumentsBulkUpdate?: Maybe<DealsDocumentsBulkUpdatePayload>;
  dealDocumentsCreate?: Maybe<DealsDocumentsCreatePayload>;
  dealDocumentsDelete?: Maybe<DealsDocumentsDeletePayload>;
  dealDocumentsGenerateZip?: Maybe<DealsDocumentsGenerateZipPayload>;
  dealDocumentsUpdate?: Maybe<DealsDocumentsUpdatePayload>;
  dealPartsCreateMeasurementTemplates?: Maybe<DealPartsCreateMeasurementTemplatesPayload>;
  dealPartsCreateQualityControlFiles?: Maybe<DealPartsCreateQualityControlFilesPayload>;
  dealPartsMoldsCreate?: Maybe<DealPartsMoldsCreatePayload>;
  dealPartsMoldsUpdate?: Maybe<DealPartsMoldsUpdatePayload>;
  dealPartsUpdateInjectionMoldingPipeline?: Maybe<DealPartsUpdateInjectionMoldingPipelinePayload>;
  dealsAddRepetitiveDeal?: Maybe<DealsAddRepetitiveDealPayload>;
  dealsAssignTeamspace?: Maybe<AssignDealTeamspacePayload>;
  dealsBillingPreferenceCreateOrUpdate?: Maybe<DealsBillingPreferenceCreateOrUpdatePayload>;
  dealsBulkActionsUpdateProductionManager?: Maybe<DealsBulkActionsUpdateProductionManagerPayload>;
  dealsCalcPartsState?: Maybe<DealsCalcPartsStatePayload>;
  dealsCompleteProduction?: Maybe<DealsCompleteProductionPayload>;
  dealsCreateSlackChannel?: Maybe<DealsCreateSlackChannelPayload>;
  dealsRemoveRepetitiveDeal?: Maybe<DealsRemoveRepetitiveDealPayload>;
  dealsReopenProduction?: Maybe<DealsReopenProductionPayload>;
  dealsSendPriceToExternal?: Maybe<DealsSendPriceToExternalPayload>;
  dealsUpdate?: Maybe<DealsUpdatePayload>;
  dealsUpdatePerson?: Maybe<DealsUpdatePersonPayload>;
  dealsUpdateProductionManager?: Maybe<DealsUpdateProductionManagerPayload>;
  dealsUpdateTpo?: Maybe<DealsUpdateTpoPayload>;
  deleteLogisticOperatorBillingAccount?: Maybe<DeleteLogisticOperatorBillingAccountPayload>;
  deliveriesConvertToShipping: DeliveriesConvertToShippingPayload;
  deliveriesConvertToStorage: DeliveriesConvertToStoragePayload;
  deliveriesUpdateComments?: Maybe<DeliveriesUpdateCommentsPayload>;
  destroyAllLogisticInvoiceRelatedShippings?: Maybe<LogisticInvoiceDestroyAllRelatedShippingsPayload>;
  destroyLogisticInvoiceFile?: Maybe<DestroyLogisticInvoiceAttachedFilePayload>;
  documentNotesCreate?: Maybe<DocumentNotesCreatePayload>;
  documentNotesDelete?: Maybe<DocumentNotesDeletePayload>;
  e2ePersonCleanup?: Maybe<E2EPersonCleanupPayload>;
  enquiriesAdditionalServicesCreateXPoints?: Maybe<EnquiriesAdditionalServicesCreateXPointsPayload>;
  enquiriesAuditCancelModeration?: Maybe<EnquiriesCancelModerationPayload>;
  enquiriesBulkActionsCreateRfq?: Maybe<EnquiriesBulkActionsCreateRfqPayload>;
  enquiriesBulkActionsPartsRestartWorkflow?: Maybe<EnquiriesBulkActionsPartsRestartWorkflowPayload>;
  enquiriesBulkActionsUpdateRelatedDealLots?: Maybe<EnquiriesBulkActionsUpdateRelatedDealLotsPayload>;
  enquiriesBulkNotesUpdate?: Maybe<EnquiriesBulkNotesUpdatePayload>;
  enquiriesCertificatesUpdate?: Maybe<EnquiriesCertificatesUpdatePayload>;
  enquiriesFillEnquiryStop?: Maybe<EnquiriesFillEnquiryStopPayload>;
  enquiriesPartsPromotionsManageDiscounts?: Maybe<PartsPromotionsManageDiscountPayload>;
  enquiriesPromotionsCreate?: Maybe<PromotionsCreatePayload>;
  enquiriesPromotionsCreateDiscount?: Maybe<PromotionsCreateDiscountPayload>;
  enquiriesPromotionsDestroyDiscount?: Maybe<PromotionsDestroyDiscountPayload>;
  enquiriesPromotionsUpdate?: Maybe<PromotionsUpdatePayload>;
  enquiriesPromotionsUpdateDiscount?: Maybe<PromotionsUpdateDiscountPayload>;
  enquiriesSfCasesSaveFeedback?: Maybe<EnquiriesSfCasesSaveFeedbackPayload>;
  enquiriesSyncForRfq?: Maybe<EnquirySyncForRfqPayload>;
  enquiriesTransferForRfq?: Maybe<EnquiryTransferForRfqPayload>;
  enquiriesUpdate?: Maybe<EnquiriesUpdatePayload>;
  enquiriesUpdateKamModeration?: Maybe<EnquiriesUpdateKamModerationPayload>;
  enquiryPartsCertificatesUpdate?: Maybe<OmsEnquiryPartCertificatesUpdatePayload>;
  enquiryPartsRfqClearNeedInfo?: Maybe<EnquiryPartsRfqClearNeedInfoPayload>;
  enquiryPartsSelectPriceOption?: Maybe<OmsSelectPriceOptionEnquiryPartPayload>;
  exportBillingAccountCreate?: Maybe<CreateBillingAccountsExportPayload>;
  exportBillingAccountGenerateCsv?: Maybe<GenerateCsvBillingAccountsExportPayload>;
  exportBillingAccountMarkRegistered?: Maybe<MarkAsRegisteredBillingAccountsExportPayload>;
  exportLogisticInvoiceCreate?: Maybe<CreateLogisticInvoicesExportPayload>;
  exportLogisticInvoiceGenerateCsv?: Maybe<GenerateCsvLogisticInvoicesExportPayload>;
  exportLogisticInvoiceMarkAsRegistered?: Maybe<MarkAsRegisteredLogisticInvoicesExportPayload>;
  exportProviderCreate?: Maybe<CreateProvidersExportPayload>;
  exportProviderGenerateCsv?: Maybe<GenerateCsvProvidersExportPayload>;
  exportProviderMarkAsRegistered?: Maybe<MarkAsRegisteredProvidersExportPayload>;
  fetchLogisticInvoiceRelatedShippings?: Maybe<LogisticInvoiceFetchLogisticInvoiceRelatedShippingsPayload>;
  frameworkBatchesDelete?: Maybe<FrameworkBatchesDeletePayload>;
  frameworkBatchesGroupCreateOrUpdate?: Maybe<FrameworkBatchesGroupCreateOrUpdatePayload>;
  generatePresignedUrl?: Maybe<GeneratePresignedUrlPayload>;
  hsCodeDatasetsBulkConfirm?: Maybe<HsCodeDatasetsBulkConfirmHsCodePayload>;
  hsCodeDatasetsBulkGenerate?: Maybe<BulkGenerateHsCodePayload>;
  hsCodeDatasetsBulkUpdate?: Maybe<HsCodeDatasetsBulkUpdatePayload>;
  hsCodeDatasetsConfirmHsCode?: Maybe<HsCodeDatasetsConfirmHsCodePayload>;
  hsCodeDatasetsCreate?: Maybe<HsCodeDatasetsCreatePayload>;
  hsCodeDatasetsDestroy?: Maybe<HsCodeDatasetsDestroyPayload>;
  hsCodeDatasetsRequestAutoDataset?: Maybe<HsCodeDatasetsRequestAutoDatasetPayload>;
  hsCodeDatasetsResetConfirmationHsCode?: Maybe<HsCodeDatasetsResetConfirmationHsCodePayload>;
  hsCodeDatasetsUpdate?: Maybe<HsCodeDatasetsUpdatePayload>;
  incomingEmailCreateMessage?: Maybe<IncomingEmailCreateMessagePayload>;
  incomingEmailCreateSalesforceCase?: Maybe<IncomingEmailCreateSalesforceCasePayload>;
  incomingEmailDelete?: Maybe<IncomingEmailDeletePayload>;
  incomingInvoiceOverrideAccounting?: Maybe<IncomingInvoicesOverrideAccountingFieldsPayload>;
  /** Send incoming invoice to Intacct */
  incomingInvoiceSendToIntacct?: Maybe<IncomingInvoicesSendToIntacctPayload>;
  /** NOT IMPLEMENTED IN UK */
  incomingInvoiceSendToMikrojump?: Maybe<IncomingInvoicesSendToMikrojumpPayload>;
  incomingInvoicesBulkBankPaymentCreate?: Maybe<IncomingInvoicesBulkBankPaymentCreatePayload>;
  incomingInvoicesBulkDatevExport?: Maybe<IncomingInvoicesBulkDatevExportPayload>;
  incomingInvoicesBulkGeneratePayouts?: Maybe<IncomingInvoicesBulkGeneratePayoutsPayload>;
  incomingInvoicesBulkIntacctExport?: Maybe<IncomingInvoicesBulkIntacctExportPayload>;
  incomingInvoicesBulkMarkAsPaid?: Maybe<IncomingInvoicesBulkMarkAsPaidPayload>;
  incomingInvoicesReallocate?: Maybe<IncomingInvoicesReallocatePayload>;
  jobOffersShippingInstructionsUpdate?: Maybe<JobOffersShippingInstructionUpdatesPayload>;
  jobsCreateAutomatically?: Maybe<CreateAutomaticallyPayload>;
  jobsRequestAutomatically?: Maybe<RequestAutomaticallyPayload>;
  logisticInvoicesBulkBankPaymentCreate?: Maybe<LogisticInvoicesBulkCreateBankPaymentPayload>;
  logisticInvoicesBulkMarkAsCanceled?: Maybe<LogisticInvoicesBulkMarkAsCanceledPayload>;
  logisticInvoicesBulkMarkAsPaid?: Maybe<LogisticInvoicesBulkMarkAsPaidPayload>;
  logisticInvoicesBulkMarkAsRegistered?: Maybe<LogisticInvoicesBulkMarkAsRegisteredPayload>;
  logisticInvoicesCreateDatevExport?: Maybe<LogisticInvoicesCreateDatevExportPayload>;
  loyaltyTransactionsCreate: LoyaltyTransactionsCreatePayload;
  masterShippingsCreate: MasterShippingsCreatePayload;
  masterShippingsCreateFromShipping: MasterShippingsCreateFromShippingPayload;
  masterShippingsShipmentOrderCreateDhlOrder?: Maybe<MasterShippingsShipmentOrderCreateDhlOrderPayload>;
  /** Fetch available options for master shipping */
  masterShippingsShipmentOrderRequestShippingOptions?: Maybe<MasterShippingsShipmentOrderRequestShippingOptionsPayload>;
  masterShippingsUpdate: MasterShippingsUpdatePayload;
  masterShippingsUpdateTracking?: Maybe<MasterShippingsUpdateTrackingPayload>;
  messageSubscriptionsBulkActionsMarkAllRead?: Maybe<MessageSubscriptionsBulkActionsMarkAllReadPayload>;
  messageSubscriptionsBulkActionsSubscribe?: Maybe<MessageSubscriptionsBulkActionsSubscribePayload>;
  messageSubscriptionsBulkActionsUnsubscribe?: Maybe<MessageSubscriptionsBulkActionsUnsubscribePayload>;
  messengerAttachmentsUpload?: Maybe<MessengerAttachmentsUploadPayload>;
  messengerConversationClearReplyRequired?: Maybe<MessengerConversationClearReplyRequiredPayload>;
  messengerMessageBookmark?: Maybe<MessengerMessageBookmarkPayload>;
  messengerMessageCreate?: Maybe<MessengerMessageCreatePayload>;
  messengerMessageCreateFromTemplate?: Maybe<MessengerMessageCreateFromTemplatePayload>;
  messengerMessageDelete?: Maybe<MessengerMessageDeletePayload>;
  messengerMessageFilterAssignUser?: Maybe<MessengerMessageFilterAssignUserPayload>;
  messengerMessageFilterCreate?: Maybe<MessengerMessageFilterCreatePayload>;
  messengerMessageFilterDelete?: Maybe<MessengerMessageFilterDeletePayload>;
  messengerMessageFilterGroupAssignUser?: Maybe<MessengerMessageFilterGroupAssignUserPayload>;
  messengerMessageFilterGroupCreate?: Maybe<MessengerMessageFilterGroupCreatePayload>;
  messengerMessageFilterGroupDelete?: Maybe<MessengerMessageFilterGroupDeletePayload>;
  messengerMessageFilterGroupUpdate?: Maybe<MessengerMessageFilterGroupUpdatePayload>;
  messengerMessageFilterUpdate?: Maybe<MessengerMessageFilterUpdatePayload>;
  messengerMessagePin?: Maybe<MessengerMessagePinPayload>;
  messengerMessageSendOriginalContent?: Maybe<MessengerMessageSendOriginalContentPayload>;
  messengerMessageTaskUpdateAssignees?: Maybe<MessengerMessageTaskUpdateAssigneesPayload>;
  messengerMessageTaskUpdateStatus?: Maybe<MessengerMessageTaskUpdateStatusPayload>;
  messengerMessageUpdate?: Maybe<MessengerMessageUpdatePayload>;
  messengerSourceMarkRead?: Maybe<MessengerChannelMarkReadPayload>;
  messengerSourceMarkUnread?: Maybe<MessengerChannelMarkUnreadPayload>;
  messengerSourceSubscribe?: Maybe<MessengerChannelSubscribePayload>;
  messengerSourceUnsubscribe?: Maybe<MessengerChannelUnsubscribePayload>;
  messengerTemplateGroupCreate?: Maybe<MessengerTemplateGroupCreatePayload>;
  messengerTemplateGroupDelete?: Maybe<MessengerTemplateGroupDeletePayload>;
  messengerTemplateGroupUpdate?: Maybe<MessengerTemplateGroupUpdatePayload>;
  moveToDraftLogisticInvoice?: Maybe<MoveToDraftLogisticInvoicePayload>;
  orderConfirmationApplyBillingAccount?: Maybe<OrderConfirmationsApplyBillingAccountPayload>;
  orderConfirmationChangeRequestApprove?: Maybe<OrderConfirmationChangeRequestsApprovePayload>;
  orderConfirmationChangeRequestReject?: Maybe<OrderConfirmationChangeRequestsRejectPayload>;
  organizationBalanceRecordsForceRecalculate?: Maybe<OrganizationBalanceRecordsForceRecalculatePayload>;
  organizationsBulkActionsUpdateProductionManager?: Maybe<OrganizationsBulkActionsUpdateProductionManagerPayload>;
  organizationsCreate?: Maybe<OrganizationsCreatePayload>;
  organizationsMerge?: Maybe<OrganizationsMergePayload>;
  organizationsReactivationTransfer?: Maybe<OrganizationsReactivationTransferPayload>;
  organizationsRequestDescription?: Maybe<OrganizationsRequestDescriptionPayload>;
  organizationsTransferToRegion?: Maybe<OrganizationTransferToRegionPayload>;
  organizationsUpdate?: Maybe<OrganizationsUpdatePayload>;
  organizationsUpdateProductionManager?: Maybe<OrganizationsUpdateProductionManagerPayload>;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoiceExportZip?: Maybe<OutcomingInvoiceExportZipPayload>;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoiceMarkAsAccrual?: Maybe<MarkAsAccrualPayload>;
  outcomingInvoiceOverrideAccounting?: Maybe<OutcomingInvoicesOverrideAccountingFieldsPayload>;
  outcomingInvoiceOverridePaymentTermsDate?: Maybe<OutcomingInvoicesOverridePaymentTermsDatePayload>;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoiceRollbackMikrojumpSync?: Maybe<OutcomingInvoicesRollbackMikrojumpSyncPayload>;
  /** Send invoice to Intacct check */
  outcomingInvoiceSendToIntacct?: Maybe<OutcomingInvoicesSendToIntacctPayload>;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoiceSendToMikrojump?: Maybe<OutcomingInvoicesSendToMikrojumpPayload>;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoicesBulkDatevExport?: Maybe<OutcomingInvoicesBulkDatevExportPayload>;
  outcomingInvoicesBulkIntacctExport?: Maybe<OutcomingInvoicesBulkIntacctExportPayload>;
  outcomingInvoicesBulkMarkAsPaid?: Maybe<OutcomingInvoicesBulkMarkAsPaidPayload>;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoicesReject?: Maybe<OutcomingInvoicesRejectPayload>;
  packageTrackingEventsCreate?: Maybe<PackageTrackingEventsCreatePayload>;
  packageTrackingEventsDelete?: Maybe<PackageTrackingEventsDeletePayload>;
  packageTrackingEventsUpdate?: Maybe<PackageTrackingEventsUpdatePayload>;
  partStateCorrectionsCreate?: Maybe<PartStateCorrectionsCreatePayload>;
  partStateCorrectionsDestroy?: Maybe<PartStateCorrectionsDestroyPayload>;
  /** NOT IMPLEMENTED IN UK */
  paymentOutcomingInvoiceRelationsCreateExportToDatev?: Maybe<PaymentOutcomingInvoiceRelationsCreateExportToDatevPayload>;
  /** NOT IMPLEMENTED IN UK */
  paymentOutcomingInvoiceRelationsUpdateRegisteredAt?: Maybe<PaymentOutcomingInvoiceRelationsUpdateRegisteredAtPayload>;
  /** NOT IMPLEMENTED IN UK */
  paymentsCreateExportToDatev?: Maybe<PaymentsCreateExportToDatevPayload>;
  paymentsRegenerateAccountingRecords?: Maybe<PaymentsRegenerateAccountingRecordsPayload>;
  paymentsTransferBetweenDeals?: Maybe<PaymentsTransferBetweenDealsPayload>;
  paymentsUpdateMethod?: Maybe<PaymetsUpdateMethodPayload>;
  paymentsUpdateRegisteredAt?: Maybe<PaymentsUpdateRegisteredAtPayload>;
  payoutsBankPaymentApproveAndCreate?: Maybe<PayoutBankPaymentApproveAndCreatePayload>;
  payoutsBulkBankPaymentApproveAndCreate?: Maybe<PayoutsBulkBankPaymentApproveAndCreatePayload>;
  payoutsBulkSetAsPaid?: Maybe<PayoutsBulkSetAsPaidPayload>;
  payoutsCancel?: Maybe<PayoutsCancelPayload>;
  payoutsComplete?: Maybe<PayoutsCompletePayload>;
  payoutsCompleteAgainstAnother?: Maybe<PayoutsCompleteAgainstAnotherPayload>;
  payoutsCreate?: Maybe<PayoutsCreatePayload>;
  payoutsDestroy?: Maybe<PayoutsDestroyPayload>;
  payoutsUpdate?: Maybe<PayoutsUpdatePayload>;
  payoutsUpdateMethod?: Maybe<PayoutsUpdateMethodPayload>;
  personsBulkUpdate: PersonsBulkUpdatePayload;
  personsCreate?: Maybe<PersonsCreatePayload>;
  personsImpersonate?: Maybe<PersonsImpersonatePayload>;
  personsMerge?: Maybe<PersonsMergePayload>;
  personsOrganizationChange?: Maybe<PersonsOrganizationChangePayload>;
  personsPunchoutAppendAddresses?: Maybe<PersonsPunchoutsAppendAddressesPayload>;
  personsPunchoutCreate?: Maybe<PersonsPunchoutsCreatePayload>;
  personsReactivationTransfer?: Maybe<PersonsReactivationTransferPayload>;
  personsSafeDestroy?: Maybe<PersonsSafeDestroyPayload>;
  personsSendNewRegionVerify?: Maybe<PersonsSendNewRegionVerifyPayload>;
  personsSyncContact?: Maybe<PersonsSyncContactPayload>;
  personsUpdate?: Maybe<PersonsUpdatePayload>;
  personsVerifyWhatsappNumber?: Maybe<PersonsVerifyWhatsAppNumberPayload>;
  productionEventsCreate?: Maybe<ProductionEventsCreatePayload>;
  productionEventsDelete?: Maybe<ProductionEventsDeletePayload>;
  productionEventsUpdate?: Maybe<ProductionEventsUpdatePayload>;
  productionScheduleItemsCreate?: Maybe<ProductionScheduleItemsCreatePayload>;
  productionScheduleItemsDestroy?: Maybe<ProductionScheduleItemsDestroyPayload>;
  productionScheduleItemsUpdate?: Maybe<ProductionScheduleItemsUpdatePayload>;
  providerChangeRequestCreate?: Maybe<ChangeRequestsCreateForProviderPayload>;
  providerOrdersCreate?: Maybe<ProviderOrdersCreatePayload>;
  providerOrdersDestroy?: Maybe<ProviderOrdersDestroyPayload>;
  providerOrdersIssueBasedOnJobOffer?: Maybe<ProviderOrdersIssueBasedOnJobOfferPayload>;
  providerOrdersShippingInstructionsUpdate?: Maybe<ProviderOrdersShippingInstructionUpdatesPayload>;
  providerOrdersSplit?: Maybe<ProviderOrdersSplitPayload>;
  providerOrdersUpdate?: Maybe<ProviderOrdersUpdatePayload>;
  providerXlsxReport?: Maybe<ProviderXlsxReportPayload>;
  providersBulkActionsAssignPartnerSuccessManager?: Maybe<ProvidersBulkActionsAssignPartnerSuccessManagerPayload>;
  providersChangePrimary?: Maybe<ChangePrimaryPayload>;
  providersContactsCreate?: Maybe<ContactsCreatePayload>;
  providersContactsDelete?: Maybe<ContactsDeletePayload>;
  providersContactsMove?: Maybe<ContactsMovePayload>;
  providersContactsUpdate?: Maybe<ContactsUpdatePayload>;
  providersCreate?: Maybe<ProvidersCreatePayload>;
  providersDelete?: Maybe<ProvidersDeletePayload>;
  providersSendToCheck?: Maybe<ProviderSendToCheckPayload>;
  providersSuccessManual?: Maybe<ProvidersSuccessManualPayload>;
  providersUpdate?: Maybe<ProvidersUpdatePayload>;
  providersUpdateTag?: Maybe<UpdateTagPayload>;
  publicDomainsCreate?: Maybe<PublicDomainsCreatePayload>;
  publishGshDealTransferredEvent?: Maybe<Scalars['Boolean']['output']>;
  publishLogisticInvoice?: Maybe<PublishLogisticInvoicePayload>;
  qualityControlsCreate?: Maybe<QualityControlsCreatePayload>;
  qualityControlsGeneratePdfReport: QualityControlsGeneratePdfReportPayload;
  qualityControlsPositionDelete?: Maybe<QualityControlsPositionsDeletePayload>;
  qualityControlsPositionUpdate?: Maybe<QualityControlsPositionsUpdatePayload>;
  qualityControlsPositionsUpdateMeasurements?: Maybe<QualityControlsPositionsUpdateMeasurementsPayload>;
  qualityControlsRepack?: Maybe<QualityControlsRepackPayload>;
  qualityControlsUpdate?: Maybe<QualityControlsUpdatePayload>;
  requireRfq?: Maybe<EnquiryPartsRequireRfqPayload>;
  rfqsBulkSendOfferMessages?: Maybe<RfqsSendBulkMessagesPayload>;
  rfqsCancel?: Maybe<RfqsCancelPayload>;
  rfqsClose?: Maybe<RfqsClosePayload>;
  rfqsDelete?: Maybe<RfqsDeletePayload>;
  rfqsOffersApply?: Maybe<RfqsOffersApplyPayload>;
  rfqsOffersBulkActionsUpdateProviderAmount?: Maybe<RfqsOffersBulkActionsUpdateProviderAmountPayload>;
  rfqsOffersDelete?: Maybe<RfqsOffersDeletePayload>;
  rfqsOffersFindOrCreate?: Maybe<RfqsOffersFindOrCreatePayload>;
  rfqsOffersPricesDelete?: Maybe<RfqsOffersPricesDeletePayload>;
  rfqsOffersUpdate?: Maybe<RfqsOffersUpdatePayload>;
  rfqsPositionsDelete?: Maybe<RfqsPositionsDeletePayload>;
  rfqsPublish?: Maybe<RfqsPublishPayload>;
  rfqsReactivate?: Maybe<RfqsReactivatePayload>;
  rfqsUpdate?: Maybe<RfqsUpdatePayload>;
  rolesRequestPermission?: Maybe<RolesRequestPermissionPayload>;
  rolesUpdatePermissions?: Maybe<RolesUpdatePermissionsPayload>;
  salesPersonsBulkUpdateRfqStatus?: Maybe<SalesPersonsBulkUpdateRfqStatusPayload>;
  setRecommendedRfqStatus?: Maybe<SetRecommendedRfqStatusPayload>;
  shipmentOrderCreateArasOrder?: Maybe<ShipmentOrderCreateArasOrderPayload>;
  shipmentOrderCreateDbSchenkerOrder?: Maybe<ShipmentOrderCreateDbSchenkerOrderPayload>;
  shipmentOrderCreateDhlOrder?: Maybe<ShipmentOrderCreateDhlOrderPayload>;
  shipmentOrderCreateEurosenderOrder?: Maybe<ShipmentOrderCreateEurosenderOrderPayload>;
  shipmentOrderCreateJumingoOrder?: Maybe<ShipmentOrderCreateJumingoOrderPayload>;
  shipmentOrderCreateUpsOrder?: Maybe<ShipmentOrderCreateUpsOrderPayload>;
  shipmentOrderCreateYurticiOrder?: Maybe<ShipmentOrderCreateYurticiOrderPayload>;
  shipmentOrderQuickBookFromXometry?: Maybe<QuickBookFromXometryPayload>;
  /** Fetch available options for shipping */
  shipmentOrderRequestShippingOptions?: Maybe<ShipmentOrderRequestShippingOptionsPayload>;
  shipmentOrderValidateAutoOrderFromXometry?: Maybe<ValidateAutoOrderFromXometryPayload>;
  shippingAddressesCreate?: Maybe<ShippingAddressesCreatePayload>;
  shippingAddressesDelete?: Maybe<ShippingAddressesDeletePayload>;
  shippingAddressesForOrgPersonsCreate?: Maybe<ShippingAddressesForOrgPersonsCreatePayload>;
  shippingAddressesUpdate?: Maybe<ShippingAddressesUpdatePayload>;
  shippingAddressesUpdateCascade?: Maybe<ShippingAddressesUpdateCascadePayload>;
  shippingCalculationsApplyCost?: Maybe<ShippingCalculationsApplyCostPayload>;
  shippingCalculationsCreate?: Maybe<ShippingCalculationsCreatePayload>;
  shippingCalculationsDelete?: Maybe<ShippingCalculationsDeletePayload>;
  shippingCalculationsRemoveManualPrices?: Maybe<ShippingCalculationsRemoveManualPricesPayload>;
  shippingCalculationsUpdate?: Maybe<ShippingCalculationsUpdatePayload>;
  shippingCalculationsUpdateManualPrices?: Maybe<ShippingCalculationsUpdateManualPricesPayload>;
  shippingInstructionOverride?: Maybe<ShippingInstructionOverridePayload>;
  shippingsAddToMasterShipping: ShippingsAddToMasterShippingPayload;
  shippingsBulkAddToMasterShipping: ShippingsBulkAddToMasterShippingPayload;
  shippingsBulkMoveToState?: Maybe<ShippingsBulkMoveToStatePayload>;
  shippingsBulkRemoveFromMasterShipping: ShippingsBulkRemoveFromMasterShippingPayload;
  shippingsBulkUpdateTracking?: Maybe<ShippingsBulkUpdateTrackingPayload>;
  shippingsCreate: ShippingsCreatePayload;
  shippingsSendToExternal?: Maybe<ShippingsSendToExternalPayload>;
  shippingsSyncWithExternal?: Maybe<ShippingsSyncWithExternalPayload>;
  shippingsUpdate: ShippingsFormUpdatePayload;
  shippingsUpdateTracking?: Maybe<ShippingsUpdateTrackingPayload>;
  teamsAddUser: TeamsAddUserPayload;
  teamsCreate: TeamsCreatePayload;
  teamsRemoveUser: TeamsRemoveUserPayload;
  teamsUpdate: TeamsUpdatePayload;
  teamsUpdateMembershipType: TeamsUpdateMembershipTypePayload;
  teamspacesAddBillingAccount?: Maybe<OmsTeamspacesAddBillingAccountPayload>;
  teamspacesAddPerson?: Maybe<OmsTeamspacesAddPersonPayload>;
  teamspacesAddShippingAddress?: Maybe<OmsTeamspaceAddShippingAddressPayload>;
  teamspacesBillingAccountCreditLimitUpdate?: Maybe<OmsTeamspacesBillingAccountsCreditLimitUpdatePayload>;
  teamspacesBillingAccountSetAsDefault?: Maybe<OmsTeamspacesBillingAccountSetAsDefaultPayload>;
  teamspacesCreate?: Maybe<OmsTeamspacesCreatePayload>;
  teamspacesDelete?: Maybe<OmsTeamspacesDeletePayload>;
  teamspacesInvitesDelete?: Maybe<OmsTeamspacesInvitesDeletePayload>;
  teamspacesInvitesResend?: Maybe<OmsTeamspacesInvitesResendPayload>;
  teamspacesPersonRoleUpdate?: Maybe<OmsTeamspacesPersonRoleUpdatePayload>;
  teamspacesRemoveBillingAccount?: Maybe<OmsTeamspacesRemoveBillingAccountPayload>;
  teamspacesRemovePerson?: Maybe<OmsTeamspacesRemovePersonPayload>;
  teamspacesRemoveShippingAddress?: Maybe<OmsTeamspaceRemoveShippingAddressPayload>;
  teamspacesSetAsDefaultShippingAddress?: Maybe<OmsTeamspaceSetAsDefaultShippingAddressPayload>;
  teamspacesSetDefaultBillingAccount?: Maybe<OmsTeamspacesSetDefaultBillingAccountPayload>;
  teamspacesTransferOwnership?: Maybe<OmsTeamspacesTransferOwnershipPayload>;
  teamspacesUpdate?: Maybe<OmsTeamspacesUpdatePayload>;
  updateLogisticInvoice?: Maybe<UpdateLogisticInvoicePayload>;
  updateLogisticInvoiceRelatedShippings?: Maybe<UpdateLogisticInvoiceRelatedShippingsPayload>;
  updateLogisticOperatorBillingAccount?: Maybe<UpdateLogisticOperatorBillingAccountPayload>;
  updateRfqFields?: Maybe<EnquiryPartsUpdateRfqFieldsPayload>;
  usersAssignRoles?: Maybe<UsersAssignRolesPayload>;
  usersCreateSubstitution?: Maybe<OmsUsersCreateSubstitutionPayload>;
  usersDeleteSubstitution?: Maybe<OmsUsersDeleteSubstitutionPayload>;
  usersEmailLogin?: Maybe<EmailLoginPayload>;
  usersUpdateAvatar?: Maybe<UsersUpdateAvatarPayload>;
  usersUpdatePermissions?: Maybe<UsersUpdatePermissionsPayload>;
  usersUpdateProfile?: Maybe<UsersUpdateProfilePayload>;
  usersUpdateSubstitution?: Maybe<OmsUsersUpdateSubstitutionPayload>;
  workspacePresetsAssignDefaultPreset?: Maybe<WorkspacePresetsAssignDefaultPresetPayload>;
  workspacePresetsAssignGlobalDefaultPreset?: Maybe<WorkspacePresetsAssignGlobalDefaultPresetPayload>;
  workspacePresetsCreate?: Maybe<WorkspacePresetsCreatePayload>;
  workspacePresetsDelete?: Maybe<WorkspacePresetsDeletePayload>;
  workspacePresetsRemoveDefaultPreset?: Maybe<WorkspacePresetsRemoveDefaultPresetPayload>;
  workspacePresetsRemoveGlobalDefaultPreset?: Maybe<WorkspacePresetsRemoveGlobalDefaultPresetPayload>;
  workspacePresetsUpdate?: Maybe<WorkspacePresetsUpdatePayload>;
  workspacesBankPaymentsDraftExport?: Maybe<BankPaymentsDraftExportPayload>;
  workspacesBankPaymentsExport?: Maybe<BankPaymentsExportPayload>;
  workspacesBillingAccountsExport?: Maybe<BillingAccountsExportPayload>;
  workspacesClaimsExport?: Maybe<ClaimsExportPayload>;
  workspacesCouponsExport?: Maybe<CouponsExportPayload>;
  workspacesDealDocumentsExport?: Maybe<DealDocumentsExportPayload>;
  workspacesDealsExport?: Maybe<DealsExportPayload>;
  workspacesDraftingDealPartsExport?: Maybe<DraftingDealPartsExportPayload>;
  workspacesDraftingEnquiryPartsExport?: Maybe<DraftingEnquiryPartsExportPayload>;
  workspacesEmailMessagesExport?: Maybe<EmailMessagesExportPayload>;
  workspacesEnquiriesExport?: Maybe<EnquiriesExportPayload>;
  workspacesEnquiriesSfCasesExport?: Maybe<EnquiriesSfCasesExportPayload>;
  workspacesEnquiryPromotionsExport?: Maybe<EnquiryPromotionsExportPayload>;
  workspacesFrameworkBatchesExport?: Maybe<FrameworkBatchesExportPayload>;
  workspacesHsCodesExport?: Maybe<HsCodesExportPayload>;
  workspacesIncomingInvoicesExport?: Maybe<IncomingInvoicesExportPayload>;
  workspacesIntacctEventsExport?: Maybe<IntacctEventsExportPayload>;
  workspacesJobOffersExport?: Maybe<JobOffersExportPayload>;
  workspacesJobsExport?: Maybe<JobsExportPayload>;
  workspacesLogisticInvoicesExport?: Maybe<LogisticInvoicesExportPayload>;
  workspacesMessagesExport?: Maybe<MessagesExportPayload>;
  workspacesOrganizationBalancesExport?: Maybe<OrganizationBalancesExportPayload>;
  workspacesOrganizationsExport?: Maybe<OrganizationsExportPayload>;
  workspacesOutcomingInvoicesExport?: Maybe<OutcomingInvoicesExportPayload>;
  workspacesPaymentsExport?: Maybe<PaymentsExportPayload>;
  workspacesPayoutsExport?: Maybe<PayoutsExportPayload>;
  workspacesPersonsExport?: Maybe<PersonsExportPayload>;
  workspacesProductionScheduleItemsExport?: Maybe<ProductionScheduleItemsExportPayload>;
  workspacesProviderOrdersExport?: Maybe<ProviderOrdersExportPayload>;
  workspacesProvidersExport?: Maybe<ProvidersExportPayload>;
  workspacesQualityControlsExport?: Maybe<QualityControlsExportPayload>;
  workspacesRefundsExport?: Maybe<RefundsExportPayload>;
  workspacesRfqOffersExport?: Maybe<RfqOffersExportPayload>;
  workspacesRfqPartnersExport?: Maybe<RfqPartnersExportPayload>;
  workspacesRfqsExport?: Maybe<RfqsExportPayload>;
  workspacesShippingAddressesExport?: Maybe<ShippingAddressesExportPayload>;
  workspacesShippingsExport?: Maybe<ShippingsExportPayload>;
  workspacesStoragesExport?: Maybe<StoragesExportPayload>;
  workspacesSubscriptionsExport?: Maybe<SubscriptionsExportPayload>;
  workspacesTasksExport?: Maybe<TasksExportPayload>;
  workspacesTeamspacesExport?: Maybe<TeamspacesExportPayload>;
  workspacesUsersExport?: Maybe<UsersExportPayload>;
};


export type MutationAddBulkLogisticInvoiceFileArgs = {
  input: AddBulkLogisticInvoiceAttachedFileInput;
};


export type MutationAddLogisticInvoiceFileArgs = {
  input: AddLogisticInvoiceAttachedFileInput;
};


export type MutationAiCopilotDislikeExtractedFieldArgs = {
  input: OmsAiCopilotDislikeExtractedFieldInput;
};


export type MutationAiCopilotTranslateArgs = {
  input: OmsAiCopilotTranslateInput;
};


export type MutationAttachedFilesCreateDirectArgs = {
  input: AttachedFilesCreateDirectInput;
};


export type MutationAttachedFilesExtractTextArgs = {
  input: AttachedFilesExtractTextInput;
};


export type MutationBankPaymentsApproveArgs = {
  input: BankPaymentsApproveInput;
};


export type MutationBankPaymentsBulkApproveArgs = {
  input: BankPaymentsBulkApproveInput;
};


export type MutationBankPaymentsBulkRecognizeAsArgs = {
  input: BankPaymentsBulkRecognizeAsInput;
};


export type MutationBankPaymentsBulkSendArgs = {
  input: BankPaymentsBulkSendToBankInput;
};


export type MutationBankPaymentsBulkSendVerifyArgs = {
  input: BankPaymentsBulkSendToBankVerifyInput;
};


export type MutationBankPaymentsBulkUpdatePartnerInfoArgs = {
  input: BankPaymentsBulkUpdatePartnerInfoInput;
};


export type MutationBankPaymentsCreateExportToDatevArgs = {
  input: BankPaymentsCreateExportToDatevInput;
};


export type MutationBankPaymentsCreateFromInvoiceArgs = {
  input: BankPaymentsCreateFromInvoiceInput;
};


export type MutationBankPaymentsCreateFromPayoutArgs = {
  input: BankPaymentsCreateFromPayoutInput;
};


export type MutationBankPaymentsDestroyArgs = {
  input: BankPaymentsDestroyInput;
};


export type MutationBankPaymentsDestroyWithPayoutsArgs = {
  input: BankPaymentsDestroyWithPayoutsInput;
};


export type MutationBankPaymentsLinkPaymentArgs = {
  input: BankPaymentsPaymentsLinkInput;
};


export type MutationBankPaymentsLinkToAccountArgs = {
  input: BankPaymentsLinkToAccountInput;
};


export type MutationBankPaymentsPaymentsCreateArgs = {
  input: BankPaymentsPaymentsCreateInput;
};


export type MutationBankPaymentsRecreateArgs = {
  input: BankPaymentsRecreateInput;
};


export type MutationBankPaymentsUnapproveArgs = {
  input: BankPaymentsUnapproveInput;
};


export type MutationBankPaymentsUpdateArgs = {
  input: BankPaymentsUpdateInput;
};


export type MutationBankPaymentsUpdateJpmStatusArgs = {
  input: BankPaymentsUpdateJpmStatusInput;
};


export type MutationBankPaymentsUpdateOutlyingTypeArgs = {
  input: BankPaymentsUpdateOutlyingTypeInput;
};


export type MutationBankPaymentsUpdateRegisteredAtArgs = {
  input: BankPaymentsUpdateRegisteredAtInput;
};


export type MutationBillingAccountXlsxReportArgs = {
  input: BillingAccountXlsxReportInput;
};


export type MutationBillingAccountsAddToPersonsArgs = {
  input: BillingAccountsAddToPersonsInput;
};


export type MutationBillingAccountsAttachedFilesDeleteArgs = {
  input: BillingAccountsAttachedFilesDeleteInput;
};


export type MutationBillingAccountsCreateArgs = {
  input: BillingAccountsCreateInput;
};


export type MutationBillingAccountsCreateAsyncArgs = {
  input: BillingAccountsCreateAsyncInput;
};


export type MutationBillingAccountsDeleteArgs = {
  input: BillingAccountsDeleteInput;
};


export type MutationBillingAccountsMergeArgs = {
  input: BillingAccountsMergeInput;
};


export type MutationBillingAccountsOrganizationsUpdateArgs = {
  input: BillingAccountsOrganizationsInput;
};


export type MutationBillingAccountsPaymentTermsUpdateArgs = {
  input: BillingAccountsPaymentTermsUpdateInput;
};


export type MutationBillingAccountsRemoveFromPersonArgs = {
  input: BillingAccountsRemoveFromPersonInput;
};


export type MutationBillingAccountsRemoveFromPersonsArgs = {
  input: BillingAccountsRemoveFromPersonsInput;
};


export type MutationBillingAccountsRequestCreditLimitArgs = {
  input: BillingAccountsRequestCreditLimitInput;
};


export type MutationBillingAccountsSendToCheckArgs = {
  input: BillingAccountSendToCheckInput;
};


export type MutationBillingAccountsSetAsDefaultArgs = {
  input: BillingAccountsSetAsDefaultInput;
};


export type MutationBillingAccountsSuccessManualArgs = {
  input: BillingAccountsSuccessManualInput;
};


export type MutationBillingAccountsToggleCreditLimitAccessArgs = {
  input: BillingAccountsToggleCreditLimitAccessInput;
};


export type MutationBillingAccountsUpdateArgs = {
  input: BillingAccountsUpdateInput;
};


export type MutationBillingAccountsUpdateAsyncArgs = {
  input: BillingAccountsUpdateAsyncInput;
};


export type MutationBillingAccountsUpdateCascadeArgs = {
  input: BillingAccountsUpdateCascadeInput;
};


export type MutationBillingAccountsUpdateCreditLimitArgs = {
  input: BillingAccountsUpdateCreditLimitInput;
};


export type MutationBulkSetCleanedFilesArgs = {
  input: AttachedFilesBulkSetCleanedFilesInput;
};


export type MutationBulkUpdatePriceAndTermsArgs = {
  input: PartsBulkUpdatePriceAndTermsInput;
};


export type MutationCancelLogisticInvoiceArgs = {
  input: CancelLogisticInvoiceInput;
};


export type MutationChangeRequestApproveArgs = {
  input: ChangeRequestsApproveInput;
};


export type MutationChangeRequestDeclineArgs = {
  input: ChangeRequestsDeclineInput;
};


export type MutationClaimsCreateArgs = {
  input: ClaimsCreateInput;
};


export type MutationClaimsDestroyArgs = {
  input: ClaimsDestroyInput;
};


export type MutationClaimsUpdateArgs = {
  input: ClaimsUpdateInput;
};


export type MutationCreateLogisticInvoiceArgs = {
  input: CreateLogisticInvoiceInput;
};


export type MutationCreateLogisticInvoiceRelatedShippingsArgs = {
  input: CreateLogisticInvoiceRelatedShippingsInput;
};


export type MutationCreateLogisticOperatorBillingAccountArgs = {
  input: CreateLogisticOperatorBillingAccountInput;
};


export type MutationCrmForceCreateDealArgs = {
  input: CrmForceCreateDealInput;
};


export type MutationCrmForceCreateOrganizationArgs = {
  input: CrmForceCreateOrganizationInput;
};


export type MutationCrmForceCreatePersonArgs = {
  input: CrmForceCreatePersonInput;
};


export type MutationCurrencyConversionArgs = {
  input: CurrencyConversionInput;
};


export type MutationDealBalanceRecordsExportForOrganizationArgs = {
  input: DealBalanceRecordsExportForOrganizationInput;
};


export type MutationDealDocumentsBulkGenerateZipArgs = {
  input: DealsDocumentsBulkGenerateZipInput;
};


export type MutationDealDocumentsBulkUpdateArgs = {
  input: DealsDocumentsBulkUpdateInput;
};


export type MutationDealDocumentsCreateArgs = {
  input: DealsDocumentsCreateInput;
};


export type MutationDealDocumentsDeleteArgs = {
  input: DealsDocumentsDeleteInput;
};


export type MutationDealDocumentsGenerateZipArgs = {
  input: DealsDocumentsGenerateZipInput;
};


export type MutationDealDocumentsUpdateArgs = {
  input: DealsDocumentsUpdateInput;
};


export type MutationDealPartsCreateMeasurementTemplatesArgs = {
  input: DealPartsCreateMeasurementTemplatesInput;
};


export type MutationDealPartsCreateQualityControlFilesArgs = {
  input: DealPartsCreateQualityControlFilesInput;
};


export type MutationDealPartsMoldsCreateArgs = {
  input: DealPartsMoldsCreateInput;
};


export type MutationDealPartsMoldsUpdateArgs = {
  input: DealPartsMoldsUpdateInput;
};


export type MutationDealPartsUpdateInjectionMoldingPipelineArgs = {
  input: DealPartsUpdateInjectionMoldingPipelineInput;
};


export type MutationDealsAddRepetitiveDealArgs = {
  input: DealsAddRepetitiveDealInput;
};


export type MutationDealsAssignTeamspaceArgs = {
  input: AssignDealTeamspaceInput;
};


export type MutationDealsBillingPreferenceCreateOrUpdateArgs = {
  input: DealsBillingPreferenceCreateOrUpdateInput;
};


export type MutationDealsBulkActionsUpdateProductionManagerArgs = {
  input: DealsBulkActionsUpdateProductionManagerInput;
};


export type MutationDealsCalcPartsStateArgs = {
  input: DealsCalcPartsStateInput;
};


export type MutationDealsCompleteProductionArgs = {
  input: DealsCompleteProductionInput;
};


export type MutationDealsCreateSlackChannelArgs = {
  input: DealsCreateSlackChannelInput;
};


export type MutationDealsRemoveRepetitiveDealArgs = {
  input: DealsRemoveRepetitiveDealInput;
};


export type MutationDealsReopenProductionArgs = {
  input: DealsReopenProductionInput;
};


export type MutationDealsSendPriceToExternalArgs = {
  input: DealsSendPriceToExternalInput;
};


export type MutationDealsUpdateArgs = {
  input: DealsUpdateInput;
};


export type MutationDealsUpdatePersonArgs = {
  input: DealsUpdatePersonInput;
};


export type MutationDealsUpdateProductionManagerArgs = {
  input: DealsUpdateProductionManagerInput;
};


export type MutationDealsUpdateTpoArgs = {
  input: DealsUpdateTpoInput;
};


export type MutationDeleteLogisticOperatorBillingAccountArgs = {
  input: DeleteLogisticOperatorBillingAccountInput;
};


export type MutationDeliveriesConvertToShippingArgs = {
  input: DeliveriesConvertToShippingInput;
};


export type MutationDeliveriesConvertToStorageArgs = {
  input: DeliveriesConvertToStorageInput;
};


export type MutationDeliveriesUpdateCommentsArgs = {
  input: DeliveriesUpdateCommentsInput;
};


export type MutationDestroyAllLogisticInvoiceRelatedShippingsArgs = {
  input: LogisticInvoiceDestroyAllRelatedShippingsInput;
};


export type MutationDestroyLogisticInvoiceFileArgs = {
  input: DestroyLogisticInvoiceAttachedFileInput;
};


export type MutationDocumentNotesCreateArgs = {
  input: DocumentNotesCreateInput;
};


export type MutationDocumentNotesDeleteArgs = {
  input: DocumentNotesDeleteInput;
};


export type MutationE2ePersonCleanupArgs = {
  input: E2EPersonCleanupInput;
};


export type MutationEnquiriesAdditionalServicesCreateXPointsArgs = {
  input: EnquiriesAdditionalServicesCreateXPointsInput;
};


export type MutationEnquiriesAuditCancelModerationArgs = {
  input: EnquiriesCancelModerationInput;
};


export type MutationEnquiriesBulkActionsCreateRfqArgs = {
  input: EnquiriesBulkActionsCreateRfqInput;
};


export type MutationEnquiriesBulkActionsPartsRestartWorkflowArgs = {
  input: EnquiriesBulkActionsPartsRestartWorkflowInput;
};


export type MutationEnquiriesBulkActionsUpdateRelatedDealLotsArgs = {
  input: EnquiriesBulkActionsUpdateRelatedDealLotsInput;
};


export type MutationEnquiriesBulkNotesUpdateArgs = {
  input: EnquiriesBulkNotesUpdateInput;
};


export type MutationEnquiriesCertificatesUpdateArgs = {
  input: EnquiriesCertificatesUpdateInput;
};


export type MutationEnquiriesFillEnquiryStopArgs = {
  input: EnquiriesFillEnquiryStopInput;
};


export type MutationEnquiriesPartsPromotionsManageDiscountsArgs = {
  input: PartsPromotionsManageDiscountInput;
};


export type MutationEnquiriesPromotionsCreateArgs = {
  input: PromotionsCreateInput;
};


export type MutationEnquiriesPromotionsCreateDiscountArgs = {
  input: PromotionsCreateDiscountInput;
};


export type MutationEnquiriesPromotionsDestroyDiscountArgs = {
  input: PromotionsDestroyDiscountInput;
};


export type MutationEnquiriesPromotionsUpdateArgs = {
  input: PromotionsUpdateInput;
};


export type MutationEnquiriesPromotionsUpdateDiscountArgs = {
  input: PromotionsUpdateDiscountInput;
};


export type MutationEnquiriesSfCasesSaveFeedbackArgs = {
  input: EnquiriesSfCasesSaveFeedbackInput;
};


export type MutationEnquiriesSyncForRfqArgs = {
  input: EnquirySyncForRfqInput;
};


export type MutationEnquiriesTransferForRfqArgs = {
  input: EnquiryTransferForRfqInput;
};


export type MutationEnquiriesUpdateArgs = {
  input: EnquiriesUpdateInput;
};


export type MutationEnquiriesUpdateKamModerationArgs = {
  input: EnquiriesUpdateKamModerationInput;
};


export type MutationEnquiryPartsCertificatesUpdateArgs = {
  input: OmsEnquiryPartCertificatesUpdateInput;
};


export type MutationEnquiryPartsRfqClearNeedInfoArgs = {
  input: EnquiryPartsRfqClearNeedInfoInput;
};


export type MutationEnquiryPartsSelectPriceOptionArgs = {
  input: OmsSelectPriceOptionEnquiryPartInput;
};


export type MutationExportBillingAccountCreateArgs = {
  input: CreateBillingAccountsExportInput;
};


export type MutationExportBillingAccountGenerateCsvArgs = {
  input: GenerateCsvBillingAccountsExportInput;
};


export type MutationExportBillingAccountMarkRegisteredArgs = {
  input: MarkAsRegisteredBillingAccountsExportInput;
};


export type MutationExportLogisticInvoiceCreateArgs = {
  input: CreateLogisticInvoicesExportInput;
};


export type MutationExportLogisticInvoiceGenerateCsvArgs = {
  input: GenerateCsvLogisticInvoicesExportInput;
};


export type MutationExportLogisticInvoiceMarkAsRegisteredArgs = {
  input: MarkAsRegisteredLogisticInvoicesExportInput;
};


export type MutationExportProviderCreateArgs = {
  input: CreateProvidersExportInput;
};


export type MutationExportProviderGenerateCsvArgs = {
  input: GenerateCsvProvidersExportInput;
};


export type MutationExportProviderMarkAsRegisteredArgs = {
  input: MarkAsRegisteredProvidersExportInput;
};


export type MutationFetchLogisticInvoiceRelatedShippingsArgs = {
  input: LogisticInvoiceFetchLogisticInvoiceRelatedShippingsInput;
};


export type MutationFrameworkBatchesDeleteArgs = {
  input: FrameworkBatchesDeleteInput;
};


export type MutationFrameworkBatchesGroupCreateOrUpdateArgs = {
  input: FrameworkBatchesGroupCreateOrUpdateInput;
};


export type MutationGeneratePresignedUrlArgs = {
  input: GeneratePresignedUrlInput;
};


export type MutationHsCodeDatasetsBulkConfirmArgs = {
  input: HsCodeDatasetsBulkConfirmHsCodeInput;
};


export type MutationHsCodeDatasetsBulkGenerateArgs = {
  input: BulkGenerateHsCodeInput;
};


export type MutationHsCodeDatasetsBulkUpdateArgs = {
  input: HsCodeDatasetsBulkUpdateInput;
};


export type MutationHsCodeDatasetsConfirmHsCodeArgs = {
  input: HsCodeDatasetsConfirmHsCodeInput;
};


export type MutationHsCodeDatasetsCreateArgs = {
  input: HsCodeDatasetsCreateInput;
};


export type MutationHsCodeDatasetsDestroyArgs = {
  input: HsCodeDatasetsDestroyInput;
};


export type MutationHsCodeDatasetsRequestAutoDatasetArgs = {
  input: HsCodeDatasetsRequestAutoDatasetInput;
};


export type MutationHsCodeDatasetsResetConfirmationHsCodeArgs = {
  input: HsCodeDatasetsResetConfirmationHsCodeInput;
};


export type MutationHsCodeDatasetsUpdateArgs = {
  input: HsCodeDatasetsUpdateInput;
};


export type MutationIncomingEmailCreateMessageArgs = {
  input: IncomingEmailCreateMessageInput;
};


export type MutationIncomingEmailCreateSalesforceCaseArgs = {
  input: IncomingEmailCreateSalesforceCaseInput;
};


export type MutationIncomingEmailDeleteArgs = {
  input: IncomingEmailDeleteInput;
};


export type MutationIncomingInvoiceOverrideAccountingArgs = {
  input: IncomingInvoicesOverrideAccountingFieldsInput;
};


export type MutationIncomingInvoiceSendToIntacctArgs = {
  input: IncomingInvoicesSendToIntacctInput;
};


export type MutationIncomingInvoiceSendToMikrojumpArgs = {
  input: IncomingInvoicesSendToMikrojumpInput;
};


export type MutationIncomingInvoicesBulkBankPaymentCreateArgs = {
  input: IncomingInvoicesBulkBankPaymentCreateInput;
};


export type MutationIncomingInvoicesBulkDatevExportArgs = {
  input: IncomingInvoicesBulkDatevExportInput;
};


export type MutationIncomingInvoicesBulkGeneratePayoutsArgs = {
  input: IncomingInvoicesBulkGeneratePayoutsInput;
};


export type MutationIncomingInvoicesBulkIntacctExportArgs = {
  input: IncomingInvoicesBulkIntacctExportInput;
};


export type MutationIncomingInvoicesBulkMarkAsPaidArgs = {
  input: IncomingInvoicesBulkMarkAsPaidInput;
};


export type MutationIncomingInvoicesReallocateArgs = {
  input: IncomingInvoicesReallocateInput;
};


export type MutationJobOffersShippingInstructionsUpdateArgs = {
  input: JobOffersShippingInstructionUpdatesInput;
};


export type MutationJobsCreateAutomaticallyArgs = {
  input: CreateAutomaticallyInput;
};


export type MutationJobsRequestAutomaticallyArgs = {
  input: RequestAutomaticallyInput;
};


export type MutationLogisticInvoicesBulkBankPaymentCreateArgs = {
  input: LogisticInvoicesBulkCreateBankPaymentInput;
};


export type MutationLogisticInvoicesBulkMarkAsCanceledArgs = {
  input: LogisticInvoicesBulkMarkAsCanceledInput;
};


export type MutationLogisticInvoicesBulkMarkAsPaidArgs = {
  input: LogisticInvoicesBulkMarkAsPaidInput;
};


export type MutationLogisticInvoicesBulkMarkAsRegisteredArgs = {
  input: LogisticInvoicesBulkMarkAsRegisteredInput;
};


export type MutationLogisticInvoicesCreateDatevExportArgs = {
  input: LogisticInvoicesCreateDatevExportInput;
};


export type MutationLoyaltyTransactionsCreateArgs = {
  input: LoyaltyTransactionsCreateInput;
};


export type MutationMasterShippingsCreateArgs = {
  input: MasterShippingsCreateInput;
};


export type MutationMasterShippingsCreateFromShippingArgs = {
  input: MasterShippingsCreateFromShippingInput;
};


export type MutationMasterShippingsShipmentOrderCreateDhlOrderArgs = {
  input: MasterShippingsShipmentOrderCreateDhlOrderInput;
};


export type MutationMasterShippingsShipmentOrderRequestShippingOptionsArgs = {
  input: MasterShippingsShipmentOrderRequestShippingOptionsInput;
};


export type MutationMasterShippingsUpdateArgs = {
  input: MasterShippingsUpdateInput;
};


export type MutationMasterShippingsUpdateTrackingArgs = {
  input: MasterShippingsUpdateTrackingInput;
};


export type MutationMessageSubscriptionsBulkActionsMarkAllReadArgs = {
  input: MessageSubscriptionsBulkActionsMarkAllReadInput;
};


export type MutationMessageSubscriptionsBulkActionsSubscribeArgs = {
  input: MessageSubscriptionsBulkActionsSubscribeInput;
};


export type MutationMessageSubscriptionsBulkActionsUnsubscribeArgs = {
  input: MessageSubscriptionsBulkActionsUnsubscribeInput;
};


export type MutationMessengerAttachmentsUploadArgs = {
  input: MessengerAttachmentsUploadInput;
};


export type MutationMessengerConversationClearReplyRequiredArgs = {
  input: MessengerConversationClearReplyRequiredInput;
};


export type MutationMessengerMessageBookmarkArgs = {
  input: MessengerMessageBookmarkInput;
};


export type MutationMessengerMessageCreateArgs = {
  input: MessengerMessageCreateInput;
};


export type MutationMessengerMessageCreateFromTemplateArgs = {
  input: MessengerMessageCreateFromTemplateInput;
};


export type MutationMessengerMessageDeleteArgs = {
  input: MessengerMessageDeleteInput;
};


export type MutationMessengerMessageFilterAssignUserArgs = {
  input: MessengerMessageFilterAssignUserInput;
};


export type MutationMessengerMessageFilterCreateArgs = {
  input: MessengerMessageFilterCreateInput;
};


export type MutationMessengerMessageFilterDeleteArgs = {
  input: MessengerMessageFilterDeleteInput;
};


export type MutationMessengerMessageFilterGroupAssignUserArgs = {
  input: MessengerMessageFilterGroupAssignUserInput;
};


export type MutationMessengerMessageFilterGroupCreateArgs = {
  input: MessengerMessageFilterGroupCreateInput;
};


export type MutationMessengerMessageFilterGroupDeleteArgs = {
  input: MessengerMessageFilterGroupDeleteInput;
};


export type MutationMessengerMessageFilterGroupUpdateArgs = {
  input: MessengerMessageFilterGroupUpdateInput;
};


export type MutationMessengerMessageFilterUpdateArgs = {
  input: MessengerMessageFilterUpdateInput;
};


export type MutationMessengerMessagePinArgs = {
  input: MessengerMessagePinInput;
};


export type MutationMessengerMessageSendOriginalContentArgs = {
  input: MessengerMessageSendOriginalContentInput;
};


export type MutationMessengerMessageTaskUpdateAssigneesArgs = {
  input: MessengerMessageTaskUpdateAssigneesInput;
};


export type MutationMessengerMessageTaskUpdateStatusArgs = {
  input: MessengerMessageTaskUpdateStatusInput;
};


export type MutationMessengerMessageUpdateArgs = {
  input: MessengerMessageUpdateInput;
};


export type MutationMessengerSourceMarkReadArgs = {
  input: MessengerChannelMarkReadInput;
};


export type MutationMessengerSourceMarkUnreadArgs = {
  input: MessengerChannelMarkUnreadInput;
};


export type MutationMessengerSourceSubscribeArgs = {
  input: MessengerChannelSubscribeInput;
};


export type MutationMessengerSourceUnsubscribeArgs = {
  input: MessengerChannelUnsubscribeInput;
};


export type MutationMessengerTemplateGroupCreateArgs = {
  input: MessengerTemplateGroupCreateInput;
};


export type MutationMessengerTemplateGroupDeleteArgs = {
  input: MessengerTemplateGroupDeleteInput;
};


export type MutationMessengerTemplateGroupUpdateArgs = {
  input: MessengerTemplateGroupUpdateInput;
};


export type MutationMoveToDraftLogisticInvoiceArgs = {
  input: MoveToDraftLogisticInvoiceInput;
};


export type MutationOrderConfirmationApplyBillingAccountArgs = {
  input: OrderConfirmationsApplyBillingAccountInput;
};


export type MutationOrderConfirmationChangeRequestApproveArgs = {
  input: OrderConfirmationChangeRequestsApproveInput;
};


export type MutationOrderConfirmationChangeRequestRejectArgs = {
  input: OrderConfirmationChangeRequestsRejectInput;
};


export type MutationOrganizationBalanceRecordsForceRecalculateArgs = {
  input: OrganizationBalanceRecordsForceRecalculateInput;
};


export type MutationOrganizationsBulkActionsUpdateProductionManagerArgs = {
  input: OrganizationsBulkActionsUpdateProductionManagerInput;
};


export type MutationOrganizationsCreateArgs = {
  input: OrganizationsCreateInput;
};


export type MutationOrganizationsMergeArgs = {
  input: OrganizationsMergeInput;
};


export type MutationOrganizationsReactivationTransferArgs = {
  input: OrganizationsReactivationTransferInput;
};


export type MutationOrganizationsRequestDescriptionArgs = {
  input: OrganizationsRequestDescriptionInput;
};


export type MutationOrganizationsTransferToRegionArgs = {
  input: OrganizationTransferToRegionInput;
};


export type MutationOrganizationsUpdateArgs = {
  input: OrganizationsUpdateInput;
};


export type MutationOrganizationsUpdateProductionManagerArgs = {
  input: OrganizationsUpdateProductionManagerInput;
};


export type MutationOutcomingInvoiceExportZipArgs = {
  input: OutcomingInvoiceExportZipInput;
};


export type MutationOutcomingInvoiceMarkAsAccrualArgs = {
  input: MarkAsAccrualInput;
};


export type MutationOutcomingInvoiceOverrideAccountingArgs = {
  input: OutcomingInvoicesOverrideAccountingFieldsInput;
};


export type MutationOutcomingInvoiceOverridePaymentTermsDateArgs = {
  input: OutcomingInvoicesOverridePaymentTermsDateInput;
};


export type MutationOutcomingInvoiceRollbackMikrojumpSyncArgs = {
  input: OutcomingInvoicesRollbackMikrojumpSyncInput;
};


export type MutationOutcomingInvoiceSendToIntacctArgs = {
  input: OutcomingInvoicesSendToIntacctInput;
};


export type MutationOutcomingInvoiceSendToMikrojumpArgs = {
  input: OutcomingInvoicesSendToMikrojumpInput;
};


export type MutationOutcomingInvoicesBulkDatevExportArgs = {
  input: OutcomingInvoicesBulkDatevExportInput;
};


export type MutationOutcomingInvoicesBulkIntacctExportArgs = {
  input: OutcomingInvoicesBulkIntacctExportInput;
};


export type MutationOutcomingInvoicesBulkMarkAsPaidArgs = {
  input: OutcomingInvoicesBulkMarkAsPaidInput;
};


export type MutationOutcomingInvoicesRejectArgs = {
  input: OutcomingInvoicesRejectInput;
};


export type MutationPackageTrackingEventsCreateArgs = {
  input: PackageTrackingEventsCreateInput;
};


export type MutationPackageTrackingEventsDeleteArgs = {
  input: PackageTrackingEventsDeleteInput;
};


export type MutationPackageTrackingEventsUpdateArgs = {
  input: PackageTrackingEventsUpdateInput;
};


export type MutationPartStateCorrectionsCreateArgs = {
  input: PartStateCorrectionsCreateInput;
};


export type MutationPartStateCorrectionsDestroyArgs = {
  input: PartStateCorrectionsDestroyInput;
};


export type MutationPaymentOutcomingInvoiceRelationsCreateExportToDatevArgs = {
  input: PaymentOutcomingInvoiceRelationsCreateExportToDatevInput;
};


export type MutationPaymentOutcomingInvoiceRelationsUpdateRegisteredAtArgs = {
  input: PaymentOutcomingInvoiceRelationsUpdateRegisteredAtInput;
};


export type MutationPaymentsCreateExportToDatevArgs = {
  input: PaymentsCreateExportToDatevInput;
};


export type MutationPaymentsRegenerateAccountingRecordsArgs = {
  input: PaymentsRegenerateAccountingRecordsInput;
};


export type MutationPaymentsTransferBetweenDealsArgs = {
  input: PaymentsTransferBetweenDealsInput;
};


export type MutationPaymentsUpdateMethodArgs = {
  input: PaymetsUpdateMethodInput;
};


export type MutationPaymentsUpdateRegisteredAtArgs = {
  input: PaymentsUpdateRegisteredAtInput;
};


export type MutationPayoutsBankPaymentApproveAndCreateArgs = {
  input: PayoutBankPaymentApproveAndCreateInput;
};


export type MutationPayoutsBulkBankPaymentApproveAndCreateArgs = {
  input: PayoutsBulkBankPaymentApproveAndCreateInput;
};


export type MutationPayoutsBulkSetAsPaidArgs = {
  input: PayoutsBulkSetAsPaidInput;
};


export type MutationPayoutsCancelArgs = {
  input: PayoutsCancelInput;
};


export type MutationPayoutsCompleteArgs = {
  input: PayoutsCompleteInput;
};


export type MutationPayoutsCompleteAgainstAnotherArgs = {
  input: PayoutsCompleteAgainstAnotherInput;
};


export type MutationPayoutsCreateArgs = {
  input: PayoutsCreateInput;
};


export type MutationPayoutsDestroyArgs = {
  input: PayoutsDestroyInput;
};


export type MutationPayoutsUpdateArgs = {
  input: PayoutsUpdateInput;
};


export type MutationPayoutsUpdateMethodArgs = {
  input: PayoutsUpdateMethodInput;
};


export type MutationPersonsBulkUpdateArgs = {
  input: PersonsBulkUpdateInput;
};


export type MutationPersonsCreateArgs = {
  input: PersonsCreateInput;
};


export type MutationPersonsImpersonateArgs = {
  input: PersonsImpersonateInput;
};


export type MutationPersonsMergeArgs = {
  input: PersonsMergeInput;
};


export type MutationPersonsOrganizationChangeArgs = {
  input: PersonsOrganizationChangeInput;
};


export type MutationPersonsPunchoutAppendAddressesArgs = {
  input: PersonsPunchoutsAppendAddressesInput;
};


export type MutationPersonsPunchoutCreateArgs = {
  input: PersonsPunchoutsCreateInput;
};


export type MutationPersonsReactivationTransferArgs = {
  input: PersonsReactivationTransferInput;
};


export type MutationPersonsSafeDestroyArgs = {
  input: PersonsSafeDestroyInput;
};


export type MutationPersonsSendNewRegionVerifyArgs = {
  input: PersonsSendNewRegionVerifyInput;
};


export type MutationPersonsSyncContactArgs = {
  input: PersonsSyncContactInput;
};


export type MutationPersonsUpdateArgs = {
  input: PersonsUpdateInput;
};


export type MutationPersonsVerifyWhatsappNumberArgs = {
  input: PersonsVerifyWhatsAppNumberInput;
};


export type MutationProductionEventsCreateArgs = {
  input: ProductionEventsCreateInput;
};


export type MutationProductionEventsDeleteArgs = {
  input: ProductionEventsDeleteInput;
};


export type MutationProductionEventsUpdateArgs = {
  input: ProductionEventsUpdateInput;
};


export type MutationProductionScheduleItemsCreateArgs = {
  input: ProductionScheduleItemsCreateInput;
};


export type MutationProductionScheduleItemsDestroyArgs = {
  input: ProductionScheduleItemsDestroyInput;
};


export type MutationProductionScheduleItemsUpdateArgs = {
  input: ProductionScheduleItemsUpdateInput;
};


export type MutationProviderChangeRequestCreateArgs = {
  input: ChangeRequestsCreateForProviderInput;
};


export type MutationProviderOrdersCreateArgs = {
  input: ProviderOrdersCreateInput;
};


export type MutationProviderOrdersDestroyArgs = {
  input: ProviderOrdersDestroyInput;
};


export type MutationProviderOrdersIssueBasedOnJobOfferArgs = {
  input: ProviderOrdersIssueBasedOnJobOfferInput;
};


export type MutationProviderOrdersShippingInstructionsUpdateArgs = {
  input: ProviderOrdersShippingInstructionUpdatesInput;
};


export type MutationProviderOrdersSplitArgs = {
  input: ProviderOrdersSplitInput;
};


export type MutationProviderOrdersUpdateArgs = {
  input: ProviderOrdersUpdateInput;
};


export type MutationProviderXlsxReportArgs = {
  input: ProviderXlsxReportInput;
};


export type MutationProvidersBulkActionsAssignPartnerSuccessManagerArgs = {
  input: ProvidersBulkActionsAssignPartnerSuccessManagerInput;
};


export type MutationProvidersChangePrimaryArgs = {
  input: ChangePrimaryInput;
};


export type MutationProvidersContactsCreateArgs = {
  input: ContactsCreateInput;
};


export type MutationProvidersContactsDeleteArgs = {
  input: ContactsDeleteInput;
};


export type MutationProvidersContactsMoveArgs = {
  input: ContactsMoveInput;
};


export type MutationProvidersContactsUpdateArgs = {
  input: ContactsUpdateInput;
};


export type MutationProvidersCreateArgs = {
  input: ProvidersCreateInput;
};


export type MutationProvidersDeleteArgs = {
  input: ProvidersDeleteInput;
};


export type MutationProvidersSendToCheckArgs = {
  input: ProviderSendToCheckInput;
};


export type MutationProvidersSuccessManualArgs = {
  input: ProvidersSuccessManualInput;
};


export type MutationProvidersUpdateArgs = {
  input: ProvidersUpdateInput;
};


export type MutationProvidersUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationPublicDomainsCreateArgs = {
  input: PublicDomainsCreateInput;
};


export type MutationPublishGshDealTransferredEventArgs = {
  input: PublishDealTransferredEventInput;
};


export type MutationPublishLogisticInvoiceArgs = {
  input: PublishLogisticInvoiceInput;
};


export type MutationQualityControlsCreateArgs = {
  input: QualityControlsCreateInput;
};


export type MutationQualityControlsGeneratePdfReportArgs = {
  input: QualityControlsGeneratePdfReportInput;
};


export type MutationQualityControlsPositionDeleteArgs = {
  input: QualityControlsPositionsDeleteInput;
};


export type MutationQualityControlsPositionUpdateArgs = {
  input: QualityControlsPositionsUpdateInput;
};


export type MutationQualityControlsPositionsUpdateMeasurementsArgs = {
  input: QualityControlsPositionsUpdateMeasurementsInput;
};


export type MutationQualityControlsRepackArgs = {
  input: QualityControlsRepackInput;
};


export type MutationQualityControlsUpdateArgs = {
  input: QualityControlsUpdateInput;
};


export type MutationRequireRfqArgs = {
  input: EnquiryPartsRequireRfqInput;
};


export type MutationRfqsBulkSendOfferMessagesArgs = {
  input: RfqsSendBulkMessagesInput;
};


export type MutationRfqsCancelArgs = {
  input: RfqsCancelInput;
};


export type MutationRfqsCloseArgs = {
  input: RfqsCloseInput;
};


export type MutationRfqsDeleteArgs = {
  input: RfqsDeleteInput;
};


export type MutationRfqsOffersApplyArgs = {
  input: RfqsOffersApplyInput;
};


export type MutationRfqsOffersBulkActionsUpdateProviderAmountArgs = {
  input: RfqsOffersBulkActionsUpdateProviderAmountInput;
};


export type MutationRfqsOffersDeleteArgs = {
  input: RfqsOffersDeleteInput;
};


export type MutationRfqsOffersFindOrCreateArgs = {
  input: RfqsOffersFindOrCreateInput;
};


export type MutationRfqsOffersPricesDeleteArgs = {
  input: RfqsOffersPricesDeleteInput;
};


export type MutationRfqsOffersUpdateArgs = {
  input: RfqsOffersUpdateInput;
};


export type MutationRfqsPositionsDeleteArgs = {
  input: RfqsPositionsDeleteInput;
};


export type MutationRfqsPublishArgs = {
  input: RfqsPublishInput;
};


export type MutationRfqsReactivateArgs = {
  input: RfqsReactivateInput;
};


export type MutationRfqsUpdateArgs = {
  input: RfqsUpdateInput;
};


export type MutationRolesRequestPermissionArgs = {
  input: RolesRequestPermissionInput;
};


export type MutationRolesUpdatePermissionsArgs = {
  input: RolesUpdatePermissionsInput;
};


export type MutationSalesPersonsBulkUpdateRfqStatusArgs = {
  input: SalesPersonsBulkUpdateRfqStatusInput;
};


export type MutationSetRecommendedRfqStatusArgs = {
  input: SetRecommendedRfqStatusInput;
};


export type MutationShipmentOrderCreateArasOrderArgs = {
  input: ShipmentOrderCreateArasOrderInput;
};


export type MutationShipmentOrderCreateDbSchenkerOrderArgs = {
  input: ShipmentOrderCreateDbSchenkerOrderInput;
};


export type MutationShipmentOrderCreateDhlOrderArgs = {
  input: ShipmentOrderCreateDhlOrderInput;
};


export type MutationShipmentOrderCreateEurosenderOrderArgs = {
  input: ShipmentOrderCreateEurosenderOrderInput;
};


export type MutationShipmentOrderCreateJumingoOrderArgs = {
  input: ShipmentOrderCreateJumingoOrderInput;
};


export type MutationShipmentOrderCreateUpsOrderArgs = {
  input: ShipmentOrderCreateUpsOrderInput;
};


export type MutationShipmentOrderCreateYurticiOrderArgs = {
  input: ShipmentOrderCreateYurticiOrderInput;
};


export type MutationShipmentOrderQuickBookFromXometryArgs = {
  input: QuickBookFromXometryInput;
};


export type MutationShipmentOrderRequestShippingOptionsArgs = {
  input: ShipmentOrderRequestShippingOptionsInput;
};


export type MutationShipmentOrderValidateAutoOrderFromXometryArgs = {
  input: ValidateAutoOrderFromXometryInput;
};


export type MutationShippingAddressesCreateArgs = {
  input: ShippingAddressesCreateInput;
};


export type MutationShippingAddressesDeleteArgs = {
  input: ShippingAddressesDeleteInput;
};


export type MutationShippingAddressesForOrgPersonsCreateArgs = {
  input: ShippingAddressesForOrgPersonsCreateInput;
};


export type MutationShippingAddressesUpdateArgs = {
  input: ShippingAddressesUpdateInput;
};


export type MutationShippingAddressesUpdateCascadeArgs = {
  input: ShippingAddressesUpdateCascadeInput;
};


export type MutationShippingCalculationsApplyCostArgs = {
  input: ShippingCalculationsApplyCostInput;
};


export type MutationShippingCalculationsCreateArgs = {
  input: ShippingCalculationsCreateInput;
};


export type MutationShippingCalculationsDeleteArgs = {
  input: ShippingCalculationsDeleteInput;
};


export type MutationShippingCalculationsRemoveManualPricesArgs = {
  input: ShippingCalculationsRemoveManualPricesInput;
};


export type MutationShippingCalculationsUpdateArgs = {
  input: ShippingCalculationsUpdateInput;
};


export type MutationShippingCalculationsUpdateManualPricesArgs = {
  input: ShippingCalculationsUpdateManualPricesInput;
};


export type MutationShippingInstructionOverrideArgs = {
  input: ShippingInstructionOverrideInput;
};


export type MutationShippingsAddToMasterShippingArgs = {
  input: ShippingsAddToMasterShippingInput;
};


export type MutationShippingsBulkAddToMasterShippingArgs = {
  input: ShippingsBulkAddToMasterShippingInput;
};


export type MutationShippingsBulkMoveToStateArgs = {
  input: ShippingsBulkMoveToStateInput;
};


export type MutationShippingsBulkRemoveFromMasterShippingArgs = {
  input: ShippingsBulkRemoveFromMasterShippingInput;
};


export type MutationShippingsBulkUpdateTrackingArgs = {
  input: ShippingsBulkUpdateTrackingInput;
};


export type MutationShippingsCreateArgs = {
  input: ShippingsCreateInput;
};


export type MutationShippingsSendToExternalArgs = {
  input: ShippingsSendToExternalInput;
};


export type MutationShippingsSyncWithExternalArgs = {
  input: ShippingsSyncWithExternalInput;
};


export type MutationShippingsUpdateArgs = {
  input: ShippingsFormUpdateInput;
};


export type MutationShippingsUpdateTrackingArgs = {
  input: ShippingsUpdateTrackingInput;
};


export type MutationTeamsAddUserArgs = {
  input: TeamsAddUserInput;
};


export type MutationTeamsCreateArgs = {
  input: TeamsCreateInput;
};


export type MutationTeamsRemoveUserArgs = {
  input: TeamsRemoveUserInput;
};


export type MutationTeamsUpdateArgs = {
  input: TeamsUpdateInput;
};


export type MutationTeamsUpdateMembershipTypeArgs = {
  input: TeamsUpdateMembershipTypeInput;
};


export type MutationTeamspacesAddBillingAccountArgs = {
  input: OmsTeamspacesAddBillingAccountInput;
};


export type MutationTeamspacesAddPersonArgs = {
  input: OmsTeamspacesAddPersonInput;
};


export type MutationTeamspacesAddShippingAddressArgs = {
  input: OmsTeamspaceAddShippingAddressInput;
};


export type MutationTeamspacesBillingAccountCreditLimitUpdateArgs = {
  input: OmsTeamspacesBillingAccountsCreditLimitUpdateInput;
};


export type MutationTeamspacesBillingAccountSetAsDefaultArgs = {
  input: OmsTeamspacesBillingAccountSetAsDefaultInput;
};


export type MutationTeamspacesCreateArgs = {
  input: OmsTeamspacesCreateInput;
};


export type MutationTeamspacesDeleteArgs = {
  input: OmsTeamspacesDeleteInput;
};


export type MutationTeamspacesInvitesDeleteArgs = {
  input: OmsTeamspacesInvitesDeleteInput;
};


export type MutationTeamspacesInvitesResendArgs = {
  input: OmsTeamspacesInvitesResendInput;
};


export type MutationTeamspacesPersonRoleUpdateArgs = {
  input: OmsTeamspacesPersonRoleUpdateInput;
};


export type MutationTeamspacesRemoveBillingAccountArgs = {
  input: OmsTeamspacesRemoveBillingAccountInput;
};


export type MutationTeamspacesRemovePersonArgs = {
  input: OmsTeamspacesRemovePersonInput;
};


export type MutationTeamspacesRemoveShippingAddressArgs = {
  input: OmsTeamspaceRemoveShippingAddressInput;
};


export type MutationTeamspacesSetAsDefaultShippingAddressArgs = {
  input: OmsTeamspaceSetAsDefaultShippingAddressInput;
};


export type MutationTeamspacesSetDefaultBillingAccountArgs = {
  input: OmsTeamspacesSetDefaultBillingAccountInput;
};


export type MutationTeamspacesTransferOwnershipArgs = {
  input: OmsTeamspacesTransferOwnershipInput;
};


export type MutationTeamspacesUpdateArgs = {
  input: OmsTeamspacesUpdateInput;
};


export type MutationUpdateLogisticInvoiceArgs = {
  input: UpdateLogisticInvoiceInput;
};


export type MutationUpdateLogisticInvoiceRelatedShippingsArgs = {
  input: UpdateLogisticInvoiceRelatedShippingsInput;
};


export type MutationUpdateLogisticOperatorBillingAccountArgs = {
  input: UpdateLogisticOperatorBillingAccountInput;
};


export type MutationUpdateRfqFieldsArgs = {
  input: EnquiryPartsUpdateRfqFieldsInput;
};


export type MutationUsersAssignRolesArgs = {
  input: UsersAssignRolesInput;
};


export type MutationUsersCreateSubstitutionArgs = {
  input: OmsUsersCreateSubstitutionInput;
};


export type MutationUsersDeleteSubstitutionArgs = {
  input: OmsUsersDeleteSubstitutionInput;
};


export type MutationUsersEmailLoginArgs = {
  input: EmailLoginInput;
};


export type MutationUsersUpdateAvatarArgs = {
  input: UsersUpdateAvatarInput;
};


export type MutationUsersUpdatePermissionsArgs = {
  input: UsersUpdatePermissionsInput;
};


export type MutationUsersUpdateProfileArgs = {
  input: UsersUpdateProfileInput;
};


export type MutationUsersUpdateSubstitutionArgs = {
  input: OmsUsersUpdateSubstitutionInput;
};


export type MutationWorkspacePresetsAssignDefaultPresetArgs = {
  input: WorkspacePresetsAssignDefaultPresetInput;
};


export type MutationWorkspacePresetsAssignGlobalDefaultPresetArgs = {
  input: WorkspacePresetsAssignGlobalDefaultPresetInput;
};


export type MutationWorkspacePresetsCreateArgs = {
  input: WorkspacePresetsCreateInput;
};


export type MutationWorkspacePresetsDeleteArgs = {
  input: WorkspacePresetsDeleteInput;
};


export type MutationWorkspacePresetsRemoveDefaultPresetArgs = {
  input: WorkspacePresetsRemoveDefaultPresetInput;
};


export type MutationWorkspacePresetsRemoveGlobalDefaultPresetArgs = {
  input: WorkspacePresetsRemoveGlobalDefaultPresetInput;
};


export type MutationWorkspacePresetsUpdateArgs = {
  input: WorkspacePresetsUpdateInput;
};


export type MutationWorkspacesBankPaymentsDraftExportArgs = {
  input: BankPaymentsDraftExportInput;
};


export type MutationWorkspacesBankPaymentsExportArgs = {
  input: BankPaymentsExportInput;
};


export type MutationWorkspacesBillingAccountsExportArgs = {
  input: BillingAccountsExportInput;
};


export type MutationWorkspacesClaimsExportArgs = {
  input: ClaimsExportInput;
};


export type MutationWorkspacesCouponsExportArgs = {
  input: CouponsExportInput;
};


export type MutationWorkspacesDealDocumentsExportArgs = {
  input: DealDocumentsExportInput;
};


export type MutationWorkspacesDealsExportArgs = {
  input: DealsExportInput;
};


export type MutationWorkspacesDraftingDealPartsExportArgs = {
  input: DraftingDealPartsExportInput;
};


export type MutationWorkspacesDraftingEnquiryPartsExportArgs = {
  input: DraftingEnquiryPartsExportInput;
};


export type MutationWorkspacesEmailMessagesExportArgs = {
  input: EmailMessagesExportInput;
};


export type MutationWorkspacesEnquiriesExportArgs = {
  input: EnquiriesExportInput;
};


export type MutationWorkspacesEnquiriesSfCasesExportArgs = {
  input: EnquiriesSfCasesExportInput;
};


export type MutationWorkspacesEnquiryPromotionsExportArgs = {
  input: EnquiryPromotionsExportInput;
};


export type MutationWorkspacesFrameworkBatchesExportArgs = {
  input: FrameworkBatchesExportInput;
};


export type MutationWorkspacesHsCodesExportArgs = {
  input: HsCodesExportInput;
};


export type MutationWorkspacesIncomingInvoicesExportArgs = {
  input: IncomingInvoicesExportInput;
};


export type MutationWorkspacesIntacctEventsExportArgs = {
  input: IntacctEventsExportInput;
};


export type MutationWorkspacesJobOffersExportArgs = {
  input: JobOffersExportInput;
};


export type MutationWorkspacesJobsExportArgs = {
  input: JobsExportInput;
};


export type MutationWorkspacesLogisticInvoicesExportArgs = {
  input: LogisticInvoicesExportInput;
};


export type MutationWorkspacesMessagesExportArgs = {
  input: MessagesExportInput;
};


export type MutationWorkspacesOrganizationBalancesExportArgs = {
  input: OrganizationBalancesExportInput;
};


export type MutationWorkspacesOrganizationsExportArgs = {
  input: OrganizationsExportInput;
};


export type MutationWorkspacesOutcomingInvoicesExportArgs = {
  input: OutcomingInvoicesExportInput;
};


export type MutationWorkspacesPaymentsExportArgs = {
  input: PaymentsExportInput;
};


export type MutationWorkspacesPayoutsExportArgs = {
  input: PayoutsExportInput;
};


export type MutationWorkspacesPersonsExportArgs = {
  input: PersonsExportInput;
};


export type MutationWorkspacesProductionScheduleItemsExportArgs = {
  input: ProductionScheduleItemsExportInput;
};


export type MutationWorkspacesProviderOrdersExportArgs = {
  input: ProviderOrdersExportInput;
};


export type MutationWorkspacesProvidersExportArgs = {
  input: ProvidersExportInput;
};


export type MutationWorkspacesQualityControlsExportArgs = {
  input: QualityControlsExportInput;
};


export type MutationWorkspacesRefundsExportArgs = {
  input: RefundsExportInput;
};


export type MutationWorkspacesRfqOffersExportArgs = {
  input: RfqOffersExportInput;
};


export type MutationWorkspacesRfqPartnersExportArgs = {
  input: RfqPartnersExportInput;
};


export type MutationWorkspacesRfqsExportArgs = {
  input: RfqsExportInput;
};


export type MutationWorkspacesShippingAddressesExportArgs = {
  input: ShippingAddressesExportInput;
};


export type MutationWorkspacesShippingsExportArgs = {
  input: ShippingsExportInput;
};


export type MutationWorkspacesStoragesExportArgs = {
  input: StoragesExportInput;
};


export type MutationWorkspacesSubscriptionsExportArgs = {
  input: SubscriptionsExportInput;
};


export type MutationWorkspacesTasksExportArgs = {
  input: TasksExportInput;
};


export type MutationWorkspacesTeamspacesExportArgs = {
  input: TeamspacesExportInput;
};


export type MutationWorkspacesUsersExportArgs = {
  input: UsersExportInput;
};

export type Oc = {
  __typename?: 'OC';
  changeRequestState?: Maybe<DealsOrderConfirmationChangeRequestStateEnumType>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  deal: Deal;
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
  paymentTerms?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  totalAmountBrut: Scalars['Float']['output'];
  totalAmountNet: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ObjectList = {
  __typename?: 'ObjectList';
  claims: Array<Claim>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNotes?: Maybe<Array<CreditNote>>;
  deal: Deal;
  deliveries?: Maybe<Array<Delivery>>;
  enquiry?: Maybe<Enquiry>;
  id: Scalars['Int']['output'];
  incomingInvoices?: Maybe<Array<IncomingInvoice>>;
  jobs?: Maybe<Array<Job>>;
  orderConfirmation?: Maybe<Oc>;
  outcomingInvoices?: Maybe<Array<OutcomingInvoice>>;
  payments: Array<Payment>;
  payouts?: Maybe<Array<Payout>>;
  providerOrders: Array<ProviderOrder>;
  qualityControls?: Maybe<Array<QualityControl>>;
  quotations: Array<Quotation>;
  rfqs?: Maybe<Array<Rfq>>;
  shippings?: Maybe<Array<Shipping>>;
  storages?: Maybe<Array<Storage>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ObjectTypeEnum {
  /** AttachedFile */
  AttachedFile = 'AttachedFile',
  /** BankPayment */
  BankPayment = 'BankPayment',
  /** BillingAccount */
  BillingAccount = 'BillingAccount',
  /** Deal::OrderConfirmation::ChangeRequest */
  ChangeRequest = 'ChangeRequest',
  /** Deal::Claim */
  Claim = 'Claim',
  /** Provider::Contact */
  Contact = 'Contact',
  /** Deal */
  Deal = 'Deal',
  /** Deal::Document */
  DealDocument = 'DealDocument',
  /** Deal::QualityControl::Document */
  Document = 'Document',
  /** Enquiry */
  Enquiry = 'Enquiry',
  /** Enquiry::Part */
  EnquiryPart = 'EnquiryPart',
  /** Enquiry::Rfq */
  EnquiryRfq = 'EnquiryRfq',
  /** FrameworkBatch */
  FrameworkBatch = 'FrameworkBatch',
  /** HsCodeDataset */
  HsCodeDataset = 'HsCodeDataset',
  /** Deal::IncomingInvoice */
  IncomingInvoice = 'IncomingInvoice',
  /** Job */
  Job = 'Job',
  /** Job::Offer */
  JobOffer = 'JobOffer',
  /** LogisticInvoice */
  LogisticInvoice = 'LogisticInvoice',
  /** LogisticOperator */
  LogisticOperator = 'LogisticOperator',
  /** MasterShipping */
  MasterShipping = 'MasterShipping',
  /** Message */
  Message = 'Message',
  /** MessageTemplateGroup */
  MessageTemplateGroup = 'MessageTemplateGroup',
  /** Deal::OrderConfirmation */
  OrderConfirmation = 'OrderConfirmation',
  /** Organization */
  Organization = 'Organization',
  /** Deal::OutcomingInvoice */
  OutcomingInvoice = 'OutcomingInvoice',
  /** Deal::Part */
  Part = 'Part',
  /** Deal::Payment */
  Payment = 'Payment',
  /** Deal::Payout */
  Payout = 'Payout',
  /** Person */
  Person = 'Person',
  /** Rfq::Position */
  Position = 'Position',
  /** Provider */
  Provider = 'Provider',
  /** Deal::ProviderOrder */
  ProviderOrder = 'ProviderOrder',
  /** PublicDomain */
  PublicDomain = 'PublicDomain',
  /** Deal::QualityControl */
  QualityControl = 'QualityControl',
  /** Rfq */
  Rfq = 'Rfq',
  /** Rfq::Offer */
  RfqOffer = 'RfqOffer',
  /** Role */
  Role = 'Role',
  /** Deal::Shipping */
  Shipping = 'Shipping',
  /** ShippingInstruction */
  ShippingInstruction = 'ShippingInstruction',
  /** Deal::Storage */
  Storage = 'Storage',
  /** Team */
  Team = 'Team',
  /** Teamspace */
  Teamspace = 'Teamspace',
  /** User */
  User = 'User'
}

/** Autogenerated input type of OmsAiCopilotDislikeExtractedField */
export type OmsAiCopilotDislikeExtractedFieldInput = {
  /** AiResponse id for extract_invoice_data */
  aiResponseId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Field name inside response (e.g., iban or line_item.0.name) */
  field: Scalars['String']['input'];
};

/** Autogenerated return type of OmsAiCopilotDislikeExtractedField. */
export type OmsAiCopilotDislikeExtractedFieldPayload = {
  __typename?: 'OmsAiCopilotDislikeExtractedFieldPayload';
  aiResponseId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  responseData: Scalars['JSON']['output'];
};

/** Autogenerated input type of OmsAiCopilotTranslate */
export type OmsAiCopilotTranslateInput = {
  args: TranslateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OmsAiCopilotTranslate. */
export type OmsAiCopilotTranslatePayload = {
  __typename?: 'OmsAiCopilotTranslatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the translation request */
  responseId: Scalars['ID']['output'];
  /** Status of the translation request */
  status: Scalars['String']['output'];
  /** Translated text if exists */
  translation?: Maybe<Scalars['String']['output']>;
};

export enum OmsClaimCustomerPositionEnumType {
  Cancel = 'cancel',
  Discount = 'discount',
  FixByCustomer = 'fix_by_customer',
  FixByShift = 'fix_by_shift',
  InformOnly = 'inform_only',
  Other = 'other',
  Unknown = 'unknown'
}

export enum OmsClaimCustomerPreferredResolutionEnumType {
  Other = 'other',
  RepairOrRemanufacture = 'repair_or_remanufacture',
  XPoints = 'x_points'
}

export enum OmsClaimStateEnum {
  CashCollection = 'cash_collection',
  Closed = 'closed',
  CustomerDraft = 'customer_draft',
  Declined = 'declined',
  Discovered = 'discovered',
  NeedInfo = 'need_info',
  New = 'new',
  ResolvedWithCustomer = 'resolved_with_customer',
  ResolvedWithProvider = 'resolved_with_provider',
  ReturnDelivery = 'return_delivery',
  SolutionSelected = 'solution_selected'
}

export enum OmsDealsAdditionalServiceReferenceTypeEnumType {
  DealPart = 'DealPart'
}

export enum OmsDealsClaimsDealFromObjectEnumType {
  Person = 'Person',
  Teamspace = 'Teamspace'
}

export type OmsEnquiryAppliedPromotionType = {
  __typename?: 'OmsEnquiryAppliedPromotionType';
  amount?: Maybe<Scalars['Float']['output']>;
  amountMoney?: Maybe<Money>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  enquiryId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  promotion: OmsEnquiryPromotionType;
  promotionId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum OmsEnquiryCertificateEnum {
  CertCompliance_2_1 = 'cert_compliance_2_1',
  CertCompliance_2_2 = 'cert_compliance_2_2',
  CertHeatTreatment = 'cert_heat_treatment',
  CertMaterials_3_1 = 'cert_materials_3_1',
  CertMaterials_3_1V2 = 'cert_materials_3_1_v2',
  CertMaterialsPlastic = 'cert_materials_plastic',
  CertOfOrigin = 'cert_of_origin',
  CertReach = 'cert_reach',
  CertRohs = 'cert_rohs'
}

export type OmsEnquiryCertificateValue = {
  __typename?: 'OmsEnquiryCertificateValue';
  amountMoney: Money;
  key: Scalars['String']['output'];
  partIds: Array<Scalars['ID']['output']>;
  positions: Scalars['Int']['output'];
};

export type OmsEnquiryCreditLimitValidationErrorType = {
  __typename?: 'OmsEnquiryCreditLimitValidationErrorType';
  baAccess?: Maybe<Scalars['String']['output']>;
  creditLimitMoney?: Maybe<Money>;
  currentDebtMoney?: Maybe<Money>;
  currentOpenOrdersMoney?: Maybe<Money>;
  currentOrderMoney?: Maybe<Money>;
  name?: Maybe<Scalars['String']['output']>;
  orgAccess?: Maybe<Scalars['String']['output']>;
  personAccess?: Maybe<Scalars['String']['output']>;
  totalMoney?: Maybe<Money>;
  valid: Scalars['Boolean']['output'];
};

export type OmsEnquiryFillEnquiryType = {
  __typename?: 'OmsEnquiryFillEnquiryType';
  startedAt: Scalars['ISO8601DateTime']['output'];
  status?: Maybe<FillEnquiryStatusEnum>;
};

export type OmsEnquiryMeasurementProtocol = {
  __typename?: 'OmsEnquiryMeasurementProtocol';
  allowedProcessIds: Array<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priceMoney: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of OmsEnquiryPartCertificatesUpdate */
export type OmsEnquiryPartCertificatesUpdateInput = {
  attributes: OmsInputsEnquiriesPartsCertificatesUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsEnquiryPartCertificatesUpdate. */
export type OmsEnquiryPartCertificatesUpdatePayload = {
  __typename?: 'OmsEnquiryPartCertificatesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  part: OmsEnquiryPartType;
};

export type OmsEnquiryPartQuantityOption = {
  __typename?: 'OmsEnquiryPartQuantityOption';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type OmsEnquiryPartQuantityOptionMoney = {
  __typename?: 'OmsEnquiryPartQuantityOptionMoney';
  cost: Scalars['Float']['output'];
  costMoney: Money;
  leadDate?: Maybe<Scalars['ISO8601Date']['output']>;
  leadTime?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  priceMoney: Money;
  quantity: Scalars['Int']['output'];
};

export type OmsEnquiryPartTagsMappingType = {
  __typename?: 'OmsEnquiryPartTagsMappingType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  partId: Scalars['ID']['output'];
  tags: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OmsEnquiryPartType = {
  __typename?: 'OmsEnquiryPartType';
  applicableCertificateKeys: Array<OmsEnquiryCertificateEnum>;
  appliedCouponValueMoney?: Maybe<Money>;
  appliedPromotions?: Maybe<Array<OmsEnquiryAppliedPromotionType>>;
  color?: Maybe<Color>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customColor?: Maybe<Scalars['String']['output']>;
  customFinish?: Maybe<Scalars['String']['output']>;
  customMaterial?: Maybe<Scalars['String']['output']>;
  customShoreHardness?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  dimensions?: Maybe<Dimension>;
  economyLeadDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expressLeadDate?: Maybe<Scalars['ISO8601Date']['output']>;
  externalRfqOfferId?: Maybe<Scalars['ID']['output']>;
  files: Array<AttachedFile>;
  finish?: Maybe<Finish>;
  finishColor?: Maybe<Color>;
  finishCustomColor?: Maybe<Scalars['String']['output']>;
  gaugeId?: Maybe<Scalars['ID']['output']>;
  hasCleaned: Scalars['Boolean']['output'];
  hasExpress?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** The material type of the part is the quote owner's favorite for its process */
  isFavoriteMaterialType: Scalars['Boolean']['output'];
  leadTimeTerms?: Maybe<Scalars['String']['output']>;
  manualPriceMoney?: Maybe<Money>;
  material?: Maybe<Material>;
  materialType?: Maybe<MaterialType>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  priceExpired: Scalars['Boolean']['output'];
  priceExpiresAt?: Maybe<Scalars['ISO8601Date']['output']>;
  priceMoney?: Maybe<Money>;
  priceOptions?: Maybe<Scalars['JSON']['output']>;
  priceValidTill?: Maybe<Scalars['ISO8601DateTime']['output']>;
  priceValidTillDefault: Scalars['ISO8601DateTime']['output'];
  priceValidTillUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  priceValidTillUpdatedBy?: Maybe<User>;
  process?: Maybe<OmsEnquiryProcessType>;
  processColor?: Maybe<Color>;
  processCustomColor?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  quantityOptions?: Maybe<Array<OmsEnquiryPartQuantityOptionMoney>>;
  rfqFeedback?: Maybe<Scalars['String']['output']>;
  rfqIsUrgent?: Maybe<Scalars['Boolean']['output']>;
  rfqNeedEngineer?: Maybe<Scalars['Boolean']['output']>;
  rfqNeedEngineerAt?: Maybe<Scalars['String']['output']>;
  rfqNeedEngineerByName?: Maybe<Scalars['String']['output']>;
  rfqNeedInfo?: Maybe<Scalars['Boolean']['output']>;
  rfqNeedInfoAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rfqNeedInfoByName?: Maybe<Scalars['String']['output']>;
  rfqOffer?: Maybe<RfqOffer>;
  rfqOfferRegion?: Maybe<Scalars['String']['output']>;
  rfqOwner?: Maybe<User>;
  rfqPositions: Array<RfqPosition>;
  rfqStatus?: Maybe<Scalars['String']['output']>;
  rfqStatusChangedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shoreHardnessId?: Maybe<Scalars['ID']['output']>;
  shouldRfq: Scalars['Boolean']['output'];
  standardLeadDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  surfaceRoughnessId?: Maybe<Scalars['ID']['output']>;
  surfaceRoughnessQuantity: Scalars['Int']['output'];
  tagList: Array<Scalars['String']['output']>;
  toleranceId?: Maybe<Scalars['ID']['output']>;
  toleranceQuantity: Scalars['Int']['output'];
  toolPriceMoney?: Maybe<Money>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OmsEnquiryPlannedMargin = {
  __typename?: 'OmsEnquiryPlannedMargin';
  canCalculate: Scalars['Boolean']['output'];
  costs: OmsEnquiryPlannedMarginCosts;
  discounts: OmsEnquiryPlannedMarginDiscounts;
  income: OmsEnquiryPlannedMarginIncome;
  margin: OmsEnquiryPlannedMarginSummary;
  totalNetto: Money;
  totalNettoWithoutDiscount: Money;
};

export type OmsEnquiryPlannedMarginCostTag = {
  __typename?: 'OmsEnquiryPlannedMarginCostTag';
  kind: OmsEnquiryPlannedMarginCostTagKind;
  partPositions: Array<Scalars['Int']['output']>;
};

export enum OmsEnquiryPlannedMarginCostTagKind {
  CostNotFound = 'cost_not_found',
  Empty = 'empty',
  ManualQuotingPrices = 'manual_quoting_prices',
  MixedPrices = 'mixed_prices',
  RfqPartnerPrices = 'rfq_partner_prices'
}

export type OmsEnquiryPlannedMarginCosts = {
  __typename?: 'OmsEnquiryPlannedMarginCosts';
  providerParts: Money;
  tag: OmsEnquiryPlannedMarginCostTag;
  total: Money;
};

export type OmsEnquiryPlannedMarginDiscounts = {
  __typename?: 'OmsEnquiryPlannedMarginDiscounts';
  appliedCoupons: Money;
  appliedPercent?: Maybe<Scalars['Float']['output']>;
  nonPartPositionCoupon: Money;
  nonPartPositionDiscount: Money;
  prepayDiscount: Money;
  total: Money;
};

export type OmsEnquiryPlannedMarginIncome = {
  __typename?: 'OmsEnquiryPlannedMarginIncome';
  certificates: Money;
  minOrderCharge: Money;
  nonPartPositionCorrection: Money;
  nonPartPositionOther: Money;
  partsValue: Money;
  total: Money;
};

export type OmsEnquiryPlannedMarginSummary = {
  __typename?: 'OmsEnquiryPlannedMarginSummary';
  plannedAmount: Money;
  plannedPercent?: Maybe<Scalars['Float']['output']>;
  plannedWithoutDiscountsAmount: Money;
  plannedWithoutDiscountsPercent?: Maybe<Scalars['Float']['output']>;
};

export type OmsEnquiryProcessType = {
  __typename?: 'OmsEnquiryProcessType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OmsEnquiryPromotionType = {
  __typename?: 'OmsEnquiryPromotionType';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountMoney?: Maybe<Money>;
  discountUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export type OmsInputsAdditionalServicesXPointsPositionType = {
  name: Scalars['String']['input'];
  points: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

export type OmsInputsAddressType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsAttachedFilesCleanedFileType = {
  cleanedFileId: Scalars['ID']['input'];
  originalFileId: Scalars['ID']['input'];
};

export enum OmsInputsAttachedFilesCleanedFilesEntityTypeEnumType {
  Deal = 'deal',
  Enquiry = 'enquiry'
}

export type OmsInputsAttachmentType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  fileBase64Encode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type OmsInputsBankPaymentsPaymentsCreateType = {
  amountBrut: Scalars['Float']['input'];
  billingAccountId: Scalars['ID']['input'];
  datevComment?: InputMaybe<Scalars['String']['input']>;
  intacctComment?: InputMaybe<Scalars['String']['input']>;
  methodId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

export type OmsInputsBankPaymentsUpdateOutlyingTypeType = {
  outlyingTransactionType?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsBankPaymentsUpdateType = {
  amount: Scalars['Float']['input'];
  bankAccount: Scalars['String']['input'];
  bankAccountHolderName: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  bankCountry: Scalars['String']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  endToEndId?: InputMaybe<Scalars['String']['input']>;
  paymentDetailsText?: InputMaybe<Scalars['String']['input']>;
  payoutTransferType: Scalars['String']['input'];
  providerCountry?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsBillingAccountCreditLimitType = {
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  creditLimitCurrency?: InputMaybe<CurrencyEnum>;
  creditLimitRequest?: InputMaybe<Scalars['Float']['input']>;
  dnbDunsNumber?: InputMaybe<Scalars['String']['input']>;
  dnbHasRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  dnbRecommendation?: InputMaybe<Scalars['Float']['input']>;
  dnbRecommendationCurrency?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsBillingAccountPaymentTermsType = {
  badPayer?: InputMaybe<Scalars['Boolean']['input']>;
  creditLimit: OmsInputsMoneyType;
  creditLimitRequest?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<Array<OmsInputsAttachmentType>>;
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTermsType: PaymentTermsTypeEnum;
};

export type OmsInputsBillingAccountRequestCreditLimitType = {
  creditLimitRequest?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsBillingAccountType = {
  accountType: Scalars['String']['input'];
  address: Scalars['String']['input'];
  attachmentUuidIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  datevId?: InputMaybe<Scalars['String']['input']>;
  einvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  overrideVatValidation?: InputMaybe<Scalars['Boolean']['input']>;
  peppolBuyerReference?: InputMaybe<Scalars['String']['input']>;
  peppolIdType?: InputMaybe<Scalars['String']['input']>;
  peppolParticipantId?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  removedAttachmentUuidIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  teamspaceId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
  vatExempt?: InputMaybe<Scalars['Boolean']['input']>;
  vatExemptionCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  vatExemptionExpirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  vatRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  vatRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  vatValidationStatus?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type OmsInputsBillingAccountUpdateCascadeType = {
  cascadeToObjects: Array<OmsInputsCascadeToObjectType>;
};

export type OmsInputsCascadeToObjectType = {
  id: Scalars['ID']['input'];
  objectType: Scalars['String']['input'];
};

export type OmsInputsCertificateType = {
  amount: Scalars['Float']['input'];
  positions: Scalars['Int']['input'];
};

export type OmsInputsCertificatesType = {
  cert_compliance_2_1?: InputMaybe<OmsInputsCertificateType>;
  cert_compliance_2_2?: InputMaybe<OmsInputsCertificateType>;
  cert_heat_treatment?: InputMaybe<OmsInputsCertificateType>;
  cert_materials_3_1?: InputMaybe<OmsInputsCertificateType>;
  cert_materials_3_1_v2?: InputMaybe<OmsInputsCertificateType>;
  cert_materials_3_2?: InputMaybe<OmsInputsCertificateType>;
  cert_materials_plastic?: InputMaybe<OmsInputsCertificateType>;
  cert_of_origin?: InputMaybe<OmsInputsCertificateType>;
  cert_reach?: InputMaybe<OmsInputsCertificateType>;
  cert_rohs?: InputMaybe<OmsInputsCertificateType>;
};

export type OmsInputsChangeRequestsProviderDataType = {
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<OmsInputsChangeRequestsProvidersBillingAddressDataType>;
  datevKonto?: InputMaybe<Scalars['String']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  notVatPayer?: InputMaybe<Scalars['Boolean']['input']>;
  payoutTransferType?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsChangeRequestsProviderType = {
  attachmentUuidIds: Array<Scalars['ID']['input']>;
  data: OmsInputsChangeRequestsProviderDataType;
  selectedNotCheckedInvoices: Array<Scalars['Int']['input']>;
  selectedNotPaidInvoices: Array<Scalars['Int']['input']>;
  sourceId: Scalars['ID']['input'];
};

export type OmsInputsChangeRequestsProvidersBillingAddressDataType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsChargeableWeightInfoType = {
  bruttoWeight: Scalars['Float']['input'];
  totalVolume: Scalars['Float']['input'];
  volumetricWeight: Scalars['Float']['input'];
};

export type OmsInputsContactType = {
  disallowToPool?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  preferredContactType?: InputMaybe<Scalars['String']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  verifiedAt?: InputMaybe<Scalars['String']['input']>;
  viber?: InputMaybe<Scalars['String']['input']>;
  wechat?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsDealPartsMeasurementTemplateType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: Scalars['String']['input'];
  mark?: InputMaybe<OmsInputsQualityControlsMeasurementMarkType>;
  maxValue?: InputMaybe<Scalars['String']['input']>;
  measurements?: InputMaybe<Scalars['JSON']['input']>;
  minMaxStr?: InputMaybe<Scalars['String']['input']>;
  minValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nominalValue: Scalars['String']['input'];
  partId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  qcCanvasId: Scalars['ID']['input'];
  qcPositionId?: InputMaybe<Scalars['ID']['input']>;
  toleranceClass?: InputMaybe<Scalars['String']['input']>;
  toolset?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsDealUpdateProductionManager = {
  pmId?: InputMaybe<Scalars['ID']['input']>;
  updateOrganizationPm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsDealsBillingPreferenceType = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  billReceiver: BillReceiverEnum;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<CarrierEnum>;
};

export type OmsInputsDealsClaimPositionType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  anotherIssues?: InputMaybe<Array<ClaimPositionsIssueEnumType>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customerPrice: Scalars['Float']['input'];
  customerPriceCurrency?: InputMaybe<CurrencyEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parentLotId?: InputMaybe<Scalars['ID']['input']>;
  partId: Scalars['ID']['input'];
  primaryIssue?: InputMaybe<ClaimPositionsIssueEnumType>;
  providerOrderId?: InputMaybe<Scalars['ID']['input']>;
  providerPrice: Scalars['Float']['input'];
  providerPriceCurrency?: InputMaybe<CurrencyEnum>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type OmsInputsDealsClaimType = {
  claimPositionsAttributes: Array<OmsInputsDealsClaimPositionType>;
  conformityCheck?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  primaryIssue?: InputMaybe<ClaimsIssueEnumType>;
  state?: InputMaybe<OmsClaimStateEnum>;
};

export type OmsInputsDealsDealType = {
  certificates?: InputMaybe<OmsInputsCertificatesType>;
  customerOrderCode?: InputMaybe<Scalars['String']['input']>;
  customerOrderDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  customerProjectNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryDeadline?: InputMaybe<Scalars['ISO8601Date']['input']>;
  externalInvoicePlatform?: InputMaybe<Scalars['String']['input']>;
  frameworkAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  gshDfm?: InputMaybe<Scalars['Boolean']['input']>;
  isComplex?: InputMaybe<Scalars['Boolean']['input']>;
  isForSoftwareTesting?: InputMaybe<Scalars['Boolean']['input']>;
  isHighValue?: InputMaybe<Scalars['Boolean']['input']>;
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
  isNpg?: InputMaybe<Scalars['Boolean']['input']>;
  isOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  isTpo?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingComment?: InputMaybe<Scalars['String']['input']>;
  manualProcessingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingFinance?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingIncomingInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingJobs?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingOrderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingOutcomingInvoiceReminders?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingOutcomingInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingPhotoReport?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingShippings?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingStages?: InputMaybe<Scalars['Boolean']['input']>;
  moldingDfmEngineerId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<OmsInputsDealsOwnerType>;
  pipedriveOrderValue?: InputMaybe<Scalars['Float']['input']>;
  productionStage?: InputMaybe<ProductionStageEnum>;
  purchaseOrderDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  reasonOfLose?: InputMaybe<Scalars['String']['input']>;
  totalPaidNett?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsDealsDocumentType = {
  dealObject?: InputMaybe<OmsInputsDealsDocumentsDealObjectType>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  fileUuidIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<DealsDocumentsTypeEnumType>;
  verdict?: InputMaybe<DealsDocumentsVerdictEnumType>;
  visibleToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToPartner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsDealsDocumentsBulkUpdateAttributesType = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<DealsDocumentsVerdictEnumType>;
  visibleToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsDealsDocumentsDealObjectType = {
  id: Scalars['ID']['input'];
  type: DealsDocumentsDealObjectsTypeEnumType;
};

export type OmsInputsDealsDocumentsFilterType = {
  dealObjects?: InputMaybe<Array<OmsInputsDealsDocumentsDealObjectType>>;
  partIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<DealsDocumentsTypeEnumType>>;
  verdicts?: InputMaybe<Array<DealsDocumentsVerdictEnumType>>;
  withoutRejected?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OmsInputsDealsDocumentsSortColumnEnumType {
  CreatedAt = 'created_at',
  DealObject = 'deal_object',
  Number = 'number',
  Type = 'type',
  UpdatedAt = 'updated_at',
  Verdict = 'verdict',
  VerdictBy = 'verdict_by',
  VerdictDate = 'verdict_date'
}

export enum OmsInputsDealsDocumentsSortDirectionEnumType {
  /** Ascending sorting */
  Ascend = 'ascend',
  /** Descending sorting */
  Descend = 'descend'
}

export type OmsInputsDealsDocumentsSortType = {
  column: OmsInputsDealsDocumentsSortColumnEnumType;
  direction?: InputMaybe<OmsInputsDealsDocumentsSortDirectionEnumType>;
};

export type OmsInputsDealsOwnerType = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsDimension = {
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsDnBCriteriaType = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  duns?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsDocumentNoteType = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  emotion: Scalars['String']['input'];
  fileUuidIds?: InputMaybe<Array<Scalars['String']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type OmsInputsEnquiriesCertificatesUpdateType = {
  orderCertificates?: InputMaybe<Array<OmsEnquiryCertificateEnum>>;
  partCertificates?: InputMaybe<Array<OmsInputsEnquiriesPartCertificateType>>;
};

export type OmsInputsEnquiriesEnquiryType = {
  assignedEng?: InputMaybe<Scalars['ID']['input']>;
  assignedSa?: InputMaybe<Scalars['ID']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  certificates?: InputMaybe<OmsInputsCertificatesType>;
  competitorQuoteLink?: InputMaybe<Scalars['String']['input']>;
  ignoreMinimumOrderValue?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddressId?: InputMaybe<Scalars['ID']['input']>;
  xometryVatNumber?: InputMaybe<OmsInputsXometryVatNumberType>;
};

export type OmsInputsEnquiriesPartCertificateType = {
  key: OmsEnquiryCertificateEnum;
  partIds: Array<Scalars['ID']['input']>;
};

export type OmsInputsEnquiriesPartsCertificatesUpdateType = {
  certificatesNeeded: Array<OmsEnquiryCertificateEnum>;
};

export type OmsInputsEnquiriesPartsPriceOptionType = {
  manualLeadTime: Scalars['Int']['input'];
  manualPrice: Scalars['Float']['input'];
};

export type OmsInputsEnquiriesPartsRequiredRfqType = {
  rfqIsUrgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsEnquiriesPartsRfqType = {
  rfqIsUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  rfqNeedInfo?: InputMaybe<Scalars['Boolean']['input']>;
  rfqOwnerId?: InputMaybe<Scalars['Int']['input']>;
  rfqStatus?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsForeignType = {
  objectId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<CustomerSourceRegionEnum>;
};

export type OmsInputsFrameworkBatchesBatchType = {
  category: BatchCategoryEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  providerOrderId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  sourceId: Scalars['ID']['input'];
  sourceType: BatchSourceEnum;
};

export type OmsInputsFrameworkBatchesGroupType = {
  batches: Array<OmsInputsFrameworkBatchesBatchType>;
  category: BatchCategoryEnum;
  changeReason?: InputMaybe<BatchChangeReasonEnum>;
  copyForPartners?: InputMaybe<Scalars['Boolean']['input']>;
  copyForPartnersOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['ISO8601Date']['input'];
  type: BatchTypeEnum;
};

export type OmsInputsFrameworkBatchesSourceType = {
  sourceId: Scalars['ID']['input'];
  sourceType: BatchSourceEnum;
};

export type OmsInputsHsCodeDatasetBulkType = {
  params: OmsInputsHsCodeDatasetType;
  partId: Scalars['ID']['input'];
};

export type OmsInputsHsCodeDatasetConfirmType = {
  hsCodeDatasetId: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
};

export type OmsInputsHsCodeDatasetType = {
  code?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsIncomingEmailsFilterType = {
  globalSearch?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsIncomingEmailsMessageType = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

export type OmsInputsIncomingInvoiceType = {
  attachedFilesAttributes?: InputMaybe<Array<OmsInputsOutcomingInvoicesAttachmentType>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  creditNote?: InputMaybe<Scalars['Boolean']['input']>;
  datevComment?: InputMaybe<Scalars['String']['input']>;
  datevVatCode?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealProviderOrderId?: InputMaybe<Scalars['Int']['input']>;
  holdUntil?: InputMaybe<Scalars['String']['input']>;
  intacctComment?: InputMaybe<Scalars['String']['input']>;
  invoicePositionsAttributes?: InputMaybe<Array<OmsInputsIncomingInvoicesInvoicePositionType>>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishedInPa?: InputMaybe<Scalars['Boolean']['input']>;
  isStorno?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['String']['input']>;
  needFixComment?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentDueDate?: InputMaybe<Scalars['String']['input']>;
  paymentRelations?: InputMaybe<Array<OmsInputsInvoicePaymentRelationType>>;
  provider?: InputMaybe<OmsInputsIncomingInvoicesProviderType>;
  providerBankDetails?: InputMaybe<OmsInputsIncomingInvoicesProviderBankDetailsType>;
  providerBillingAddress?: InputMaybe<OmsInputsIncomingInvoicesProviderBillingAddressType>;
  providerContact?: InputMaybe<OmsInputsIncomingInvoicesProviderContactType>;
  refInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  registeredAt?: InputMaybe<Scalars['String']['input']>;
  sachkontoNumber?: InputMaybe<Scalars['String']['input']>;
  selfBilling?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  uploads?: InputMaybe<Array<OmsInputsIncomingInvoicesUploadType>>;
  validity?: InputMaybe<Scalars['String']['input']>;
  vatPdfCorrectionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  xometryVatNumber?: InputMaybe<OmsInputsXometryVatNumberType>;
  xometryVatNumberId?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsIncomingInvoicesInvoicePositionType = {
  accountingCategory?: InputMaybe<Scalars['String']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  pricePerPiece?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  refId?: InputMaybe<Scalars['Int']['input']>;
  refType?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsIncomingInvoicesProviderBankDetailsType = {
  bankAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  swiftbic?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsIncomingInvoicesProviderBillingAddressType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsIncomingInvoicesProviderContactType = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsIncomingInvoicesProviderType = {
  id: Scalars['Int']['input'];
  intacctId: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  notVatPayer?: InputMaybe<Scalars['Boolean']['input']>;
  payoutTransferType: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
};

export type OmsInputsIncomingInvoicesReallocateToType = {
  amountMoney: OmsInputsMoneyType;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

export type OmsInputsIncomingInvoicesUploadType = {
  file: Scalars['String']['input'];
};

export type OmsInputsInvoicePaymentRelationType = {
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['Int']['input'];
  totalAmountBrutto: Scalars['Float']['input'];
};

export type OmsInputsJobsGlobalOffersFiltersType = {
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsLogisticInvoicePositionType = {
  amountBrutto: Scalars['Float']['input'];
  amountNetto: Scalars['Float']['input'];
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  positionType: LogisticInvoicePositionTypeEnum;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  vatAmount: Scalars['Float']['input'];
  vatRate: Scalars['Float']['input'];
};

export type OmsInputsLogisticInvoiceRelatedShippingType = {
  allocatedCharges: Scalars['Float']['input'];
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  expenseType: LogisticInvoicePositionTypeEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  shippingId?: InputMaybe<Scalars['ID']['input']>;
};

export type OmsInputsLogisticInvoiceType = {
  amountBrutto: Scalars['Float']['input'];
  amountNetto: Scalars['Float']['input'];
  approvedByFinance?: InputMaybe<Scalars['Boolean']['input']>;
  approvedByOperation?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentUuidIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  creditNote: Scalars['Boolean']['input'];
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  logisticOperatorBillingAccountId?: InputMaybe<Scalars['ID']['input']>;
  number: Scalars['String']['input'];
  paidAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  parentInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  positionsAttributes?: InputMaybe<Array<OmsInputsLogisticInvoicePositionType>>;
  registeredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  relatedShippingsAttributes?: InputMaybe<Array<OmsInputsLogisticInvoiceRelatedShippingType>>;
  removedAttachmentUuidIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OmsInputsLogisticOperatorBillingAccountType = {
  accountType: BillingAccountAccountTypeEnum;
  accountingSystemId: Scalars['String']['input'];
  address: Scalars['String']['input'];
  bankAccount: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  bankCountry: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  city: Scalars['String']['input'];
  directDebit: Scalars['Boolean']['input'];
  logisticOperatorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  taxCode?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type OmsInputsLoyaltyTransactionType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  ownerType?: InputMaybe<OmsLoyaltyBalancesOwnerEnumType>;
  /** deprecated in favour of owner_id/owner_type */
  personId?: InputMaybe<Scalars['ID']['input']>;
  pointsAmount: Scalars['Int']['input'];
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  recipientType?: InputMaybe<OmsLoyaltyBalancesOwnerEnumType>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  referenceType?: InputMaybe<LoyaltyTransactionsReferenceEnumType>;
  transactionType?: InputMaybe<LoyaltyTransactionsTypeEnumType>;
  trigger: LoyaltyTransactionsTriggerEnumType;
};

export type OmsInputsManagePromotionType = {
  partId: Scalars['ID']['input'];
  promotion: OmsInputsPromotionDiscountType;
};

export type OmsInputsManualPriceCellParametersType = {
  days?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  transportMode?: InputMaybe<DealsTransportModeEnumType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsManualPriceParametersType = {
  a2c?: InputMaybe<OmsInputsManualPriceCellParametersType>;
  direction?: InputMaybe<ShippingCalculationDirectionEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  kind: PriceKindEnum;
  name?: InputMaybe<Scalars['String']['input']>;
  p2x?: InputMaybe<OmsInputsManualPriceCellParametersType>;
  x2x?: InputMaybe<OmsInputsManualPriceCellParametersType>;
};

export type OmsInputsMasterShippingType = {
  actualShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  allocateDiscountsAndSurcharges?: InputMaybe<Scalars['Boolean']['input']>;
  customsClearanceStatus?: InputMaybe<ShippingCustomsClearanceStatusEnum>;
  customsDocumentsStatus?: InputMaybe<ShippingCustomsDocumentsStatusEnum>;
  deliveryBasis?: InputMaybe<ShippingDeliveryBasisEnum>;
  deliveryType?: InputMaybe<ShippingDeliveryTypeEnum>;
  destinationAddress?: InputMaybe<OmsInputsShippingsAddressType>;
  direction: ShippingDirectionEnum;
  expectedDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  gstInvoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  gstInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  holdUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  logisticAggregator?: InputMaybe<Scalars['String']['input']>;
  logisticOperator?: InputMaybe<Scalars['String']['input']>;
  movementReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['BigInt']['input']>;
  positionNaming?: InputMaybe<ShippingPositionNamingEnum>;
  shippingAlert?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCost?: InputMaybe<InputsMoneyType>;
  shippingOption?: InputMaybe<Scalars['String']['input']>;
  shippingOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shippingParameters?: InputMaybe<Array<OmsInputsShippingsParametersType>>;
  sourceAddress?: InputMaybe<OmsInputsShippingsAddressType>;
  state: ShippingStateEnum;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsMasterShippingsSearchAddressType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsMessageSubscriptionsSubscriptionType = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

export type OmsInputsMessageTemplateGroupFilterType = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<TemplateDirectionEnum>;
  locales?: InputMaybe<Array<TemplateLocaleEnum>>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<TemplateTypeEnum>>;
};

export type OmsInputsMessageTemplateGroupSortType = {
  field: TemplateSortableFieldsEnumType;
  order: TemplateSortOrderEnumType;
};

export type OmsInputsMessengerAttachmentType = {
  fileBase64Encode: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OmsInputsMessengerMessageFilterGroupType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type OmsInputsMessengerMessageFilterType = {
  authorType?: InputMaybe<UserEnum>;
  comment?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<MessageDirectionEnum>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ignoreCounters?: InputMaybe<Scalars['Boolean']['input']>;
  messageType?: InputMaybe<MessageFilterTypeEnum>;
  muteNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<MessageSourceTypeEnum>;
  title: Scalars['String']['input'];
};

export type OmsInputsMessengerMessageTaskType = {
  assignees?: InputMaybe<Array<Scalars['ID']['input']>>;
  deadline?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  priority: Priority;
  taskStatus: TaskStatusEnum;
  taskType: TaskType;
};

export type OmsInputsMessengerMessageType = {
  attachmentUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  carbonCopyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  contentRaw?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  isVisibleToClient?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleToPartner?: InputMaybe<Scalars['Boolean']['input']>;
  mentions?: InputMaybe<Array<InputsMessengerMentionType>>;
  replyOnId?: InputMaybe<Scalars['ID']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<OmsInputsMessengerMessageTaskType>;
  type?: InputMaybe<MessageTypeEnum>;
};

export type OmsInputsMessengerTemplateCategoryType = {
  entryPoint: TemplateEntryPointEnum;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

export type OmsInputsMessengerTemplateGroupType = {
  blindCarbonCopy?: InputMaybe<Array<Scalars['String']['input']>>;
  carbonCopy?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId: Scalars['ID']['input'];
  constantName?: InputMaybe<Scalars['String']['input']>;
  direction: TemplateDirectionEnum;
  locales: Array<OmsInputsMessengerTemplateType>;
  messageActionsGroupId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  type: TemplateTypeEnum;
};

export type OmsInputsMessengerTemplateType = {
  content: Scalars['String']['input'];
  locale: TemplateLocaleEnum;
  subject: Scalars['String']['input'];
};

export type OmsInputsMessengerTemplatedMessageType = {
  attachmentUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  isVisibleToClient?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleToPartner?: InputMaybe<Scalars['Boolean']['input']>;
  mentions?: InputMaybe<Array<InputsMessengerMentionType>>;
  prepareAttachments?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OmsInputsMoldCleanedFile = {
  fileId?: InputMaybe<Scalars['BigInt']['input']>;
  parentId: Scalars['BigInt']['input'];
  useOriginal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsMoldRelatedPart = {
  moldCavity: Scalars['Int']['input'];
  partId: Scalars['Int']['input'];
};

export type OmsInputsMoneyType = {
  amount: Scalars['String']['input'];
  amountCents: Scalars['String']['input'];
  currencyCode: CurrencyEnum;
};

export type OmsInputsOrganizationType = {
  customerOrderGrade?: InputMaybe<Scalars['String']['input']>;
  customerOrderGradeFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  customerOrderGradeOverride?: InputMaybe<Scalars['Boolean']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Scalars['String']['input']>;
  externalInvoicePlatform?: InputMaybe<Scalars['String']['input']>;
  foreignRegionAttributes?: InputMaybe<OmsInputsForeignType>;
  group?: InputMaybe<Scalars['String']['input']>;
  hsCodeNotificationsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isForSoftwareTesting?: InputMaybe<Scalars['Boolean']['input']>;
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
  kam?: InputMaybe<OmsInputsDealsOwnerType>;
  manualCalcAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingComment?: InputMaybe<Scalars['String']['input']>;
  manualProcessingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingFinance?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingJobs?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingOrderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingOutcomingInvoiceReminders?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingOutcomingInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingPhotoReport?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingShippings?: InputMaybe<Scalars['Boolean']['input']>;
  manualProcessingStages?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsOrganizationUpdatePmCascade = {
  cascadeOption: ProductionManagerCascadeOptionEnum;
  pmId?: InputMaybe<Scalars['ID']['input']>;
};

export type OmsInputsOutcomingInvoiceByAtType = {
  at?: InputMaybe<Scalars['String']['input']>;
  by?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsOutcomingInvoiceType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  creditNote?: InputMaybe<Scalars['Boolean']['input']>;
  creditNoteReason?: InputMaybe<OutcomingInvoicesCreditNoteReasonEnumType>;
  creditNoteReasonClaimId?: InputMaybe<Scalars['Int']['input']>;
  datevComment?: InputMaybe<Scalars['String']['input']>;
  datevVatCode?: InputMaybe<Scalars['String']['input']>;
  emailInvoiceOnPublish?: InputMaybe<Scalars['Boolean']['input']>;
  intacctComment?: InputMaybe<Scalars['String']['input']>;
  invoiceChecked?: InputMaybe<OmsInputsOutcomingInvoiceByAtType>;
  invoiceNeedFix?: InputMaybe<OmsInputsOutcomingInvoiceByAtType>;
  invoicePositionsAttributes?: InputMaybe<Array<OmsInputsOutcomingInvoicesInvoicePositionType>>;
  invoiceReady?: InputMaybe<OmsInputsOutcomingInvoiceByAtType>;
  isPublishedInCa?: InputMaybe<Scalars['Boolean']['input']>;
  isStorno?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentDueDate?: InputMaybe<Scalars['String']['input']>;
  paymentRelations?: InputMaybe<Array<OmsInputsInvoicePaymentRelationType>>;
  paymentTermsDate?: InputMaybe<Scalars['String']['input']>;
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTermsDiscountDate?: InputMaybe<Scalars['String']['input']>;
  paymentTermsDiscountDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTermsDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  paymentTermsType?: InputMaybe<PaymentTermsTypeEnum>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhone?: InputMaybe<Scalars['String']['input']>;
  positionsDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderDate?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  refInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  refPositionsSources?: InputMaybe<Scalars['String']['input']>;
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
  registeredAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  requestAccrual?: InputMaybe<Scalars['Boolean']['input']>;
  sachkontoNumber?: InputMaybe<Scalars['String']['input']>;
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  toBePaidAmountCents?: InputMaybe<Scalars['String']['input']>;
  toBePaidAmountCurrency?: InputMaybe<Scalars['String']['input']>;
  toBePaidInDifferentCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  xometryVatNumber?: InputMaybe<OmsInputsXometryVatNumberType>;
};

export type OmsInputsOutcomingInvoicesAttachmentType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type OmsInputsOutcomingInvoicesInvoicePositionType = {
  accountingCategory?: InputMaybe<Scalars['String']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  pricePerPiece?: InputMaybe<Scalars['String']['input']>;
  providerPrice?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  refId?: InputMaybe<Scalars['Int']['input']>;
  refType?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsPackageTrackingEventType = {
  eventPattern: Scalars['String']['input'];
  logisticOperator: Scalars['String']['input'];
  packageStatus: Scalars['String']['input'];
};

export type OmsInputsPartInjectionMoldingPipeline = {
  dfmProcessRequired?: InputMaybe<Scalars['Boolean']['input']>;
  dfmReportFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dfmReportRequested?: InputMaybe<Scalars['Boolean']['input']>;
  dfmReportSigned?: InputMaybe<Scalars['Boolean']['input']>;
  modificationPlanFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  modificationPlanSigned?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineType?: InputMaybe<PipelineTypeEnum>;
  providerOrderId?: InputMaybe<Scalars['ID']['input']>;
  toolingGoFormFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  toolingGoFormSigned?: InputMaybe<Scalars['Boolean']['input']>;
  trialSamplesApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsPartMold = {
  childParts?: InputMaybe<Array<OmsInputsMoldRelatedPart>>;
  cleanedFiles?: InputMaybe<Array<OmsInputsMoldCleanedFile>>;
  comments?: InputMaybe<Scalars['String']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<OmsInputsDimension>;
  fileIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  itemMassKg?: InputMaybe<Scalars['Float']['input']>;
  moldBase?: InputMaybe<Scalars['String']['input']>;
  moldCavityFinish?: InputMaybe<Scalars['String']['input']>;
  moldCavityMaterial?: InputMaybe<Scalars['String']['input']>;
  moldCoreFinish?: InputMaybe<Scalars['String']['input']>;
  moldCoreMaterial?: InputMaybe<Scalars['String']['input']>;
  moldDesign?: InputMaybe<Scalars['String']['input']>;
  moldExportable?: InputMaybe<Scalars['Boolean']['input']>;
  moldLife?: InputMaybe<Scalars['Int']['input']>;
  moldLifters?: InputMaybe<Scalars['Int']['input']>;
  moldManualInserts?: InputMaybe<Scalars['Int']['input']>;
  moldRunnerType?: InputMaybe<Scalars['String']['input']>;
  moldShippingExpected?: InputMaybe<Scalars['Boolean']['input']>;
  moldSliders?: InputMaybe<Scalars['Int']['input']>;
  moldType?: InputMaybe<Scalars['String']['input']>;
  moldWeight?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nonDrawingFileIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  productionRemark?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsPartStateCorrectionType = {
  comment: Scalars['String']['input'];
  partId: Scalars['Int']['input'];
  state: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type OmsInputsPartsBulkUpdatePriceAndTermsType = {
  noQuote?: InputMaybe<Scalars['Boolean']['input']>;
  recommendRfq?: InputMaybe<Scalars['Boolean']['input']>;
  rfqFeedback?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsPaymentsUpdateMethodType = {
  methodId?: InputMaybe<Scalars['ID']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsPayoutCompleteAgainstAnotherType = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

export type OmsInputsPayoutCompleteType = {
  invoicePaid?: InputMaybe<Scalars['Boolean']['input']>;
  paidAt: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
  poPaid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsPayoutType = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approvedAt?: InputMaybe<Scalars['String']['input']>;
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  datevComment?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  intacctComment?: InputMaybe<Scalars['String']['input']>;
  isRefund: Scalars['Boolean']['input'];
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentDetails?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsPayoutsUpdateMethodType = {
  methodId?: InputMaybe<Scalars['ID']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsPersonBulkUpdateType = {
  carbonCopyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  logisticEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  ocEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentReminderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  technicalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  tpoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsPersonContactType = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OmsInputsPersonType = {
  birthday?: InputMaybe<Scalars['ISO8601Date']['input']>;
  carbonCopyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contactAttributes?: InputMaybe<OmsInputsPersonContactType>;
  defaultShippingAddressId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  foreignRegionAttributes?: InputMaybe<OmsInputsForeignType>;
  frameworkAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  logisticEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  mailingSuspendedTill?: InputMaybe<Scalars['ISO8601Date']['input']>;
  mailingsSubscription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ocEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  paymentReminderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pipedriveOrderValue?: InputMaybe<Scalars['Float']['input']>;
  technicalEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  totalPaidNett?: InputMaybe<Scalars['Float']['input']>;
  tpoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsPersonsPunchoutAddressType = {
  addressId: Scalars['ID']['input'];
  addressType: PunchoutAddressTypeEnum;
  externalId: Scalars['String']['input'];
};

export type OmsInputsPositionParametersType = {
  height: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  partId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  samplesQuantity?: InputMaybe<Scalars['Int']['input']>;
  weight: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type OmsInputsPromotionDiscountType = {
  code?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountUnit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  lockQuoteLimit?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type OmsInputsPromotionType = {
  code: Scalars['String']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountUnit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  lockQuoteLimit?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type OmsInputsProviderOrderCreateType = {
  conformityCheck?: InputMaybe<OmsProviderOrderConformityCheckEnum>;
  creditNoteRequestedAmount?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyEnum;
  deadline: Scalars['ISO8601Date']['input'];
  dealId: Scalars['ID']['input'];
  fullyPaidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate: Scalars['ISO8601Date']['input'];
  lots?: InputMaybe<Array<OmsInputsProviderOrdersLotType>>;
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  pnmEscalation?: InputMaybe<Scalars['Boolean']['input']>;
  providerId: Scalars['ID']['input'];
  publicComment?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  qcReportRequired?: InputMaybe<Scalars['Boolean']['input']>;
  samplesConfirmationStatus?: InputMaybe<ProviderOrdersSamplesConfirmationStatusEnum>;
  secondaryProduction?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryProductionReason?: InputMaybe<OmsProviderOrderSecondaryProductionReasonEnum>;
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  services?: InputMaybe<Array<OmsInputsProviderOrdersServiceType>>;
  shipAllowDirectLegal?: InputMaybe<Scalars['Boolean']['input']>;
  shipAllowDirectLegalXomSales?: InputMaybe<Scalars['Boolean']['input']>;
  shipAllowDirectOrder?: InputMaybe<Scalars['Boolean']['input']>;
  shipAllowDirectProvider?: InputMaybe<Scalars['Boolean']['input']>;
  shipDirection?: InputMaybe<ProviderOrdersShipDirectionEnum>;
  shipDirectionToEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  shipIncoterms?: InputMaybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly?: InputMaybe<Scalars['Boolean']['input']>;
  shipIncotermsCity?: InputMaybe<Scalars['String']['input']>;
  shipIncotermsCountry?: InputMaybe<Scalars['String']['input']>;
  shipQcRequired?: InputMaybe<Scalars['Boolean']['input']>;
  shipWarehouse?: InputMaybe<WarehouseInstructionEnum>;
  shippingCreationRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  shippingProcessingInstruction?: InputMaybe<ShippingInstructionEnum>;
  state: ProviderOrderStateEnum;
  visibleInPa: Scalars['Boolean']['input'];
};

export type OmsInputsProviderOrderUpdateType = {
  conformityCheck?: InputMaybe<OmsProviderOrderConformityCheckEnum>;
  creditNoteRequestedAmount?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyEnum;
  deadline: Scalars['ISO8601Date']['input'];
  deadlineUpdateCategory?: InputMaybe<ProviderOrdersDeadlineUpdateCategoryEnum>;
  deadlineUpdateComment?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  fullyPaidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  issueDate: Scalars['ISO8601Date']['input'];
  lots?: InputMaybe<Array<OmsInputsProviderOrdersLotType>>;
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  pnmEscalation?: InputMaybe<Scalars['Boolean']['input']>;
  providerId: Scalars['ID']['input'];
  publicComment?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  qcReportRequired?: InputMaybe<Scalars['Boolean']['input']>;
  samplesConfirmationStatus?: InputMaybe<ProviderOrdersSamplesConfirmationStatusEnum>;
  secondaryProduction?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryProductionReason?: InputMaybe<OmsProviderOrderSecondaryProductionReasonEnum>;
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  services?: InputMaybe<Array<OmsInputsProviderOrdersServiceType>>;
  shipAllowDirectLegal?: InputMaybe<Scalars['Boolean']['input']>;
  shipAllowDirectLegalXomSales?: InputMaybe<Scalars['Boolean']['input']>;
  shipAllowDirectOrder?: InputMaybe<Scalars['Boolean']['input']>;
  shipAllowDirectProvider?: InputMaybe<Scalars['Boolean']['input']>;
  shipDirection?: InputMaybe<ProviderOrdersShipDirectionEnum>;
  shipDirectionToEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  shipIncoterms?: InputMaybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly?: InputMaybe<Scalars['Boolean']['input']>;
  shipIncotermsCity?: InputMaybe<Scalars['String']['input']>;
  shipIncotermsCountry?: InputMaybe<Scalars['String']['input']>;
  shipQcRequired?: InputMaybe<Scalars['Boolean']['input']>;
  shipWarehouse?: InputMaybe<WarehouseInstructionEnum>;
  shipmentDateRevisedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shipmentDateRevisedCategory?: InputMaybe<ShipmentEstimateUpdateCategoryEnum>;
  shipmentDateRevisedComment?: InputMaybe<Scalars['String']['input']>;
  shippingCreationRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  shippingProcessingInstruction?: InputMaybe<ShippingInstructionEnum>;
  state: ProviderOrderStateEnum;
  visibleInPa: Scalars['Boolean']['input'];
};

export type OmsInputsProviderOrdersLotType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  parentId: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
};

export type OmsInputsProviderOrdersProductionScheduleItemCreateType = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  stageDate: Scalars['ISO8601Date']['input'];
  stageName: ProductionScheduleStageNameEnum;
  stageNameCustom?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsProviderOrdersProductionScheduleItemUpdateType = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  fileIds: Array<Scalars['ID']['input']>;
  responded?: InputMaybe<Scalars['Boolean']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  stageDate: Scalars['ISO8601Date']['input'];
  stageName: ProductionScheduleStageNameEnum;
  stageNameCustom?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsProviderOrdersServiceType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  typeName: TypeNameEnum;
};

export type OmsInputsProviderType = {
  acceptSelfBilling?: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoacceptOffers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoacceptOffersFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  allowDirectshipOrders?: InputMaybe<Scalars['Boolean']['input']>;
  allowDirectshipOrdersFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  autoacceptPoNumberLimit?: InputMaybe<Scalars['Int']['input']>;
  autoacceptPoNumberLimitFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  autoacceptPoValueLimit?: InputMaybe<Scalars['Int']['input']>;
  autoacceptPoValueLimitFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bdoNumber?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<OmsInputsAddressType>;
  contact?: InputMaybe<OmsInputsContactType>;
  currency?: InputMaybe<CurrencyEnum>;
  datevKonto?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  freeCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  freeCapacityFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  gstIn?: InputMaybe<Scalars['String']['input']>;
  intacctId?: InputMaybe<Scalars['String']['input']>;
  languageList?: InputMaybe<Array<Scalars['String']['input']>>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  limitsComment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notVatPayer?: InputMaybe<Scalars['Boolean']['input']>;
  onImprovement?: InputMaybe<Scalars['Boolean']['input']>;
  onImprovementComment?: InputMaybe<Scalars['String']['input']>;
  onImprovementFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  onImprovementStartedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  partnerNetworkManagerFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  partnerNetworkManagerId?: InputMaybe<Scalars['ID']['input']>;
  partnerSuccessManagerId?: InputMaybe<Scalars['ID']['input']>;
  payoutTransferType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  poNumberLimit?: InputMaybe<Scalars['Int']['input']>;
  poNumberLimitFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  poValueLimit?: InputMaybe<Scalars['Float']['input']>;
  poValueLimitFreezeUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  publicComment?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<OmsInputsAddressType>;
  state?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<OmsInputsTagType>;
  testPartner?: InputMaybe<Scalars['Boolean']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsQualityControlType = {
  dealId: Scalars['ID']['input'];
  fileUuidIds?: InputMaybe<Array<Scalars['String']['input']>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<OmsInputsQualityControlsPositionType>>;
  reportComment?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsQualityControlsMeasurementMarkCordsType = {
  offsetX?: InputMaybe<Scalars['Float']['input']>;
  offsetY?: InputMaybe<Scalars['Float']['input']>;
  r?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsQualityControlsMeasurementMarkType = {
  active: Scalars['Boolean']['input'];
  canvasId: Scalars['BigInt']['input'];
  fill: Scalars['String']['input'];
  key: Scalars['String']['input'];
  label: OmsInputsQualityControlsMeasurementMarkCordsType;
  point: OmsInputsQualityControlsMeasurementMarkCordsType;
  position: Scalars['String']['input'];
  v: Scalars['String']['input'];
};

export type OmsInputsQualityControlsMeasurementType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: Scalars['String']['input'];
  mark?: InputMaybe<OmsInputsQualityControlsMeasurementMarkType>;
  maxValue?: InputMaybe<Scalars['String']['input']>;
  measurements: Scalars['JSON']['input'];
  minMaxStr?: InputMaybe<Scalars['String']['input']>;
  minValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nominalValue: Scalars['String']['input'];
  partId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  qcCanvasId: Scalars['ID']['input'];
  qcPositionId: Scalars['ID']['input'];
  toleranceClass?: InputMaybe<Scalars['String']['input']>;
  toolset?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsQualityControlsPdfReportDoneBy = {
  date?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsQualityControlsPdfReportParams = {
  customer?: InputMaybe<Scalars['String']['input']>;
  doneBy?: InputMaybe<OmsInputsQualityControlsPdfReportDoneBy>;
  locale?: InputMaybe<Scalars['String']['input']>;
  orderNum?: InputMaybe<Scalars['String']['input']>;
  partIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  preparedFor?: InputMaybe<Scalars['String']['input']>;
  reportBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsQualityControlsPositionType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  atmPressure?: InputMaybe<Scalars['Float']['input']>;
  businessVerdict?: InputMaybe<Scalars['String']['input']>;
  businessVerdictComment?: InputMaybe<Scalars['String']['input']>;
  businessVerdictPublished?: InputMaybe<Scalars['Boolean']['input']>;
  customerPrice?: InputMaybe<Scalars['Float']['input']>;
  humidity?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lotId: Scalars['Int']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  measurements?: InputMaybe<Array<OmsInputsQualityControlsMeasurementType>>;
  name: Scalars['String']['input'];
  officialVerdictComment?: InputMaybe<Scalars['String']['input']>;
  partDetails?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['Int']['input'];
  postProcessing?: InputMaybe<Scalars['String']['input']>;
  providerOrderId?: InputMaybe<Scalars['ID']['input']>;
  providerPrice?: InputMaybe<Scalars['Float']['input']>;
  qcCoating?: InputMaybe<Scalars['String']['input']>;
  qcCoatingComment?: InputMaybe<Scalars['String']['input']>;
  qcCompliance?: InputMaybe<Scalars['String']['input']>;
  qcComplianceComment?: InputMaybe<Scalars['String']['input']>;
  qcConservation?: InputMaybe<Scalars['String']['input']>;
  qcConservationComment?: InputMaybe<Scalars['String']['input']>;
  qcDocuments?: InputMaybe<Scalars['String']['input']>;
  qcDocumentsComment?: InputMaybe<Scalars['String']['input']>;
  qcFinish?: InputMaybe<Scalars['String']['input']>;
  qcFinishComment?: InputMaybe<Scalars['String']['input']>;
  qcMarking?: InputMaybe<Scalars['String']['input']>;
  qcMarkingComment?: InputMaybe<Scalars['String']['input']>;
  qcOther?: InputMaybe<Scalars['String']['input']>;
  qcOtherComment?: InputMaybe<Scalars['String']['input']>;
  qcPackaging?: InputMaybe<Scalars['String']['input']>;
  qcPackagingComment?: InputMaybe<Scalars['String']['input']>;
  qcQuantity?: InputMaybe<Scalars['String']['input']>;
  qcQuantityComment?: InputMaybe<Scalars['String']['input']>;
  qcQuantityObserved?: InputMaybe<Scalars['Int']['input']>;
  qtyAccepted?: InputMaybe<Scalars['Int']['input']>;
  qtyChecked?: InputMaybe<Scalars['Int']['input']>;
  qtyHold?: InputMaybe<Scalars['Int']['input']>;
  qtyRejected?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  techVerdict?: InputMaybe<Scalars['String']['input']>;
  techVerdictComment?: InputMaybe<Scalars['String']['input']>;
  techVerdictPublished?: InputMaybe<Scalars['Boolean']['input']>;
  temperature?: InputMaybe<Scalars['Int']['input']>;
};

export type OmsInputsQualityControlsRepackType = {
  action: Scalars['String']['input'];
  conformityCheck?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<Scalars['Int']['input']>>;
  restAction?: InputMaybe<Scalars['String']['input']>;
  restPositions?: InputMaybe<Array<Scalars['Int']['input']>>;
  restStorageLocation?: InputMaybe<Scalars['String']['input']>;
  restStorageProcessingState?: InputMaybe<Scalars['String']['input']>;
  restUseSameSize?: InputMaybe<Scalars['Boolean']['input']>;
  storageLocation?: InputMaybe<Scalars['String']['input']>;
  storageProcessingState?: InputMaybe<Scalars['String']['input']>;
  updateConformityCheck?: InputMaybe<Scalars['Boolean']['input']>;
  useSameSize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OmsInputsRfqType = {
  currency?: InputMaybe<CurrencyEnum>;
  needInfo?: InputMaybe<Scalars['Boolean']['input']>;
  offerStrategyContent?: InputMaybe<Scalars['JSON']['input']>;
  offerStrategyId?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  publicComment?: InputMaybe<Scalars['String']['input']>;
  publicationEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  publicationStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  rfqEngineerId?: InputMaybe<Scalars['ID']['input']>;
  selectedPartners?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<RfqsStateEnumType>;
};

export type OmsInputsRfqsOfferType = {
  currency?: InputMaybe<CurrencyEnum>;
  decisionRefusalReason?: InputMaybe<Scalars['String']['input']>;
  decisionState?: InputMaybe<RfqsOffersDecisionStateEnumType>;
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  prices?: InputMaybe<Array<OmsInputsRfqsOffersPriceType>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type OmsInputsRfqsOffersBulkActionsProviderAmountType = {
  priceId: Scalars['ID']['input'];
  providerPriceAmount: Scalars['String']['input'];
};

export type OmsInputsRfqsOffersPriceType = {
  appliedMargin?: InputMaybe<Scalars['Float']['input']>;
  customerPrice?: InputMaybe<OmsInputsMoneyType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  leadtime?: InputMaybe<Scalars['Int']['input']>;
  providerPrice?: InputMaybe<OmsInputsMoneyType>;
  quantity: Scalars['Int']['input'];
  rfqPositionId: Scalars['Int']['input'];
  transportationTime?: InputMaybe<Scalars['Int']['input']>;
};

export type OmsInputsRfqsOffersRateType = {
  enquiryPartId: Scalars['ID']['input'];
  price: OmsInputsMoneyType;
  quantity: Scalars['Int']['input'];
  quotePrice: OmsInputsMoneyType;
};

export type OmsInputsShipmentOrderAddressType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsShipmentOrderArasAddressType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type OmsInputsShipmentOrderDhlAddressType = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type OmsInputsShipmentOrderDbSchenkerAddressType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  personName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type OmsInputsShipmentOrderEurosenderAddressType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type OmsInputsShipmentOrderPackageType = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsShipmentOrderPickupOptionsType = {
  closeTime: Scalars['String']['input'];
  location: Scalars['String']['input'];
};

export type OmsInputsShipmentOrderUpsAddressType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type OmsInputsShipmentOrderYurticiAddressType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsShippingAddressForOrgPersonsType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type OmsInputsShippingAddressType = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['ID']['input'];
  zip: Scalars['String']['input'];
};

export type OmsInputsShippingAddressUpdateCascadeType = {
  cascadeToObjects: Array<OmsInputsCascadeToObjectType>;
};

export type OmsInputsShippingCalculationType = {
  batchesCount?: InputMaybe<Scalars['Int']['input']>;
  chargeableWeight?: InputMaybe<Scalars['Float']['input']>;
  chargeableWeightInfo?: InputMaybe<OmsInputsChargeableWeightInfoType>;
  comment?: InputMaybe<Scalars['String']['input']>;
  destinationAddress?: InputMaybe<OmsInputsAddressType>;
  direction?: InputMaybe<ShippingCalculationDirectionEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<OmsInputsPositionParametersType>>;
  samplesChargeableWeight?: InputMaybe<Scalars['Float']['input']>;
  samplesChargeableWeightInfo?: InputMaybe<OmsInputsChargeableWeightInfoType>;
  sourceAddress?: InputMaybe<OmsInputsAddressType>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<ShippingCalculationSourceEnum>;
};

export type OmsInputsShippingInstructions = {
  shipDirection: ProviderOrdersShipDirectionEnum;
  shipDirectionToEndCustomer: Scalars['Boolean']['input'];
  shipIncoterms: ProviderOrdersIncotermsEnum;
  shipIncotermsByPlaneOnly: Scalars['Boolean']['input'];
  shipIncotermsCity: Scalars['String']['input'];
  shipIncotermsCountry: Scalars['String']['input'];
  shipQcRequired: Scalars['Boolean']['input'];
  shipWarehouse: WarehouseInstructionEnum;
};

export type OmsInputsShippingsAddressType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gstIn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  teamspaceId?: InputMaybe<Scalars['ID']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsShippingsCreateType = {
  actualDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  actualShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  allocateDiscountsAndSurcharges?: InputMaybe<Scalars['Boolean']['input']>;
  customsClearanceStatus?: InputMaybe<ShippingCustomsClearanceStatusEnum>;
  customsDocumentsStatus?: InputMaybe<ShippingCustomsDocumentsStatusEnum>;
  customsOfficeCode?: InputMaybe<Scalars['String']['input']>;
  dealParts?: InputMaybe<Array<OmsInputsShippingsPartType>>;
  deliveryBasis?: InputMaybe<ShippingDeliveryBasisEnum>;
  deliveryNoteComment?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<ShippingDeliveryTypeEnum>;
  destinationAddress?: InputMaybe<OmsInputsShippingsAddressType>;
  direction: ShippingDirectionEnum;
  directionToEndCustomer: Scalars['Boolean']['input'];
  expectedDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedShipmentTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  exporterOfRecord?: InputMaybe<ShippingExporterOfRecordEnum>;
  gstInvoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  gstInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  holdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  holdById?: InputMaybe<Scalars['BigInt']['input']>;
  holdUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  importerOfRecord?: InputMaybe<ShippingImporterOfRecordEnum>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  logisticAggregator?: InputMaybe<Scalars['String']['input']>;
  logisticAggregatorId?: InputMaybe<Scalars['BigInt']['input']>;
  logisticOperator?: InputMaybe<Scalars['String']['input']>;
  logisticOperatorId?: InputMaybe<Scalars['BigInt']['input']>;
  lots?: InputMaybe<Array<OmsInputsShippingsLotType>>;
  movementReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  noInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noInvoiceRequiredComment?: InputMaybe<Scalars['String']['input']>;
  noPartnerInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noPartnerInvoiceRequiredComment?: InputMaybe<Scalars['String']['input']>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['BigInt']['input']>;
  packagingReportCheckStatus?: InputMaybe<Scalars['String']['input']>;
  positionNaming?: InputMaybe<ShippingPositionNamingEnum>;
  publishedInCa?: InputMaybe<Scalars['Boolean']['input']>;
  publishedInPa?: InputMaybe<Scalars['Boolean']['input']>;
  readyForCollection?: InputMaybe<Scalars['Boolean']['input']>;
  receivedProcessingStatus?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<OmsInputsShippingsServiceType>>;
  shippingAlert?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCost?: InputMaybe<OmsInputsMoneyType>;
  shippingOption?: InputMaybe<Scalars['String']['input']>;
  shippingOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shippingParameters?: InputMaybe<Array<OmsInputsShippingsParametersType>>;
  sourceAddress?: InputMaybe<OmsInputsShippingsAddressType>;
  sourceProviderOrderId?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseInstruction?: InputMaybe<WarehouseInstructionEnum>;
};

export type OmsInputsShippingsLotType = {
  customerPrice?: InputMaybe<OmsInputsMoneyType>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  partId?: InputMaybe<Scalars['BigInt']['input']>;
  providerPrice?: InputMaybe<OmsInputsMoneyType>;
  quantity: Scalars['Int']['input'];
};

export type OmsInputsShippingsParametersType = {
  brutto?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsShippingsPartType = {
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type OmsInputsShippingsServiceType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  typeName: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type OmsInputsShippingsUpdateType = {
  actualDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  actualShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  allocateDiscountsAndSurcharges?: InputMaybe<Scalars['Boolean']['input']>;
  customsClearanceStatus?: InputMaybe<ShippingCustomsClearanceStatusEnum>;
  customsDocumentsStatus?: InputMaybe<ShippingCustomsDocumentsStatusEnum>;
  customsOfficeCode?: InputMaybe<Scalars['String']['input']>;
  dealParts?: InputMaybe<Array<OmsInputsShippingsPartType>>;
  deliveryBasis?: InputMaybe<ShippingDeliveryBasisEnum>;
  deliveryNoteComment?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<ShippingDeliveryTypeEnum>;
  destinationAddress?: InputMaybe<OmsInputsShippingsAddressType>;
  direction: ShippingDirectionEnum;
  directionToEndCustomer: Scalars['Boolean']['input'];
  expectedDeliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedShipmentDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedShipmentTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  exporterOfRecord?: InputMaybe<ShippingExporterOfRecordEnum>;
  gstInvoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  gstInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  holdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  holdById?: InputMaybe<Scalars['BigInt']['input']>;
  holdUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  importerOfRecord?: InputMaybe<ShippingImporterOfRecordEnum>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  logisticAggregator?: InputMaybe<Scalars['String']['input']>;
  logisticAggregatorId?: InputMaybe<Scalars['BigInt']['input']>;
  logisticOperator?: InputMaybe<Scalars['String']['input']>;
  logisticOperatorId?: InputMaybe<Scalars['BigInt']['input']>;
  lots?: InputMaybe<Array<OmsInputsShippingsLotType>>;
  movementReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  noInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noInvoiceRequiredComment?: InputMaybe<Scalars['String']['input']>;
  noPartnerInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noPartnerInvoiceRequiredComment?: InputMaybe<Scalars['String']['input']>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifyPartner?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['BigInt']['input']>;
  packagingReportCheckStatus?: InputMaybe<Scalars['String']['input']>;
  positionNaming?: InputMaybe<ShippingPositionNamingEnum>;
  publishedInCa?: InputMaybe<Scalars['Boolean']['input']>;
  publishedInPa?: InputMaybe<Scalars['Boolean']['input']>;
  readyForCollection?: InputMaybe<Scalars['Boolean']['input']>;
  receivedProcessingStatus?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<OmsInputsShippingsServiceType>>;
  shippingAlert?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCost?: InputMaybe<OmsInputsMoneyType>;
  shippingOption?: InputMaybe<Scalars['String']['input']>;
  shippingOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shippingParameters?: InputMaybe<Array<OmsInputsShippingsParametersType>>;
  sourceAddress?: InputMaybe<OmsInputsShippingsAddressType>;
  sourceProviderOrderId?: InputMaybe<Scalars['Int']['input']>;
  state: ShippingStateEnum;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseInstruction?: InputMaybe<WarehouseInstructionEnum>;
};

export type OmsInputsTagType = {
  certifications?: InputMaybe<Array<Scalars['Int']['input']>>;
  industries?: InputMaybe<Array<Scalars['Int']['input']>>;
  languages?: InputMaybe<Array<Scalars['Int']['input']>>;
  materials?: InputMaybe<Array<Scalars['Int']['input']>>;
  partnerSegments?: InputMaybe<Array<Scalars['Int']['input']>>;
  productionMethodFeatures?: InputMaybe<Array<Scalars['Int']['input']>>;
  productionMethods?: InputMaybe<Array<Scalars['Int']['input']>>;
  qualities?: InputMaybe<Array<Scalars['Int']['input']>>;
  restrictedMethods?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OmsInputsTeamsCreateType = {
  constantName: Scalars['String']['input'];
  label: Scalars['String']['input'];
  parentTeamId?: InputMaybe<Scalars['BigInt']['input']>;
  teamType?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsTeamsUpdateType = {
  label: Scalars['String']['input'];
  parentTeamId?: InputMaybe<Scalars['BigInt']['input']>;
  teamType?: InputMaybe<Scalars['String']['input']>;
};

export type OmsInputsUserAutoAssignmentSettings = {
  customerOrderGrade?: InputMaybe<Array<CustomerOrderGradeEnum>>;
  languages?: InputMaybe<Array<LanguageEnum>>;
  maxDeals?: InputMaybe<Scalars['Int']['input']>;
  overloadPossible?: InputMaybe<Scalars['Boolean']['input']>;
  technology?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OmsInputsUserEmailLogin = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type OmsInputsUserPermission = {
  expiresAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
};

export type OmsInputsUserProfile = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  autoAssignmentSettings?: InputMaybe<OmsInputsUserAutoAssignmentSettings>;
  birthday?: InputMaybe<Scalars['ISO8601Date']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  couponLimit?: InputMaybe<Scalars['Int']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  podId?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<UserRegionEnum>;
  rfqLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type OmsInputsUsersCreateSubstitutionType = {
  deputyUserId: Scalars['ID']['input'];
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

export type OmsInputsUsersUpdateSubstitutionType = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

export type OmsInputsWorkspacePresetType = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  exportColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  workspaceName: Scalars['String']['input'];
};

export type OmsInputsXometryVatNumberType = {
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  reverseCharge?: InputMaybe<Scalars['Boolean']['input']>;
  reverseChargeRemark?: InputMaybe<Scalars['String']['input']>;
  validation?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export enum OmsLoyaltyBalancesOwnerEnumType {
  Person = 'Person',
  Teamspace = 'Teamspace'
}

export enum OmsLoyaltyTransactionsStatusEnumType {
  Cancelled = 'cancelled',
  Pending = 'pending',
  Succeeded = 'succeeded',
  Transferred = 'transferred'
}

export enum OmsProviderOrderConformityCheckEnum {
  HasIssues = 'has_issues',
  IssuesResolved = 'issues_resolved',
  Ok = 'ok'
}

export enum OmsProviderOrderSecondaryProductionReasonEnum {
  Other = 'other',
  ProviderFault = 'provider_fault',
  XometryFault = 'xometry_fault'
}

/** Autogenerated input type of OmsSelectPriceOptionEnquiryPart */
export type OmsSelectPriceOptionEnquiryPartInput = {
  attributes: OmsInputsEnquiriesPartsPriceOptionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsSelectPriceOptionEnquiryPart. */
export type OmsSelectPriceOptionEnquiryPartPayload = {
  __typename?: 'OmsSelectPriceOptionEnquiryPartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiryPart: OmsEnquiryPartType;
};

export type OmsSubstitution = {
  __typename?: 'OmsSubstitution';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deputyUser: User;
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/** Autogenerated input type of OmsTeamspaceAddShippingAddress */
export type OmsTeamspaceAddShippingAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId: Scalars['ID']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspaceAddShippingAddress. */
export type OmsTeamspaceAddShippingAddressPayload = {
  __typename?: 'OmsTeamspaceAddShippingAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspaceShippingAddress: TeamspaceShippingAddress;
};

/** Autogenerated input type of OmsTeamspaceRemoveShippingAddress */
export type OmsTeamspaceRemoveShippingAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId: Scalars['ID']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspaceRemoveShippingAddress. */
export type OmsTeamspaceRemoveShippingAddressPayload = {
  __typename?: 'OmsTeamspaceRemoveShippingAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspaceShippingAddress: TeamspaceShippingAddress;
};

export enum OmsTeamspaceRoleEnum {
  Buyer = 'buyer',
  Editor = 'editor',
  Owner = 'owner',
  Viewer = 'viewer'
}

/** Autogenerated input type of OmsTeamspaceSetAsDefaultShippingAddress */
export type OmsTeamspaceSetAsDefaultShippingAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId: Scalars['ID']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspaceSetAsDefaultShippingAddress. */
export type OmsTeamspaceSetAsDefaultShippingAddressPayload = {
  __typename?: 'OmsTeamspaceSetAsDefaultShippingAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspaceShippingAddress: TeamspaceShippingAddress;
};

/** Autogenerated input type of OmsTeamspacesAddBillingAccount */
export type OmsTeamspacesAddBillingAccountInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamspaceCreditLimitAccess: Scalars['Boolean']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesAddBillingAccount. */
export type OmsTeamspacesAddBillingAccountPayload = {
  __typename?: 'OmsTeamspacesAddBillingAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspaceBillingAccount: TeamspaceBillingAccount;
};

/** Autogenerated input type of OmsTeamspacesAddPerson */
export type OmsTeamspacesAddPersonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  moveXPointsAndDeals?: InputMaybe<Scalars['Boolean']['input']>;
  personIds: Array<Scalars['ID']['input']>;
  role: OmsTeamspaceRoleEnum;
  shareBillingAndShipping: Scalars['Boolean']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesAddPerson. */
export type OmsTeamspacesAddPersonPayload = {
  __typename?: 'OmsTeamspacesAddPersonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesBillingAccountSetAsDefault */
export type OmsTeamspacesBillingAccountSetAsDefaultInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesBillingAccountSetAsDefault. */
export type OmsTeamspacesBillingAccountSetAsDefaultPayload = {
  __typename?: 'OmsTeamspacesBillingAccountSetAsDefaultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspaceBillingAccount: TeamspaceBillingAccount;
};

/** Autogenerated input type of OmsTeamspacesBillingAccountsCreditLimitUpdate */
export type OmsTeamspacesBillingAccountsCreditLimitUpdateInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditLimit: Scalars['Boolean']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesBillingAccountsCreditLimitUpdate. */
export type OmsTeamspacesBillingAccountsCreditLimitUpdatePayload = {
  __typename?: 'OmsTeamspacesBillingAccountsCreditLimitUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspaceBillingAccount: TeamspaceBillingAccount;
};

/** Autogenerated input type of OmsTeamspacesCreate */
export type OmsTeamspacesCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  moveXPointsAndDeals?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
  shareBillingAndShipping: Scalars['Boolean']['input'];
};

/** Autogenerated return type of OmsTeamspacesCreate. */
export type OmsTeamspacesCreatePayload = {
  __typename?: 'OmsTeamspacesCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesDelete */
export type OmsTeamspacesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesDelete. */
export type OmsTeamspacesDeletePayload = {
  __typename?: 'OmsTeamspacesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesInvitesDelete */
export type OmsTeamspacesInvitesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesInvitesDelete. */
export type OmsTeamspacesInvitesDeletePayload = {
  __typename?: 'OmsTeamspacesInvitesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invite: Invite;
};

/** Autogenerated input type of OmsTeamspacesInvitesResend */
export type OmsTeamspacesInvitesResendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesInvitesResend. */
export type OmsTeamspacesInvitesResendPayload = {
  __typename?: 'OmsTeamspacesInvitesResendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invite: Invite;
};

/** Autogenerated input type of OmsTeamspacesPersonRoleUpdate */
export type OmsTeamspacesPersonRoleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personIds: Array<Scalars['ID']['input']>;
  role: OmsTeamspaceRoleEnum;
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesPersonRoleUpdate. */
export type OmsTeamspacesPersonRoleUpdatePayload = {
  __typename?: 'OmsTeamspacesPersonRoleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesRemoveBillingAccount */
export type OmsTeamspacesRemoveBillingAccountInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesRemoveBillingAccount. */
export type OmsTeamspacesRemoveBillingAccountPayload = {
  __typename?: 'OmsTeamspacesRemoveBillingAccountPayload';
  billingAccount: BillingAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of OmsTeamspacesRemovePerson */
export type OmsTeamspacesRemovePersonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesRemovePerson. */
export type OmsTeamspacesRemovePersonPayload = {
  __typename?: 'OmsTeamspacesRemovePersonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesSetDefaultBillingAccount */
export type OmsTeamspacesSetDefaultBillingAccountInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesSetDefaultBillingAccount. */
export type OmsTeamspacesSetDefaultBillingAccountPayload = {
  __typename?: 'OmsTeamspacesSetDefaultBillingAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesTransferOwnership */
export type OmsTeamspacesTransferOwnershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  downgradedOwnerRole: OmsTeamspaceRoleEnum;
  newOwnerId: Scalars['ID']['input'];
  teamspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsTeamspacesTransferOwnership. */
export type OmsTeamspacesTransferOwnershipPayload = {
  __typename?: 'OmsTeamspacesTransferOwnershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

/** Autogenerated input type of OmsTeamspacesUpdate */
export type OmsTeamspacesUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  highVolumeEnabled: Scalars['Boolean']['input'];
  isForSoftwareTesting?: InputMaybe<Scalars['Boolean']['input']>;
  manualCalcAllowed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  teamspaceId: Scalars['ID']['input'];
  tpoEnabled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of OmsTeamspacesUpdate. */
export type OmsTeamspacesUpdatePayload = {
  __typename?: 'OmsTeamspacesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  teamspace: Teamspace;
};

export type OmsTypesInputsPaginationType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OmsTypesMessengerSubscriptionFilterType = {
  dealStateOpen?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewFromCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewFromPartners?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OmsTypesMessengerTaskFilterType = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  authorType?: InputMaybe<UserEnum>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  createdFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdTill?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  deadlineFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  deadlineTill?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Array<Priority>>;
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskStatus?: InputMaybe<Array<TaskStatusEnum>>;
  taskType?: InputMaybe<TaskType>;
};

export type OmsTypesMessengerTaskSortType = {
  orderBy: OrderOptions;
  sortBy?: InputMaybe<SortOptions>;
};

/** Autogenerated input type of OmsUsersCreateSubstitution */
export type OmsUsersCreateSubstitutionInput = {
  attributes: OmsInputsUsersCreateSubstitutionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsUsersCreateSubstitution. */
export type OmsUsersCreateSubstitutionPayload = {
  __typename?: 'OmsUsersCreateSubstitutionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  substitution: OmsSubstitution;
};

/** Autogenerated input type of OmsUsersDeleteSubstitution */
export type OmsUsersDeleteSubstitutionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsUsersDeleteSubstitution. */
export type OmsUsersDeleteSubstitutionPayload = {
  __typename?: 'OmsUsersDeleteSubstitutionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of OmsUsersUpdateSubstitution */
export type OmsUsersUpdateSubstitutionInput = {
  attributes: OmsInputsUsersUpdateSubstitutionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OmsUsersUpdateSubstitution. */
export type OmsUsersUpdateSubstitutionPayload = {
  __typename?: 'OmsUsersUpdateSubstitutionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  substitution: OmsSubstitution;
};

export type OrderConfirmation = {
  __typename?: 'OrderConfirmation';
  billingAccount?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deal: Deal;
  dealId: Scalars['ID']['output'];
  delayReason?: Maybe<Scalars['String']['output']>;
  endCustomerShippingAddress?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  lots: Array<Lot>;
  moldsWithoutExpectedShipping: Array<Lot>;
  nonPartPositions?: Maybe<Array<AdditionalService>>;
  number: Scalars['String']['output'];
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  paymentTermsDiscountDays?: Maybe<Scalars['Int']['output']>;
  paymentTermsDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  paymentTermsType?: Maybe<PaymentTermsTypeEnum>;
  sachkontoNumber?: Maybe<Scalars['ID']['output']>;
  shippingAddress?: Maybe<Scalars['JSON']['output']>;
  totalAmountBrut: Scalars['Float']['output'];
  totalAmountBrutMoney: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  xometryVatNumber?: Maybe<XometryVatNumber>;
};

/** Autogenerated input type of OrderConfirmationChangeRequestsApprove */
export type OrderConfirmationChangeRequestsApproveInput = {
  changeRequestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  manualProcessingReason: Scalars['String']['input'];
  skipCreditLimitWarningComment?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrderConfirmationChangeRequestsApprove. */
export type OrderConfirmationChangeRequestsApprovePayload = {
  __typename?: 'OrderConfirmationChangeRequestsApprovePayload';
  changeRequest?: Maybe<DealsOrderConfirmationChangeRequestType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditLimitValidationError?: Maybe<OmsEnquiryCreditLimitValidationErrorType>;
};

/** Autogenerated input type of OrderConfirmationChangeRequestsReject */
export type OrderConfirmationChangeRequestsRejectInput = {
  changeRequestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  manualProcessingReason: Scalars['String']['input'];
};

/** Autogenerated return type of OrderConfirmationChangeRequestsReject. */
export type OrderConfirmationChangeRequestsRejectPayload = {
  __typename?: 'OrderConfirmationChangeRequestsRejectPayload';
  changeRequest: DealsOrderConfirmationChangeRequestType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type OrderConfirmationVat = {
  __typename?: 'OrderConfirmationVat';
  vatRate: Scalars['Float']['output'];
  xomVatNumber?: Maybe<XometryVatNumber>;
};

/** Autogenerated input type of OrderConfirmationsApplyBillingAccount */
export type OrderConfirmationsApplyBillingAccountInput = {
  billingAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderConfirmationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrderConfirmationsApplyBillingAccount. */
export type OrderConfirmationsApplyBillingAccountPayload = {
  __typename?: 'OrderConfirmationsApplyBillingAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

export enum OrderOptions {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderedBy = Person | User;

export type Organization = {
  __typename?: 'Organization';
  autoGrade?: Maybe<Scalars['String']['output']>;
  billingAccounts?: Maybe<Array<BillingAccount>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerOrderGrade?: Maybe<Scalars['String']['output']>;
  customerOrderGradeFreezeAt?: Maybe<Scalars['ISO8601Date']['output']>;
  customerOrderGradeFreezeBy?: Maybe<User>;
  customerOrderGradeFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  customerOrderGradeOverride?: Maybe<Scalars['Boolean']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  deals: Array<Deal>;
  dealsClaim: Scalars['Int']['output'];
  dealsInProduction: Scalars['Int']['output'];
  dealsTotalCount: Scalars['Int']['output'];
  dealsWon: Scalars['Int']['output'];
  defaultShippingAddress?: Maybe<ShippingAddress>;
  defaultShippingAddressId?: Maybe<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  descriptionUpdatedBy?: Maybe<User>;
  emailDomains?: Maybe<Scalars['String']['output']>;
  externalCrmId?: Maybe<Scalars['String']['output']>;
  externalCrmUrl?: Maybe<Scalars['String']['output']>;
  externalInvoicePlatform?: Maybe<Scalars['String']['output']>;
  hsCodeNotificationsDisabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  isForSoftwareTesting: Scalars['Boolean']['output'];
  isImportant: Scalars['Boolean']['output'];
  kam?: Maybe<PdUser>;
  manualCalcAllowed: Scalars['Boolean']['output'];
  manualProcessingComment?: Maybe<Scalars['String']['output']>;
  manualProcessingEmails: Scalars['Boolean']['output'];
  manualProcessingFinance: Scalars['Boolean']['output'];
  manualProcessingJobs: Scalars['Boolean']['output'];
  manualProcessingOrderConfirmation: Scalars['Boolean']['output'];
  manualProcessingOutcomingInvoiceReminders: Scalars['Boolean']['output'];
  manualProcessingOutcomingInvoices: Scalars['Boolean']['output'];
  manualProcessingPhotoReport: Scalars['Boolean']['output'];
  manualProcessingShippings: Scalars['Boolean']['output'];
  manualProcessingStages: Scalars['Boolean']['output'];
  movedTo?: Maybe<IntercompanyObject>;
  movedToRegion?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  persons?: Maybe<Array<Person>>;
  personsTotalCount: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveUrl: Scalars['String']['output'];
  pm?: Maybe<User>;
  pmId?: Maybe<Scalars['ID']['output']>;
  productionManager?: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBalanceRecord = {
  __typename?: 'OrganizationBalanceRecord';
  balanceBrutto: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentDue: Scalars['Float']['output'];
  date: Scalars['ISO8601Date']['output'];
  dealBalanceRecords: Array<DealBalanceRecord>;
  id: Scalars['Int']['output'];
  invoicedBrutto: Scalars['Float']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  overdueAbove30Days: Scalars['Float']['output'];
  overdueBelow30Days: Scalars['Float']['output'];
  overdueBrutto: Scalars['Float']['output'];
  paidBrutto: Scalars['Float']['output'];
  prepayments: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of OrganizationBalanceRecordsForceRecalculate */
export type OrganizationBalanceRecordsForceRecalculateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationBalanceRecordsForceRecalculate. */
export type OrganizationBalanceRecordsForceRecalculatePayload = {
  __typename?: 'OrganizationBalanceRecordsForceRecalculatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of OrganizationBalancesExport */
export type OrganizationBalancesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of OrganizationBalancesExport. */
export type OrganizationBalancesExportPayload = {
  __typename?: 'OrganizationBalancesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type OrganizationBillingAccounts = {
  __typename?: 'OrganizationBillingAccounts';
  billingAccounts: Array<BillingAccount>;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationData = {
  __typename?: 'OrganizationData';
  creditLimitRecommendationMoney?: Maybe<DnBMoney>;
  duns: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Phone>;
  primaryAddress?: Maybe<PrimaryAddress>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationDeals = {
  __typename?: 'OrganizationDeals';
  deals: Array<Deal>;
  salesClaimDeals: SalesDeals;
  salesLostDeals: SalesDeals;
  salesOpenDeals: SalesDeals;
  salesTotalDeals: SalesDeals;
  salesWonDeals: SalesDeals;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationPersons = {
  __typename?: 'OrganizationPersons';
  persons: Array<Person>;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of OrganizationTransferToRegion */
export type OrganizationTransferToRegionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  toRegion: RegionEnum;
};

/** Autogenerated return type of OrganizationTransferToRegion. */
export type OrganizationTransferToRegionPayload = {
  __typename?: 'OrganizationTransferToRegionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of OrganizationsBulkActionsUpdateProductionManager */
export type OrganizationsBulkActionsUpdateProductionManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds: Array<Scalars['ID']['input']>;
  pmId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationsBulkActionsUpdateProductionManager. */
export type OrganizationsBulkActionsUpdateProductionManagerPayload = {
  __typename?: 'OrganizationsBulkActionsUpdateProductionManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OrganizationsCollection = {
  __typename?: 'OrganizationsCollection';
  collection: Array<Organization>;
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of OrganizationsCreate */
export type OrganizationsCreateInput = {
  attributes: OmsInputsOrganizationType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizationsCreate. */
export type OrganizationsCreatePayload = {
  __typename?: 'OrganizationsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of OrganizationsExport */
export type OrganizationsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of OrganizationsExport. */
export type OrganizationsExportPayload = {
  __typename?: 'OrganizationsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of OrganizationsMerge */
export type OrganizationsMergeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mergedOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationsMerge. */
export type OrganizationsMergePayload = {
  __typename?: 'OrganizationsMergePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of OrganizationsReactivationTransfer */
export type OrganizationsReactivationTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationsReactivationTransfer. */
export type OrganizationsReactivationTransferPayload = {
  __typename?: 'OrganizationsReactivationTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of OrganizationsRequestDescription */
export type OrganizationsRequestDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationsRequestDescription. */
export type OrganizationsRequestDescriptionPayload = {
  __typename?: 'OrganizationsRequestDescriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of OrganizationsUpdate */
export type OrganizationsUpdateInput = {
  attributes: OmsInputsOrganizationType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationsUpdate. */
export type OrganizationsUpdatePayload = {
  __typename?: 'OrganizationsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of OrganizationsUpdateProductionManager */
export type OrganizationsUpdateProductionManagerInput = {
  attributes: OmsInputsOrganizationUpdatePmCascade;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationsUpdateProductionManager. */
export type OrganizationsUpdateProductionManagerPayload = {
  __typename?: 'OrganizationsUpdateProductionManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

export type OutcomingInvoice = {
  __typename?: 'OutcomingInvoice';
  accrualAt?: Maybe<Scalars['ISO8601Date']['output']>;
  billingAccount?: Maybe<Scalars['JSON']['output']>;
  cashCollectionComment?: Maybe<Scalars['String']['output']>;
  cashCollectionStatus?: Maybe<OutcomingInvoicesCashCollectionEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNote: Scalars['Boolean']['output'];
  creditNoteReason?: Maybe<OutcomingInvoicesCreditNoteReasonEnumType>;
  creditNoteReasonClaim?: Maybe<Claim>;
  creditNotes?: Maybe<Array<OutcomingInvoice>>;
  currency: Scalars['String']['output'];
  deal: Deal;
  dealId: Scalars['ID']['output'];
  files: Array<AttachedFile>;
  id: Scalars['Int']['output'];
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  invoiceChecked?: Maybe<OutcomingInvoiceByAt>;
  invoiceNeedFix?: Maybe<OutcomingInvoiceByAt>;
  invoiceReady?: Maybe<OutcomingInvoiceByAt>;
  isStorno: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  negotiatedDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  organizationVat?: Maybe<Scalars['String']['output']>;
  overrideAccountingDataDisabled: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentInfo?: Maybe<Scalars['String']['output']>;
  paymentRelations?: Maybe<Array<PaymentOutcomingInvoiceRelation>>;
  paymentTermsDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  paymentTermsType?: Maybe<PaymentTermsTypeEnum>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<InvoicePosition>>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  refInvoice?: Maybe<OutcomingInvoice>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  rejectedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  requestAccrual: Scalars['Boolean']['output'];
  shippingInfo?: Maybe<OutcomingInvoicesShippingInfoType>;
  state: Scalars['String']['output'];
  toBePaidAmountMoney?: Maybe<Money>;
  toBePaidInDifferentCurrency: Scalars['Boolean']['output'];
  totalAmountBrutto?: Maybe<Scalars['Float']['output']>;
  totalAmountBruttoMoney: Money;
  totalAmountNetto?: Maybe<Scalars['Float']['output']>;
  totalAmountNettoMoney: Money;
  uiNumber: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type OutcomingInvoiceFilesArgs = {
  context?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type OutcomingInvoicePaymentInfoArgs = {
  paidAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sourceShippingId?: InputMaybe<Scalars['Int']['input']>;
  totalAmountBruttoMoney?: InputMaybe<OmsInputsMoneyType>;
};


export type OutcomingInvoiceShippingInfoArgs = {
  shippingIds: Array<Scalars['Int']['input']>;
};

export type OutcomingInvoiceByAt = {
  __typename?: 'OutcomingInvoiceByAt';
  at: Scalars['String']['output'];
  by: Scalars['String']['output'];
};

export type OutcomingInvoiceExport = {
  __typename?: 'OutcomingInvoiceExport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  outcomingInvoices?: Maybe<Array<OutcomingInvoice>>;
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of OutcomingInvoiceExportZip */
export type OutcomingInvoiceExportZipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
};

/** Autogenerated return type of OutcomingInvoiceExportZip. */
export type OutcomingInvoiceExportZipPayload = {
  __typename?: 'OutcomingInvoiceExportZipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exportZipState: ZipState;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of OutcomingInvoicesBulkDatevExport */
export type OutcomingInvoicesBulkDatevExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of OutcomingInvoicesBulkDatevExport. */
export type OutcomingInvoicesBulkDatevExportPayload = {
  __typename?: 'OutcomingInvoicesBulkDatevExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  export: OutcomingInvoiceExport;
};

/** Autogenerated input type of OutcomingInvoicesBulkIntacctExport */
export type OutcomingInvoicesBulkIntacctExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of OutcomingInvoicesBulkIntacctExport. */
export type OutcomingInvoicesBulkIntacctExportPayload = {
  __typename?: 'OutcomingInvoicesBulkIntacctExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  export: IntacctOutcomingInvoiceExportType;
};

/** Autogenerated input type of OutcomingInvoicesBulkMarkAsPaid */
export type OutcomingInvoicesBulkMarkAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  invoiceIds: Array<Scalars['ID']['input']>;
  markAsRegistered: Scalars['Boolean']['input'];
  paidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  transactionType: Scalars['String']['input'];
};

/** Autogenerated return type of OutcomingInvoicesBulkMarkAsPaid. */
export type OutcomingInvoicesBulkMarkAsPaidPayload = {
  __typename?: 'OutcomingInvoicesBulkMarkAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum OutcomingInvoicesCashCollectionEnum {
  /** Credit Note Awaiting */
  CreditNoteAwaiting = 'credit_note_awaiting',
  /** Credit Reform */
  CreditReform = 'credit_reform',
  /** Credit Reform Failed */
  CreditReformFailed = 'credit_reform_failed',
  /** Credit Reform Paid */
  CreditReformPaid = 'credit_reform_paid',
  /** Insolvency */
  Insolvency = 'insolvency',
  /** Internal Cash Collector */
  InternalCashCollector = 'internal_cash_collector',
  /** KAM */
  Kam = 'kam',
  /** Legal */
  Legal = 'legal',
  /** Ongoing Claim */
  OngoingClaim = 'ongoing_claim',
  /** Production Manager */
  ProductionManager = 'production_manager',
  /** Ship And Hold */
  ShipAndHold = 'ship_and_hold'
}

export enum OutcomingInvoicesCreditNoteReasonEnumType {
  /** Claim */
  Claim = 'claim',
  /** Wrong BA (reissue) */
  WrongBa = 'wrong_ba',
  /** Wrong Prices or Quantity */
  WrongPriceOrQuantity = 'wrong_price_or_quantity'
}

/** Autogenerated input type of OutcomingInvoicesExport */
export type OutcomingInvoicesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of OutcomingInvoicesExport. */
export type OutcomingInvoicesExportPayload = {
  __typename?: 'OutcomingInvoicesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of OutcomingInvoicesOverrideAccountingFields */
export type OutcomingInvoicesOverrideAccountingFieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  sachkontoNumber?: InputMaybe<Scalars['String']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
  vatPercent: Scalars['Float']['input'];
  xometryVatCountry?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OutcomingInvoicesOverrideAccountingFields. */
export type OutcomingInvoicesOverrideAccountingFieldsPayload = {
  __typename?: 'OutcomingInvoicesOverrideAccountingFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

/** Autogenerated input type of OutcomingInvoicesOverridePaymentTermsDate */
export type OutcomingInvoicesOverridePaymentTermsDateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  issuedAt: Scalars['ISO8601Date']['input'];
  paymentTermsDate: Scalars['ISO8601Date']['input'];
  paymentTermsType: PaymentTermsTypeEnum;
};

/** Autogenerated return type of OutcomingInvoicesOverridePaymentTermsDate. */
export type OutcomingInvoicesOverridePaymentTermsDatePayload = {
  __typename?: 'OutcomingInvoicesOverridePaymentTermsDatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

/** Autogenerated input type of OutcomingInvoicesRollbackMikrojumpSync */
export type OutcomingInvoicesRollbackMikrojumpSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OutcomingInvoicesRollbackMikrojumpSync. */
export type OutcomingInvoicesRollbackMikrojumpSyncPayload = {
  __typename?: 'OutcomingInvoicesRollbackMikrojumpSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

/** Autogenerated input type of OutcomingInvoicesSendToIntacct */
export type OutcomingInvoicesSendToIntacctInput = {
  attributes?: InputMaybe<OmsInputsOutcomingInvoiceType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OutcomingInvoicesSendToIntacct. */
export type OutcomingInvoicesSendToIntacctPayload = {
  __typename?: 'OutcomingInvoicesSendToIntacctPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

/** Autogenerated input type of OutcomingInvoicesSendToMikrojump */
export type OutcomingInvoicesSendToMikrojumpInput = {
  attributes?: InputMaybe<OmsInputsOutcomingInvoiceType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OutcomingInvoicesSendToMikrojump. */
export type OutcomingInvoicesSendToMikrojumpPayload = {
  __typename?: 'OutcomingInvoicesSendToMikrojumpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

export type OutcomingInvoicesShippingInfoType = {
  __typename?: 'OutcomingInvoicesShippingInfoType';
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum OverallStageEnum {
  /** calculated */
  Calculated = 'calculated',
  /** draft */
  Draft = 'draft',
  /** enquiry_cancelled */
  EnquiryCancelled = 'enquiry_cancelled',
  /** lost */
  Lost = 'lost',
  /** need_calculate */
  NeedCalculate = 'need_calculate',
  /** pending */
  Pending = 'pending',
  /** prod_delivered */
  ProdDelivered = 'prod_delivered',
  /** prod_placed */
  ProdPlaced = 'prod_placed',
  /** prod_placing */
  ProdPlacing = 'prod_placing',
  /** prod_processing */
  ProdProcessing = 'prod_processing',
  /** prod_shipped2c */
  ProdShipped2c = 'prod_shipped2c',
  /** prod_shipped2x */
  ProdShipped2x = 'prod_shipped2x',
  /** prod_warehouse */
  ProdWarehouse = 'prod_warehouse',
  /** submitted */
  Submitted = 'submitted',
  /** won */
  Won = 'won'
}

export type Overview = {
  __typename?: 'Overview';
  auditState: Scalars['String']['output'];
  enquiryId?: Maybe<Scalars['Int']['output']>;
  isDrawingsOk: Scalars['Boolean']['output'];
  parts: Array<Part>;
  quantityPcs: Scalars['Int']['output'];
  quantityTotal: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type PackageTrackingEvent = {
  __typename?: 'PackageTrackingEvent';
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventPattern: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  logisticOperator: Scalars['String']['output'];
  packageStatus: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of PackageTrackingEventsCreate */
export type PackageTrackingEventsCreateInput = {
  attributes: OmsInputsPackageTrackingEventType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PackageTrackingEventsCreate. */
export type PackageTrackingEventsCreatePayload = {
  __typename?: 'PackageTrackingEventsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  packageTrackingEvent: PackageTrackingEvent;
};

/** Autogenerated input type of PackageTrackingEventsDelete */
export type PackageTrackingEventsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PackageTrackingEventsDelete. */
export type PackageTrackingEventsDeletePayload = {
  __typename?: 'PackageTrackingEventsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PackageTrackingEventsUpdate */
export type PackageTrackingEventsUpdateInput = {
  attributes: OmsInputsPackageTrackingEventType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PackageTrackingEventsUpdate. */
export type PackageTrackingEventsUpdatePayload = {
  __typename?: 'PackageTrackingEventsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  packageTrackingEvent: PackageTrackingEvent;
};

export type PaginatedActivityRecords = {
  __typename?: 'PaginatedActivityRecords';
  hasMore: Scalars['Boolean']['output'];
  records: Array<ActivityRecord>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  collection: Array<PaginationUnion>;
  currentPage: Scalars['Int']['output'];
  firstPage: Scalars['Boolean']['output'];
  lastPage: Scalars['Boolean']['output'];
  limitValue: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  outOfRange: Scalars['Boolean']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationUnion = ExportBillingAccountType | ExportLogisticInvoiceType | ExportProviderType | LogisticInvoice | LogisticInvoiceRelatedShipping | Shipping;

export type Part = {
  __typename?: 'Part';
  auditDrawingReworkTask?: Maybe<Scalars['String']['output']>;
  auditDrawingsReworkStatus: Scalars['String']['output'];
  auditDrawingsReworkedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  auditReviewRemark: Scalars['String']['output'];
  auditState: Scalars['String']['output'];
  auditUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cavities?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerNote?: Maybe<Scalars['String']['output']>;
  customerPrice?: Maybe<Money>;
  dealId?: Maybe<Scalars['Int']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  dimensionsObject?: Maybe<PartDimensions>;
  drawingsState: DealPartDrawingsStateEnum;
  enquiryPart?: Maybe<OmsEnquiryPartType>;
  files?: Maybe<Array<AttachedFile>>;
  foreignPart?: Maybe<ForeignPart>;
  hsCode?: Maybe<Scalars['String']['output']>;
  hsCodeName?: Maybe<Scalars['String']['output']>;
  hsCodeRef?: Maybe<PartHsCode>;
  id: Scalars['Int']['output'];
  injectionMoldingPipeline?: Maybe<PartInjectionMoldingPipeline>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isExpress?: Maybe<Scalars['Boolean']['output']>;
  isOrdered: Scalars['Boolean']['output'];
  itemMassKg?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use measurement_protocol_needed instead */
  measurementProtocol?: Maybe<Scalars['String']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['String']['output']>;
  mold?: Maybe<Part>;
  moldBase?: Maybe<Scalars['String']['output']>;
  moldCavity?: Maybe<Scalars['Int']['output']>;
  moldCavityFinish?: Maybe<Scalars['String']['output']>;
  moldCavityMaterial?: Maybe<Scalars['String']['output']>;
  moldCoreFinish?: Maybe<Scalars['String']['output']>;
  moldCoreMaterial?: Maybe<Scalars['String']['output']>;
  moldDesign?: Maybe<Scalars['String']['output']>;
  moldExportable: Scalars['Boolean']['output'];
  moldLife?: Maybe<Scalars['Int']['output']>;
  moldLifters?: Maybe<Scalars['Int']['output']>;
  moldManualInserts?: Maybe<Scalars['Int']['output']>;
  moldParts: Array<Part>;
  moldRunnerType?: Maybe<Scalars['String']['output']>;
  moldShippingExpected: Scalars['Boolean']['output'];
  moldSliders?: Maybe<Scalars['Int']['output']>;
  moldType?: Maybe<Scalars['String']['output']>;
  moldWeight?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noQuote: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  overseas: Scalars['Boolean']['output'];
  partType: PartTypeEnum;
  position?: Maybe<Scalars['Int']['output']>;
  postProcessing?: Maybe<Scalars['String']['output']>;
  preQuoted?: Maybe<Scalars['Boolean']['output']>;
  preQuotedBy?: Maybe<Provider>;
  preQuotedComment?: Maybe<Scalars['String']['output']>;
  processType?: Maybe<Scalars['String']['output']>;
  productionRemark?: Maybe<Scalars['String']['output']>;
  providerPrice?: Maybe<Money>;
  qtyClaim: Scalars['Int']['output'];
  qtyDelivered: Scalars['Int']['output'];
  qtyInProduction: Scalars['Int']['output'];
  qtyOrdered: Scalars['Int']['output'];
  qtyShipped: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  relatedObjects: Array<RelatedObject>;
  returnRequired?: Maybe<Scalars['Boolean']['output']>;
  samplesComment?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  samplesQuantity?: Maybe<Scalars['Int']['output']>;
  shippings?: Maybe<Array<Shipping>>;
  surfaceRoughness?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  tolerance?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  versionsCount: Scalars['Int']['output'];
  volumeMm3?: Maybe<Scalars['Float']['output']>;
  weightKg: Scalars['Float']['output'];
};


export type PartTagsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type PartDimensions = {
  __typename?: 'PartDimensions';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type PartHsCode = {
  __typename?: 'PartHsCode';
  code?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['Int']['output']>;
  confirmedByRef?: Maybe<User>;
  confirmedHsCodeDataset?: Maybe<ConfirmedHsCodeDataset>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partId: Scalars['BigInt']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PartInjectionMoldingPipeline = {
  __typename?: 'PartInjectionMoldingPipeline';
  createdAt: Scalars['ISO8601DateTime']['output'];
  dfmProcessRequired: Scalars['Boolean']['output'];
  dfmReportFiles?: Maybe<Array<AttachedFile>>;
  dfmReportRequested: Scalars['Boolean']['output'];
  dfmReportRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dfmReportRequestedBy?: Maybe<User>;
  dfmReportSigned: Scalars['Boolean']['output'];
  dfmReportSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dfmReportSignedBy?: Maybe<User>;
  id: Scalars['Int']['output'];
  modificationPlanFiles?: Maybe<Array<AttachedFile>>;
  modificationPlanSigned: Scalars['Boolean']['output'];
  modificationPlanSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  modificationPlanSignedBy?: Maybe<User>;
  partId: Scalars['BigInt']['output'];
  pipelineType?: Maybe<PipelineTypeEnum>;
  pipelineTypeSelectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pipelineTypeSelectedBy?: Maybe<User>;
  providerOrder?: Maybe<ProviderOrder>;
  providerOrderId?: Maybe<Scalars['BigInt']['output']>;
  toolingGoFormFiles?: Maybe<Array<AttachedFile>>;
  toolingGoFormSigned: Scalars['Boolean']['output'];
  toolingGoFormSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  toolingGoFormSignedBy?: Maybe<User>;
  trialSamplesApproved: Scalars['Boolean']['output'];
  trialSamplesApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  trialSamplesApprovedBy?: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PartStateCorrection = {
  __typename?: 'PartStateCorrection';
  comment: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  part: Part;
  partId: Scalars['Int']['output'];
  publishedBy?: Maybe<User>;
  publishedById?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Int']['output'];
};

/** Autogenerated input type of PartStateCorrectionsCreate */
export type PartStateCorrectionsCreateInput = {
  attributes: Array<OmsInputsPartStateCorrectionType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PartStateCorrectionsCreate. */
export type PartStateCorrectionsCreatePayload = {
  __typename?: 'PartStateCorrectionsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  partStateCorrections: Array<PartStateCorrection>;
};

/** Autogenerated input type of PartStateCorrectionsDestroy */
export type PartStateCorrectionsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PartStateCorrectionsDestroy. */
export type PartStateCorrectionsDestroyPayload = {
  __typename?: 'PartStateCorrectionsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  partStateCorrection: PartStateCorrection;
};

export type PartStateRecord = {
  __typename?: 'PartStateRecord';
  corrections?: Maybe<CorrectionReferences>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentReferences?: Maybe<DocumentReferences>;
  id: Scalars['ID']['output'];
  invCustomer: Scalars['Int']['output'];
  invPartner: Scalars['Int']['output'];
  invWriteOff: Scalars['Int']['output'];
  orderedActual: Scalars['Int']['output'];
  orderedHold: Scalars['Int']['output'];
  part: Part;
  partId: Scalars['Int']['output'];
  prodDelivered: Scalars['Int']['output'];
  prodPlaced: Scalars['Int']['output'];
  prodPlacing: Scalars['Int']['output'];
  prodProcessing: Scalars['Int']['output'];
  prodShipped2c: Scalars['Int']['output'];
  prodShipped2x: Scalars['Int']['output'];
  prodWarehouse: Scalars['Int']['output'];
  qaClaims: Scalars['Int']['output'];
  qaIssues: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PartStateRecordsGroup = {
  __typename?: 'PartStateRecordsGroup';
  corrections: Array<PartStateCorrection>;
  partId: Scalars['Int']['output'];
  records: Array<PartStateRecord>;
};

export enum PartTypeEnum {
  CustomerObject = 'customer_object',
  Mold = 'mold',
  Standard = 'standard'
}

export type Participants = {
  __typename?: 'Participants';
  assignedSa?: Maybe<User>;
  assignedSaId?: Maybe<Scalars['ID']['output']>;
  auditEngineers: Array<User>;
  auditEngineersIds?: Maybe<Array<Scalars['ID']['output']>>;
  claimManagers: Array<User>;
  claimManagersIds?: Maybe<Array<Scalars['ID']['output']>>;
  deal: Deal;
  dealId: Scalars['ID']['output'];
  draftingEngineers: Array<User>;
  draftingEngineersIds?: Maybe<Array<Scalars['ID']['output']>>;
  jobOwners: Array<User>;
  jobOwnersIds?: Maybe<Array<Scalars['ID']['output']>>;
  kam?: Maybe<User>;
  kamId?: Maybe<Scalars['ID']['output']>;
  moldingDfmEngineer?: Maybe<User>;
  moldingDfmEngineerId?: Maybe<Scalars['ID']['output']>;
  orderedBy?: Maybe<OrderedBy>;
  orderedById?: Maybe<Scalars['ID']['output']>;
  orderedByType?: Maybe<Scalars['String']['output']>;
  partnerNetworkManagers: Array<User>;
  partnerNetworkManagersIds?: Maybe<Array<Scalars['ID']['output']>>;
  partnerSuccessManagers: Array<User>;
  partnerSuccessManagersIds?: Maybe<Array<Scalars['ID']['output']>>;
  pricingEngineer?: Maybe<User>;
  pricingEngineerId?: Maybe<Scalars['ID']['output']>;
  productionManager?: Maybe<User>;
  productionManagerId?: Maybe<Scalars['ID']['output']>;
  rfqOwners: Array<User>;
  rfqOwnersIds?: Maybe<Array<Scalars['ID']['output']>>;
  shippingOwners: Array<User>;
  shippingOwnersIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated input type of PartsBulkUpdatePriceAndTerms */
export type PartsBulkUpdatePriceAndTermsInput = {
  attributes: OmsInputsPartsBulkUpdatePriceAndTermsType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of PartsBulkUpdatePriceAndTerms. */
export type PartsBulkUpdatePriceAndTermsPayload = {
  __typename?: 'PartsBulkUpdatePriceAndTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of PartsPromotionsManageDiscount */
export type PartsPromotionsManageDiscountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hidePartsDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  promotions: Array<OmsInputsManagePromotionType>;
};

/** Autogenerated return type of PartsPromotionsManageDiscount. */
export type PartsPromotionsManageDiscountPayload = {
  __typename?: 'PartsPromotionsManageDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

export type Payment = {
  __typename?: 'Payment';
  accountingRecords: Array<AccountingRecord>;
  amountBrut?: Maybe<Scalars['Float']['output']>;
  amountBrutMoney: Money;
  amountNet?: Maybe<Scalars['Float']['output']>;
  amountNetMoney: Money;
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountReceivedMoney: Money;
  billingAccount?: Maybe<BillingAccount>;
  billingAccountId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  deal: Deal;
  id: Scalars['Int']['output'];
  invoiceRelations?: Maybe<Array<PaymentOutcomingInvoiceRelation>>;
  isRefund: Scalars['Boolean']['output'];
  method?: Maybe<Scalars['JSON']['output']>;
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  positions?: Maybe<Array<PaymentPosition>>;
  refundMethodType?: Maybe<RefundMethodTypesEnum>;
  refunds?: Maybe<Array<Payment>>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  source?: Maybe<PaymentsSourceType>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripePayoutEffectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PaymentOutcomingInvoiceRelation = {
  __typename?: 'PaymentOutcomingInvoiceRelation';
  connectedRelation?: Maybe<PaymentOutcomingInvoiceRelation>;
  /** Actual only for Builded Relations (without ID) */
  connectedRelationKey?: Maybe<Scalars['String']['output']>;
  creditNote?: Maybe<OutcomingInvoice>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  deal: Deal;
  id?: Maybe<Scalars['ID']['output']>;
  initiatedByOutcomingInvoice?: Maybe<OutcomingInvoice>;
  initiatedByPayment?: Maybe<Payment>;
  /** Actual only for Builded Relations (without ID) */
  key: Scalars['String']['output'];
  outcomingInvoice: OutcomingInvoice;
  payment: Payment;
  paymentBalances: PaymentOutcomingInvoiceRelationPaymentBalance;
  paymentDate: Scalars['ISO8601Date']['output'];
  refund?: Maybe<Payment>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  totalAmountBrutto: Scalars['Float']['output'];
  totalAmountBruttoMoney: Money;
};

export type PaymentOutcomingInvoiceRelationPaymentBalance = {
  __typename?: 'PaymentOutcomingInvoiceRelationPaymentBalance';
  afterAllocatedMoney: Money;
  beforeAllocatedMoney: Money;
};

/** Autogenerated input type of PaymentOutcomingInvoiceRelationsCreateExportToDatev */
export type PaymentOutcomingInvoiceRelationsCreateExportToDatevInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationFrom: Scalars['ISO8601Date']['input'];
  durationTo: Scalars['ISO8601Date']['input'];
  ids: Array<Scalars['ID']['input']>;
  period: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of PaymentOutcomingInvoiceRelationsCreateExportToDatev. */
export type PaymentOutcomingInvoiceRelationsCreateExportToDatevPayload = {
  __typename?: 'PaymentOutcomingInvoiceRelationsCreateExportToDatevPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datevPaymentOutcomingInvoiceRelationsExport: PaymentOutcomingInvoiceRelationsExport;
};

export type PaymentOutcomingInvoiceRelationsExport = {
  __typename?: 'PaymentOutcomingInvoiceRelationsExport';
  accountingPeriod: Scalars['ISO8601Date']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom: Scalars['ISO8601Date']['output'];
  durationTo: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  relations?: Maybe<Array<PaymentOutcomingInvoiceRelation>>;
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of PaymentOutcomingInvoiceRelationsUpdateRegisteredAt */
export type PaymentOutcomingInvoiceRelationsUpdateRegisteredAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  registeredAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of PaymentOutcomingInvoiceRelationsUpdateRegisteredAt. */
export type PaymentOutcomingInvoiceRelationsUpdateRegisteredAtPayload = {
  __typename?: 'PaymentOutcomingInvoiceRelationsUpdateRegisteredAtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  relations: Array<PaymentOutcomingInvoiceRelation>;
};

export type PaymentPosition = {
  __typename?: 'PaymentPosition';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  totalBrut?: Maybe<Scalars['Float']['output']>;
  totalBrutMoney?: Maybe<Money>;
  totalNet?: Maybe<Scalars['Float']['output']>;
  totalNetMoney?: Maybe<Money>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum PaymentTermsTypeEnum {
  FirstDayOfNextMonth = 'first_day_of_next_month',
  Standard = 'standard'
}

/** Autogenerated input type of PaymentsCreateExportToDatev */
export type PaymentsCreateExportToDatevInput = {
  accountingRecords: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationFrom?: InputMaybe<Scalars['String']['input']>;
  durationTo?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
  period: Scalars['String']['input'];
  selectedType?: InputMaybe<Scalars['String']['input']>;
  withRegistered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of PaymentsCreateExportToDatev. */
export type PaymentsCreateExportToDatevPayload = {
  __typename?: 'PaymentsCreateExportToDatevPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datevPaymentsExport: PaymentsExport;
};

export type PaymentsExport = {
  __typename?: 'PaymentsExport';
  accountingPeriod: Scalars['ISO8601Date']['output'];
  additionalData?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  csvReports?: Maybe<Array<AttachedFile>>;
  durationFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  durationTo?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  payments?: Maybe<Array<Payment>>;
  payouts?: Maybe<Array<Payout>>;
  selected: Array<Scalars['Int']['output']>;
  selectedSize: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of PaymentsExport */
export type PaymentsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of PaymentsExport. */
export type PaymentsExportPayload = {
  __typename?: 'PaymentsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of PaymentsRegenerateAccountingRecords */
export type PaymentsRegenerateAccountingRecordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PaymentsRegenerateAccountingRecords. */
export type PaymentsRegenerateAccountingRecordsPayload = {
  __typename?: 'PaymentsRegenerateAccountingRecordsPayload';
  accountingRecords: Array<AccountingRecord>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type PaymentsSourceType = {
  __typename?: 'PaymentsSourceType';
  amount?: Maybe<Scalars['Float']['output']>;
  amountMoney?: Maybe<Money>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PaymentsTransferBetweenDeals */
export type PaymentsTransferBetweenDealsInput = {
  amountBrut: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  datevComment?: InputMaybe<Scalars['String']['input']>;
  intacctComment?: InputMaybe<Scalars['String']['input']>;
  newDealId: Scalars['ID']['input'];
  paidAt: Scalars['String']['input'];
  paymentId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of PaymentsTransferBetweenDeals. */
export type PaymentsTransferBetweenDealsPayload = {
  __typename?: 'PaymentsTransferBetweenDealsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  refundPayment: Payment;
};

/** Autogenerated input type of PaymentsUpdateRegisteredAt */
export type PaymentsUpdateRegisteredAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportId: Scalars['ID']['input'];
  overwrite: Scalars['Boolean']['input'];
  registeredAt: Scalars['String']['input'];
};

/** Autogenerated return type of PaymentsUpdateRegisteredAt. */
export type PaymentsUpdateRegisteredAtPayload = {
  __typename?: 'PaymentsUpdateRegisteredAtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
};

/** Autogenerated input type of PaymetsUpdateMethod */
export type PaymetsUpdateMethodInput = {
  attributes: OmsInputsPaymentsUpdateMethodType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PaymetsUpdateMethod. */
export type PaymetsUpdateMethodPayload = {
  __typename?: 'PaymetsUpdateMethodPayload';
  bankPayment?: Maybe<WorkspacesUpdatedBankPayment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Payout = {
  __typename?: 'Payout';
  amount?: Maybe<Scalars['Float']['output']>;
  amountMoney: Money;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvedBy?: Maybe<User>;
  approvedById?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  datevComment?: Maybe<Scalars['String']['output']>;
  deal: Deal;
  dealId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fastPay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instantPay: Scalars['Boolean']['output'];
  intacctComment?: Maybe<Scalars['String']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isRefund: Scalars['Boolean']['output'];
  method?: Maybe<Method>;
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentDetails?: Maybe<Scalars['String']['output']>;
  prepayment: Scalars['Boolean']['output'];
  provider: Provider;
  providerId: Scalars['ID']['output'];
  realloc?: Maybe<Payout>;
  refunds: Array<Payout>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  source: PayoutSourceType;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  state: Scalars['String']['output'];
  transactionType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of PayoutBankPaymentApproveAndCreate */
export type PayoutBankPaymentApproveAndCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payoutId: Scalars['ID']['input'];
};

/** Autogenerated return type of PayoutBankPaymentApproveAndCreate. */
export type PayoutBankPaymentApproveAndCreatePayload = {
  __typename?: 'PayoutBankPaymentApproveAndCreatePayload';
  bankPayment: BankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type PayoutSourceType = IncomingInvoice | Payout | ProviderOrder;

/** Autogenerated input type of PayoutsBulkBankPaymentApproveAndCreate */
export type PayoutsBulkBankPaymentApproveAndCreateInput = {
  attributes: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PayoutsBulkBankPaymentApproveAndCreate. */
export type PayoutsBulkBankPaymentApproveAndCreatePayload = {
  __typename?: 'PayoutsBulkBankPaymentApproveAndCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of PayoutsBulkSetAsPaid */
export type PayoutsBulkSetAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of PayoutsBulkSetAsPaid. */
export type PayoutsBulkSetAsPaidPayload = {
  __typename?: 'PayoutsBulkSetAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PayoutsCancel */
export type PayoutsCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PayoutsCancel. */
export type PayoutsCancelPayload = {
  __typename?: 'PayoutsCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payout: Payout;
};

/** Autogenerated input type of PayoutsCompleteAgainstAnother */
export type PayoutsCompleteAgainstAnotherInput = {
  attributes: OmsInputsPayoutCompleteAgainstAnotherType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PayoutsCompleteAgainstAnother. */
export type PayoutsCompleteAgainstAnotherPayload = {
  __typename?: 'PayoutsCompleteAgainstAnotherPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payout: Payout;
};

/** Autogenerated input type of PayoutsComplete */
export type PayoutsCompleteInput = {
  attributes: OmsInputsPayoutCompleteType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PayoutsComplete. */
export type PayoutsCompletePayload = {
  __typename?: 'PayoutsCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payout: Payout;
};

/** Autogenerated input type of PayoutsCreate */
export type PayoutsCreateInput = {
  attributes: OmsInputsPayoutType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of PayoutsCreate. */
export type PayoutsCreatePayload = {
  __typename?: 'PayoutsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payout: Payout;
};

/** Autogenerated input type of PayoutsDestroy */
export type PayoutsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PayoutsDestroy. */
export type PayoutsDestroyPayload = {
  __typename?: 'PayoutsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payout: Payout;
};

/** Autogenerated input type of PayoutsExport */
export type PayoutsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of PayoutsExport. */
export type PayoutsExportPayload = {
  __typename?: 'PayoutsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of PayoutsUpdate */
export type PayoutsUpdateInput = {
  attributes: OmsInputsPayoutType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of PayoutsUpdateMethod */
export type PayoutsUpdateMethodInput = {
  attributes: OmsInputsPayoutsUpdateMethodType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PayoutsUpdateMethod. */
export type PayoutsUpdateMethodPayload = {
  __typename?: 'PayoutsUpdateMethodPayload';
  bankPayment: WorkspacesUpdatedBankPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of PayoutsUpdate. */
export type PayoutsUpdatePayload = {
  __typename?: 'PayoutsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payout: Payout;
};

export type PdUser = {
  __typename?: 'PdUser';
  id?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Performance = {
  __typename?: 'Performance';
  ordersBePaidCount?: Maybe<Scalars['BigInt']['output']>;
  ordersBePaidValue?: Maybe<Scalars['BigInt']['output']>;
  ordersInProductionCount?: Maybe<Scalars['BigInt']['output']>;
  ordersInProductionMoney?: Maybe<Money>;
  ordersInProductionValue?: Maybe<Scalars['BigInt']['output']>;
  ordersPaidCount?: Maybe<Scalars['BigInt']['output']>;
  ordersPaidValue?: Maybe<Scalars['BigInt']['output']>;
  totalOrdersCount?: Maybe<Scalars['BigInt']['output']>;
  totalOrdersValue?: Maybe<Scalars['BigInt']['output']>;
};

export type Person = {
  __typename?: 'Person';
  billingAccountId?: Maybe<Scalars['ID']['output']>;
  billingAccountPerson?: Maybe<BillingAccountsPerson>;
  billingAccounts: Array<BillingAccount>;
  billingAccountsPersons: Array<BillingAccountsPerson>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  carbonCopyEmails: Array<Scalars['String']['output']>;
  contact?: Maybe<PersonContact>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deals?: Maybe<Array<Deal>>;
  dealsOrderedCount: Scalars['Int']['output'];
  dealsTotalCount: Scalars['Int']['output'];
  defaultBillingAccount?: Maybe<BillingAccount>;
  defaultShippingAddress?: Maybe<ShippingAddress>;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  emailHasPublicDomain: Scalars['Boolean']['output'];
  externalCrmId?: Maybe<Scalars['String']['output']>;
  externalCrmUrl?: Maybe<Scalars['String']['output']>;
  hasPunchout: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** @deprecated always true */
  inLoyaltyProgram: Scalars['Boolean']['output'];
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  invoiceEmails: Array<Scalars['String']['output']>;
  isRobot: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logisticEmails: Array<Scalars['String']['output']>;
  mailingSuspendedTill?: Maybe<Scalars['ISO8601Date']['output']>;
  mailingsSubscription?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  movedTo?: Maybe<IntercompanyObject>;
  movedToRegion?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  nps?: Maybe<Scalars['String']['output']>;
  ocEmails: Array<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  outcomingInvoiceEmail: Scalars['String']['output'];
  /** Deprecated, use organization.kam instead. */
  owner?: Maybe<PdUser>;
  paymentReminderEmails: Array<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveUrl: Scalars['String']['output'];
  shippingAddresses?: Maybe<Array<ShippingAddress>>;
  technicalEmails: Array<Scalars['String']['output']>;
  tpoEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  whatsappAllowed: Scalars['Boolean']['output'];
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};


export type PersonBillingAccountPersonArgs = {
  billingAccountId: Scalars['ID']['input'];
};


export type PersonDealsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonContact = {
  __typename?: 'PersonContact';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastVisitedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of PersonsBulkUpdate */
export type PersonsBulkUpdateInput = {
  attributes: OmsInputsPersonBulkUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of PersonsBulkUpdate. */
export type PersonsBulkUpdatePayload = {
  __typename?: 'PersonsBulkUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  persons: Array<Person>;
};

/** Autogenerated input type of PersonsCreate */
export type PersonsCreateInput = {
  attributes: OmsInputsPersonType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PersonsCreate. */
export type PersonsCreatePayload = {
  __typename?: 'PersonsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsExport */
export type PersonsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of PersonsExport. */
export type PersonsExportPayload = {
  __typename?: 'PersonsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of PersonsImpersonate */
export type PersonsImpersonateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsImpersonate. */
export type PersonsImpersonatePayload = {
  __typename?: 'PersonsImpersonatePayload';
  accessToken: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PersonsMerge */
export type PersonsMergeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mergedPersonId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsMerge. */
export type PersonsMergePayload = {
  __typename?: 'PersonsMergePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsOrganizationChange */
export type PersonsOrganizationChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsOrganizationChange. */
export type PersonsOrganizationChangePayload = {
  __typename?: 'PersonsOrganizationChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsPunchoutsAppendAddresses */
export type PersonsPunchoutsAppendAddressesInput = {
  addresses: Array<OmsInputsPersonsPunchoutAddressType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsPunchoutsAppendAddresses. */
export type PersonsPunchoutsAppendAddressesPayload = {
  __typename?: 'PersonsPunchoutsAppendAddressesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsPunchoutsCreate */
export type PersonsPunchoutsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsPunchoutsCreate. */
export type PersonsPunchoutsCreatePayload = {
  __typename?: 'PersonsPunchoutsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsReactivationTransfer */
export type PersonsReactivationTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsReactivationTransfer. */
export type PersonsReactivationTransferPayload = {
  __typename?: 'PersonsReactivationTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsSafeDestroy */
export type PersonsSafeDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsSafeDestroy. */
export type PersonsSafeDestroyPayload = {
  __typename?: 'PersonsSafeDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsSyncContact */
export type PersonsSyncContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsSyncContact. */
export type PersonsSyncContactPayload = {
  __typename?: 'PersonsSyncContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsUpdate */
export type PersonsUpdateInput = {
  attributes: OmsInputsPersonType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsUpdate. */
export type PersonsUpdatePayload = {
  __typename?: 'PersonsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonsVerifyWhatsAppNumber */
export type PersonsVerifyWhatsAppNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonsVerifyWhatsAppNumber. */
export type PersonsVerifyWhatsAppNumberPayload = {
  __typename?: 'PersonsVerifyWhatsAppNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

export type Phone = {
  __typename?: 'Phone';
  isdCode?: Maybe<Scalars['String']['output']>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PinnedMessage = {
  __typename?: 'PinnedMessage';
  attachments: Array<PinnedMessageAttachment>;
  author: PinnedMessageAuthor;
  content?: Maybe<Scalars['String']['output']>;
  contentRaw?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isTask: Scalars['Boolean']['output'];
  isVisibleToClient: Scalars['Boolean']['output'];
  isVisibleToPartner: Scalars['Boolean']['output'];
  pinnedAt: Scalars['ISO8601DateTime']['output'];
  region: RegionEnum;
  source: PinnedMessageSource;
};

export type PinnedMessageAttachment = {
  __typename?: 'PinnedMessageAttachment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  previewLargeUrl?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  uuidId: Scalars['String']['output'];
};

export type PinnedMessageAuthor = {
  __typename?: 'PinnedMessageAuthor';
  absence: AbsenceStatusEnum;
  authorType: UserEnum;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PinnedMessageSource = {
  __typename?: 'PinnedMessageSource';
  dealId?: Maybe<Scalars['ID']['output']>;
  parent?: Maybe<PinnedMessageSource>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
};

export type PinnedMessagesCollection = {
  __typename?: 'PinnedMessagesCollection';
  collection: Array<PinnedMessage>;
  failedRegions?: Maybe<Array<RegionEnum>>;
  total: Scalars['Int']['output'];
};

export enum PipelineTypeEnum {
  Modification = 'modification',
  New = 'new'
}

export type PlacingData = {
  __typename?: 'PlacingData';
  cancellationRatio?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Position = {
  __typename?: 'Position';
  height: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  partId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  samplesQuantity?: Maybe<Scalars['Int']['output']>;
  weight: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type PrepareAttachment = {
  __typename?: 'PrepareAttachment';
  name: Scalars['String']['output'];
  selected: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  a2c?: Maybe<PriceCell>;
  default: Scalars['Boolean']['output'];
  direction?: Maybe<ShippingCalculationDirectionEnum>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  p2x?: Maybe<PriceCell>;
  selected: Scalars['Boolean']['output'];
  sender: Scalars['String']['output'];
  total: Money;
  x2x?: Maybe<PriceCell>;
};

export type PriceCell = {
  __typename?: 'PriceCell';
  days?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<PriceTagEnum>>;
  tariff?: Maybe<Scalars['String']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  value: Money;
};

export enum PriceKindEnum {
  Batch = 'batch',
  Group = 'group',
  Sample = 'sample'
}

export enum PriceMethodEnum {
  Auto = 'Auto',
  Manual = 'Manual',
  Rfq = 'RFQ',
  Tpo = 'TPO'
}

export enum PriceTagEnum {
  Manual = 'manual',
  TopendEstimate = 'topend_estimate'
}

export type PrimaryAddress = {
  __typename?: 'PrimaryAddress';
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum Priority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type ProductionEventType = {
  __typename?: 'ProductionEventType';
  endDate: Scalars['ISO8601Date']['output'];
  name: Scalars['String']['output'];
  productionEventId: Scalars['ID']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  type: EventsTypeEnum;
};

/** Autogenerated input type of ProductionEventsCreate */
export type ProductionEventsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601Date']['input'];
  name: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of ProductionEventsCreate. */
export type ProductionEventsCreatePayload = {
  __typename?: 'ProductionEventsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ProductionEventsDelete */
export type ProductionEventsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProductionEventsDelete. */
export type ProductionEventsDeletePayload = {
  __typename?: 'ProductionEventsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ProductionEventsUpdate */
export type ProductionEventsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601Date']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of ProductionEventsUpdate. */
export type ProductionEventsUpdatePayload = {
  __typename?: 'ProductionEventsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProductionManager = {
  __typename?: 'ProductionManager';
  alarmDeals: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dailyStandUp: Scalars['Int']['output'];
  dealsOnHold: Scalars['Int']['output'];
  dealsPaidButOpen: Scalars['Int']['output'];
  dealsPartsNeedInfo: Scalars['Int']['output'];
  dealsSoldButNotPlaced: Scalars['Int']['output'];
  dealsWithSamples: Scalars['Int']['output'];
  dealsWonWithoutInvoices: Scalars['Int']['output'];
  frameworkDeals: Scalars['Int']['output'];
  frameworkShippingSchedule: Scalars['Int']['output'];
  highValueDeals: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  importantDeals: Scalars['Int']['output'];
  inTransitP2c: Scalars['Int']['output'];
  inTransitP2x: Scalars['Int']['output'];
  inTransitX2c: Scalars['Int']['output'];
  incomingInvoicesNeedReview: Scalars['Int']['output'];
  newClaims: Scalars['Int']['output'];
  ocDeadlineIsExpired: Scalars['Int']['output'];
  openCheckpoints: Scalars['Int']['output'];
  openClaims: Scalars['Int']['output'];
  openDeals: Scalars['Int']['output'];
  openIncomingInvoices: Scalars['Int']['output'];
  openOutcomingInvoices: Scalars['Int']['output'];
  openProductionOrders: Scalars['Int']['output'];
  openQualityControls: Scalars['Int']['output'];
  openShippings: Scalars['Int']['output'];
  outcomingInvoicesNeedFix: Scalars['Int']['output'];
  partnerIsFixing: Scalars['Int']['output'];
  pmId?: Maybe<Scalars['ID']['output']>;
  poAbandoned: Scalars['Int']['output'];
  poDlIsExpired: Scalars['Int']['output'];
  poDlIsHere: Scalars['Int']['output'];
  poLeadtimeOverdue: Scalars['Int']['output'];
  poProviderSelected: Scalars['Int']['output'];
  poWithoutInvoices: Scalars['Int']['output'];
  podId?: Maybe<Scalars['Int']['output']>;
  qcIssuesNeedVerdict: Scalars['Int']['output'];
  qcWithoutTechnicalVerdict: Scalars['Int']['output'];
  secondaryProduction: Scalars['Int']['output'];
  sendOc: Scalars['Int']['output'];
  sfCasesNew: Scalars['Int']['output'];
  sfCasesOnHold: Scalars['Int']['output'];
  sfCasesPending: Scalars['Int']['output'];
  sfCasesSolved: Scalars['Int']['output'];
  shippingsAbandoned: Scalars['Int']['output'];
  shippingsBoxReady: Scalars['Int']['output'];
  shippingsReadyForShipping: Scalars['Int']['output'];
  shippingsWithoutInvoices: Scalars['Int']['output'];
  storagesNotEmpty: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vqcNeedFix: Scalars['Int']['output'];
  xometryEuDeals: Scalars['Int']['output'];
  xometryTrDeals: Scalars['Int']['output'];
  xometryUkDeals: Scalars['Int']['output'];
};

export enum ProductionManagerCascadeOptionEnum {
  /** Do not cascade update to any Deal */
  NoUpdate = 'no_update',
  /** Cascade update to OPEN Deals of this Org. with current PM */
  UpdateAll = 'update_all',
  /** Cascade update to OPEN Deals of this Org. */
  UpdateOpen = 'update_open',
  /** Cascade update to all Deals of this Org. */
  UpdateOpenWithCurrentPm = 'update_open_with_current_pm'
}

export type ProductionScheduleItem = {
  __typename?: 'ProductionScheduleItem';
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvedBy?: Maybe<User>;
  approvedById?: Maybe<Scalars['BigInt']['output']>;
  attachedFiles: Array<AttachedFile>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  providerOrder: ProviderOrder;
  providerOrderId: Scalars['BigInt']['output'];
  respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  respondedBy?: Maybe<ProductionScheduleItemResponder>;
  respondedById?: Maybe<Scalars['BigInt']['output']>;
  respondedByType?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  stageDate?: Maybe<Scalars['ISO8601Date']['output']>;
  stageName?: Maybe<ProductionScheduleStageNameEnum>;
  stageNameCustom?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProductionScheduleItemResponder = ProviderContact | User;

/** Autogenerated input type of ProductionScheduleItemsCreate */
export type ProductionScheduleItemsCreateInput = {
  attributes: OmsInputsProviderOrdersProductionScheduleItemCreateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerOrderId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProductionScheduleItemsCreate. */
export type ProductionScheduleItemsCreatePayload = {
  __typename?: 'ProductionScheduleItemsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productionScheduleItem: ProductionScheduleItem;
};

/** Autogenerated input type of ProductionScheduleItemsDestroy */
export type ProductionScheduleItemsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProductionScheduleItemsDestroy. */
export type ProductionScheduleItemsDestroyPayload = {
  __typename?: 'ProductionScheduleItemsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ProductionScheduleItemsExport */
export type ProductionScheduleItemsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of ProductionScheduleItemsExport. */
export type ProductionScheduleItemsExportPayload = {
  __typename?: 'ProductionScheduleItemsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ProductionScheduleItemsUpdate */
export type ProductionScheduleItemsUpdateInput = {
  attributes: OmsInputsProviderOrdersProductionScheduleItemUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProductionScheduleItemsUpdate. */
export type ProductionScheduleItemsUpdatePayload = {
  __typename?: 'ProductionScheduleItemsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productionScheduleItem: ProductionScheduleItem;
};

export enum ProductionScheduleStageNameEnum {
  MaterialCertificate = 'material_certificate',
  Measurements = 'measurements',
  OrderMaterial = 'order_material',
  Other = 'other',
  Packaging = 'packaging',
  ProductionInProgress = 'production_in_progress',
  SyncWithPartner = 'sync_with_partner'
}

export enum ProductionStageEnum {
  /** calculated */
  Calculated = 'calculated',
  /** draft */
  Draft = 'draft',
  /** enquiry_cancelled */
  EnquiryCancelled = 'enquiry_cancelled',
  /** need_calculate */
  NeedCalculate = 'need_calculate',
  /** pending */
  Pending = 'pending',
  /** prod_delivered */
  ProdDelivered = 'prod_delivered',
  /** prod_placed */
  ProdPlaced = 'prod_placed',
  /** prod_placing */
  ProdPlacing = 'prod_placing',
  /** prod_processing */
  ProdProcessing = 'prod_processing',
  /** prod_shipped2c */
  ProdShipped2c = 'prod_shipped2c',
  /** prod_shipped2x */
  ProdShipped2x = 'prod_shipped2x',
  /** prod_warehouse */
  ProdWarehouse = 'prod_warehouse',
  /** submitted */
  Submitted = 'submitted'
}

/** Autogenerated input type of PromotionsCreateDiscount */
export type PromotionsCreateDiscountInput = {
  attributes: OmsInputsPromotionDiscountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PromotionsCreateDiscount. */
export type PromotionsCreateDiscountPayload = {
  __typename?: 'PromotionsCreateDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of PromotionsCreate */
export type PromotionsCreateInput = {
  attributes: OmsInputsPromotionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PromotionsCreate. */
export type PromotionsCreatePayload = {
  __typename?: 'PromotionsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiryPromotion: OmsEnquiryPromotionType;
};

/** Autogenerated input type of PromotionsDestroyDiscount */
export type PromotionsDestroyDiscountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PromotionsDestroyDiscount. */
export type PromotionsDestroyDiscountPayload = {
  __typename?: 'PromotionsDestroyDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

/** Autogenerated input type of PromotionsUpdateDiscount */
export type PromotionsUpdateDiscountInput = {
  attributes: OmsInputsPromotionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enquiryId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PromotionsUpdateDiscount. */
export type PromotionsUpdateDiscountPayload = {
  __typename?: 'PromotionsUpdateDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiryPromotion: OmsEnquiryPromotionType;
};

/** Autogenerated input type of PromotionsUpdate */
export type PromotionsUpdateInput = {
  attributes: OmsInputsPromotionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PromotionsUpdate. */
export type PromotionsUpdatePayload = {
  __typename?: 'PromotionsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiryPromotion: OmsEnquiryPromotionType;
};

export type Provider = {
  __typename?: 'Provider';
  acceptSelfBilling: Scalars['Boolean']['output'];
  activeChangeRequestId?: Maybe<Scalars['ID']['output']>;
  allowAutoacceptOffers?: Maybe<Scalars['Boolean']['output']>;
  allowAutoacceptOffersFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  allowDirectshipOrders?: Maybe<Scalars['Boolean']['output']>;
  allowDirectshipOrdersFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  autoacceptPoNumberLimit?: Maybe<Scalars['Int']['output']>;
  autoacceptPoNumberLimitFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  autoacceptPoValueLimit?: Maybe<Scalars['Float']['output']>;
  autoacceptPoValueLimitFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  autoacceptPoValueLimitMoney?: Maybe<Money>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankAccountHolderName?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankPayments?: Maybe<Array<BankPayment>>;
  bdoNumber?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  comment?: Maybe<Scalars['String']['output']>;
  contacts: Array<ProviderContact>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: CurrencyEnum;
  datevKonto?: Maybe<Scalars['String']['output']>;
  decoratedName: Scalars['String']['output'];
  eligibleForSelfBilling: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  financeCheckAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  financeCheckBy?: Maybe<User>;
  freeCapacity: Scalars['Boolean']['output'];
  freeCapacityFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  generatedComment?: Maybe<Scalars['String']['output']>;
  gstIn?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  incomingInvoices: Array<IncomingInvoice>;
  intacctId?: Maybe<Scalars['String']['output']>;
  isEuropean?: Maybe<Scalars['Boolean']['output']>;
  lastVisitAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  limitsComment?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notVatPayer: Scalars['Boolean']['output'];
  onImprovement: Scalars['Boolean']['output'];
  onImprovementComment?: Maybe<Scalars['String']['output']>;
  onImprovementFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  onImprovementStartedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  partnerNetworkManager?: Maybe<User>;
  partnerNetworkManagerFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  partnerSuccessManager?: Maybe<User>;
  payoutTransferType?: Maybe<Scalars['String']['output']>;
  payouts: Array<Payout>;
  performance?: Maybe<Performance>;
  phone?: Maybe<Scalars['String']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  placingData?: Maybe<PlacingData>;
  poNumberLimit?: Maybe<Scalars['Int']['output']>;
  poNumberLimitFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  poValueLimit?: Maybe<Scalars['Float']['output']>;
  poValueLimitFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  poValueLimitMoney?: Maybe<Money>;
  primaryContact?: Maybe<ProviderContact>;
  primaryContactId?: Maybe<Scalars['Int']['output']>;
  productionHoliday: Scalars['Boolean']['output'];
  providerOrders?: Maybe<Array<ProviderOrder>>;
  publicComment?: Maybe<Scalars['String']['output']>;
  publicHoliday: Scalars['Boolean']['output'];
  rank?: Maybe<Rank>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Address>;
  state: ProviderStateEnum;
  tags: Array<Tag>;
  testPartner: Scalars['Boolean']['output'];
  updatedAfterRegistered?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatId?: Maybe<Scalars['String']['output']>;
  vatValidationStatus?: Maybe<VatValidationStatusEnumType>;
  vatValidationTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type ProviderBankPaymentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type ProviderGeneratedCommentArgs = {
  dealId: Scalars['ID']['input'];
};


export type ProviderIncomingInvoicesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type ProviderPayoutsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderBalanceLineType = {
  __typename?: 'ProviderBalanceLineType';
  balanceMoney?: Maybe<Money>;
  creditNote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  invoiceAmountMoney?: Maybe<Money>;
  invoiceRequired?: Maybe<Scalars['Boolean']['output']>;
  issuedPaid?: Maybe<Scalars['ISO8601Date']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  paidAmountMoney?: Maybe<Money>;
  paymentDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentTypePostfix?: Maybe<Scalars['JSON']['output']>;
  paymentTypePrefix?: Maybe<Scalars['String']['output']>;
  providerOrderId?: Maybe<Scalars['ID']['output']>;
  providerOrderNumber?: Maybe<Scalars['String']['output']>;
  selfBilling?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSuffix?: Maybe<Scalars['String']['output']>;
  totalsMoney?: Maybe<Money>;
};

export type ProviderBalanceType = {
  __typename?: 'ProviderBalanceType';
  data: Array<ProviderOrdersBalance>;
  id: Scalars['String']['output'];
  more: Scalars['Boolean']['output'];
};

export type ProviderChangeRequestInfo = {
  __typename?: 'ProviderChangeRequestInfo';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  notCheckedInvoices: Array<IncomingInvoice>;
  notPaidInvoices: Array<IncomingInvoice>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProviderContact = {
  __typename?: 'ProviderContact';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  disallowToPool?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  openPassword?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  preferredContactType?: Maybe<Scalars['String']['output']>;
  provider: Provider;
  providerId: Scalars['ID']['output'];
  telegram?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verifiedAt?: Maybe<Scalars['String']['output']>;
  verifyKey?: Maybe<Scalars['String']['output']>;
  viber?: Maybe<Scalars['String']['output']>;
  wechat?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
};

export type ProviderData = {
  __typename?: 'ProviderData';
  bankAccount?: Maybe<DataItem>;
  bankAccountHolderName?: Maybe<DataItem>;
  bankCode?: Maybe<DataItem>;
  bankCountry?: Maybe<DataItem>;
  bankName?: Maybe<DataItem>;
  billingAddress?: Maybe<BillingAddressData>;
  datevKonto?: Maybe<DataItem>;
  intacctId?: Maybe<DataItem>;
  legalName?: Maybe<DataItem>;
  notVatPayer?: Maybe<DataItem>;
  payoutTransferType?: Maybe<DataItem>;
  vatId?: Maybe<DataItem>;
};

export type ProviderOrder = {
  __typename?: 'ProviderOrder';
  additionalServices: Array<AdditionalService>;
  allocatedAmountMoney: Money;
  allowDirectShipping: Scalars['Boolean']['output'];
  attachedFiles: Array<AttachedFile>;
  conformityCheck?: Maybe<OmsProviderOrderConformityCheckEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNoteRequestedAmountMoney: Money;
  creditNoteRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creditNoteRequestedBy?: Maybe<User>;
  currency: Scalars['String']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  deadlineInitial?: Maybe<Scalars['ISO8601Date']['output']>;
  deadlineUpdateCategory?: Maybe<ProviderOrdersDeadlineUpdateCategoryEnum>;
  deadlineUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deadlineUpdatedBy?: Maybe<User>;
  deal: Deal;
  dealId: Scalars['Int']['output'];
  documentsCounters: ProviderOrdersDocumentsCountsType;
  fullyPaidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  incomingInvoices?: Maybe<Array<IncomingInvoice>>;
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  lots: Array<Lot>;
  moldsWithoutExpectedShipping: Array<Lot>;
  number: Scalars['String']['output'];
  partsValueNetto?: Maybe<Scalars['Float']['output']>;
  partsValueNettoMoney: Money;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  payouts: Array<Payout>;
  pnmEscalation: Scalars['Boolean']['output'];
  productionScheduleItems: Array<ProductionScheduleItem>;
  provider?: Maybe<Provider>;
  providerId: Scalars['ID']['output'];
  publicComment?: Maybe<Scalars['String']['output']>;
  qcReportRequired: Scalars['Boolean']['output'];
  relatedDeliveries: Array<Delivery>;
  relatedShippings: Array<Shipping>;
  renegotiatedValueNettoMoney: Money;
  samplesConfirmationStatus?: Maybe<ProviderOrdersSamplesConfirmationStatusEnum>;
  samplesConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  samplesConfirmedBy?: Maybe<ProviderOrdersSamplesConfirmedBy>;
  samplesConfirmedById?: Maybe<Scalars['ID']['output']>;
  samplesMainProviderOrder?: Maybe<ProviderOrder>;
  samplesMainProviderOrderId?: Maybe<Scalars['ID']['output']>;
  samplesPoType?: Maybe<ProviderOrdersSamplesProviderOrderTypeEnum>;
  samplesProviderOrder?: Maybe<ProviderOrder>;
  samplesProviderOrderId?: Maybe<Scalars['ID']['output']>;
  secondaryProduction: Scalars['Boolean']['output'];
  secondaryProductionReason?: Maybe<OmsProviderOrderSecondaryProductionReasonEnum>;
  sendReminders: Scalars['Boolean']['output'];
  servicesValueNetto?: Maybe<Scalars['Float']['output']>;
  servicesValueNettoMoney: Money;
  shipAllowDirectLegal?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectLegalXomSales?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectOrder?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectProvider?: Maybe<Scalars['Boolean']['output']>;
  shipDirection?: Maybe<ProviderOrdersShipDirectionEnum>;
  shipDirectionToEndCustomer?: Maybe<Scalars['Boolean']['output']>;
  shipIncoterms?: Maybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly: Scalars['Boolean']['output'];
  shipIncotermsCity?: Maybe<Scalars['String']['output']>;
  shipIncotermsCountry?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated, please use [ship_warehouse] instead. */
  shipQc?: Maybe<ProviderOrdersShipQcEnum>;
  shipQcRequired?: Maybe<Scalars['Boolean']['output']>;
  shipWarehouse?: Maybe<WarehouseInstructionEnum>;
  shipmentDateRevisedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  shipmentDateRevisedCategory?: Maybe<ShipmentEstimateUpdateCategoryEnum>;
  shippingCreationRestricted: Scalars['Boolean']['output'];
  shippingInstructionsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingInstructionsUpdatedBy?: Maybe<User>;
  shippingProcessingInstruction?: Maybe<ShippingInstructionEnum>;
  state: ProviderOrderStateEnum;
  stateLastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totalAmountNet: Scalars['Float']['output'];
  totalAmountNetMoney: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  visibleInPa: Scalars['Boolean']['output'];
  xometryVatNumber?: Maybe<XometryVatNumber>;
};


export type ProviderOrderAttachedFilesArgs = {
  context?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProviderOrderIncomingInvoicesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type ProviderOrderPayoutsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderOrderLeadtimeEventType = {
  __typename?: 'ProviderOrderLeadtimeEventType';
  dealId: Scalars['ID']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  name: Scalars['String']['output'];
  providerOrderId: Scalars['ID']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  type: EventsTypeEnum;
};

export enum ProviderOrderStateEnum {
  /** canceled */
  Canceled = 'canceled',
  /** placed */
  Placed = 'placed',
  /** produced */
  Produced = 'produced',
  /** provider_selected */
  ProviderSelected = 'provider_selected',
  /** shipped */
  Shipped = 'shipped'
}

export type ProviderOrdersBalance = {
  __typename?: 'ProviderOrdersBalance';
  data: Array<ProviderBalanceLineType>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of ProviderOrdersCreate */
export type ProviderOrdersCreateInput = {
  attributes: OmsInputsProviderOrderCreateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProviderOrdersCreate. */
export type ProviderOrdersCreatePayload = {
  __typename?: 'ProviderOrdersCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  providerOrder: ProviderOrder;
};

export enum ProviderOrdersDeadlineUpdateCategoryEnum {
  /** Client related move */
  ClientRelatedMove = 'client_related_move',
  /** Framework alignment */
  FrameworkAlignment = 'framework_alignment',
  /** IM related move */
  ImRelatedMove = 'im_related_move',
  /** Other */
  Other = 'other',
  /** Placing related move */
  PlacingRelatedMove = 'placing_related_move',
  /** Samples alignment */
  SamplesAlignment = 'samples_alignment',
  /** Xometry fault compensation move */
  XometryFaultCompensationMove = 'xometry_fault_compensation_move'
}

/** Autogenerated input type of ProviderOrdersDestroy */
export type ProviderOrdersDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProviderOrdersDestroy. */
export type ProviderOrdersDestroyPayload = {
  __typename?: 'ProviderOrdersDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  providerOrder: ProviderOrder;
};

export type ProviderOrdersDocumentsCountsType = {
  __typename?: 'ProviderOrdersDocumentsCountsType';
  accepted: Scalars['Int']['output'];
  incomplete: Scalars['Int']['output'];
  needVerdict: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  verdictNotNeeded: Scalars['Int']['output'];
};

/** Autogenerated input type of ProviderOrdersExport */
export type ProviderOrdersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of ProviderOrdersExport. */
export type ProviderOrdersExportPayload = {
  __typename?: 'ProviderOrdersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum ProviderOrdersIncotermsEnum {
  /** DAP */
  Dap = 'DAP',
  /** EXW */
  Exw = 'EXW'
}

/** Autogenerated input type of ProviderOrdersIssueBasedOnJobOffer */
export type ProviderOrdersIssueBasedOnJobOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createDraftPo?: InputMaybe<Scalars['Boolean']['input']>;
  jobOfferId: Scalars['ID']['input'];
  notifyProvider?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ProviderOrdersIssueBasedOnJobOffer. */
export type ProviderOrdersIssueBasedOnJobOfferPayload = {
  __typename?: 'ProviderOrdersIssueBasedOnJobOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  providerOrder: ProviderOrder;
};

export enum ProviderOrdersSamplesConfirmationStatusEnum {
  /** Confirmed */
  Confirmed = 'confirmed',
  /** Rejected */
  Rejected = 'rejected',
  /** Required */
  Required = 'required'
}

export type ProviderOrdersSamplesConfirmedBy = Person | User;

export enum ProviderOrdersSamplesProviderOrderTypeEnum {
  /** Main Batch */
  MainBatch = 'main_batch',
  /** Samples */
  Samples = 'samples'
}

export enum ProviderOrdersShipDirectionEnum {
  /** P2C */
  P2c = 'p2c',
  /** P2X */
  P2x = 'p2x'
}

export enum ProviderOrdersShipQcEnum {
  /** No QC */
  Nqc = 'nqc',
  /** Xometry QC */
  Xqc = 'xqc'
}

/** Autogenerated input type of ProviderOrdersShippingInstructionUpdates */
export type ProviderOrdersShippingInstructionUpdatesInput = {
  attributes: OmsInputsShippingInstructions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProviderOrdersShippingInstructionUpdates. */
export type ProviderOrdersShippingInstructionUpdatesPayload = {
  __typename?: 'ProviderOrdersShippingInstructionUpdatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  providerOrder: ProviderOrder;
};

/** Autogenerated input type of ProviderOrdersSplit */
export type ProviderOrdersSplitInput = {
  attributes: OmsInputsProviderOrderCreateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerOrderIdToSplit: Scalars['ID']['input'];
  sourceProviderOrderComment?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProviderOrdersSplit. */
export type ProviderOrdersSplitPayload = {
  __typename?: 'ProviderOrdersSplitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  providerOrder: ProviderOrder;
};

/** Autogenerated input type of ProviderOrdersUpdate */
export type ProviderOrdersUpdateInput = {
  attributes: OmsInputsProviderOrderUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProviderOrdersUpdate. */
export type ProviderOrdersUpdatePayload = {
  __typename?: 'ProviderOrdersUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  providerOrder: ProviderOrder;
};

/** Autogenerated input type of ProviderSendToCheck */
export type ProviderSendToCheckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProviderSendToCheck. */
export type ProviderSendToCheckPayload = {
  __typename?: 'ProviderSendToCheckPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  provider: Provider;
};

export enum ProviderStateEnum {
  /** blacklist */
  Blacklist = 'blacklist',
  /** deleted */
  Deleted = 'deleted',
  /** enrolled_via_website */
  EnrolledViaWebsite = 'enrolled_via_website',
  /** found_by_us */
  FoundByUs = 'found_by_us',
  /** probation */
  Probation = 'probation',
  /** test_part */
  TestPart = 'test_part',
  /** trusted */
  Trusted = 'trusted'
}

export type ProviderTotalsBalanceType = {
  __typename?: 'ProviderTotalsBalanceType';
  balanceMoney: Money;
  invoicesBalanceMoney: Money;
  prepaymentsMoney: Money;
};

export type ProviderTransactionRecordChildType = {
  __typename?: 'ProviderTransactionRecordChildType';
  dealId?: Maybe<Scalars['ID']['output']>;
  invoicedAmount?: Maybe<Money>;
  paidMoney?: Maybe<Money>;
  providerOrderId: Scalars['ID']['output'];
  providerOrderNumber: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleSuffix?: Maybe<Scalars['String']['output']>;
};

export type ProviderTransactionRecordType = {
  __typename?: 'ProviderTransactionRecordType';
  children: Array<ProviderTransactionRecordChildType>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  paidMoney?: Maybe<Money>;
  title: Scalars['String']['output'];
  titleSuffix?: Maybe<Scalars['String']['output']>;
};

export type ProviderTransactionsType = {
  __typename?: 'ProviderTransactionsType';
  data: Array<ProviderTransactionRecordType>;
  more: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ProviderXlsxReport */
export type ProviderXlsxReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  providerId: Scalars['ID']['input'];
  searchLine?: InputMaybe<Scalars['String']['input']>;
  showPaid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ProviderXlsxReport. */
export type ProviderXlsxReportPayload = {
  __typename?: 'ProviderXlsxReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ProvidersBulkActionsAssignPartnerSuccessManager */
export type ProvidersBulkActionsAssignPartnerSuccessManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerSuccessManagerId: Scalars['ID']['input'];
  providerIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProvidersBulkActionsAssignPartnerSuccessManager. */
export type ProvidersBulkActionsAssignPartnerSuccessManagerPayload = {
  __typename?: 'ProvidersBulkActionsAssignPartnerSuccessManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ProvidersCreate */
export type ProvidersCreateInput = {
  attributes?: InputMaybe<OmsInputsProviderType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProvidersCreate. */
export type ProvidersCreatePayload = {
  __typename?: 'ProvidersCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  provider: Provider;
};

/** Autogenerated input type of ProvidersDelete */
export type ProvidersDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProvidersDelete. */
export type ProvidersDeletePayload = {
  __typename?: 'ProvidersDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  provider: Provider;
};

/** Autogenerated input type of ProvidersExport */
export type ProvidersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of ProvidersExport. */
export type ProvidersExportPayload = {
  __typename?: 'ProvidersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ProvidersSuccessManual */
export type ProvidersSuccessManualInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<OmsInputsAttachmentType>>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProvidersSuccessManual. */
export type ProvidersSuccessManualPayload = {
  __typename?: 'ProvidersSuccessManualPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  provider: Provider;
};

/** Autogenerated input type of ProvidersUpdate */
export type ProvidersUpdateInput = {
  attributes: OmsInputsProviderType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ProvidersUpdate. */
export type ProvidersUpdatePayload = {
  __typename?: 'ProvidersUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  provider: Provider;
};

/** Autogenerated input type of PublicDomainsCreate */
export type PublicDomainsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of PublicDomainsCreate. */
export type PublicDomainsCreatePayload = {
  __typename?: 'PublicDomainsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PublicHolidayEventType = {
  __typename?: 'PublicHolidayEventType';
  endDate: Scalars['ISO8601Date']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  type: EventsTypeEnum;
};

/** Autogenerated input type of PublishDealTransferredEvent */
export type PublishDealTransferredEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jcOff?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of PublishLogisticInvoice */
export type PublishLogisticInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishLogisticInvoice. */
export type PublishLogisticInvoicePayload = {
  __typename?: 'PublishLogisticInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

export enum PunchoutAddressTypeEnum {
  BillingAccount = 'BillingAccount',
  ShippingAddress = 'ShippingAddress'
}

export type QualityControl = {
  __typename?: 'QualityControl';
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<QualityControlsPositionType>>;
  relatedProviderOrders?: Maybe<Array<ProviderOrder>>;
  reportComment?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of QualityControlsCreate */
export type QualityControlsCreateInput = {
  attributes: OmsInputsQualityControlType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of QualityControlsCreate. */
export type QualityControlsCreatePayload = {
  __typename?: 'QualityControlsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  qualityControl: QualityControl;
};

/** Autogenerated input type of QualityControlsExport */
export type QualityControlsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of QualityControlsExport. */
export type QualityControlsExportPayload = {
  __typename?: 'QualityControlsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of QualityControlsGeneratePdfReport */
export type QualityControlsGeneratePdfReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reportParams: OmsInputsQualityControlsPdfReportParams;
};

/** Autogenerated return type of QualityControlsGeneratePdfReport. */
export type QualityControlsGeneratePdfReportPayload = {
  __typename?: 'QualityControlsGeneratePdfReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type QualityControlsMeasurementMarkCordsType = {
  __typename?: 'QualityControlsMeasurementMarkCordsType';
  offsetX?: Maybe<Scalars['Float']['output']>;
  offsetY?: Maybe<Scalars['Float']['output']>;
  r?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type QualityControlsMeasurementMarkType = {
  __typename?: 'QualityControlsMeasurementMarkType';
  active: Scalars['Boolean']['output'];
  canvasId: Scalars['BigInt']['output'];
  fill: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: QualityControlsMeasurementMarkCordsType;
  point: QualityControlsMeasurementMarkCordsType;
  position: Scalars['String']['output'];
  v: Scalars['String']['output'];
};

export type QualityControlsMeasurementType = {
  __typename?: 'QualityControlsMeasurementType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  mark?: Maybe<QualityControlsMeasurementMarkType>;
  maxValue?: Maybe<Scalars['String']['output']>;
  measurements?: Maybe<Scalars['JSON']['output']>;
  minMaxStr?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nominalValue: Scalars['String']['output'];
  part?: Maybe<Part>;
  partId?: Maybe<Scalars['BigInt']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  qcCanvas: AttachedFile;
  qcCanvasId: Scalars['BigInt']['output'];
  qcPosition?: Maybe<QualityControlsPositionType>;
  qcPositionId?: Maybe<Scalars['BigInt']['output']>;
  toleranceClass?: Maybe<Scalars['String']['output']>;
  toolset?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verdict?: Maybe<Scalars['String']['output']>;
};

export type QualityControlsPositionType = {
  __typename?: 'QualityControlsPositionType';
  atmPressure?: Maybe<Scalars['Float']['output']>;
  businessVerdict?: Maybe<Scalars['String']['output']>;
  businessVerdictComment?: Maybe<Scalars['String']['output']>;
  businessVerdictPublished?: Maybe<Scalars['Boolean']['output']>;
  businessVerdictUpdatedBy?: Maybe<ByJson>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerPrice: Scalars['Float']['output'];
  customerPriceCurrency: Scalars['String']['output'];
  customerPriceMoney: Money;
  humidity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  lot?: Maybe<Lot>;
  lotId: Scalars['Int']['output'];
  material?: Maybe<Scalars['String']['output']>;
  measurements?: Maybe<Array<QualityControlsMeasurementType>>;
  measurementsCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  officialVerdictComment?: Maybe<Scalars['String']['output']>;
  part: Part;
  partDetails?: Maybe<Scalars['String']['output']>;
  partId: Scalars['Int']['output'];
  positionUpdatedBy?: Maybe<ByJson>;
  postProcessing?: Maybe<Scalars['String']['output']>;
  providerOrder?: Maybe<ProviderOrder>;
  providerOrderId?: Maybe<Scalars['ID']['output']>;
  providerPrice: Scalars['Float']['output'];
  providerPriceCurrency: Scalars['String']['output'];
  providerPriceMoney: Money;
  qcCoating?: Maybe<Scalars['String']['output']>;
  qcCoatingComment?: Maybe<Scalars['String']['output']>;
  qcCompliance?: Maybe<Scalars['String']['output']>;
  qcComplianceComment?: Maybe<Scalars['String']['output']>;
  qcConservation?: Maybe<Scalars['String']['output']>;
  qcConservationComment?: Maybe<Scalars['String']['output']>;
  qcCreatedBy?: Maybe<ByJson>;
  qcCreatedByUser?: Maybe<User>;
  qcDocuments?: Maybe<Scalars['String']['output']>;
  qcDocumentsComment?: Maybe<Scalars['String']['output']>;
  qcFinish?: Maybe<Scalars['String']['output']>;
  qcFinishComment?: Maybe<Scalars['String']['output']>;
  qcMarking?: Maybe<Scalars['String']['output']>;
  qcMarkingComment?: Maybe<Scalars['String']['output']>;
  qcOther?: Maybe<Scalars['String']['output']>;
  qcOtherComment?: Maybe<Scalars['String']['output']>;
  qcPackaging?: Maybe<Scalars['String']['output']>;
  qcPackagingComment?: Maybe<Scalars['String']['output']>;
  qcQuantity?: Maybe<Scalars['String']['output']>;
  qcQuantityComment?: Maybe<Scalars['String']['output']>;
  qcQuantityObserved?: Maybe<Scalars['Int']['output']>;
  qccLink: Scalars['String']['output'];
  qtyAccepted?: Maybe<Scalars['Int']['output']>;
  qtyChecked?: Maybe<Scalars['Int']['output']>;
  qtyHold?: Maybe<Scalars['Int']['output']>;
  qtyRejected?: Maybe<Scalars['Int']['output']>;
  qualityControlId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  rejectReason?: Maybe<Scalars['String']['output']>;
  techVerdict?: Maybe<Scalars['String']['output']>;
  techVerdictComment?: Maybe<Scalars['String']['output']>;
  techVerdictPublished?: Maybe<Scalars['Boolean']['output']>;
  techVerdictUpdatedBy?: Maybe<ByJson>;
  temperature?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of QualityControlsPositionsDelete */
export type QualityControlsPositionsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of QualityControlsPositionsDelete. */
export type QualityControlsPositionsDeletePayload = {
  __typename?: 'QualityControlsPositionsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of QualityControlsPositionsUpdate */
export type QualityControlsPositionsUpdateInput = {
  attributes: OmsInputsQualityControlsPositionType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated input type of QualityControlsPositionsUpdateMeasurements */
export type QualityControlsPositionsUpdateMeasurementsInput = {
  attributes: Array<OmsInputsQualityControlsMeasurementType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  previewBase64?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of QualityControlsPositionsUpdateMeasurements. */
export type QualityControlsPositionsUpdateMeasurementsPayload = {
  __typename?: 'QualityControlsPositionsUpdateMeasurementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  qualityControlPosition: QualityControlsPositionType;
};

/** Autogenerated return type of QualityControlsPositionsUpdate. */
export type QualityControlsPositionsUpdatePayload = {
  __typename?: 'QualityControlsPositionsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  qualityControlPosition: QualityControlsPositionType;
};

/** Autogenerated input type of QualityControlsRepack */
export type QualityControlsRepackInput = {
  attributes: OmsInputsQualityControlsRepackType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of QualityControlsRepack. */
export type QualityControlsRepackPayload = {
  __typename?: 'QualityControlsRepackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  result: DealsSourceType;
};

/** Autogenerated input type of QualityControlsUpdate */
export type QualityControlsUpdateInput = {
  attributes: OmsInputsQualityControlType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of QualityControlsUpdate. */
export type QualityControlsUpdatePayload = {
  __typename?: 'QualityControlsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  qualityControl: QualityControl;
};

export type Query = {
  __typename?: 'Query';
  activityRecord: ActivityRecord;
  activityRecords?: Maybe<Array<ActivityRecord>>;
  activityRecordsByDeal?: Maybe<Array<ActivityRecord>>;
  activityRecordsDealCombined: PaginatedActivityRecords;
  /** Get latest AI invoice data validation (compared response) by attached file id */
  aiCopilotInvoiceDataValidation?: Maybe<AiResponse>;
  /** Get the status and result of an AI Copilot translation request */
  aiCopilotTranslationStatus?: Maybe<TranslationStatus>;
  authorizeAction: Authorization;
  bankAccount?: Maybe<BankAccount>;
  bankPayment?: Maybe<BankPayment>;
  bankPaymentExport: Export;
  bankPaymentExports: Array<Export>;
  bankPaymentImport: Import;
  bankPaymentImports: Array<Import>;
  /** NOT IMPLEMENTED IN UK */
  bankPaymentsToBeExported?: Maybe<Array<BankPayment>>;
  billingAccount?: Maybe<BillingAccount>;
  billingAccountBalanceDetails: BalanceDetails;
  billingAccountBalanceTotals: BalanceTotals;
  billingAccountsMatchingVatOrTaxId?: Maybe<Array<BillingAccount>>;
  billingAccountsOrganizationsByBillingAccount: Array<BillingAccountsOrganization>;
  /** Fetch list of related objects for BA */
  billingAccountsRelatedObjects: RelatedObjects;
  /** Fetch BA vat validations */
  billingAccountsValidations: Validations;
  builtOutcomingInvoiceRelations: Array<PaymentOutcomingInvoiceRelation>;
  /** Fetch list of cascade objects for BA */
  cascadeBillingAccountsObjectList: CascadeBillingAccountsObjectListType;
  /** Fetch list of cascade objects for SA */
  cascadeShippingAddressesObjectList: CascadeShippingAddressesObjectListType;
  /** Fetch sum of cavities for deal parts */
  cavities: Scalars['Int']['output'];
  /** Fetch certificates */
  certificates: Array<Certificate>;
  changeRequest: ChangeRequest;
  changeRequestRelatedDataByProvider: ProviderChangeRequestInfo;
  claim: Claim;
  claims: Array<Claim>;
  /** Fetch tags by context */
  contextTags?: Maybe<Array<Tag>>;
  countersDraftingEngineers: DraftingEngineer;
  countersFinance: Finance;
  countersProductionManagers: ProductionManager;
  countersRfqManagers: Array<RfqManager>;
  countersSalesPersons: Array<SalesPerson>;
  countersSettings?: Maybe<Array<CountersSettings>>;
  countries?: Maybe<Array<CountryType>>;
  currencyRate: CurrencyRate;
  /** NOT IMPLEMENTED IN UK */
  datevBankPaymentsExport?: Maybe<BankPaymentsExport>;
  /** NOT IMPLEMENTED IN UK */
  datevBankPaymentsExports?: Maybe<Array<BankPaymentsExport>>;
  datevLogisticInvoicesSearch: Array<LogisticInvoice>;
  /** NOT IMPLEMENTED IN UK */
  datevPaymentOutcomingInvoiceRelationsExport?: Maybe<PaymentOutcomingInvoiceRelationsExport>;
  /** NOT IMPLEMENTED IN UK */
  datevPaymentOutcomingInvoiceRelationsExports?: Maybe<Array<PaymentOutcomingInvoiceRelationsExport>>;
  /** NOT IMPLEMENTED IN UK */
  datevPaymentsExport?: Maybe<PaymentsExport>;
  /** NOT IMPLEMENTED IN UK */
  datevPaymentsExports?: Maybe<Array<PaymentsExport>>;
  /** Fetch deal details */
  deal?: Maybe<Deal>;
  dealAccountingRecords: Array<AccountingRecord>;
  dealAggregations: DealAggregations;
  dealBalance: Balance;
  dealDelivery: Delivery;
  dealDocuments: Array<DealsDocumentType>;
  dealDocumentsDealObjects: Array<DealsDocumentsDealObjectType>;
  dealDocumentsRequirements: Array<DealsDocumentsRequirementType>;
  dealDocumentsRequirementsByParts: Array<DealsDocumentsRequirementByPartsType>;
  dealIncomingInvoice: IncomingInvoice;
  dealIncomingInvoices: Array<IncomingInvoice>;
  dealLotsByIds: Array<Lot>;
  /** Fetch list of deal objects for sidebar */
  dealObjectList: ObjectList;
  dealOrderConfirmation: OrderConfirmation;
  /** Get XomVatNumber + VatRate for order confirmation */
  dealOrderConfirmationVat: OrderConfirmationVat;
  dealOutcomingInvoice: OutcomingInvoice;
  dealParticipants: Participants;
  /** Fetch deal parts */
  dealParts?: Maybe<Array<Part>>;
  /** Retreive parts state records */
  dealPartsState: Array<PartStateRecordsGroup>;
  dealPaymentOutcomingInvoiceRelationsLoad: Array<PaymentOutcomingInvoiceRelation>;
  dealProviderOrders: Array<ProviderOrder>;
  dealQualityControl: QualityControl;
  dealQuotation: Quotation;
  dealRelatedDocuments: RelatedCollection;
  dealRestrictedHsCode?: Maybe<Scalars['String']['output']>;
  dealShipping: Shipping;
  dealSource: DealsSourceType;
  dealSources: SourceCollection;
  defaultWorkspacePreset: DefaultWorkspacePresets;
  /** D&B: Request Credit Limit */
  dnbCreditLimit: ExtendedMatch;
  /** D&B: Find organization */
  dnbExtendedMatch: ExtendedMatch;
  /** D&B: Fetch logs */
  dnbFetchLogs?: Maybe<Array<RequestLog>>;
  /** Fetch forecast for document currency conversion */
  documentCurrencyConversionForecast: Base;
  /** OMS DocumentNotes list */
  documentNotes?: Maybe<Array<DocumentNoteType>>;
  draftShippingCalculation: ShippingCalculation;
  /** Fetch enquiry */
  enquiry?: Maybe<Enquiry>;
  /** Fetch enquiry lead time based on date and working days */
  enquiryLeadTime: LeadTime;
  /** Fetch enquiry materials */
  enquiryMaterials: Array<Material>;
  /** Planned margin breakdown for the quote */
  enquiryPlannedMargin: OmsEnquiryPlannedMargin;
  /** Fetch enquiry processes */
  enquiryProcesses?: Maybe<Array<OmsEnquiryProcessType>>;
  /** Fetch enquiry promotion */
  enquiryPromotion?: Maybe<OmsEnquiryPromotionType>;
  /** Search enquiries */
  enquirySearch?: Maybe<Array<Enquiry>>;
  /** Get tags related to enquiry */
  enquiryTagsMapping?: Maybe<Array<OmsEnquiryPartTagsMappingType>>;
  enquiryValidateCreditLimit?: Maybe<OmsEnquiryCreditLimitValidationErrorType>;
  /** All permissions list */
  erpPermissions?: Maybe<Array<ErpPermissionsGrouped>>;
  eventTypes?: Maybe<Array<EventType>>;
  exportBillingAccounts: ExportBillingAccountType;
  exportLogisticInvoice: ExportLogisticInvoiceType;
  exportLogisticInvoices: PaginationResult;
  exportProviders: ExportProviderType;
  exportsBillingAccounts: PaginationResult;
  exportsProviders: PaginationResult;
  /** Fetch feature_flag status by name */
  featureFlag: FeatureFlag;
  /** Fetch feature_flags for erp */
  featureFlags: Array<FeatureFlag>;
  fetchShippingInstructor?: Maybe<ShippingInstructorFields>;
  /** Fetch files by source_type source_id */
  files?: Maybe<Array<AttachedFile>>;
  /** Fetch deal batches */
  frameworkAvailableSources: Array<BatchSource>;
  /** Fetch Batch Groups */
  frameworkBatchGroups: BatchGroup;
  /** Suggested Provider Orders */
  frameworkBatchSuggestedProviderOrders: Array<BatchProviderOrder>;
  /** Fetch !!!ALL!!! help links */
  helpLinks?: Maybe<Array<HelpLink>>;
  hsCodeDatasetsByDealPart: Array<HsCodeDataset>;
  /** Fetch email message */
  incomingEmail: IncomingEmail;
  /** Deal related object list */
  incomingEmailDealRelatedObjectList: Array<IncomingEmailsSourceType>;
  /** Search deals */
  incomingEmailSearchDeals: Array<SearchResult>;
  incomingInvoicesBulkBankPaymentInit?: Maybe<Array<Array<Init>>>;
  /** NOT IMPLEMENTED IN UK */
  incomingInvoicesDatevFields?: Maybe<DatevFieldsType>;
  /** NOT IMPLEMENTED IN UK */
  incomingInvoicesProviderVatRate: Scalars['Float']['output'];
  incomingInvoicesRealloc: Realloc;
  /** Fetch job global offers */
  jobGlobalOffers?: Maybe<Array<GlobalJobOffer>>;
  /** Fetch job global statistic */
  jobGlobalStatistic?: Maybe<JobStatistic>;
  /** Search jobs */
  jobSearch?: Maybe<Array<Job>>;
  /** KAM users */
  kams?: Maybe<Array<User>>;
  /** Get Logistic Invoice by ID */
  logisticInvoice: LogisticInvoice;
  logisticInvoicePositionPositionTypes: Array<LogisticInvoicePositionsPosition>;
  logisticInvoicePositionTaxCodes: Array<LogisticInvoicePositionsTaxCode>;
  logisticInvoices: PaginationResult;
  logisticInvoicesBulkBankPaymentInit: Array<Array<BulkBankPaymentInit>>;
  logisticInvoicesShippings: PaginationResult;
  logisticOperator: LogisticOperator;
  logisticOperatorBillingAccount: LogisticOperatorBillingAccount;
  logisticOperatorBillingAccounts: Array<LogisticOperatorBillingAccount>;
  logisticOperators: Array<LogisticOperator>;
  /** Person loyalty balance */
  loyaltyData?: Maybe<LoyaltyBalance>;
  /** Person loyalty balance history */
  loyaltyHistoryData: Array<Transaction>;
  masterShipping?: Maybe<MasterShipping>;
  masterShippingsChildShippingOptions: Array<Shipping>;
  masterShippingsGenerateDhlDescription?: Maybe<Scalars['String']['output']>;
  masterShippingsSearchForShipping: Array<MasterShipping>;
  /** Fetch enquiry Measurement Protocols */
  measurementProtocols?: Maybe<Array<OmsEnquiryMeasurementProtocol>>;
  /** Fetch my bookmarks */
  messengerBookmarks: Array<Message>;
  /** Fetch chat user list */
  messengerChatUsers: Array<MessageUser>;
  /** Fetch my counters */
  messengerCounter: Counter;
  /** Fetch all users associated with a deal with their participant roles */
  messengerDealParticipants: Array<DealParticipantWithRole>;
  /** Returns a list of users and customers that can be mentioned in a message */
  messengerMentionables: Array<MentionableType>;
  /** Fetch my mentions */
  messengerMentions: Array<Message>;
  /** Fetch all available action buttons */
  messengerMessageActions: Array<MessageActionsGroup>;
  /** Fetch Message Filter Groups */
  messengerMessageFilterGroups: Array<MessageFilterGroup>;
  /** Fetch Message Filters */
  messengerMessageFilters: Array<MessageFilter>;
  /** Fetch deal messages */
  messengerMessages: MessageCollection;
  /** Fetch message */
  messengerMessagesById: Array<Message>;
  /** Fetch source pinned messages */
  messengerPinnedMessages: PinnedMessagesCollection;
  /** Render message template */
  messengerRenderTemplate?: Maybe<RenderedTemplate>;
  /** Fetch source */
  messengerSource: MessageSource;
  /** Return related objects to the source */
  messengerSourceRelatedObjects?: Maybe<SourceRelatedObjects>;
  /** Fetch deal objects */
  messengerSources: Array<MessageSource>;
  /** Fetch subscriptions */
  messengerSubscriptions: Array<Subscription>;
  messengerSuggestedCarbonCopyUsersBySource: SuggestedCarbonCopyUser;
  /** Fetch my tasks */
  messengerTasks: Array<Message>;
  /** Fetch Message Template Categories */
  messengerTemplateCategories: Array<TemplateCategory>;
  /** Fetch placeholders by type */
  messengerTemplatePlaceholders: TemplatePlaceholdersCollectionType;
  /** Fetch placeholders collection */
  messengerTemplatePlaceholdersCollection: Array<TemplatePlaceholderType>;
  /** Fetch message templates collection */
  messengerTemplatesCollection?: Maybe<MessageTemplateGroupCollection>;
  /** Fetch users */
  messengerUsers: Array<MessageUser>;
  /** Fetch active Offer::Strategy by kind */
  offerStrategies?: Maybe<Array<Strategy>>;
  /** Fetch organization details */
  organization?: Maybe<Organization>;
  /** Fetch organization balance at given date */
  organizationBalanceRecordsFind?: Maybe<OrganizationBalanceRecord>;
  organizationBillingAccounts: OrganizationBillingAccounts;
  organizationDeals: OrganizationDeals;
  organizationPersons: OrganizationPersons;
  organizationsByTeamspace: OrganizationsCollection;
  /** NOT IMPLEMENTED IN UK */
  outcomingInvoiceExportZipState?: Maybe<ZipState>;
  outcomingInvoiceExportZipStateIntacct?: Maybe<IntacctZipStateType>;
  outcomingInvoicesAccountingFields?: Maybe<AccountingFieldsType>;
  /** Fetch deal overview */
  overview?: Maybe<Overview>;
  packageTrackingEvents: Array<PackageTrackingEvent>;
  /** Fetch deal part */
  part?: Maybe<Part>;
  /** Fetch deal part measurement tempaltes */
  partMeasurementTemplates: Array<QualityControlsMeasurementType>;
  /** Fetch parts with similar name */
  partsWithSimilarName?: Maybe<Array<Part>>;
  /** NOT IMPLEMENTED IN UK */
  paymentOutcomingInvoiceRelationsToBeExported?: Maybe<Array<PaymentOutcomingInvoiceRelation>>;
  /** NOT IMPLEMENTED IN UK */
  paymentsToBeExported?: Maybe<Array<Payment>>;
  payout: Payout;
  payouts: Array<Payout>;
  payoutsBulkBankPaymentInit?: Maybe<Array<Array<Init>>>;
  /** NOT IMPLEMENTED IN UK */
  payoutsToBeExported?: Maybe<Array<Payout>>;
  /** Fetch person details */
  person?: Maybe<Person>;
  /** Fetch provider details */
  provider?: Maybe<Provider>;
  providerBalance: ProviderBalanceType;
  providerBalanceTotals: ProviderTotalsBalanceType;
  /** Fetch partner's calendar events for specific year */
  providerCalendarEvents: Array<CalendarEvent>;
  providerOrder: ProviderOrder;
  providerOrderGenerateIncotermsComment?: Maybe<Scalars['String']['output']>;
  providerOrderPayoutsBalance: Money;
  providerPayoutsBalance: Money;
  providerTransactions: ProviderTransactionsType;
  providersSearch?: Maybe<Array<Provider>>;
  /** Fetch Providers vat validations */
  providersValidations: Validations;
  /** Fetch public holidays for choosen country */
  publicHolidays: Array<Scalars['ISO8601Date']['output']>;
  /** Fetch recent KAM organizations */
  recentKamOrganizations?: Maybe<Array<Organization>>;
  /** Fetch country regions */
  regions: Array<Region>;
  rfq: Rfq;
  rfqOffer: RfqOffer;
  rfqOfferApplyRates: Array<RfqsOffersRateType>;
  rfqTargetMarginRules: Array<RfqTargetMarginRule>;
  /** All roles list */
  roles?: Maybe<Array<Role>>;
  /** Roles list for specific user */
  rolesForUser?: Maybe<Array<Role>>;
  /** NOT IMPLEMENTED IN UK */
  sachkontos: Array<Sachkonto>;
  /** Fetch account objects for Bank Payment */
  searchAccount: Account;
  /** Fetch account related objects for Bank Payment */
  searchAccountRelatedObjects: AccountRelatedObjects;
  /** Fetch advanced search results */
  searchAdvanced?: Maybe<Results>;
  /** Fetch autocomplete search results */
  searchAutocomplete?: Maybe<Array<AutocompleteGroup>>;
  shippingCalculationDirections: Array<ShippingCalculationDirection>;
  shippingCalculations: Array<ShippingCalculation>;
  shippingTargetFeesLoadForShipping: ShippingTargetFeeByCurrency;
  shippings: PaginationResult;
  /** Fetch shipping customs office codes */
  shippingsCustomsOfficeCodes: Array<CustomsOfficeCode>;
  shippingsGenerateDhlDescription?: Maybe<Scalars['String']['output']>;
  shippingsMasterSuggestions: Array<Shipping>;
  shippingsTransliterateAddress: DealShippingAddressType;
  supportTickets: SupportTicketsPageType;
  /** Fetch all or filtered by context tags */
  tags?: Maybe<Array<Tag>>;
  team: Team;
  teams: Array<Team>;
  /** Fetch teamspace */
  teamspace: Teamspace;
  teamspaceBillingAccounts: BillingAccountsCollection;
  teamspaceOwnerOrganizationShippingAddresses: Array<ShippingAddress>;
  teamspaceShippingAddresses: ShippingAddressesCollection;
  /** OMS Person's teamspaces list */
  teamspaces: TeamspacesCollection;
  /** OMS user details */
  user?: Maybe<User>;
  /** Individual permissions list for specific user */
  userPermissions?: Maybe<Array<UserPermission>>;
  /** OMS users list */
  users?: Maybe<Array<User>>;
  /** Validates a shipping address via Google Address Validation API */
  validateShippingAddress: AddressValidationResult;
  workspacePresets: Array<WorkspacePreset>;
  workspacesBankPayment?: Maybe<WorkspacesUpdatedBankPayment>;
  workspacesBankPayments: WorkspacesBankPaymentsCollection;
  workspacesBankPaymentsDraft: WorkspacesBankPaymentsDraftCollection;
  workspacesBankPaymentsTotalAmounts: WorkspacesBankPaymentTotalAmounts;
  workspacesBillingAccounts: WorkspacesBillingAccountsCollection;
  workspacesClaims: WorkspacesClaimsCollection;
  workspacesCoupons: WorkspacesCouponsCollection;
  workspacesDealDocuments: WorkspacesDealDocumentsCollection;
  workspacesDeals: WorkspacesDealsCollection;
  workspacesDraftingDealParts: WorkspacesDraftingDealPartsCollection;
  workspacesDraftingEnquiryParts: WorkspacesDraftingEnquiryPartsCollection;
  workspacesEmailMessages: WorkspacesEmailMessagesCollection;
  workspacesEnquiries: WorkspacesEnquiriesCollection;
  workspacesEnquiriesSfCases: WorkspacesEnquiriesSfCasesCollection;
  workspacesEnquiryPromotions: WorkspacesEnquiryPromotionsCollection;
  workspacesFrameworkBatches: WorkspacesFrameworkBatchesCollection;
  workspacesHsCodes: WorkspacesHsCodesCollection;
  workspacesIncomingInvoices: WorkspacesIncomingInvoicesCollection;
  workspacesIncomingInvoicesTotalAmounts: WorkspacesTotalAmounts;
  workspacesIntacctEvents: WorkspacesIntacctEventsCollection;
  workspacesJobOffers: WorkspacesJobOffersCollection;
  workspacesJobs: WorkspacesJobsCollection;
  workspacesLogisticInvoices: WorkspacesLogisticInvoicesCollection;
  workspacesLogisticInvoicesTotalAmounts: WorkspacesTotalAmounts;
  workspacesMessages: WorkspacesMessagesCollection;
  workspacesOrganizationBalances: WorkspacesOrganizationBalancesCollection;
  workspacesOrganizationBalancesTotalAmounts: WorkspacesOrganizationBalancesTotalAmounts;
  workspacesOrganizations: WorkspacesOrganizationsCollection;
  workspacesOutcomingInvoices: WorkspacesOutcomingInvoicesCollection;
  workspacesOutcomingInvoicesTotalAmounts: WorkspacesOutcomingInvoiceTotalAmounts;
  workspacesPayments: WorkspacesPaymentsCollection;
  workspacesPayouts: WorkspacesPayoutsCollection;
  workspacesPayoutsTotalAmounts: WorkspacesPayoutTotalAmounts;
  workspacesPersons: WorkspacesPersonsCollection;
  workspacesProductionScheduleItems: WorkspacesProductionScheduleItemsCollection;
  workspacesProviderOrders: WorkspacesProviderOrdersCollection;
  workspacesProviders: WorkspacesProvidersCollection;
  workspacesQualityControls: WorkspacesQualityControlsCollection;
  workspacesRefunds: WorkspacesRefundsCollection;
  workspacesRfqOffers: WorkspacesRfqOffersCollection;
  workspacesRfqPartners: WorkspacesRfqPartnersCollection;
  workspacesRfqs: WorkspacesRfqsCollection;
  workspacesShippingAddresses: WorkspacesShippingAddressesCollection;
  workspacesShippings: WorkspacesShippingsCollection;
  workspacesStorages: WorkspacesStoragesCollection;
  workspacesSubscriptions: WorkspacesSubscriptionsCollection;
  workspacesTasks: WorkspacesTasksCollection;
  workspacesTeamspaces: WorkspacesTeamspacesCollection;
  workspacesUsers: WorkspacesUsersCollection;
  xometryBankAccount?: Maybe<XometryBankAccount>;
  xometryVatNumbers?: Maybe<Array<XometryVatNumber>>;
};


export type QueryActivityRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityRecordsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  objectId: Scalars['ID']['input'];
  objectType: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivityRecordsByDealArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  dealId: Scalars['ID']['input'];
  objectType: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivityRecordsDealCombinedArgs = {
  authorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentContains?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['Int']['input']>;
  dealId: Scalars['ID']['input'];
  maxDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  minDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  objectTypes?: InputMaybe<Array<ObjectTypeEnum>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAiCopilotInvoiceDataValidationArgs = {
  attachedFileId: Scalars['ID']['input'];
};


export type QueryAiCopilotTranslationStatusArgs = {
  responseId: Scalars['ID']['input'];
};


export type QueryAuthorizeActionArgs = {
  action: Scalars['String']['input'];
  group: Scalars['String']['input'];
  subjectClass?: InputMaybe<Scalars['String']['input']>;
  subjectConstantName?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankAccountArgs = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryBankPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankPaymentExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankPaymentImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankPaymentsToBeExportedArgs = {
  accountId: Scalars['ID']['input'];
  durationFrom?: InputMaybe<Scalars['String']['input']>;
  durationTo?: InputMaybe<Scalars['String']['input']>;
  numbers?: InputMaybe<Scalars['String']['input']>;
  withRegistered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBillingAccountArgs = {
  filesContext?: InputMaybe<Array<BillingAccountsAttachedFilesContextEnumType>>;
  id: Scalars['ID']['input'];
};


export type QueryBillingAccountBalanceDetailsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchLine?: InputMaybe<Scalars['String']['input']>;
  showBalancedDeal?: InputMaybe<Scalars['Boolean']['input']>;
  showNotCompletedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBillingAccountBalanceTotalsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryBillingAccountsMatchingVatOrTaxIdArgs = {
  currentId?: InputMaybe<Scalars['ID']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBillingAccountsOrganizationsByBillingAccountArgs = {
  billingAccountId: Scalars['ID']['input'];
};


export type QueryBillingAccountsRelatedObjectsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingAccountsValidationsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryBuiltOutcomingInvoiceRelationsArgs = {
  outcomingInvoiceId: Scalars['ID']['input'];
};


export type QueryCascadeBillingAccountsObjectListArgs = {
  afterSave?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryCascadeShippingAddressesObjectListArgs = {
  afterSave?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryCavitiesArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryChangeRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChangeRequestRelatedDataByProviderArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryClaimArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClaimsArgs = {
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectType?: InputMaybe<OmsDealsClaimsDealFromObjectEnumType>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContextTagsArgs = {
  contexts?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCountersDraftingEngineersArgs = {
  customerGrade?: InputMaybe<Scalars['String']['input']>;
  podId?: InputMaybe<Scalars['Int']['input']>;
  process?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountersProductionManagersArgs = {
  pmId?: InputMaybe<Scalars['ID']['input']>;
  podId?: InputMaybe<Scalars['Int']['input']>;
  psmId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCountersRfqManagersArgs = {
  rfqOwnerId?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountersSalesPersonsArgs = {
  salesPersonId?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountersSettingsArgs = {
  targetTable?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrencyRateArgs = {
  currencyIsoFrom?: InputMaybe<Scalars['String']['input']>;
  currencyIsoTo?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryDatevBankPaymentsExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDatevLogisticInvoicesSearchArgs = {
  durationFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  durationTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  withRegistered: Scalars['Boolean']['input'];
};


export type QueryDatevPaymentOutcomingInvoiceRelationsExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDatevPaymentsExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealArgs = {
  id: Scalars['ID']['input'];
  isPipedriveId?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDealAccountingRecordsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealAggregationsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealBalanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealDocumentsArgs = {
  dealId: Scalars['ID']['input'];
  filter?: InputMaybe<OmsInputsDealsDocumentsFilterType>;
  sort?: InputMaybe<OmsInputsDealsDocumentsSortType>;
};


export type QueryDealDocumentsDealObjectsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealDocumentsRequirementsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealDocumentsRequirementsByPartsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealIncomingInvoiceArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryDealIncomingInvoicesArgs = {
  dealId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDealLotsByIdsArgs = {
  filter: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDealObjectListArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealOrderConfirmationArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealOrderConfirmationVatArgs = {
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  billingAccountType: Scalars['String']['input'];
  billingAccountVatCountry?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  destinationCountry: Scalars['String']['input'];
};


export type QueryDealOutcomingInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealParticipantsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealPartsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealPartsStateArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealPaymentOutcomingInvoiceRelationsLoadArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  outcomingInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDealProviderOrdersArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryDealQualityControlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealRelatedDocumentsArgs = {
  objectId: Scalars['Int']['input'];
  objectType: Scalars['String']['input'];
};


export type QueryDealRestrictedHsCodeArgs = {
  code: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
};


export type QueryDealShippingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealSourceArgs = {
  sourceId: Scalars['Int']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryDealSourcesArgs = {
  dealId: Scalars['Int']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  providerOrderId?: InputMaybe<Scalars['ID']['input']>;
  sources?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDefaultWorkspacePresetArgs = {
  workspaceName: Scalars['String']['input'];
};


export type QueryDnbCreditLimitArgs = {
  billingAccountId: Scalars['ID']['input'];
};


export type QueryDnbExtendedMatchArgs = {
  billingAccountId: Scalars['ID']['input'];
  criterias: OmsInputsDnBCriteriaType;
};


export type QueryDnbFetchLogsArgs = {
  billingAccountId: Scalars['ID']['input'];
};


export type QueryDocumentCurrencyConversionForecastArgs = {
  documentId: Scalars['ID']['input'];
  documentType: Scalars['String']['input'];
};


export type QueryDocumentNotesArgs = {
  documentId: Scalars['ID']['input'];
  documentType: Scalars['String']['input'];
};


export type QueryDraftShippingCalculationArgs = {
  batchesCount?: InputMaybe<Scalars['Int']['input']>;
  positions?: InputMaybe<Array<OmsInputsPositionParametersType>>;
  sourceId: Scalars['Int']['input'];
  sourceType: ShippingCalculationSourceEnum;
};


export type QueryEnquiryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnquiryLeadTimeArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  workingDays: Scalars['Int']['input'];
};


export type QueryEnquiryMaterialsArgs = {
  materialIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEnquiryPlannedMarginArgs = {
  enquiryId: Scalars['ID']['input'];
};


export type QueryEnquiryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnquirySearchArgs = {
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['JSON']['input'];
};


export type QueryEnquiryTagsMappingArgs = {
  id: Scalars['ID']['input'];
  rfqOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEnquiryValidateCreditLimitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventTypesArgs = {
  dependence?: InputMaybe<DependenceEnum>;
};


export type QueryExportBillingAccountsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportLogisticInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportLogisticInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExportProvidersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportsBillingAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExportsProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureFlagArgs = {
  name: Scalars['String']['input'];
};


export type QueryFetchShippingInstructorArgs = {
  dealId: Scalars['ID']['input'];
  isSample: Scalars['Boolean']['input'];
  providerId: Scalars['ID']['input'];
  risk?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilesArgs = {
  contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryFrameworkAvailableSourcesArgs = {
  batchType?: InputMaybe<BatchTypeEnum>;
  category?: InputMaybe<BatchCategoryEnum>;
  dealId: Scalars['ID']['input'];
};


export type QueryFrameworkBatchGroupsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryFrameworkBatchSuggestedProviderOrdersArgs = {
  sourceTypes?: Array<OmsInputsFrameworkBatchesSourceType>;
};


export type QueryHsCodeDatasetsByDealPartArgs = {
  partId: Scalars['ID']['input'];
};


export type QueryIncomingEmailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIncomingEmailDealRelatedObjectListArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryIncomingEmailSearchDealsArgs = {
  filter?: InputMaybe<OmsInputsIncomingEmailsFilterType>;
  id: Scalars['ID']['input'];
};


export type QueryIncomingInvoicesBulkBankPaymentInitArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryIncomingInvoicesDatevFieldsArgs = {
  dealId: Scalars['ID']['input'];
  providerOrderId?: InputMaybe<Scalars['ID']['input']>;
  refInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  shippingId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIncomingInvoicesProviderVatRateArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  providerId: Scalars['ID']['input'];
};


export type QueryIncomingInvoicesReallocArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobGlobalOffersArgs = {
  filters?: InputMaybe<OmsInputsJobsGlobalOffersFiltersType>;
  jobId: Scalars['ID']['input'];
};


export type QueryJobGlobalStatisticArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryLogisticInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLogisticInvoicesArgs = {
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  creditNote?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  strictNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLogisticInvoicesBulkBankPaymentInitArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryLogisticInvoicesShippingsArgs = {
  attributes?: InputMaybe<ShippingsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLogisticOperatorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLogisticOperatorBillingAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLogisticOperatorsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  operators?: InputMaybe<Scalars['Boolean']['input']>;
  trackable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLoyaltyDataArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  ownerType?: InputMaybe<OmsLoyaltyBalancesOwnerEnumType>;
  teamspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLoyaltyHistoryDataArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  ownerType?: InputMaybe<OmsLoyaltyBalancesOwnerEnumType>;
};


export type QueryMasterShippingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMasterShippingsChildShippingOptionsArgs = {
  destinationAddress?: InputMaybe<OmsInputsMasterShippingsSearchAddressType>;
  direction: ShippingDirectionEnum;
  logisticOperator?: InputMaybe<Scalars['String']['input']>;
  sourceAddress?: InputMaybe<OmsInputsMasterShippingsSearchAddressType>;
  state: ShippingStateEnum;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMasterShippingsGenerateDhlDescriptionArgs = {
  masterShippingId: Scalars['ID']['input'];
};


export type QueryMasterShippingsSearchForShippingArgs = {
  destinationAddress?: InputMaybe<OmsInputsMasterShippingsSearchAddressType>;
  direction: ShippingDirectionEnum;
  logisticOperator?: InputMaybe<Scalars['String']['input']>;
  sourceAddress?: InputMaybe<OmsInputsMasterShippingsSearchAddressType>;
  state: ShippingStateEnum;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeasurementProtocolsArgs = {
  currencyIsoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessengerBookmarksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessengerChatUsersArgs = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryMessengerDealParticipantsArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryMessengerMentionablesArgs = {
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessengerMentionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessengerMessageActionsArgs = {
  templateType?: InputMaybe<TemplateTypeEnum>;
};


export type QueryMessengerMessagesArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessengerMessagesByIdArgs = {
  messageIds: Array<Scalars['ID']['input']>;
};


export type QueryMessengerPinnedMessagesArgs = {
  includeIntercompanyMessages?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryMessengerRenderTemplateArgs = {
  id: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryMessengerSourceArgs = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryMessengerSourceRelatedObjectsArgs = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryMessengerSourcesArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessengerSubscriptionsArgs = {
  filter?: InputMaybe<OmsTypesMessengerSubscriptionFilterType>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessengerSuggestedCarbonCopyUsersBySourceArgs = {
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};


export type QueryMessengerTasksArgs = {
  filter: OmsTypesMessengerTaskFilterType;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort: OmsTypesMessengerTaskSortType;
};


export type QueryMessengerTemplateCategoriesArgs = {
  attributes?: InputMaybe<OmsInputsMessengerTemplateCategoryType>;
};


export type QueryMessengerTemplatePlaceholdersArgs = {
  type: TemplateTypeEnum;
};


export type QueryMessengerTemplatesCollectionArgs = {
  filter?: InputMaybe<OmsInputsMessageTemplateGroupFilterType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<OmsInputsMessageTemplateGroupSortType>;
};


export type QueryOfferStrategiesArgs = {
  kind: KindEnum;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
  isPipedriveId?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizationBalanceRecordsFindArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationBillingAccountsArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationDealsArgs = {
  completedStages?: InputMaybe<Array<CompletedStageEnum>>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationPersonsArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchByRelatedEmail?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsByTeamspaceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  teamspaceId: Scalars['ID']['input'];
};


export type QueryOutcomingInvoiceExportZipStateArgs = {
  exportId: Scalars['ID']['input'];
};


export type QueryOutcomingInvoiceExportZipStateIntacctArgs = {
  exportId: Scalars['ID']['input'];
};


export type QueryOutcomingInvoicesAccountingFieldsArgs = {
  billingAccountId: Scalars['ID']['input'];
  dealId: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  issuedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  refInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  shippingId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOverviewArgs = {
  id: Scalars['ID']['input'];
  isPipedriveId?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartMeasurementTemplatesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartsWithSimilarNameArgs = {
  partId: Scalars['ID']['input'];
};


export type QueryPaymentOutcomingInvoiceRelationsToBeExportedArgs = {
  durationFrom: Scalars['ISO8601Date']['input'];
  durationTo: Scalars['ISO8601Date']['input'];
  withRegistered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentsToBeExportedArgs = {
  durationFrom?: InputMaybe<Scalars['String']['input']>;
  durationTo?: InputMaybe<Scalars['String']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
  numbers?: InputMaybe<Scalars['String']['input']>;
  withRegistered: Scalars['Boolean']['input'];
};


export type QueryPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutsArgs = {
  dealId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPayoutsBulkBankPaymentInitArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPayoutsToBeExportedArgs = {
  durationFrom?: InputMaybe<Scalars['String']['input']>;
  durationTo?: InputMaybe<Scalars['String']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
  numbers?: InputMaybe<Scalars['String']['input']>;
  withRegistered: Scalars['Boolean']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
  isPipedriveId?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProviderBalanceArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  onlyWithPrepayments?: InputMaybe<Scalars['Boolean']['input']>;
  providerId: Scalars['ID']['input'];
  searchLine?: InputMaybe<Scalars['String']['input']>;
  showNotCompletedInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  showNotCompletedPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  showPaid?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProviderBalanceTotalsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  providerId: Scalars['ID']['input'];
};


export type QueryProviderCalendarEventsArgs = {
  providerId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryProviderOrderArgs = {
  convertToProviderOrderCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryProviderOrderGenerateIncotermsCommentArgs = {
  shipIncoterms?: InputMaybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly?: InputMaybe<Scalars['Boolean']['input']>;
  shipIncotermsCity?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProviderOrderPayoutsBalanceArgs = {
  providerOrderId: Scalars['ID']['input'];
};


export type QueryProviderPayoutsBalanceArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryProviderTransactionsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  providerId: Scalars['ID']['input'];
};


export type QueryProvidersSearchArgs = {
  filters: InputsProvidersSearch;
};


export type QueryProvidersValidationsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryPublicHolidaysArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryRecentKamOrganizationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRfqArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRfqOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRfqOfferApplyRatesArgs = {
  rates: Array<OmsInputsRfqsOffersRateType>;
};


export type QueryRfqTargetMarginRulesArgs = {
  offerId: Scalars['ID']['input'];
};


export type QueryRolesForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySachkontosArgs = {
  type: SachkontoType;
};


export type QuerySearchAccountArgs = {
  term: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QuerySearchAccountRelatedObjectsArgs = {
  term: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QuerySearchAdvancedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type QuerySearchAutocompleteArgs = {
  query: Scalars['String']['input'];
};


export type QueryShippingCalculationsArgs = {
  sourceId: Scalars['Int']['input'];
  sourceType: ShippingCalculationSourceEnum;
};


export type QueryShippingTargetFeesLoadForShippingArgs = {
  shippingId: Scalars['ID']['input'];
};


export type QueryShippingsArgs = {
  attributes?: InputMaybe<DealsShippings>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShippingsGenerateDhlDescriptionArgs = {
  shippingId: Scalars['ID']['input'];
};


export type QueryShippingsMasterSuggestionsArgs = {
  shippingId: Scalars['ID']['input'];
};


export type QueryShippingsTransliterateAddressArgs = {
  address: OmsInputsShippingsAddressType;
};


export type QuerySupportTicketsArgs = {
  filter?: InputMaybe<SupportTicketsFilterType>;
};


export type QueryTagsArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamArgs = {
  constantName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<RegionEnum>;
};


export type QueryTeamsArgs = {
  constantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  filterByUserId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<RegionEnum>;
};


export type QueryTeamspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamspaceBillingAccountsArgs = {
  teamspaceId: Scalars['ID']['input'];
};


export type QueryTeamspaceOwnerOrganizationShippingAddressesArgs = {
  teamspaceId: Scalars['ID']['input'];
};


export type QueryTeamspaceShippingAddressesArgs = {
  teamspaceId: Scalars['ID']['input'];
};


export type QueryTeamspacesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<OmsTypesInputsPaginationType>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
  isPipedriveId?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  roleName?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryValidateShippingAddressArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkspacePresetsArgs = {
  workspaceName: Scalars['String']['input'];
};


export type QueryWorkspacesBankPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspacesBankPaymentsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesBankPaymentsDraftArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesBankPaymentsTotalAmountsArgs = {
  filterQuery: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
  workspaceName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkspacesBillingAccountsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesClaimsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesCouponsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesDealDocumentsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesDealsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesDraftingDealPartsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesDraftingEnquiryPartsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesEmailMessagesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesEnquiriesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesEnquiriesSfCasesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesEnquiryPromotionsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesFrameworkBatchesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesHsCodesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesIncomingInvoicesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesIncomingInvoicesTotalAmountsArgs = {
  filterQuery: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesIntacctEventsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesJobOffersArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesJobsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesLogisticInvoicesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesLogisticInvoicesTotalAmountsArgs = {
  filterQuery: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesMessagesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesOrganizationBalancesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesOrganizationBalancesTotalAmountsArgs = {
  filterQuery: Scalars['String']['input'];
  queryOptions: Scalars['JSON']['input'];
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesOrganizationsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesOutcomingInvoicesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesOutcomingInvoicesTotalAmountsArgs = {
  filterQuery: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesPaymentsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesPayoutsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesPayoutsTotalAmountsArgs = {
  filterQuery: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesPersonsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesProductionScheduleItemsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesProviderOrdersArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesProvidersArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesQualityControlsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesRefundsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesRfqOffersArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesRfqPartnersArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesRfqsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesShippingAddressesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesShippingsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesStoragesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesSubscriptionsArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesTasksArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesTeamspacesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryWorkspacesUsersArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<WorkspacesInputsGenericPaginationType>;
  presetId?: InputMaybe<Scalars['ID']['input']>;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};


export type QueryXometryBankAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryXometryVatNumbersArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of QuickBookFromXometry */
export type QuickBookFromXometryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of QuickBookFromXometry. */
export type QuickBookFromXometryPayload = {
  __typename?: 'QuickBookFromXometryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Quotation = {
  __typename?: 'Quotation';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deal: Deal;
  dealId: Scalars['ID']['output'];
  documentState?: Maybe<Scalars['String']['output']>;
  driveFileGeneratedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  driveFileId?: Maybe<Scalars['String']['output']>;
  driveFileName?: Maybe<Scalars['String']['output']>;
  driveWebViewLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  lots: Array<Lot>;
  number?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['Int']['output']>;
  prepayAmount?: Maybe<Scalars['Float']['output']>;
  prepayPercent?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['ISO8601Date']['output']>;
};

export enum QuotationMethodEnum {
  Autoquoted = 'autoquoted',
  ManuallyQuoted = 'manually_quoted',
  MixedPending = 'mixed_pending',
  MixedQuoted = 'mixed_quoted'
}

export enum QuotingStateEnum {
  CalcFinished = 'calc_finished',
  Calculation = 'calculation',
  Editing = 'editing',
  Finalized = 'finalized',
  HighVolumePending = 'high_volume_pending',
  Moderation = 'moderation',
  SaChecked = 'sa_checked',
  Waiting = 'waiting'
}

export type Rank = {
  __typename?: 'Rank';
  cancelRatio?: Maybe<Scalars['Float']['output']>;
  commIssuesRatio?: Maybe<Scalars['Float']['output']>;
  communication?: Maybe<Scalars['Float']['output']>;
  delayedProviderOrdersQuantity?: Maybe<Scalars['Float']['output']>;
  overdueRatio?: Maybe<Scalars['Float']['output']>;
  packFailRatio?: Maybe<Scalars['Float']['output']>;
  packing?: Maybe<Scalars['Float']['output']>;
  poQuantity?: Maybe<Scalars['Float']['output']>;
  quality?: Maybe<Scalars['Float']['output']>;
  qualityRatio?: Maybe<Scalars['Float']['output']>;
  timing?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type Realloc = {
  __typename?: 'Realloc';
  allocatedAmountMoney: Money;
  creditNote: Scalars['Boolean']['output'];
  incomingInvoices: Array<IncomingInvoice>;
  parentInvoice?: Maybe<IncomingInvoice>;
  providerOrders: Array<ProviderOrder>;
  totalAmountBruttoMoney: Money;
};

export enum RecognitionMethodEnum {
  BodyParsing = 'body_parsing',
  DynamicReply = 'dynamic_reply',
  HeaderReference = 'header_reference',
  Manual = 'manual',
  MessageIdTracking = 'message_id_tracking',
  Unknown = 'unknown'
}

export type Ref = AdditionalService | Lot;

export type RefInvoice = {
  __typename?: 'RefInvoice';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNote: Scalars['Boolean']['output'];
  datevComment?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ID']['output'];
  dealProviderOrderId: Scalars['ID']['output'];
  holdUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['Int']['output'];
  intacctComment?: Maybe<Scalars['String']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isPartial: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  numberErp: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderId: Scalars['ID']['output'];
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  totalAmountBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  totalAmountNettoCents?: Maybe<Scalars['BigInt']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validity?: Maybe<Scalars['String']['output']>;
  vatAmountCents?: Maybe<Scalars['BigInt']['output']>;
  vatAvg?: Maybe<Scalars['Float']['output']>;
};

export enum RefundMethodTypesEnum {
  AchBucs = 'ach_bucs',
  Paypal = 'paypal',
  Transfer = 'transfer',
  Wire = 'wire'
}

/** Autogenerated input type of RefundsExport */
export type RefundsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of RefundsExport. */
export type RefundsExportPayload = {
  __typename?: 'RefundsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Region = {
  __typename?: 'Region';
  cities: Array<City>;
  name: Scalars['String']['output'];
};

export enum RegionEnum {
  Cn = 'CN',
  Eu = 'EU',
  Sg = 'SG',
  Tr = 'TR',
  Uk = 'UK'
}

export type RelatedCollection = {
  __typename?: 'RelatedCollection';
  referring: Array<DealsSourceType>;
  related: Array<DealsSourceType>;
};

export type RelatedObject = {
  __typename?: 'RelatedObject';
  customerPriceCurrency: CurrencyEnum;
  customerPriceMoney: Money;
  id: Scalars['ID']['output'];
  meta?: Maybe<RelatedObjectMeta>;
  providerPriceCurrency: CurrencyEnum;
  providerPriceMoney: Money;
  quantity: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type RelatedObjectMeta = {
  __typename?: 'RelatedObjectMeta';
  direction?: Maybe<Scalars['String']['output']>;
};

export type RelatedObjects = {
  __typename?: 'RelatedObjects';
  orderConfirmations?: Maybe<Array<OrderConfirmation>>;
  outcomingInvoices?: Maybe<Array<OutcomingInvoice>>;
};

export enum RelatedShippingSplitFormulaEnum {
  ByCustomerPrice = 'by_customer_price',
  ByWeight = 'by_weight'
}

/** Intercompany Object Relation */
export enum RelationEnum {
  /** migration */
  Migration = 'migration',
  /** outsourcing */
  Outsourcing = 'outsourcing',
  /** rfq */
  Rfq = 'rfq'
}

export type RenderedTemplate = {
  __typename?: 'RenderedTemplate';
  attachments: Array<Attachment>;
  /** abbreviated as "BCC" */
  blindCarbonCopy?: Maybe<Array<Scalars['String']['output']>>;
  /** abbreviated as "CC" */
  carbonCopy?: Maybe<Array<Scalars['String']['output']>>;
  constantName?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  direction: TemplateDirectionEnum;
  documents: Array<Attachment>;
  id: Scalars['ID']['output'];
  locale: TemplateLocaleEnum;
  name?: Maybe<Scalars['String']['output']>;
  prepareAttachments: Array<PrepareAttachment>;
  readOnly: Scalars['Boolean']['output'];
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  subject?: Maybe<Scalars['String']['output']>;
  type: TemplateTypeEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ReplyRequired = {
  __typename?: 'ReplyRequired';
  customerReplyRequired?: Maybe<Scalars['Boolean']['output']>;
  customerReplyRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerReplyRequiredClearedById?: Maybe<Scalars['ID']['output']>;
  partnerReplyRequired?: Maybe<Scalars['Boolean']['output']>;
  partnerReplyRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  partnerReplyRequiredClearedById?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of RequestAutomatically */
export type RequestAutomaticallyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestAutomatically. */
export type RequestAutomaticallyPayload = {
  __typename?: 'RequestAutomaticallyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['ID']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RequestLog = {
  __typename?: 'RequestLog';
  billingAccountId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  duns?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  matchDataCriteria?: Maybe<Scalars['String']['output']>;
  queryParams?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: Scalars['JSON']['output'];
  userId: Scalars['ID']['output'];
};

export enum RequiredDocumentsTypeEnumType {
  /** Certificate of compliance – Type 2.1 */
  CertCompliance_2_1 = 'cert_compliance_2_1',
  /** Certificate of compliance – Type 2.2 */
  CertCompliance_2_2 = 'cert_compliance_2_2',
  /** Heat treatment protocols */
  CertHeatTreatment = 'cert_heat_treatment',
  /** Raw material certificate (metals) */
  CertMaterials_3_1 = 'cert_materials_3_1',
  /** Raw material certificate – Type 3.1 (EN 10204) */
  CertMaterials_3_1V2 = 'cert_materials_3_1_v2',
  /** Material certificate type 3.2 according to EN 10204 */
  CertMaterials_3_2 = 'cert_materials_3_2',
  /** Raw material certificate (plastics) */
  CertMaterialsPlastic = 'cert_materials_plastic',
  /** Certificate of Origin */
  CertOfOrigin = 'cert_of_origin',
  /** REACH certificate */
  CertReach = 'cert_reach',
  /** RoHS certificate */
  CertRohs = 'cert_rohs',
  /** CMM Report */
  Cmm = 'cmm',
  /** First Article Inspection Report (FAIR) */
  Fair = 'fair',
  /** QC */
  QcReportRequired = 'qc_report_required',
  /** Standard Measurement Protocol */
  Standard = 'standard'
}

export type Results = {
  __typename?: 'Results';
  aggs: Array<Agg>;
  items: Array<SearchItemType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Rfq = {
  __typename?: 'Rfq';
  attachedFiles?: Maybe<Array<AttachedFile>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: CurrencyEnum;
  deal: Deal;
  enquiry: Enquiry;
  id: Scalars['Int']['output'];
  needInfo: Scalars['Boolean']['output'];
  needInfoAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  needInfoBy?: Maybe<User>;
  offerStrategyContent?: Maybe<Scalars['JSON']['output']>;
  offerStrategyId?: Maybe<Scalars['ID']['output']>;
  offers: Array<RfqOffer>;
  owner?: Maybe<User>;
  positions: Array<RfqPosition>;
  publicComment?: Maybe<Scalars['String']['output']>;
  publicationEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publicationStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  selectedPartners?: Maybe<Array<Provider>>;
  state: RfqsStateEnumType;
  statistics?: Maybe<RfqStatistics>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  xometryNumber?: Maybe<Scalars['String']['output']>;
};

export enum RfqAutoassignmentSegmentEnum {
  Im = 'im',
  Individual = 'individual',
  ThreeD = 'three_d',
  Unscoped = 'unscoped',
  Vip = 'vip'
}

export type RfqManager = {
  __typename?: 'RfqManager';
  counterName: Scalars['String']['output'];
  rfqOwnerId?: Maybe<Scalars['ID']['output']>;
  value: Scalars['Int']['output'];
};

export type RfqOffer = {
  __typename?: 'RfqOffer';
  attachedFiles?: Maybe<Array<AttachedFile>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: CurrencyEnum;
  customerPricesTotal?: Maybe<Money>;
  decidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  decidedBy?: Maybe<User>;
  decisionRefusalReason?: Maybe<Scalars['String']['output']>;
  decisionState: RfqsOffersDecisionStateEnumType;
  id: Scalars['Int']['output'];
  isPreferred: Scalars['Boolean']['output'];
  marginRules: Array<RfqPositionMarginRules>;
  prices?: Maybe<Array<RfqsOffersPriceType>>;
  provider: Provider;
  providerComment?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['ID']['output'];
  providerMatchedTags?: Maybe<Array<Tag>>;
  providerPricesTotal?: Maybe<Money>;
  qualifiedViewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  responseRefusalReason?: Maybe<Scalars['String']['output']>;
  responseState: RfqsOffersResponseStateEnumType;
  rfq: Rfq;
  shippingInstruction?: Maybe<ShippingInstruction>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of RfqOffersExport */
export type RfqOffersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of RfqOffersExport. */
export type RfqOffersExportPayload = {
  __typename?: 'RfqOffersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of RfqPartnersExport */
export type RfqPartnersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of RfqPartnersExport. */
export type RfqPartnersExportPayload = {
  __typename?: 'RfqPartnersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type RfqPosition = {
  __typename?: 'RfqPosition';
  attachedFiles?: Maybe<Array<AttachedFile>>;
  color?: Maybe<Color>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customColor?: Maybe<Scalars['String']['output']>;
  customFinish?: Maybe<Scalars['String']['output']>;
  customMaterial?: Maybe<Scalars['String']['output']>;
  customShoreHardness?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Dimension>;
  enquiryPartId: Scalars['ID']['output'];
  enquiryQuantityOptions: Array<OmsEnquiryPartQuantityOption>;
  finish?: Maybe<Finish>;
  finishColor?: Maybe<Color>;
  finishCustomColor?: Maybe<Scalars['String']['output']>;
  gauge?: Maybe<Scalars['JSON']['output']>;
  gaugeId?: Maybe<Scalars['ID']['output']>;
  hardwareQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  layerThickness?: Maybe<Scalars['Int']['output']>;
  manualPrice: Money;
  material?: Maybe<Material>;
  materialType?: Maybe<MaterialType>;
  measurementProtocol?: Maybe<OmsEnquiryMeasurementProtocol>;
  measurementProtocolNeeded?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partContent?: Maybe<Scalars['JSON']['output']>;
  partMarkings?: Maybe<Scalars['JSON']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  process?: Maybe<OmsEnquiryProcessType>;
  processColor?: Maybe<Color>;
  processCustomColor?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  quantityOptions: Array<OmsEnquiryPartQuantityOption>;
  resolution?: Maybe<Scalars['String']['output']>;
  rfqId: Scalars['ID']['output'];
  rfqState: RfqsStateEnumType;
  samplesComment?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  samplesQuantity?: Maybe<Scalars['Int']['output']>;
  shoreHardnessId?: Maybe<Scalars['ID']['output']>;
  surfaceTitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  threadingQuantity?: Maybe<Scalars['Int']['output']>;
  toleranceTitle?: Maybe<Scalars['String']['output']>;
  toolLife?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  volume?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightKgPerPiece?: Maybe<Scalars['Float']['output']>;
};

export type RfqPositionMarginRules = {
  __typename?: 'RfqPositionMarginRules';
  rfqPositionId: Scalars['ID']['output'];
  rules: Array<RfqTargetMarginRule>;
};

export type RfqStatistics = {
  __typename?: 'RfqStatistics';
  ended?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interested: Scalars['Int']['output'];
  offersPublished: Scalars['Int']['output'];
  qualifiedViews: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  responded: Scalars['Int']['output'];
  started?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totalReaction: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
};

export type RfqTargetMarginRule = {
  __typename?: 'RfqTargetMarginRule';
  itemCostFrom: Money;
  itemCostTo: Money;
  margin: Scalars['Float']['output'];
  quantityFrom: Scalars['Int']['output'];
  quantityTo: Scalars['Int']['output'];
};

/** Autogenerated input type of RfqsCancel */
export type RfqsCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  decisionRefusalReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsCancel. */
export type RfqsCancelPayload = {
  __typename?: 'RfqsCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

/** Autogenerated input type of RfqsClose */
export type RfqsCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsClose. */
export type RfqsClosePayload = {
  __typename?: 'RfqsClosePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

/** Autogenerated input type of RfqsDelete */
export type RfqsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsDelete. */
export type RfqsDeletePayload = {
  __typename?: 'RfqsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

/** Autogenerated input type of RfqsExport */
export type RfqsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of RfqsExport. */
export type RfqsExportPayload = {
  __typename?: 'RfqsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of RfqsOffersApply */
export type RfqsOffersApplyInput = {
  accept: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  positionIds: Array<Scalars['ID']['input']>;
  review: Scalars['Boolean']['input'];
};

/** Autogenerated return type of RfqsOffersApply. */
export type RfqsOffersApplyPayload = {
  __typename?: 'RfqsOffersApplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfqOffer: RfqOffer;
};

/** Autogenerated input type of RfqsOffersBulkActionsUpdateProviderAmount */
export type RfqsOffersBulkActionsUpdateProviderAmountInput = {
  attributes: Array<OmsInputsRfqsOffersBulkActionsProviderAmountType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsOffersBulkActionsUpdateProviderAmount. */
export type RfqsOffersBulkActionsUpdateProviderAmountPayload = {
  __typename?: 'RfqsOffersBulkActionsUpdateProviderAmountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfqOffer: RfqOffer;
};

export enum RfqsOffersDecisionStateEnumType {
  /** Accepted */
  Accepted = 'accepted',
  /** Negotiating */
  Negotiating = 'negotiating',
  /** Pending */
  Pending = 'pending',
  /** Rejected */
  Rejected = 'rejected'
}

/** Autogenerated input type of RfqsOffersDelete */
export type RfqsOffersDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsOffersDelete. */
export type RfqsOffersDeletePayload = {
  __typename?: 'RfqsOffersDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfqOffer: RfqOffer;
};

/** Autogenerated input type of RfqsOffersFindOrCreate */
export type RfqsOffersFindOrCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  rfqId: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsOffersFindOrCreate. */
export type RfqsOffersFindOrCreatePayload = {
  __typename?: 'RfqsOffersFindOrCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  new: Scalars['Boolean']['output'];
  rfqOffer: RfqOffer;
};

export type RfqsOffersPriceType = {
  __typename?: 'RfqsOffersPriceType';
  appliedMargin?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerPrice: Money;
  enquiryPartId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  leadtime?: Maybe<Scalars['Int']['output']>;
  providedById?: Maybe<Scalars['Int']['output']>;
  providedByType?: Maybe<Scalars['String']['output']>;
  providerPrice: Money;
  quantity: Scalars['Int']['output'];
  rfqOfferId: Scalars['Int']['output'];
  rfqPositionId: Scalars['Int']['output'];
  transportationTime: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of RfqsOffersPricesDelete */
export type RfqsOffersPricesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsOffersPricesDelete. */
export type RfqsOffersPricesDeletePayload = {
  __typename?: 'RfqsOffersPricesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfqOfferPrice: RfqsOffersPriceType;
};

export type RfqsOffersRateType = {
  __typename?: 'RfqsOffersRateType';
  enquiryPartId: Scalars['ID']['output'];
  price: Money;
  quantity: Scalars['Int']['output'];
  quotePrice: Money;
};

export enum RfqsOffersResponseStateEnumType {
  /** Canceled */
  Canceled = 'canceled',
  /** Empty */
  Empty = 'empty',
  /** Interested */
  Interested = 'interested',
  /** Rejected */
  Rejected = 'rejected',
  /** Submitted */
  Submitted = 'submitted'
}

/** Autogenerated input type of RfqsOffersUpdate */
export type RfqsOffersUpdateInput = {
  attributes: OmsInputsRfqsOfferType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsOffersUpdate. */
export type RfqsOffersUpdatePayload = {
  __typename?: 'RfqsOffersUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfqOffer: RfqOffer;
};

/** Autogenerated input type of RfqsPositionsDelete */
export type RfqsPositionsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsPositionsDelete. */
export type RfqsPositionsDeletePayload = {
  __typename?: 'RfqsPositionsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfqPosition: RfqPosition;
};

/** Autogenerated input type of RfqsPublish */
export type RfqsPublishInput = {
  attributes: OmsInputsRfqType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsPublish. */
export type RfqsPublishPayload = {
  __typename?: 'RfqsPublishPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

/** Autogenerated input type of RfqsReactivate */
export type RfqsReactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  publicationEnd: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of RfqsReactivate. */
export type RfqsReactivatePayload = {
  __typename?: 'RfqsReactivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

/** Autogenerated input type of RfqsSendBulkMessages */
export type RfqsSendBulkMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  rfqId: Scalars['ID']['input'];
  rfqOfferIds: Array<Scalars['ID']['input']>;
  templateGroupId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RfqsSendBulkMessages. */
export type RfqsSendBulkMessagesPayload = {
  __typename?: 'RfqsSendBulkMessagesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum RfqsStateEnumType {
  Active = 'active',
  Canceled = 'canceled',
  Closed = 'closed',
  Draft = 'draft',
  Expired = 'expired',
  PartnersSelection = 'partners_selection'
}

/** Autogenerated input type of RfqsUpdate */
export type RfqsUpdateInput = {
  attributes: OmsInputsRfqType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RfqsUpdate. */
export type RfqsUpdatePayload = {
  __typename?: 'RfqsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rfq: Rfq;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['ISO8601DateTime']['output'];
  erpPermissions: Array<ErpPermission>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Intercompany Object Role */
export enum RoleEnum {
  /** prod */
  Prod = 'prod',
  /** rfq */
  Rfq = 'rfq',
  /** sales */
  Sales = 'sales',
  /** source */
  Source = 'source',
  /** target */
  Target = 'target'
}

/** Autogenerated input type of RolesRequestPermission */
export type RolesRequestPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  permissionAction: Scalars['String']['input'];
  permissionGroup: Scalars['String']['input'];
};

/** Autogenerated return type of RolesRequestPermission. */
export type RolesRequestPermissionPayload = {
  __typename?: 'RolesRequestPermissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RolesUpdatePermissions */
export type RolesUpdatePermissionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  erpPermissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

/** Autogenerated return type of RolesUpdatePermissions. */
export type RolesUpdatePermissionsPayload = {
  __typename?: 'RolesUpdatePermissionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type Sachkonto = {
  __typename?: 'Sachkonto';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: SachkontoType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export enum SachkontoType {
  /** for OutcomingInvoices */
  Customer = 'customer',
  /** for IncomingInvoices */
  Partner = 'partner'
}

export type SalesDeals = {
  __typename?: 'SalesDeals';
  count: Scalars['Int']['output'];
  presetId?: Maybe<Scalars['ID']['output']>;
};

export type SalesPerson = {
  __typename?: 'SalesPerson';
  counterName: Scalars['String']['output'];
  salesPersonId?: Maybe<Scalars['ID']['output']>;
  value: Scalars['Int']['output'];
};

export type SearchItemType = {
  __typename?: 'SearchItemType';
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  dealId?: Maybe<Scalars['Int']['output']>;
  dealNumber?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  organizationDisplayName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  personDisplayName?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['Int']['output']>;
  personNumber?: Maybe<Scalars['String']['output']>;
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  providerNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
};

/** Autogenerated input type of SetRecommendedRfqStatus */
export type SetRecommendedRfqStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of SetRecommendedRfqStatus. */
export type SetRecommendedRfqStatusPayload = {
  __typename?: 'SetRecommendedRfqStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};

export enum ShipmentEstimateUpdateCategoryEnum {
  /** Force majeure (weather, transport strikes, customs issues, etc.) */
  ForceMajeure = 'force_majeure',
  /** Lack of communication */
  LackOfCommunication = 'lack_of_communication',
  /** Late material purchase */
  LateMaterialPurchase = 'late_material_purchase',
  /** Machine / internal issue */
  MachineInternalIssue = 'machine_internal_issue',
  /** Material certificates delay */
  MaterialCertificatesDelay = 'material_certificates_delay',
  /** Measurement report delay */
  MeasurementReportDelay = 'measurement_report_delay',
  /** Other */
  Other = 'other',
  /** Reproduction / rework */
  ReproductionRework = 'reproduction_rework',
  /** Subcontractor delay */
  SubcontractorDelay = 'subcontractor_delay',
  /** Technical clarification (no customer initiated) */
  TechnicalClarification = 'technical_clarification',
  /** Wrong estimation of capacity */
  WrongCapacityEstimation = 'wrong_capacity_estimation',
  /** Wrong estimation of leadtime */
  WrongLeadtimeEstimation = 'wrong_leadtime_estimation'
}

/** Autogenerated input type of ShipmentOrderCreateArasOrder */
export type ShipmentOrderCreateArasOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAddress: OmsInputsShipmentOrderArasAddressType;
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShipmentOrderCreateArasOrder. */
export type ShipmentOrderCreateArasOrderPayload = {
  __typename?: 'ShipmentOrderCreateArasOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ShipmentOrderCreateDbSchenkerOrder */
export type ShipmentOrderCreateDbSchenkerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAddress: OmsInputsShipmentOrderDbSchenkerAddressType;
  pickupDatetimeEnd: Scalars['ISO8601DateTime']['input'];
  pickupDatetimeStart: Scalars['ISO8601DateTime']['input'];
  shippingId: Scalars['ID']['input'];
  sourceAddress: OmsInputsShipmentOrderDbSchenkerAddressType;
  uitCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShipmentOrderCreateDbSchenkerOrder. */
export type ShipmentOrderCreateDbSchenkerOrderPayload = {
  __typename?: 'ShipmentOrderCreateDbSchenkerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ShipmentOrderCreateDhlOrder */
export type ShipmentOrderCreateDhlOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  destinationAddress: OmsInputsShipmentOrderDhlAddressType;
  expectedDeliveryDate: Scalars['ISO8601Date']['input'];
  movementReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  operator: Scalars['String']['input'];
  pickupOptions: OmsInputsShipmentOrderPickupOptionsType;
  plannedShippingDate: Scalars['ISO8601DateTime']['input'];
  productCode: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  shippingId: Scalars['ID']['input'];
  sourceAddress: OmsInputsShipmentOrderDhlAddressType;
};

/** Autogenerated return type of ShipmentOrderCreateDhlOrder. */
export type ShipmentOrderCreateDhlOrderPayload = {
  __typename?: 'ShipmentOrderCreateDhlOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  steps: CreateDhlOrderSteps;
};

/** Autogenerated input type of ShipmentOrderCreateEurosenderOrder */
export type ShipmentOrderCreateEurosenderOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contentDescription: Scalars['String']['input'];
  destinationAddress: OmsInputsShipmentOrderEurosenderAddressType;
  pickupDatetime: Scalars['ISO8601DateTime']['input'];
  serviceName: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  shippingId: Scalars['ID']['input'];
  sourceAddress: OmsInputsShipmentOrderEurosenderAddressType;
};

/** Autogenerated return type of ShipmentOrderCreateEurosenderOrder. */
export type ShipmentOrderCreateEurosenderOrderPayload = {
  __typename?: 'ShipmentOrderCreateEurosenderOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ShipmentOrderCreateJumingoOrder */
export type ShipmentOrderCreateJumingoOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['ISO8601Date']['input'];
  operator: Scalars['String']['input'];
  pickupDate: Scalars['ISO8601Date']['input'];
  pickupMaxTime: Scalars['String']['input'];
  pickupMinTime: Scalars['String']['input'];
  shippingId: Scalars['ID']['input'];
  tariffId: Scalars['String']['input'];
  tariffName: Scalars['String']['input'];
};

/** Autogenerated return type of ShipmentOrderCreateJumingoOrder. */
export type ShipmentOrderCreateJumingoOrderPayload = {
  __typename?: 'ShipmentOrderCreateJumingoOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ShipmentOrderCreateUpsOrder */
export type ShipmentOrderCreateUpsOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAddress: OmsInputsShipmentOrderUpsAddressType;
  serviceCode: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  shipmentDescription: Scalars['String']['input'];
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  shippingCostCurrency?: InputMaybe<Scalars['String']['input']>;
  shippingId: Scalars['ID']['input'];
  sourceAddress: OmsInputsShipmentOrderUpsAddressType;
};

/** Autogenerated return type of ShipmentOrderCreateUpsOrder. */
export type ShipmentOrderCreateUpsOrderPayload = {
  __typename?: 'ShipmentOrderCreateUpsOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ShipmentOrderCreateYurticiOrder */
export type ShipmentOrderCreateYurticiOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  destinationAddress: OmsInputsShipmentOrderYurticiAddressType;
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShipmentOrderCreateYurticiOrder. */
export type ShipmentOrderCreateYurticiOrderPayload = {
  __typename?: 'ShipmentOrderCreateYurticiOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export enum ShipmentOrderOperatorsEnum {
  /** Aras Kargo */
  Aras = 'aras',
  /** DB Schenker */
  DbSchenker = 'db_schenker',
  /** DHL */
  Dhl = 'dhl',
  /** Eurosender */
  Eurosender = 'eurosender',
  /** Jumingo */
  Jumingo = 'jumingo',
  /** UPS */
  Ups = 'ups',
  /** Yurtici */
  Yurtici = 'yurtici'
}

/** Autogenerated input type of ShipmentOrderRequestShippingOptions */
export type ShipmentOrderRequestShippingOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAddress: OmsInputsShipmentOrderAddressType;
  operators: Array<ShipmentOrderOperatorsEnum>;
  packages: Array<OmsInputsShipmentOrderPackageType>;
  plannedShippingDate: Scalars['ISO8601Date']['input'];
  shippingId: Scalars['ID']['input'];
  sourceAddress: OmsInputsShipmentOrderAddressType;
};

/** Autogenerated return type of ShipmentOrderRequestShippingOptions. */
export type ShipmentOrderRequestShippingOptionsPayload = {
  __typename?: 'ShipmentOrderRequestShippingOptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Shipping = {
  __typename?: 'Shipping';
  actualDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  actualShipmentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  allocateDiscountsAndSurcharges: Scalars['Boolean']['output'];
  allocatedCosts: Array<ShippingAllocatedCost>;
  allowDirectShipping: Scalars['Boolean']['output'];
  attachedFiles: Array<AttachedFile>;
  autoOrderFromPartnerState: ShippingAutoOrderFromPartnerStateEnum;
  autoOrderFromXometryErrors?: Maybe<Array<Scalars['String']['output']>>;
  autoOrderFromXometryState: AutoOrderFromXometryStateEnum;
  /** N + 1, don't query for collection */
  countryOfOriginOfGoods?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentlyViewing: Scalars['Int']['output'];
  customsClearanceStatus: ShippingCustomsClearanceStatusEnum;
  customsClearanceStatusUpdatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  customsDocumentsStatus?: Maybe<ShippingCustomsDocumentsStatusEnum>;
  customsOfficeCode?: Maybe<Scalars['String']['output']>;
  deal: Deal;
  dealId: Scalars['Int']['output'];
  deliveryBasis?: Maybe<ShippingDeliveryBasisEnum>;
  deliveryNoteComment?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<ShippingDeliveryTypeEnum>;
  destinationAddress?: Maybe<DealShippingAddressType>;
  direction: Scalars['String']['output'];
  expectedDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expectedShipmentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expectedShipmentTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  exporterOfRecord?: Maybe<ShippingExporterOfRecordEnum>;
  externalId?: Maybe<Scalars['String']['output']>;
  gerlachExportState: GerlachExportStateEnum;
  gstInvoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  gstInvoiceNumber?: Maybe<Scalars['String']['output']>;
  holdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  holdBy?: Maybe<User>;
  holdUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  /** N + 1, don't query for collection */
  hsCodesError?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  importerOfRecord?: Maybe<ShippingImporterOfRecordEnum>;
  intercompanyObjects?: Maybe<Array<IntercompanyObject>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isExport: Scalars['Boolean']['output'];
  isImport: Scalars['Boolean']['output'];
  isImportAndExport: Scalars['Boolean']['output'];
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  logisticAggregator?: Maybe<Scalars['String']['output']>;
  logisticAggregatorRef?: Maybe<LogisticOperator>;
  logisticInvoiceAllocatedCosts: Array<ShippingLogisticInvoiceAllocatedCost>;
  logisticOperator?: Maybe<Scalars['String']['output']>;
  logisticOperatorRef?: Maybe<LogisticOperator>;
  lots: Array<Lot>;
  masterShipping?: Maybe<MasterShipping>;
  masterShippingId?: Maybe<Scalars['ID']['output']>;
  movementReferenceNumber?: Maybe<Scalars['String']['output']>;
  noInvoiceRequired: Scalars['Boolean']['output'];
  noInvoiceRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  noInvoiceRequiredBy?: Maybe<User>;
  noInvoiceRequiredComment?: Maybe<Scalars['String']['output']>;
  noPartnerInvoiceRequired: Scalars['Boolean']['output'];
  noPartnerInvoiceRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  noPartnerInvoiceRequiredBy?: Maybe<User>;
  noPartnerInvoiceRequiredComment?: Maybe<Scalars['String']['output']>;
  notifiedCustomerAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notifiedPartnerAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notifyCustomer?: Maybe<Scalars['Boolean']['output']>;
  notifyPartner?: Maybe<Scalars['Boolean']['output']>;
  number: Scalars['String']['output'];
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  packagingReportCheckStatus?: Maybe<Scalars['String']['output']>;
  packagingReportCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  positionNaming?: Maybe<ShippingPositionNamingEnum>;
  /** @deprecated This field is deprecated, please use [ship_warehouse] instead. */
  processingInstruction?: Maybe<ShippingInstructionEnum>;
  publishedInCa?: Maybe<Scalars['Boolean']['output']>;
  publishedInPa?: Maybe<Scalars['Boolean']['output']>;
  readyForCollection: Scalars['Boolean']['output'];
  readyForCollectionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  receivedProcessingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  receivedProcessingStatus: Scalars['String']['output'];
  referringDocuments: Array<ShippingRelatedObject>;
  relatedDocuments: Array<ShippingRelatedObject>;
  relatedProviderOrders?: Maybe<Array<ProviderOrder>>;
  services: Array<AdditionalService>;
  shippingAlertAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingAlertBy?: Maybe<User>;
  shippingAlertById?: Maybe<Scalars['ID']['output']>;
  shippingAlertMessage?: Maybe<Scalars['String']['output']>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingCostActual?: Maybe<Scalars['Float']['output']>;
  shippingCostActualCurrency?: Maybe<Scalars['String']['output']>;
  shippingCostActualMoney?: Maybe<Money>;
  shippingCostCurrency: Scalars['String']['output'];
  shippingCostMoney: Money;
  shippingOption?: Maybe<Scalars['String']['output']>;
  shippingOrderNumber?: Maybe<Scalars['String']['output']>;
  shippingParameters?: Maybe<Array<ShippingParameters>>;
  /** N + 1, don't query for collection */
  singlePartner: Scalars['Boolean']['output'];
  sourceAddress?: Maybe<DealShippingAddressType>;
  sourceProviderOrder?: Maybe<ProviderOrder>;
  state: Scalars['String']['output'];
  trackingCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  trackingLink?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingRecords: Array<ShippingTrackingRecord>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  warehouseInstruction?: Maybe<WarehouseInstructionEnum>;
  weightBruttoKg: Scalars['Float']['output'];
  weightNettoKg: Scalars['Float']['output'];
  xometryNumber: Scalars['String']['output'];
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['Int']['output'];
  sourceType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type ShippingAddressesCollection = {
  __typename?: 'ShippingAddressesCollection';
  collection: Array<TeamspaceShippingAddress>;
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of ShippingAddressesCreate */
export type ShippingAddressesCreateInput = {
  attributes: OmsInputsShippingAddressType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShippingAddressesCreate. */
export type ShippingAddressesCreatePayload = {
  __typename?: 'ShippingAddressesCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingAddress: ShippingAddress;
};

/** Autogenerated input type of ShippingAddressesDelete */
export type ShippingAddressesDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingAddressesDelete. */
export type ShippingAddressesDeletePayload = {
  __typename?: 'ShippingAddressesDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingAddress: ShippingAddress;
};

/** Autogenerated input type of ShippingAddressesExport */
export type ShippingAddressesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of ShippingAddressesExport. */
export type ShippingAddressesExportPayload = {
  __typename?: 'ShippingAddressesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of ShippingAddressesForOrgPersonsCreate */
export type ShippingAddressesForOrgPersonsCreateInput = {
  attributes: OmsInputsShippingAddressForOrgPersonsType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShippingAddressesForOrgPersonsCreate. */
export type ShippingAddressesForOrgPersonsCreatePayload = {
  __typename?: 'ShippingAddressesForOrgPersonsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Autogenerated input type of ShippingAddressesUpdateCascade */
export type ShippingAddressesUpdateCascadeInput = {
  attributes: OmsInputsShippingAddressUpdateCascadeType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingAddressesUpdateCascade. */
export type ShippingAddressesUpdateCascadePayload = {
  __typename?: 'ShippingAddressesUpdateCascadePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingAddress: ShippingAddress;
};

/** Autogenerated input type of ShippingAddressesUpdate */
export type ShippingAddressesUpdateInput = {
  attributes: OmsInputsShippingAddressType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingAddressesUpdate. */
export type ShippingAddressesUpdatePayload = {
  __typename?: 'ShippingAddressesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingAddress: ShippingAddress;
};

export type ShippingAllocatedCost = {
  __typename?: 'ShippingAllocatedCost';
  allocatedCharges: Money;
  expenseType: LogisticInvoicePositionTypeEnum;
  shortExpenseType: Scalars['String']['output'];
};

export enum ShippingAutoOrderFromPartnerStateEnum {
  /** failed */
  Failed = 'failed',
  /** manual_order */
  ManualOrder = 'manual_order',
  /** not_checked */
  NotChecked = 'not_checked',
  /** ordered */
  Ordered = 'ordered',
  /** skipped */
  Skipped = 'skipped',
  /** waits_for_hs_codes */
  WaitsForHsCodes = 'waits_for_hs_codes'
}

export type ShippingCalculation = {
  __typename?: 'ShippingCalculation';
  batchesCount: Scalars['Int']['output'];
  chargeableWeight?: Maybe<Scalars['Float']['output']>;
  chargeableWeightInfo?: Maybe<ChargeableWeightInfo>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<CurrencyEnum>;
  destinationAddress: Address;
  direction?: Maybe<ShippingCalculationDirectionEnum>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  positions: Array<Position>;
  prices: Array<Price>;
  sameSourceContent: Scalars['Boolean']['output'];
  samplesChargeableWeight?: Maybe<Scalars['Float']['output']>;
  samplesChargeableWeightInfo?: Maybe<ChargeableWeightInfo>;
  selected: Scalars['Boolean']['output'];
  sourceAddress: Address;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type ShippingCalculationDirection = {
  __typename?: 'ShippingCalculationDirection';
  direction: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ShippingCalculationDirectionEnum {
  P2c = 'p2c',
  P2ce = 'p2ce',
  P2xX2c = 'p2x_x2c',
  P2xX2xX2c = 'p2x_x2x_x2c',
  P2xpXp2c = 'p2xp_xp2c',
  P2xsXs2c = 'p2xs_xs2c',
  X2c = 'x2c',
  X2xX2c = 'x2x_x2c',
  Xp2c = 'xp2c'
}

/** A list of sources */
export enum ShippingCalculationSourceEnum {
  DealProviderorder = 'deal_providerorder',
  Enquiry = 'enquiry',
  GshJob = 'gsh_job',
  Job = 'job'
}

/** Autogenerated input type of ShippingCalculationsApplyCost */
export type ShippingCalculationsApplyCostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  priceId: Scalars['Int']['input'];
};

/** Autogenerated return type of ShippingCalculationsApplyCost. */
export type ShippingCalculationsApplyCostPayload = {
  __typename?: 'ShippingCalculationsApplyCostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingCalculation: ShippingCalculation;
};

/** Autogenerated input type of ShippingCalculationsCreate */
export type ShippingCalculationsCreateInput = {
  attributes: OmsInputsShippingCalculationType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShippingCalculationsCreate. */
export type ShippingCalculationsCreatePayload = {
  __typename?: 'ShippingCalculationsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingCalculation: ShippingCalculation;
};

/** Autogenerated input type of ShippingCalculationsDelete */
export type ShippingCalculationsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingCalculationsDelete. */
export type ShippingCalculationsDeletePayload = {
  __typename?: 'ShippingCalculationsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingCalculation: ShippingCalculation;
};

/** Autogenerated input type of ShippingCalculationsRemoveManualPrices */
export type ShippingCalculationsRemoveManualPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingCalculationsRemoveManualPrices. */
export type ShippingCalculationsRemoveManualPricesPayload = {
  __typename?: 'ShippingCalculationsRemoveManualPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingCalculation: ShippingCalculation;
};

/** Autogenerated input type of ShippingCalculationsUpdate */
export type ShippingCalculationsUpdateInput = {
  attributes: OmsInputsShippingCalculationType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of ShippingCalculationsUpdateManualPrices */
export type ShippingCalculationsUpdateManualPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  prices?: InputMaybe<Array<OmsInputsManualPriceParametersType>>;
};

/** Autogenerated return type of ShippingCalculationsUpdateManualPrices. */
export type ShippingCalculationsUpdateManualPricesPayload = {
  __typename?: 'ShippingCalculationsUpdateManualPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingCalculation: ShippingCalculation;
};

/** Autogenerated return type of ShippingCalculationsUpdate. */
export type ShippingCalculationsUpdatePayload = {
  __typename?: 'ShippingCalculationsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingCalculation: ShippingCalculation;
};

export enum ShippingCustomsClearanceStatusEnum {
  /** Done */
  Done = 'done',
  /** Email sent */
  EmailSent = 'email_sent',
  /** In progress */
  InProgress = 'in_progress',
  /** Not started */
  NotStarted = 'not_started'
}

export enum ShippingCustomsDocumentsStatusEnum {
  /** Completed */
  Completed = 'completed',
  /** In Progress */
  InProgress = 'in_progress',
  /** New */
  New = 'new',
  /** Not Required */
  NotRequired = 'not_required'
}

export enum ShippingDeliveryBasisEnum {
  /** CFR */
  Cfr = 'CFR',
  /** CIF */
  Cif = 'CIF',
  /** CIP */
  Cip = 'CIP',
  /** CPT */
  Cpt = 'CPT',
  /** DAP */
  Dap = 'DAP',
  /** DAT */
  Dat = 'DAT',
  /** DDP */
  Ddp = 'DDP',
  /** EXW */
  Exw = 'EXW',
  /** FAS */
  Fas = 'FAS',
  /** FCA */
  Fca = 'FCA',
  /** FOB */
  Fob = 'FOB'
}

export enum ShippingDeliveryTypeEnum {
  /** Box */
  Box = 'box',
  /** Packet */
  Packet = 'packet',
  /** Pallet */
  Pallet = 'pallet'
}

export enum ShippingDirectionEnum {
  /** Customer to Partner */
  C2p = 'c2p',
  /** Customer to Xometry */
  C2x = 'c2x',
  /** Partner to Customer */
  P2c = 'p2c',
  /** Partner to Partner */
  P2p = 'p2p',
  /** Partner to Xometry */
  P2x = 'p2x',
  /** Xometry to Customer */
  X2c = 'x2c',
  /** Xometry to Partner */
  X2p = 'x2p'
}

export enum ShippingExporterOfRecordEnum {
  /** Partner as Exporter of Record */
  Partner = 'partner',
  /** Xometry India as Exporter of Record */
  XometryIndia = 'xometry_india',
  /** Xometry Singapore as Exporter of Record */
  XometrySg = 'xometry_sg'
}

export enum ShippingImporterOfRecordEnum {
  /** Customer as Importer of Record */
  Customer = 'customer',
  /** Xometry EU as Importer of Record */
  XometryEu = 'xometry_eu',
  /** Xometry Inc. as Importer of Record */
  XometryInc = 'xometry_inc',
  /** Xometry TR as Importer of Record */
  XometryTr = 'xometry_tr',
  /** Xometry UK as Importer of Record */
  XometryUk = 'xometry_uk'
}

export type ShippingInstruction = {
  __typename?: 'ShippingInstruction';
  id: Scalars['ID']['output'];
  overriddenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  overriddenBy?: Maybe<User>;
  shipAllowDirectLegal?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectLegalXomSales?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectOrder?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectProvider?: Maybe<Scalars['Boolean']['output']>;
  shipDirection?: Maybe<ProviderOrdersShipDirectionEnum>;
  shipDirectionToEndCustomer?: Maybe<Scalars['Boolean']['output']>;
  shipIncoterms?: Maybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly?: Maybe<Scalars['Boolean']['output']>;
  shipIncotermsCity?: Maybe<Scalars['String']['output']>;
  shipIncotermsCountry?: Maybe<Scalars['String']['output']>;
  shipQcRequired?: Maybe<Scalars['Boolean']['output']>;
  shipWarehouse?: Maybe<WarehouseInstructionEnum>;
};

/** A list of shipping processing instruction */
export enum ShippingInstructionEnum {
  /** Repack */
  Repack = 'repack',
  /** Repack for Provider */
  Repack2p = 'repack2p',
  /** Xometry Scrap */
  Scrap = 'scrap',
  /** Xometry Store */
  Store = 'store',
  /** Xometry QC */
  Xqc = 'xqc'
}

/** Autogenerated input type of ShippingInstructionOverride */
export type ShippingInstructionOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shipDirection: ProviderOrdersShipDirectionEnum;
  shipDirectionToEndCustomer: Scalars['Boolean']['input'];
  shipIncoterms: ProviderOrdersIncotermsEnum;
  shipIncotermsByPlaneOnly: Scalars['Boolean']['input'];
  shipIncotermsCity: Scalars['String']['input'];
  shipIncotermsCountry: Scalars['String']['input'];
  shipQcRequired: Scalars['Boolean']['input'];
  shipWarehouse: WarehouseInstructionEnum;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of ShippingInstructionOverride. */
export type ShippingInstructionOverridePayload = {
  __typename?: 'ShippingInstructionOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shippingInstruction: ShippingInstruction;
};

export type ShippingInstructorFields = {
  __typename?: 'ShippingInstructorFields';
  shipAllowDirectLegal?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectLegalXomSales?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectOrder?: Maybe<Scalars['Boolean']['output']>;
  shipAllowDirectProvider?: Maybe<Scalars['Boolean']['output']>;
  shipDirection?: Maybe<ProviderOrdersShipDirectionEnum>;
  shipDirectionToEndCustomer?: Maybe<Scalars['Boolean']['output']>;
  shipIncoterms?: Maybe<ProviderOrdersIncotermsEnum>;
  shipIncotermsByPlaneOnly?: Maybe<Scalars['Boolean']['output']>;
  shipIncotermsCity?: Maybe<Scalars['String']['output']>;
  shipIncotermsCountry?: Maybe<Scalars['String']['output']>;
  shipQcRequired?: Maybe<Scalars['Boolean']['output']>;
  shipWarehouse?: Maybe<WarehouseInstructionEnum>;
};

export type ShippingLogisticInvoiceAllocatedCost = {
  __typename?: 'ShippingLogisticInvoiceAllocatedCost';
  allocatedCharges: Money;
  logisticInvoice: LogisticInvoice;
};

export type ShippingParameters = {
  __typename?: 'ShippingParameters';
  brutto?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum ShippingPositionNamingEnum {
  /** clients */
  Clients = 'clients',
  /** customs */
  Customs = 'customs',
  /** customs_and_clients */
  CustomsAndClients = 'customs_and_clients'
}

export type ShippingRelatedObject = {
  __typename?: 'ShippingRelatedObject';
  canceled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  objectId: Scalars['BigInt']['output'];
  objectType: Scalars['String']['output'];
};

/** State of Shippings and Master Shippings */
export enum ShippingStateEnum {
  /** Box Ready */
  BoxReady = 'box_ready',
  /** Canceled */
  Canceled = 'canceled',
  /** Delivered */
  Delivered = 'delivered',
  /** Draft */
  Draft = 'draft',
  /** In Transit */
  InTransit = 'in_transit',
  /** Packing */
  Packing = 'packing',
  /** PM Draft */
  PmDraft = 'pm_draft',
  /** Ready For Shipping */
  ReadyForShipping = 'ready_for_shipping',
  /** Shipping Ordered */
  ShippingOrdered = 'shipping_ordered'
}

export type ShippingTargetFee = {
  __typename?: 'ShippingTargetFee';
  acceptableFee: Money;
  targetFee: Money;
};

export type ShippingTargetFeeByCurrency = {
  __typename?: 'ShippingTargetFeeByCurrency';
  eur?: Maybe<ShippingTargetFee>;
  gbp?: Maybe<ShippingTargetFee>;
  inr?: Maybe<ShippingTargetFee>;
  sgd?: Maybe<ShippingTargetFee>;
  try?: Maybe<ShippingTargetFee>;
  usd?: Maybe<ShippingTargetFee>;
};

export type ShippingTrackingRecord = {
  __typename?: 'ShippingTrackingRecord';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  data?: Maybe<ShippingTrackingRecordData>;
  id: Scalars['BigInt']['output'];
};

export type ShippingTrackingRecordData = {
  __typename?: 'ShippingTrackingRecordData';
  createdAt?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  packageStatus?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ShippingsAddToMasterShipping */
export type ShippingsAddToMasterShippingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  masterShippingId: Scalars['ID']['input'];
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingsAddToMasterShipping. */
export type ShippingsAddToMasterShippingPayload = {
  __typename?: 'ShippingsAddToMasterShippingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping: MasterShipping;
};

/** Autogenerated input type of ShippingsBulkAddToMasterShipping */
export type ShippingsBulkAddToMasterShippingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  masterShippingId: Scalars['ID']['input'];
  shippingIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ShippingsBulkAddToMasterShipping. */
export type ShippingsBulkAddToMasterShippingPayload = {
  __typename?: 'ShippingsBulkAddToMasterShippingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping: MasterShipping;
  validationErrors: Array<AddToMasterShippingValidationErrors>;
};

/** Autogenerated input type of ShippingsBulkMoveToState */
export type ShippingsBulkMoveToStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingIds: Array<Scalars['ID']['input']>;
  state: Scalars['String']['input'];
};

/** Autogenerated return type of ShippingsBulkMoveToState. */
export type ShippingsBulkMoveToStatePayload = {
  __typename?: 'ShippingsBulkMoveToStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ShippingsBulkRemoveFromMasterShipping */
export type ShippingsBulkRemoveFromMasterShippingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  masterShippingId: Scalars['ID']['input'];
  shippingIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ShippingsBulkRemoveFromMasterShipping. */
export type ShippingsBulkRemoveFromMasterShippingPayload = {
  __typename?: 'ShippingsBulkRemoveFromMasterShippingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  masterShipping: MasterShipping;
};

/** Autogenerated input type of ShippingsBulkUpdateTracking */
export type ShippingsBulkUpdateTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ShippingsBulkUpdateTracking. */
export type ShippingsBulkUpdateTrackingPayload = {
  __typename?: 'ShippingsBulkUpdateTrackingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ShippingsCreate */
export type ShippingsCreateInput = {
  attributes: OmsInputsShippingsCreateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingsCreate. */
export type ShippingsCreatePayload = {
  __typename?: 'ShippingsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shipping: Shipping;
};

/** Autogenerated input type of ShippingsExport */
export type ShippingsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of ShippingsExport. */
export type ShippingsExportPayload = {
  __typename?: 'ShippingsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type ShippingsFilter = {
  actualDeliveryDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  actualDeliveryDateUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  actualShipmentDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  actualShipmentDateUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  ignoredAllocatedExpenseTypes?: InputMaybe<Array<LogisticInvoicePositionTypeEnum>>;
  ignoredShippingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  logisticOperatorId?: InputMaybe<Scalars['ID']['input']>;
  providerOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shippingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  shippingNumber?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ShippingsFormUpdate */
export type ShippingsFormUpdateInput = {
  attributes: OmsInputsShippingsUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /**
   * When provided, original attributes will be compared to database values and new attributes to detect conflicts.
   * If no conflicts found, only changed values will be written to database.
   *        When not provided, attributes will be written to database as is.
   *
   */
  originalAttributes?: InputMaybe<OmsInputsShippingsUpdateType>;
};

/** Autogenerated return type of ShippingsFormUpdate. */
export type ShippingsFormUpdatePayload = {
  __typename?: 'ShippingsFormUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conflicts?: Maybe<Array<AttributesConflict>>;
  createdOutcomingInvoiceId?: Maybe<Scalars['ID']['output']>;
  shipping: Shipping;
};

/** Autogenerated input type of ShippingsSendToExternal */
export type ShippingsSendToExternalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingsSendToExternal. */
export type ShippingsSendToExternalPayload = {
  __typename?: 'ShippingsSendToExternalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type ShippingsSplit = {
  amount: Scalars['Float']['input'];
  expenseType: LogisticInvoicePositionTypeEnum;
  formula: RelatedShippingSplitFormulaEnum;
};

/** Autogenerated input type of ShippingsSyncWithExternal */
export type ShippingsSyncWithExternalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingsSyncWithExternal. */
export type ShippingsSyncWithExternalPayload = {
  __typename?: 'ShippingsSyncWithExternalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shipping: Shipping;
};

/** Autogenerated input type of ShippingsUpdateTracking */
export type ShippingsUpdateTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShippingsUpdateTracking. */
export type ShippingsUpdateTrackingPayload = {
  __typename?: 'ShippingsUpdateTrackingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Shipping>;
};

export type ShoreHardness = {
  __typename?: 'ShoreHardness';
  createdAt: Scalars['ISO8601DateTime']['output'];
  custom: Scalars['Boolean']['output'];
  default: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum SortDirectionEnum {
  /** Ascending sorting */
  Asc = 'asc',
  /** Descending sorting */
  Desc = 'desc'
}

export enum SortOptions {
  Author = 'author',
  Creation = 'creation',
  Deadline = 'deadline',
  Priority = 'priority',
  Status = 'status',
  Type = 'type'
}

export type Source = ProviderOrder | Shipping;

export type SourceCollection = {
  __typename?: 'SourceCollection';
  sources: Array<DealsSourceType>;
};


export type SourceCollectionSourcesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SourceRelatedObjects = {
  __typename?: 'SourceRelatedObjects';
  person?: Maybe<Person>;
  provider?: Maybe<Provider>;
};

export type Storage = {
  __typename?: 'Storage';
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  location: StorageLocationEnum;
  number: Scalars['String']['output'];
  processingState: Scalars['String']['output'];
  quantityInital: Scalars['Int']['output'];
  quantityLeft: Scalars['Int']['output'];
  storageType: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum StorageLocationEnum {
  /** Basement */
  Basement = 'basement',
  /** BGL Rack 0 */
  BglRack_0 = 'bgl_rack_0',
  /** BGL Rack 1 */
  BglRack_1 = 'bgl_rack_1',
  /** BGL Rack 2 */
  BglRack_2 = 'bgl_rack_2',
  /** BGL Rack 3 */
  BglRack_3 = 'bgl_rack_3',
  /** BGL Rack 4 */
  BglRack_4 = 'bgl_rack_4',
  /** BGL Rack 5 */
  BglRack_5 = 'bgl_rack_5',
  /** BGL Rack 6 */
  BglRack_6 = 'bgl_rack_6',
  /** BGL Rack 7 */
  BglRack_7 = 'bgl_rack_7',
  /** BGL Rack 8 */
  BglRack_8 = 'bgl_rack_8',
  /** BGL Rack 9 */
  BglRack_9 = 'bgl_rack_9',
  /** BGL Rack 10 */
  BglRack_10 = 'bgl_rack_10',
  /** BGL Rack 11 */
  BglRack_11 = 'bgl_rack_11',
  /** Big Room */
  BigRoom = 'big_room',
  /** DB Schenker France */
  DbSchenkerFrance = 'db_schenker_france',
  /** DB Schenker warehouse */
  DbSchenkerWarehouse = 'db_schenker_warehouse',
  /** Dispose of */
  DisposeOf = 'dispose_of',
  /** Glonn Warehouse */
  GlonnWarehouse = 'glonn_warehouse',
  /** GOT Warehouse Colnbrook */
  GotWarehouseColnbrook = 'got_warehouse_colnbrook',
  /** GOT Warehouse Santry */
  GotWarehouseSantry = 'got_warehouse_santry',
  /** Linther Spedition */
  LintherSpedition = 'linther_spedition',
  /** Otto-2 Warehouse */
  Otto2Warehouse = 'otto2_warehouse',
  /** QC Room */
  QcRoom = 'qc_room',
  /** Shipping Room */
  ShippingRoom = 'shipping_room',
  /** Storage Room */
  StorageRoom = 'storage_room',
  /** Trashed */
  Trashed = 'trashed'
}

/** Autogenerated input type of StoragesExport */
export type StoragesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of StoragesExport. */
export type StoragesExportPayload = {
  __typename?: 'StoragesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Strategy = {
  __typename?: 'Strategy';
  active: Scalars['String']['output'];
  constantName?: Maybe<Scalars['String']['output']>;
  content: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deal?: Maybe<Deal>;
  dealName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastReadMessageId?: Maybe<Scalars['ID']['output']>;
  lastReply?: Maybe<Message>;
  source?: Maybe<MessageSource>;
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SubscriptionsExport */
export type SubscriptionsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of SubscriptionsExport. */
export type SubscriptionsExportPayload = {
  __typename?: 'SubscriptionsExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type SuggestedCarbonCopyUser = {
  __typename?: 'SuggestedCarbonCopyUser';
  participants: Array<MessageUser>;
  totalCount: Scalars['Int']['output'];
};

export type SupportTicketsFilterType = {
  jobOfferId?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  providerOrderId?: InputMaybe<Scalars['Int']['input']>;
};

export type SupportTicketsPageType = {
  __typename?: 'SupportTicketsPageType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  tickets: Array<Ticket>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SurfaceRoughness = {
  __typename?: 'SurfaceRoughness';
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  i18nKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantityEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  approved: Scalars['Boolean']['output'];
  context: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Tag>;
  parentId?: Maybe<Scalars['ID']['output']>;
  processType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum TaskStatusEnum {
  Completed = 'completed',
  InProgress = 'in_progress',
  New = 'new'
}

export enum TaskType {
  Call = 'call',
  ChangesInDeal = 'changes_in_deal',
  CheckCustomerNotes = 'check_customer_notes',
  CheckStatus = 'check_status',
  CheckingMaterialCertificate = 'checking_material_certificate',
  CheckingMeasurementProtocol = 'checking_measurement_protocol',
  Checkpoint = 'checkpoint',
  CreateDocument = 'create_document',
  DiscussIssue = 'discuss_issue',
  Drawing = 'drawing',
  General = 'general',
  InvoiceIssue = 'invoice_issue',
  Molding = 'molding',
  PlacingIssues = 'placing_issues',
  PlacingRepeatDeal = 'placing_repeat_deal',
  ReplacingRequest = 'replacing_request',
  RequestApprove = 'request_approve',
  RevenueForecastDiff = 'revenue_forecast_diff',
  Shipping = 'shipping',
  TalkToCustomer = 'talk_to_customer',
  TalkToPartner = 'talk_to_partner'
}

/** Autogenerated input type of TasksExport */
export type TasksExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of TasksExport. */
export type TasksExportPayload = {
  __typename?: 'TasksExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  childTeams: Array<Team>;
  constantName: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  parentTeam?: Maybe<Team>;
  parentTeamId?: Maybe<Scalars['BigInt']['output']>;
  recursiveParents: Array<Team>;
  region: RegionEnum;
  teamType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<TeamMembership>;
};

export type TeamMembership = {
  __typename?: 'TeamMembership';
  id: Scalars['Int']['output'];
  membershipType: MembershipTypeEnum;
  team: Team;
  teamId: Scalars['BigInt']['output'];
  user: User;
  userId: Scalars['BigInt']['output'];
};

/** Autogenerated input type of TeamsAddUser */
export type TeamsAddUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  membershipType: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of TeamsAddUser. */
export type TeamsAddUserPayload = {
  __typename?: 'TeamsAddUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  team: Team;
};

/** Autogenerated input type of TeamsCreate */
export type TeamsCreateInput = {
  attributes: OmsInputsTeamsCreateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TeamsCreate. */
export type TeamsCreatePayload = {
  __typename?: 'TeamsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  team: Team;
};

/** Autogenerated input type of TeamsRemoveUser */
export type TeamsRemoveUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of TeamsRemoveUser. */
export type TeamsRemoveUserPayload = {
  __typename?: 'TeamsRemoveUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  team: Team;
};

/** Autogenerated input type of TeamsUpdate */
export type TeamsUpdateInput = {
  attributes: OmsInputsTeamsUpdateType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of TeamsUpdateMembershipType */
export type TeamsUpdateMembershipTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  membershipType: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of TeamsUpdateMembershipType. */
export type TeamsUpdateMembershipTypePayload = {
  __typename?: 'TeamsUpdateMembershipTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  team: Team;
};

/** Autogenerated return type of TeamsUpdate. */
export type TeamsUpdatePayload = {
  __typename?: 'TeamsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  team: Team;
};

export type Teamspace = {
  __typename?: 'Teamspace';
  billingAccounts?: Maybe<Array<TeamspaceBillingAccount>>;
  billingAccountsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deals: Array<Deal>;
  dealsCount: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  highVolumeEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isForSoftwareTesting: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  loyaltyData?: Maybe<LoyaltyBalance>;
  manualCalcAllowed: Scalars['Boolean']['output'];
  members?: Maybe<Array<Member>>;
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<Member>;
  pendingInvitations?: Maybe<Array<Invite>>;
  pendingInvitationsCount: Scalars['Int']['output'];
  roleForPerson?: Maybe<OmsTeamspaceRoleEnum>;
  tpoEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type TeamspaceBillingAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamspaceDealsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type TeamspaceMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamspacePendingInvitationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamspaceRoleForPersonArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamspaceBillingAccount = {
  __typename?: 'TeamspaceBillingAccount';
  billingAccount: BillingAccount;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  teamspace: Teamspace;
  teamspaceCreditLimitAccess: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Teamspace information */
export type TeamspaceMembership = {
  __typename?: 'TeamspaceMembership';
  /** Teamspace ID */
  id: Scalars['ID']['output'];
  /** Teamspace name */
  name: Scalars['String']['output'];
  /** Person role in the teamspace */
  role: MessengerTeamspaceRoleEnum;
};

export type TeamspaceShippingAddress = {
  __typename?: 'TeamspaceShippingAddress';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  shippingAddress: ShippingAddress;
  teamspace: Teamspace;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TeamspacesCollection = {
  __typename?: 'TeamspacesCollection';
  collection: Array<Teamspace>;
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of TeamspacesExport */
export type TeamspacesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of TeamspacesExport. */
export type TeamspacesExportPayload = {
  __typename?: 'TeamspacesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

export type Template = {
  __typename?: 'Template';
  /** abbreviated as "BCC" */
  blindCarbonCopy?: Maybe<Array<Scalars['String']['output']>>;
  /** abbreviated as "CC" */
  carbonCopy?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<TemplateCategory>;
  constantName?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  direction: TemplateDirectionEnum;
  id: Scalars['ID']['output'];
  locale: TemplateLocaleEnum;
  mentions: Array<MentionType>;
  messageType: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  subject?: Maybe<Scalars['String']['output']>;
  type: TemplateTypeEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TemplateCategory = {
  __typename?: 'TemplateCategory';
  channels: Array<TemplateChannelEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  entryPoints: Array<TemplateEntryPointEnum>;
  id: Scalars['ID']['output'];
  templatesGroups: Array<ManagerTemplateGroupType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum TemplateChannelEnum {
  Email = 'EMAIL',
  Messenger = 'MESSENGER',
  Whatsapp = 'WHATSAPP'
}

export enum TemplateDirectionEnum {
  Any = 'any',
  X2c = 'x2c',
  X2p = 'x2p',
  X2x = 'x2x'
}

export enum TemplateEntryPointEnum {
  DealHeader = 'DEAL_HEADER',
  DocumentEmail = 'DOCUMENT_EMAIL',
  DocumentMessenger = 'DOCUMENT_MESSENGER',
  GeneralMessengerPerson = 'GENERAL_MESSENGER_PERSON',
  GeneralMessengerProvider = 'GENERAL_MESSENGER_PROVIDER',
  PersonEmail = 'PERSON_EMAIL'
}

export enum TemplateLocaleEnum {
  Cs = 'CS',
  Da = 'DA',
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fi = 'FI',
  Fr = 'FR',
  It = 'IT',
  Nb = 'NB',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  Sv = 'SV',
  Tr = 'TR'
}

export type TemplatePlaceholderItem = {
  __typename?: 'TemplatePlaceholderItem';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TemplatePlaceholderType = {
  __typename?: 'TemplatePlaceholderType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TemplatePlaceholdersCollectionType = {
  __typename?: 'TemplatePlaceholdersCollectionType';
  content: Array<TemplatePlaceholderItem>;
  recipients: Array<TemplatePlaceholderItem>;
};

export enum TemplateSortOrderEnumType {
  Asc = 'asc',
  Desc = 'desc'
}

export enum TemplateSortableFieldsEnumType {
  Category = 'category',
  CreatedAt = 'created_at',
  Direction = 'direction',
  Id = 'id',
  Name = 'name',
  Type = 'type'
}

export enum TemplateTypeEnum {
  BillingAccount = 'billing_account',
  Claim = 'claim',
  Custom = 'custom',
  DeliveryObsolete = 'delivery_obsolete',
  Enquiry = 'enquiry',
  EnquiryNotifications = 'enquiry_notifications',
  EnquiryRfq = 'enquiry_rfq',
  GeneralMailer = 'general_mailer',
  IncomingInvoice = 'incoming_invoice',
  Job = 'job',
  Offer = 'offer',
  OrderConfirmation = 'order_confirmation',
  Organization = 'organization',
  OutcomingInvoice = 'outcoming_invoice',
  Payment = 'payment',
  PoReminder = 'po_reminder',
  PoolApplication = 'pool_application',
  ProviderContact = 'provider_contact',
  ProviderOrder = 'provider_order',
  Publication = 'publication',
  QualityControl = 'quality_control',
  Quotation = 'quotation',
  Rfq = 'rfq',
  RfqOffer = 'rfq_offer',
  Shipping = 'shipping',
  ShippingObsolete = 'shipping_obsolete',
  SpecialOffer = 'special_offer',
  StatusChange = 'status_change',
  Whatsapp = 'whatsapp'
}

export type Ticket = {
  __typename?: 'Ticket';
  categoryName?: Maybe<Scalars['String']['output']>;
  claimId?: Maybe<Scalars['Int']['output']>;
  dealId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobOfferId?: Maybe<Scalars['Int']['output']>;
  providerOrderId?: Maybe<Scalars['Int']['output']>;
  requestedAt: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Tolerance = {
  __typename?: 'Tolerance';
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  i18nKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantityEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  createdAt: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  moneyAmount: Scalars['Int']['output'];
  ownerId: Scalars['ID']['output'];
  ownerType: OmsLoyaltyBalancesOwnerEnumType;
  personId: Scalars['ID']['output'];
  pointsAmount: Scalars['Int']['output'];
  referenceId?: Maybe<Scalars['ID']['output']>;
  referenceType?: Maybe<LoyaltyTransactionsReferenceEnumType>;
  state: Scalars['String']['output'];
  status: OmsLoyaltyTransactionsStatusEnumType;
  transactionType: LoyaltyTransactionsTypeEnumType;
  transferredToId?: Maybe<Scalars['ID']['output']>;
  transferredToName?: Maybe<Scalars['String']['output']>;
  transferredToType?: Maybe<OmsLoyaltyBalancesOwnerEnumType>;
  trigger: LoyaltyTransactionsTriggerEnumType;
};

export enum TransferEnum {
  /** UK Only: ach_bucs */
  AchBucs = 'ach_bucs',
  /** ach_sepa */
  AchSepa = 'ach_sepa',
  /** wire */
  Wire = 'wire'
}

export type TranslateInput = {
  /** Name of the field being translated */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** Additional instructions for translation/rewriting */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Language for proof-reading (defaults to user locale) */
  proofReadingLanguage?: InputMaybe<Scalars['String']['input']>;
  /** ID from ai_responses table for existing responses */
  responseId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the target object to be translated */
  targetId: Scalars['ID']['input'];
  /** Target language code (e.g., en, de, fr) */
  targetLanguage: Scalars['String']['input'];
  /** Type of the target object (e.g., Message, User) */
  targetType: Scalars['String']['input'];
  /** Text to be translated */
  text: Scalars['String']['input'];
  /** Type of translation request: show_translation, rewrite, refresh_proof_reading */
  translateRequest?: InputMaybe<Scalars['String']['input']>;
  /** Existing translation text for proof-reading */
  translation?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationStatus = {
  __typename?: 'TranslationStatus';
  /** Proof-reading feedback (only present when status is completed) */
  proofReading?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the translation request */
  responseId: Scalars['String']['output'];
  /** Current status of the translation (pending, completed, failed) */
  status: Scalars['String']['output'];
  /** The translated text (only present when status is completed) */
  translation?: Maybe<Scalars['String']['output']>;
};

export enum TypeNameEnum {
  CertMaterial = 'cert_material',
  Correction = 'correction',
  Coupon = 'coupon',
  CustomClearance = 'custom_clearance',
  Discount = 'discount',
  DiscountPrepay = 'discount_prepay',
  EngineeringInspection = 'engineering_inspection',
  ImTools = 'im_tools',
  Material = 'material',
  MeasurementProtocols = 'measurement_protocols',
  MinOrderCharge = 'min_order_charge',
  Other = 'other',
  Packaging = 'packaging',
  Parts = 'parts',
  Service = 'service',
  Total = 'total',
  Transport = 'transport',
  XPoints = 'x_points'
}

/** Autogenerated input type of UpdateLogisticInvoice */
export type UpdateLogisticInvoiceInput = {
  attributes: OmsInputsLogisticInvoiceType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateLogisticInvoice. */
export type UpdateLogisticInvoicePayload = {
  __typename?: 'UpdateLogisticInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

/** Autogenerated input type of UpdateLogisticInvoiceRelatedShippings */
export type UpdateLogisticInvoiceRelatedShippingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  relatedShippings?: InputMaybe<Array<OmsInputsLogisticInvoiceRelatedShippingType>>;
};

/** Autogenerated return type of UpdateLogisticInvoiceRelatedShippings. */
export type UpdateLogisticInvoiceRelatedShippingsPayload = {
  __typename?: 'UpdateLogisticInvoiceRelatedShippingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticInvoice?: Maybe<LogisticInvoice>;
};

/** Autogenerated input type of UpdateLogisticOperatorBillingAccount */
export type UpdateLogisticOperatorBillingAccountInput = {
  attributes: OmsInputsLogisticOperatorBillingAccountType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateLogisticOperatorBillingAccount. */
export type UpdateLogisticOperatorBillingAccountPayload = {
  __typename?: 'UpdateLogisticOperatorBillingAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  logisticOperatorBillingAccount?: Maybe<LogisticOperatorBillingAccount>;
};

/** Autogenerated input type of UpdateTag */
export type UpdateTagInput = {
  approved: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTag. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tag: Tag;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  autoAssignmentSettings?: Maybe<AutoAssignmentSettings>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  couponLimit: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRobot: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  messageFilterGroups?: Maybe<Array<MessageFilterGroup>>;
  messageFilters?: Maybe<Array<MessageFilter>>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['ID']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<UserRegionEnum>;
  rfqLimit?: Maybe<Scalars['Int']['output']>;
  roles: Array<Role>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  substitutedBy?: Maybe<Array<OmsSubstitution>>;
  substitutedByArchived?: Maybe<Array<OmsSubstitution>>;
  substitutingFor?: Maybe<Array<OmsSubstitution>>;
  substitutingForArchived?: Maybe<Array<OmsSubstitution>>;
  teams: Array<TeamMembership>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum UserEnum {
  Client = 'CLIENT',
  ExternalContact = 'EXTERNAL_CONTACT',
  Partner = 'PARTNER',
  Xometry = 'XOMETRY'
}

export type UserPermission = {
  __typename?: 'UserPermission';
  createdAt: Scalars['ISO8601DateTime']['output'];
  erpPermission: ErpPermission;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum UserRegionEnum {
  De = 'DE',
  Fr = 'FR',
  NordixBenelux = 'NordixBenelux',
  Others = 'Others',
  Ukie = 'UKIE'
}

/** Autogenerated input type of UsersAssignRoles */
export type UsersAssignRolesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UsersAssignRoles. */
export type UsersAssignRolesPayload = {
  __typename?: 'UsersAssignRolesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
};

/** Autogenerated input type of UsersExport */
export type UsersExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<WorkspacesInputsExportColumnType>;
  filename: Scalars['String']['input'];
  filterQuery: Scalars['String']['input'];
  format: Scalars['String']['input'];
  paginationParams: WorkspacesInputsGenericPaginationType;
  queryOptions?: InputMaybe<Scalars['JSON']['input']>;
  selectedRecords?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortParams?: InputMaybe<Array<WorkspacesInputsGenericSortingType>>;
  timezoneOffset: Scalars['Int']['input'];
};

/** Autogenerated return type of UsersExport. */
export type UsersExportPayload = {
  __typename?: 'UsersExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of UsersUpdateAvatar */
export type UsersUpdateAvatarInput = {
  avatarData: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UsersUpdateAvatar. */
export type UsersUpdateAvatarPayload = {
  __typename?: 'UsersUpdateAvatarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of UsersUpdatePermissions */
export type UsersUpdatePermissionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<OmsInputsUserPermission>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UsersUpdatePermissions. */
export type UsersUpdatePermissionsPayload = {
  __typename?: 'UsersUpdatePermissionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userPermissions: Array<UserPermission>;
};

/** Autogenerated input type of UsersUpdateProfile */
export type UsersUpdateProfileInput = {
  attributes: OmsInputsUserProfile;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UsersUpdateProfile. */
export type UsersUpdateProfilePayload = {
  __typename?: 'UsersUpdateProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type Utm = {
  __typename?: 'Utm';
  campaign?: Maybe<Scalars['BigInt']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ValidateAutoOrderFromXometry */
export type ValidateAutoOrderFromXometryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shippingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ValidateAutoOrderFromXometry. */
export type ValidateAutoOrderFromXometryPayload = {
  __typename?: 'ValidateAutoOrderFromXometryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shipping: Shipping;
  valid: Scalars['Boolean']['output'];
};

export type Validations = {
  __typename?: 'Validations';
  bffValidation?: Maybe<VatValidation>;
  ecValidation?: Maybe<VatValidation>;
  lastValidation?: Maybe<VatValidation>;
  total: Scalars['Int']['output'];
  validations: Array<VatValidation>;
};

export type VatValidation = {
  __typename?: 'VatValidation';
  bffCityValid?: Maybe<Scalars['Boolean']['output']>;
  bffCode?: Maybe<Scalars['Int']['output']>;
  bffMessage?: Maybe<Scalars['String']['output']>;
  bffNameValid?: Maybe<Scalars['Boolean']['output']>;
  bffResponse?: Maybe<Scalars['JSON']['output']>;
  bffStreetValid?: Maybe<Scalars['Boolean']['output']>;
  bffVatValid?: Maybe<Scalars['Boolean']['output']>;
  bffZipValid?: Maybe<Scalars['Boolean']['output']>;
  checkedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  ecAddress?: Maybe<Scalars['String']['output']>;
  ecName?: Maybe<Scalars['String']['output']>;
  ecRequestDate?: Maybe<Scalars['String']['output']>;
  ecResponse?: Maybe<Scalars['JSON']['output']>;
  ecValid?: Maybe<Scalars['Boolean']['output']>;
  ecVatNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  request?: Maybe<Scalars['JSON']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum VatValidationStatusEnumType {
  Failed = 'Failed',
  Invalid = 'Invalid',
  Pending = 'Pending',
  Valid = 'Valid'
}

/** A list of WarehouseInstruction */
export enum WarehouseInstructionEnum {
  /** Not Applicable */
  NotApplicable = 'not_applicable',
  /** Repack */
  Repack = 'repack',
  /** Repack for Provider */
  Repack2p = 'repack2p',
  /** Xometry Scrap */
  Scrap = 'scrap',
  /** Xometry Store */
  Store = 'store',
  /** Xometry QC */
  Xqc = 'xqc'
}

export enum WhatsAppStatusEnum {
  DialogClosed = 'dialog_closed',
  DialogInitialized = 'dialog_initialized',
  DialogOpen = 'dialog_open',
  NoVerifiedNumber = 'no_verified_number',
  VerifiedNoMessages = 'verified_no_messages'
}

export type WorkspacePreset = {
  __typename?: 'WorkspacePreset';
  columns?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  exportColumns?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  lastUpdatedBy?: Maybe<User>;
  name: Scalars['String']['output'];
  owner: User;
  public: Scalars['Boolean']['output'];
  query?: Maybe<Scalars['String']['output']>;
  sortColumn?: Maybe<Scalars['String']['output']>;
  sortDirection?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  workspaceName: Scalars['String']['output'];
};

/** Autogenerated input type of WorkspacePresetsAssignDefaultPreset */
export type WorkspacePresetsAssignDefaultPresetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  presetId: Scalars['ID']['input'];
  workspaceName: Scalars['String']['input'];
};

/** Autogenerated return type of WorkspacePresetsAssignDefaultPreset. */
export type WorkspacePresetsAssignDefaultPresetPayload = {
  __typename?: 'WorkspacePresetsAssignDefaultPresetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WorkspacePresetsAssignGlobalDefaultPreset */
export type WorkspacePresetsAssignGlobalDefaultPresetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  presetId: Scalars['ID']['input'];
  workspaceName: Scalars['String']['input'];
};

/** Autogenerated return type of WorkspacePresetsAssignGlobalDefaultPreset. */
export type WorkspacePresetsAssignGlobalDefaultPresetPayload = {
  __typename?: 'WorkspacePresetsAssignGlobalDefaultPresetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WorkspacePresetsCreate */
export type WorkspacePresetsCreateInput = {
  attributes: OmsInputsWorkspacePresetType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WorkspacePresetsCreate. */
export type WorkspacePresetsCreatePayload = {
  __typename?: 'WorkspacePresetsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  workspacePreset: WorkspacePreset;
};

/** Autogenerated input type of WorkspacePresetsDelete */
export type WorkspacePresetsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of WorkspacePresetsDelete. */
export type WorkspacePresetsDeletePayload = {
  __typename?: 'WorkspacePresetsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WorkspacePresetsRemoveDefaultPreset */
export type WorkspacePresetsRemoveDefaultPresetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceName: Scalars['String']['input'];
};

/** Autogenerated return type of WorkspacePresetsRemoveDefaultPreset. */
export type WorkspacePresetsRemoveDefaultPresetPayload = {
  __typename?: 'WorkspacePresetsRemoveDefaultPresetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WorkspacePresetsRemoveGlobalDefaultPreset */
export type WorkspacePresetsRemoveGlobalDefaultPresetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceName: Scalars['String']['input'];
};

/** Autogenerated return type of WorkspacePresetsRemoveGlobalDefaultPreset. */
export type WorkspacePresetsRemoveGlobalDefaultPresetPayload = {
  __typename?: 'WorkspacePresetsRemoveGlobalDefaultPresetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WorkspacePresetsUpdate */
export type WorkspacePresetsUpdateInput = {
  attributes: OmsInputsWorkspacePresetType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of WorkspacePresetsUpdate. */
export type WorkspacePresetsUpdatePayload = {
  __typename?: 'WorkspacePresetsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  workspacePreset: WorkspacePreset;
};

export type WorkspacesAcceptedJobOffer = {
  __typename?: 'WorkspacesAcceptedJobOffer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  providerOrderId?: Maybe<Scalars['ID']['output']>;
  responseState?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPayment = {
  __typename?: 'WorkspacesBankPayment';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  amountCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  amountMoney: Money;
  amountToBeRecognizedCents?: Maybe<Scalars['BigInt']['output']>;
  amountToBeRecognizedCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  amountToBeRecognizedMoney: Money;
  approvedAt?: Maybe<Scalars['Float']['output']>;
  /** custom workspace_object */
  approvedBy?: Maybe<WorkspacesPayoutUser>;
  batchImportId?: Maybe<Scalars['BigInt']['output']>;
  billingAccountId?: Maybe<Scalars['String']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  counterparty?: Maybe<Scalars['JSON']['output']>;
  counterpartyId?: Maybe<Scalars['BigInt']['output']>;
  counterpartyType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  direction?: Maybe<Scalars['String']['output']>;
  endToEndId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** custom workspace_object */
  logisticPayouts?: Maybe<Array<WorkspacesBankPaymentLogisticPayout>>;
  outlyingTransactionType?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  paymentDetails?: Maybe<Scalars['JSON']['output']>;
  paymentDetailsBankAccount?: Maybe<Scalars['String']['output']>;
  paymentDetailsBankCode?: Maybe<Scalars['String']['output']>;
  paymentDetailsBankCountry?: Maybe<Scalars['String']['output']>;
  paymentDetailsPayoutTransferType?: Maybe<Scalars['String']['output']>;
  paymentDetailsProviderCountry?: Maybe<Scalars['String']['output']>;
  paymentDetailsProviderName?: Maybe<Scalars['String']['output']>;
  paymentDetailsString?: Maybe<Scalars['String']['output']>;
  paymentDetailsTransactionId?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  payments?: Maybe<Array<WorkspacesBankPaymentPayment>>;
  /** custom workspace_object */
  payouts?: Maybe<Array<WorkspacesBankPaymentPayout>>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerLegalName?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  sentToBankAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentToBankByName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom workspace_object */
  xometryBankAccount?: Maybe<Scalars['JSON']['output']>;
  xometryBankAccountAccountId?: Maybe<Scalars['String']['output']>;
  xometryBankAccountAccountNumber?: Maybe<Scalars['String']['output']>;
  xometryBankAccountString?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesBankPaymentExport = {
  __typename?: 'WorkspacesBankPaymentExport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentLogisticInvoice = {
  __typename?: 'WorkspacesBankPaymentLogisticInvoice';
  amountBruttoMoney: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentLogisticPayout = {
  __typename?: 'WorkspacesBankPaymentLogisticPayout';
  amountMoney: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  logisticInvoice?: Maybe<WorkspacesBankPaymentLogisticInvoice>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentPayment = {
  __typename?: 'WorkspacesBankPaymentPayment';
  amountBrut?: Maybe<Scalars['Float']['output']>;
  amountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  amountBrutMoney?: Maybe<Money>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isRefund: Scalars['Boolean']['output'];
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  source?: Maybe<Scalars['JSON']['output']>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentPayout = {
  __typename?: 'WorkspacesBankPaymentPayout';
  amount: Scalars['Float']['output'];
  amountMoney: Money;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fastPay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instantPay: Scalars['Boolean']['output'];
  isRefund: Scalars['Boolean']['output'];
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  prepayment: Scalars['Boolean']['output'];
  source?: Maybe<Scalars['JSON']['output']>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentTotalAmounts = {
  __typename?: 'WorkspacesBankPaymentTotalAmounts';
  totalAmount: Money;
};

export type WorkspacesBankPaymentUpdatedPayment = {
  __typename?: 'WorkspacesBankPaymentUpdatedPayment';
  amountBrut?: Maybe<Scalars['Float']['output']>;
  amountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  amountBrutMoney?: Maybe<Money>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  isRefund: Scalars['Boolean']['output'];
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  source?: Maybe<WorkspacesBankPaymentUpdatedPaymentSource>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentUpdatedPaymentSource = {
  __typename?: 'WorkspacesBankPaymentUpdatedPaymentSource';
  amount?: Maybe<Scalars['Float']['output']>;
  amountMoney?: Maybe<Money>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesBankPaymentUpdatedPayout = {
  __typename?: 'WorkspacesBankPaymentUpdatedPayout';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['BigInt']['output'];
  amountMoney: Money;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fastPay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instantPay: Scalars['Boolean']['output'];
  isRefund: Scalars['Boolean']['output'];
  methodId?: Maybe<Scalars['ID']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  prepayment: Scalars['Boolean']['output'];
  source?: Maybe<WorkspacesBankPaymentUpdatedPayoutSource>;
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentUpdatedPayoutSource = {
  __typename?: 'WorkspacesBankPaymentUpdatedPayoutSource';
  amount?: Maybe<Scalars['Float']['output']>;
  amountMoney?: Maybe<Money>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesBankPaymentsCollection = {
  __typename?: 'WorkspacesBankPaymentsCollection';
  objects: Array<WorkspacesBankPayment>;
  total: Scalars['Int']['output'];
};

export type WorkspacesBankPaymentsDraft = {
  __typename?: 'WorkspacesBankPaymentsDraft';
  amountCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  amountMoney: Money;
  amountToBeRecognizedCents?: Maybe<Scalars['BigInt']['output']>;
  amountToBeRecognizedCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  amountToBeRecognizedMoney: Money;
  approvedAt?: Maybe<Scalars['Float']['output']>;
  /** custom workspace_object */
  approvedBy?: Maybe<WorkspacesPayoutUser>;
  bankPaymentExportStatusCode?: Maybe<Scalars['String']['output']>;
  bankPaymentExportStatusText?: Maybe<Scalars['String']['output']>;
  /** workspace_object */
  batchExport?: Maybe<WorkspacesBankPaymentExport>;
  batchImportId?: Maybe<Scalars['BigInt']['output']>;
  billingAccountId?: Maybe<Scalars['String']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  counterparty?: Maybe<Scalars['JSON']['output']>;
  counterpartyId?: Maybe<Scalars['BigInt']['output']>;
  counterpartyType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  endToEndId?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  jpmCheckAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  jpmStatus?: Maybe<Scalars['String']['output']>;
  lastExportRowBatchId?: Maybe<Scalars['BigInt']['output']>;
  lastExportRowResponse?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  logisticInvoices?: Maybe<Array<WorkspacesBankPaymentLogisticInvoice>>;
  /** custom workspace_object */
  logisticPayouts?: Maybe<Array<WorkspacesBankPaymentLogisticPayout>>;
  outlyingTransactionType?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  paymentDetails?: Maybe<Scalars['JSON']['output']>;
  paymentDetailsBankAccount?: Maybe<Scalars['String']['output']>;
  paymentDetailsBankCode?: Maybe<Scalars['String']['output']>;
  paymentDetailsBankCountry?: Maybe<Scalars['String']['output']>;
  paymentDetailsPayoutTransferType?: Maybe<Scalars['String']['output']>;
  paymentDetailsProviderCountry?: Maybe<Scalars['String']['output']>;
  paymentDetailsProviderName?: Maybe<Scalars['String']['output']>;
  paymentDetailsString?: Maybe<Scalars['String']['output']>;
  paymentDetailsTransactionId?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  payments?: Maybe<Array<WorkspacesBankPaymentPayment>>;
  /** custom workspace_object */
  payouts?: Maybe<Array<WorkspacesBankPaymentPayout>>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerLegalName?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  sentToBankAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentToBankByName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['BigInt']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom workspace_object */
  xometryBankAccount?: Maybe<Scalars['JSON']['output']>;
  xometryBankAccountAccountId?: Maybe<Scalars['String']['output']>;
  xometryBankAccountString?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesBankPaymentsDraftCollection = {
  __typename?: 'WorkspacesBankPaymentsDraftCollection';
  objects: Array<WorkspacesBankPaymentsDraft>;
  total: Scalars['Int']['output'];
};

export type WorkspacesBillingAccount = {
  __typename?: 'WorkspacesBillingAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creditLimitCents?: Maybe<Scalars['BigInt']['output']>;
  creditLimitCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  creditLimitMoney: Money;
  creditLimitRequestCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  creditLimitRequestMoney: Money;
  creditLimitUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creditLimitUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  creditLimitUpdatedByName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dnbDunsNumber?: Maybe<Scalars['String']['output']>;
  dnbRecommendationCents?: Maybe<Scalars['BigInt']['output']>;
  dnbRecommendationCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dnbRecommendationMoney: Money;
  dnbRecommendationUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasDnbDunsDuplicates?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  mergedToId?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  paymentTermsType: Scalars['String']['output'];
  paymentTermsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentTermsUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  paymentTermsUpdatedByName?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  personsLinked?: Maybe<Array<Scalars['JSON']['output']>>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  salesPersonIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  salesPersonNames?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAfterRegistered?: Maybe<Scalars['Boolean']['output']>;
  vatValidationStatus?: Maybe<Scalars['String']['output']>;
  vatValidationTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesBillingAccountsCollection = {
  __typename?: 'WorkspacesBillingAccountsCollection';
  objects: Array<WorkspacesBillingAccount>;
  total: Scalars['Int']['output'];
};

export type WorkspacesClaim = {
  __typename?: 'WorkspacesClaim';
  ageHours: Scalars['Int']['output'];
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimNumber?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  directExpenses?: Maybe<Scalars['Float']['output']>;
  entryPoint?: Maybe<Scalars['String']['output']>;
  euCustoms?: Maybe<Scalars['Boolean']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  itemsCount?: Maybe<Scalars['Int']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ocBillingCountry?: Maybe<Scalars['String']['output']>;
  ocBillingName?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  partnerNetworkManagerIds: Array<Scalars['BigInt']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  positionsCount?: Maybe<Scalars['Int']['output']>;
  primaryIssue?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  productionMethodsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  /** workspace_object */
  providerOrders?: Maybe<Array<WorkspacesClaimProviderOrder>>;
  /** workspace_object */
  providers?: Maybe<Array<WorkspacesClaimProvider>>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalCustomerValueCents?: Maybe<Scalars['BigInt']['output']>;
  totalCustomerValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalCustomerValueMoney: Money;
  totalProviderValueCents?: Maybe<Scalars['BigInt']['output']>;
  totalProviderValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalProviderValueMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  typeClaim?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601Date']['output'];
};

export type WorkspacesClaimProvider = {
  __typename?: 'WorkspacesClaimProvider';
  /** skip */
  createdAt: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** skip */
  updatedAt: Scalars['ISO8601Date']['output'];
};

export type WorkspacesClaimProviderOrder = {
  __typename?: 'WorkspacesClaimProviderOrder';
  createdAt: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  number?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601Date']['output'];
};

export type WorkspacesClaimsCollection = {
  __typename?: 'WorkspacesClaimsCollection';
  objects: Array<WorkspacesClaim>;
  total: Scalars['Int']['output'];
};

export type WorkspacesCoupon = {
  __typename?: 'WorkspacesCoupon';
  applicationCount?: Maybe<Scalars['Int']['output']>;
  applicationValueCents?: Maybe<Scalars['BigInt']['output']>;
  applicationValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  applicationValueMoney: Money;
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmountCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  discountAmountMoney: Money;
  discountAmountPercent?: Maybe<Scalars['Float']['output']>;
  discountUnit: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  lastApplicationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastApplicationDealId?: Maybe<Scalars['Int']['output']>;
  organizationCountry?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validOrganizations?: Maybe<Scalars['String']['output']>;
  validPersons?: Maybe<Scalars['String']['output']>;
  validProcesses?: Maybe<Scalars['String']['output']>;
  valueFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  valueTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type WorkspacesCouponsCollection = {
  __typename?: 'WorkspacesCouponsCollection';
  objects: Array<WorkspacesCoupon>;
  total: Scalars['Int']['output'];
};

export type WorkspacesDeal = {
  __typename?: 'WorkspacesDeal';
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  billingAccountTaxId?: Maybe<Scalars['String']['output']>;
  billingAccountType?: Maybe<Scalars['String']['output']>;
  billingAccountVatValidationStatus?: Maybe<Scalars['String']['output']>;
  billingAccountVatValidationTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  billingAddressValue?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  confirmDate?: Maybe<Scalars['ISO8601Date']['output']>;
  consistencyCheck?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency: Scalars['String']['output'];
  /** custom workspace_object */
  customerInvoicesSumNettoMoney?: Maybe<Money>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  customerProjectNumber?: Maybe<Scalars['String']['output']>;
  deadlineAlarm?: Maybe<Scalars['Boolean']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealIsBigOrHeavy?: Maybe<Scalars['Boolean']['output']>;
  dealNotes?: Maybe<Scalars['String']['output']>;
  delayReason?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  deliveryDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  deliveryDueDays?: Maybe<Scalars['Int']['output']>;
  dfmProcessRequired: Scalars['Boolean']['output'];
  /** _allow_array */
  dfmProcessTypes?: Maybe<Array<PipelineTypeEnum>>;
  /** custom */
  dfmReportProcessBusinessDays?: Maybe<Scalars['Int']['output']>;
  dfmReportRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dfmReportSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  drawingCleanupStatus?: Maybe<Scalars['String']['output']>;
  enquiryId?: Maybe<Scalars['BigInt']['output']>;
  euCustoms: Scalars['Boolean']['output'];
  frameworkAgreement: Scalars['Boolean']['output'];
  grade?: Maybe<Scalars['String']['output']>;
  /** custom */
  hasCustomerCreditNote?: Maybe<Scalars['Boolean']['output']>;
  hasCustomerInvoice: Scalars['Boolean']['output'];
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  injectionMouldingDeferredPayment: Scalars['Boolean']['output'];
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting: Scalars['Boolean']['output'];
  isFullyInvoiced: Scalars['Boolean']['output'];
  isFullyPaid: Scalars['Boolean']['output'];
  isFullyShipped: Scalars['Boolean']['output'];
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isImportant?: Maybe<Scalars['Boolean']['output']>;
  isNpg: Scalars['Boolean']['output'];
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  kamId?: Maybe<Scalars['Int']['output']>;
  kamName?: Maybe<Scalars['String']['output']>;
  manualProcessingComment?: Maybe<Scalars['String']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  modificationPlanSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  moldingDfmEngineerId?: Maybe<Scalars['BigInt']['output']>;
  moldingDfmEngineerName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  ocPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  occrOpenId?: Maybe<Scalars['BigInt']['output']>;
  occrOpenValidTillDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  occrStates?: Maybe<Array<Scalars['String']['output']>>;
  oiEarliestPaymentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  oiHasUnpaid?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  oiStates?: Maybe<Array<Scalars['String']['output']>>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationIndustry?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationWebsite?: Maybe<Scalars['String']['output']>;
  overallStage?: Maybe<Scalars['String']['output']>;
  overallStageOrdered: Scalars['String']['output'];
  partsPlaced?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  personContactId?: Maybe<Scalars['Int']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personLanguage?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveOrderValueCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  pipedriveOrderValueMoney: Money;
  pipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  pipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  poAllSamplesConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  poSamplesConfirmationStatuses?: Maybe<Array<Scalars['String']['output']>>;
  poStateLastChange?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  poStates?: Maybe<Array<Scalars['String']['output']>>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  pricingMethod?: Maybe<Array<Scalars['String']['output']>>;
  productionCompleted?: Maybe<Scalars['Boolean']['output']>;
  productionStage?: Maybe<Scalars['String']['output']>;
  productionStageOrdered: Scalars['String']['output'];
  purchaseOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readyForPlacing?: Maybe<Scalars['Boolean']['output']>;
  reasonOfLose?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  repetitiveRelations?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  requiredDocuments: Array<RequiredDocumentsTypeEnumType>;
  salesPersonId?: Maybe<Scalars['BigInt']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  sendOc?: Maybe<Scalars['Boolean']['output']>;
  shippingAddressValue?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  shippingZip?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  teamspaceId?: Maybe<Scalars['BigInt']['output']>;
  /** _allow_array */
  techAuditStatuses?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  techTags?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  techTagsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  toolingGoFormSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totalAmountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  totalAmountBrutCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalAmountBrutMoney: Money;
  totalAmountNetCents?: Maybe<Scalars['BigInt']['output']>;
  totalAmountNetCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalAmountNetMoney: Money;
  totalPaidNettCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  totalPaidNettMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  trialSamplesApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unpaidInvoiceExists: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type WorkspacesDealDocument = {
  __typename?: 'WorkspacesDealDocument';
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingAccountType?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCurrency?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealNumber: Scalars['String']['output'];
  dealObjectId: Scalars['BigInt']['output'];
  dealObjectNumber: Scalars['String']['output'];
  dealObjectType: Scalars['String']['output'];
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  enquiryId?: Maybe<Scalars['BigInt']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  partsTagsMaterials?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  partsTagsMethodFeatures?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  partsTagsMethods?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  partsTagsMethodsHighLevel?: Maybe<Array<Scalars['BigInt']['output']>>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  providerCountry?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['BigInt']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerOrderAllowDirectShipping?: Maybe<Scalars['Boolean']['output']>;
  providerOrderConformityCheck?: Maybe<Scalars['String']['output']>;
  providerOrderCreatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderCurrency?: Maybe<Scalars['String']['output']>;
  providerOrderDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderDeadlineInitial?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderFullyPaidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderId?: Maybe<Scalars['BigInt']['output']>;
  providerOrderIssueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderNumber?: Maybe<Scalars['String']['output']>;
  providerOrderPublished?: Maybe<Scalars['Boolean']['output']>;
  providerOrderState?: Maybe<Scalars['String']['output']>;
  providerOrderTotalValueNettoCents?: Maybe<Scalars['BigInt']['output']>;
  providerOrderTotalValueNettoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  providerOrderTotalValueNettoMoney: Money;
  providerPartnerNetworkManagerId?: Maybe<Scalars['BigInt']['output']>;
  providerPartnerNetworkManagerName?: Maybe<Scalars['String']['output']>;
  providerRegion?: Maybe<Scalars['String']['output']>;
  providerState?: Maybe<Scalars['String']['output']>;
  providerTotalRank?: Maybe<Scalars['Float']['output']>;
  /** _allow_array */
  requiredDocuments: Array<RequiredDocumentsTypeEnumType>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesConfirmationStatusCombined?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verdict: Scalars['String']['output'];
  verdictById?: Maybe<Scalars['BigInt']['output']>;
  verdictByName?: Maybe<Scalars['String']['output']>;
  verdictDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  visibleToCustomer: Scalars['Boolean']['output'];
  visibleToPartner: Scalars['Boolean']['output'];
};

export type WorkspacesDealDocumentsCollection = {
  __typename?: 'WorkspacesDealDocumentsCollection';
  objects: Array<WorkspacesDealDocument>;
  total: Scalars['Int']['output'];
};

export type WorkspacesDealsCollection = {
  __typename?: 'WorkspacesDealsCollection';
  objects: Array<WorkspacesDeal>;
  total: Scalars['Int']['output'];
};

export type WorkspacesDraftingDealPart = {
  __typename?: 'WorkspacesDraftingDealPart';
  auditDrawingReworkTask?: Maybe<Scalars['String']['output']>;
  auditDrawingsReworkedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  auditDrawingsReworkedBy?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  auditUpdatedBy?: Maybe<Array<Scalars['BigInt']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsOpen: Scalars['Int']['output'];
  claimsState?: Maybe<Scalars['String']['output']>;
  claimsTotal: Scalars['Int']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  dealsOpen: Scalars['Int']['output'];
  dealsTotal: Scalars['Int']['output'];
  dimensionsError?: Maybe<Scalars['Boolean']['output']>;
  drawingTaskType?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  enquiryDrawingsReworkedBy?: Maybe<Array<Scalars['BigInt']['output']>>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  kamId?: Maybe<Scalars['Int']['output']>;
  kamName?: Maybe<Scalars['String']['output']>;
  l2gFilesDownloadState?: Maybe<FileDownloadStateEnum>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  minutesSinceLastAudit: Scalars['Int']['output'];
  needInfoAge?: Maybe<Scalars['Int']['output']>;
  orderConfirmationAgeMinutes: Scalars['Int']['output'];
  orderConfirmationCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  orderConfirmationTotalAmountNetCents?: Maybe<Scalars['BigInt']['output']>;
  orderConfirmationTotalAmountNetCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  orderConfirmationTotalAmountNetMoney: Money;
  /** custom _allow_array */
  orderedBy?: Maybe<Array<Scalars['String']['output']>>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  partsCount?: Maybe<Scalars['Int']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personLocale?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  poCount?: Maybe<Scalars['Int']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  productionMethods?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  productionMethodsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  reworkStatus?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  slackLink?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesDraftingDealPartsCollection = {
  __typename?: 'WorkspacesDraftingDealPartsCollection';
  objects: Array<WorkspacesDraftingDealPart>;
  total: Scalars['Int']['output'];
};

export type WorkspacesDraftingEnquiryPart = {
  __typename?: 'WorkspacesDraftingEnquiryPart';
  allDrawingsReworked: Scalars['Boolean']['output'];
  allPartsCleaned: Scalars['Boolean']['output'];
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealIsOnHold?: Maybe<Scalars['Boolean']['output']>;
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  /** _allow_array */
  drawingsReworkedBy?: Maybe<Array<Scalars['BigInt']['output']>>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  partsCount: Scalars['Int']['output'];
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  /** _allow_array */
  process?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  rfqOwners?: Maybe<Array<Scalars['BigInt']['output']>>;
  rfqRequired: Scalars['Boolean']['output'];
  rfqRequiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  rfqStatuses?: Maybe<Array<Scalars['String']['output']>>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesQuotaNeeded?: Maybe<Scalars['Boolean']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesDraftingEnquiryPartsCollection = {
  __typename?: 'WorkspacesDraftingEnquiryPartsCollection';
  objects: Array<WorkspacesDraftingEnquiryPart>;
  total: Scalars['Int']['output'];
};

export type WorkspacesEmailMessage = {
  __typename?: 'WorkspacesEmailMessage';
  createdAt: Scalars['ISO8601Date']['output'];
  /** custom */
  direction: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  mailgunMessageId: Scalars['String']['output'];
  originalContentId?: Maybe<Scalars['BigInt']['output']>;
  parsedContent?: Maybe<Scalars['String']['output']>;
  /** custom */
  primaryMessageId?: Maybe<Scalars['BigInt']['output']>;
  /** custom */
  replyOnId?: Maybe<Scalars['String']['output']>;
  /** custom */
  status: Scalars['String']['output'];
};

export type WorkspacesEmailMessagesCollection = {
  __typename?: 'WorkspacesEmailMessagesCollection';
  objects: Array<WorkspacesEmailMessage>;
  total: Scalars['Int']['output'];
};

export type WorkspacesEnquiriesCollection = {
  __typename?: 'WorkspacesEnquiriesCollection';
  objects: Array<WorkspacesEnquiry>;
  total: Scalars['Int']['output'];
};

export type WorkspacesEnquiriesSfCase = {
  __typename?: 'WorkspacesEnquiriesSfCase';
  /** custom workspace_object */
  additionalRequirements?: Maybe<Scalars['JSON']['output']>;
  aiResponseId: Scalars['BigInt']['output'];
  billingAddressMatch?: Maybe<Scalars['String']['output']>;
  bruttoPriceMatch?: Maybe<Scalars['String']['output']>;
  certificatesMatch?: Maybe<Scalars['String']['output']>;
  checkCreditLimit?: Maybe<Scalars['String']['output']>;
  checkEngineerModeration?: Maybe<Scalars['String']['output']>;
  checkPartDimensions?: Maybe<Scalars['String']['output']>;
  checkPartNames?: Maybe<Scalars['String']['output']>;
  checkPartWeights?: Maybe<Scalars['String']['output']>;
  checkQuoteValidity?: Maybe<Scalars['String']['output']>;
  confirmationStatus: Scalars['String']['output'];
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmedBySfUserId?: Maybe<Scalars['String']['output']>;
  couponMatch?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** custom workspace_object */
  dataForSf?: Maybe<Scalars['JSON']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealNumber?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealTestDeal?: Maybe<Scalars['Boolean']['output']>;
  emailsMatch?: Maybe<Scalars['String']['output']>;
  enquiryId: Scalars['BigInt']['output'];
  enquiryNumber?: Maybe<Scalars['String']['output']>;
  /** custom */
  enquiryReconciliationSummary?: Maybe<Scalars['String']['output']>;
  enquiryState?: Maybe<Scalars['String']['output']>;
  /** custom */
  enquiryValidationSummary?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  feedback?: Maybe<Scalars['JSON']['output']>;
  hasPurchaseOrder: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  latestDeadlineMatch?: Maybe<Scalars['String']['output']>;
  nettoPriceMatch?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  newEmails?: Maybe<Scalars['JSON']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  partsComparison?: Maybe<Scalars['JSON']['output']>;
  /** custom */
  partsStatus?: Maybe<Scalars['String']['output']>;
  partsSummary?: Maybe<Scalars['String']['output']>;
  partsValueMatch?: Maybe<Scalars['String']['output']>;
  paymentTermsMatch?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  /** custom */
  proformaInvoiceRequest?: Maybe<Scalars['String']['output']>;
  /** custom */
  purchaseOrderDisplay?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quoteNumber?: Maybe<Scalars['String']['output']>;
  searchSource?: Maybe<Scalars['String']['output']>;
  sfCaseId: Scalars['String']['output'];
  /** custom */
  sfCaseUrl?: Maybe<Scalars['String']['output']>;
  shippingAddressMatch?: Maybe<Scalars['String']['output']>;
  shippingCostsMatch?: Maybe<Scalars['String']['output']>;
  /** custom */
  statusForSf?: Maybe<Scalars['String']['output']>;
  /** custom */
  unrecognisedParts?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatMatch?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesEnquiriesSfCasesCollection = {
  __typename?: 'WorkspacesEnquiriesSfCasesCollection';
  objects: Array<WorkspacesEnquiriesSfCase>;
  total: Scalars['Int']['output'];
};

export type WorkspacesEnquiry = {
  __typename?: 'WorkspacesEnquiry';
  /** custom */
  additionalServices: Scalars['JSON']['output'];
  assignedEng?: Maybe<Scalars['Int']['output']>;
  assignedEngineerName?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  competitorQuoteLink?: Maybe<Scalars['String']['output']>;
  /** custom */
  conversion?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  /** _allow_array */
  dealIntercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealIsOnHold?: Maybe<Scalars['Boolean']['output']>;
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealSalesforceId?: Maybe<Scalars['String']['output']>;
  dealSource?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  dealTechTags?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  dealTechTagsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  extraKamModerationRequired?: Maybe<Scalars['Boolean']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasCustomerNote: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  kamModerationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** custom */
  lastMessage?: Maybe<Scalars['JSON']['output']>;
  number: Scalars['String']['output'];
  orderedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** custom */
  parts: Scalars['JSON']['output'];
  /** _allow_array */
  partsProcesses?: Maybe<Array<Scalars['String']['output']>>;
  partsValueCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  partsValueMoney: Money;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  productionMethodsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  quotationMethod?: Maybe<Scalars['String']['output']>;
  quotingState?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  repetitiveRelations?: Maybe<Array<Scalars['String']['output']>>;
  rfqAge?: Maybe<Scalars['Int']['output']>;
  rfqAutoassignmentSegment?: Maybe<Scalars['String']['output']>;
  rfqFeedback: Scalars['Boolean']['output'];
  rfqIsUrgent?: Maybe<Scalars['Boolean']['output']>;
  rfqNeedEngineer?: Maybe<Scalars['Boolean']['output']>;
  rfqNeedInfo?: Maybe<Scalars['Boolean']['output']>;
  rfqNeedInfoAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  rfqOwnerIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  rfqOwnerNames?: Maybe<Scalars['String']['output']>;
  rfqPartsCleaned: Scalars['Boolean']['output'];
  /** _allow_array */
  rfqStatuses?: Maybe<Array<Scalars['String']['output']>>;
  rfqStatusesMapsChangedAt?: Maybe<Scalars['JSON']['output']>;
  rfqsInterestedResponsesCount: Scalars['Int']['output'];
  rfqsRejectedResponsesCount: Scalars['Int']['output'];
  rfqsSubmittedResponsesCount: Scalars['Int']['output'];
  salesAssistantId?: Maybe<Scalars['BigInt']['output']>;
  salesAssistantName?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['BigInt']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesQuotaNeeded?: Maybe<Scalars['Boolean']['output']>;
  shippingAddressName?: Maybe<Scalars['String']['output']>;
  shippingCostCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  shippingCostMoney: Money;
  state: Scalars['String']['output'];
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalAmountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  totalAmountBrutMoney: Money;
  totalAmountNetCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  totalAmountNetMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vatAmountCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  vatAmountMoney: Money;
};

export type WorkspacesEnquiryPromotion = {
  __typename?: 'WorkspacesEnquiryPromotion';
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountAmountCents: Scalars['BigInt']['output'];
  discountAmountPercent: Scalars['BigInt']['output'];
  discountUnit: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type WorkspacesEnquiryPromotionsCollection = {
  __typename?: 'WorkspacesEnquiryPromotionsCollection';
  objects: Array<WorkspacesEnquiryPromotion>;
  total: Scalars['Int']['output'];
};

export type WorkspacesFrameworkBatch = {
  __typename?: 'WorkspacesFrameworkBatch';
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  billingAccountTaxId?: Maybe<Scalars['String']['output']>;
  billingAccountType?: Maybe<Scalars['String']['output']>;
  billingAccountVatId?: Maybe<Scalars['String']['output']>;
  billingAccountVatValidationStatus?: Maybe<Scalars['String']['output']>;
  billingAccountVatValidationTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  billingAddressValue?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  confirmDate?: Maybe<Scalars['ISO8601Date']['output']>;
  consistencyCheck?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency: Scalars['String']['output'];
  /** custom workspace_object */
  customerInvoicesSumNettoMoney?: Maybe<Money>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  deadlineAlarm?: Maybe<Scalars['Boolean']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealIsBigOrHeavy?: Maybe<Scalars['Boolean']['output']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  deliveryDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  deliveryDueDays?: Maybe<Scalars['Int']['output']>;
  drawingCleanupStatus?: Maybe<Scalars['String']['output']>;
  enquiryId?: Maybe<Scalars['BigInt']['output']>;
  euCustoms?: Maybe<Scalars['Boolean']['output']>;
  frameworkAgreement: Scalars['Boolean']['output'];
  frameworkBatchClientSchedule: Scalars['Boolean']['output'];
  frameworkBatchDate?: Maybe<Scalars['ISO8601Date']['output']>;
  frameworkBatchDaysLeft?: Maybe<Scalars['Int']['output']>;
  frameworkBatchFulfilledQuantity: Scalars['Int']['output'];
  frameworkBatchFulfilledValueCents?: Maybe<Scalars['BigInt']['output']>;
  frameworkBatchFulfilledValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  frameworkBatchFulfilledValueMoney: Money;
  frameworkBatchQuantity: Scalars['Int']['output'];
  frameworkBatchRemainingQuantity: Scalars['Int']['output'];
  frameworkBatchType?: Maybe<Scalars['String']['output']>;
  frameworkBatchValueCents?: Maybe<Scalars['BigInt']['output']>;
  frameworkBatchValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  frameworkBatchValueMoney: Money;
  grade?: Maybe<Scalars['String']['output']>;
  /** custom */
  hasCustomerCreditNote?: Maybe<Scalars['Boolean']['output']>;
  hasCustomerInvoice: Scalars['Boolean']['output'];
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting: Scalars['Boolean']['output'];
  isFullyInvoiced: Scalars['Boolean']['output'];
  isFullyPaid: Scalars['Boolean']['output'];
  isFullyShipped: Scalars['Boolean']['output'];
  isHighValue: Scalars['Boolean']['output'];
  isImportant?: Maybe<Scalars['Boolean']['output']>;
  isNpg: Scalars['Boolean']['output'];
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  kamId?: Maybe<Scalars['Int']['output']>;
  kamName?: Maybe<Scalars['String']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  /** custom */
  number?: Maybe<Scalars['String']['output']>;
  ocPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationIndustry?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationWebsite?: Maybe<Scalars['String']['output']>;
  overallStage?: Maybe<Scalars['String']['output']>;
  overallStageOrdered: Scalars['String']['output'];
  partsPlaced?: Maybe<Scalars['String']['output']>;
  personContactId?: Maybe<Scalars['Int']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personLanguage?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pipedriveOrderValueCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  pipedriveOrderValueMoney: Money;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  pricingMethod?: Maybe<Array<Scalars['String']['output']>>;
  productionCompleted?: Maybe<Scalars['Boolean']['output']>;
  productionStage?: Maybe<Scalars['String']['output']>;
  productionStageOrdered: Scalars['String']['output'];
  purchaseOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readyForPlacing?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  requiredDocuments: Array<RequiredDocumentsTypeEnumType>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  sendOc?: Maybe<Scalars['Boolean']['output']>;
  shippingAddressValue?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  shippingZip?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  techAuditStatuses?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  techTags?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  techTagsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalAmountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  totalAmountBrutCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalAmountBrutMoney: Money;
  totalAmountNetCents?: Maybe<Scalars['BigInt']['output']>;
  totalAmountNetCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalAmountNetMoney: Money;
  totalPaidNettCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  totalPaidNettMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type WorkspacesFrameworkBatchesCollection = {
  __typename?: 'WorkspacesFrameworkBatchesCollection';
  objects: Array<WorkspacesFrameworkBatch>;
  total: Scalars['Int']['output'];
};

export type WorkspacesHsCode = {
  __typename?: 'WorkspacesHsCode';
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  /** _allow_array */
  direction?: Maybe<Array<Scalars['String']['output']>>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  partId: Scalars['Int']['output'];
  partName?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  poDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  shippingState?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesHsCodesCollection = {
  __typename?: 'WorkspacesHsCodesCollection';
  objects: Array<WorkspacesHsCode>;
  total: Scalars['Int']['output'];
};

export type WorkspacesIncomingInvoice = {
  __typename?: 'WorkspacesIncomingInvoice';
  /** workspace_object */
  activeChangeRequest?: Maybe<WorkspacesProviderChangeRequest>;
  activeVatExemptionCertificate?: Maybe<Scalars['ISO8601Date']['output']>;
  amountLeftCents?: Maybe<Scalars['BigInt']['output']>;
  amountLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  amountLeftMoney: Money;
  approvedByManager?: Maybe<Scalars['String']['output']>;
  approvedByManagerAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  baType?: Maybe<Scalars['String']['output']>;
  baVatCountry?: Maybe<Scalars['String']['output']>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  businessVerdicts?: Maybe<Array<Scalars['String']['output']>>;
  checkedByFinance?: Maybe<Scalars['String']['output']>;
  checkedByFinanceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNote: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  datevComment?: Maybe<Scalars['String']['output']>;
  datevVatCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealProviderOrderId: Scalars['BigInt']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  holdUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  icCustomer?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  intacctComment?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  invoiceChecked?: Maybe<Scalars['JSON']['output']>;
  invoicePartnerCountry?: Maybe<Scalars['String']['output']>;
  invoicePartnerLegalName?: Maybe<Scalars['String']['output']>;
  invoicePartnerLegalNameLower?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  invoicePrepared?: Maybe<Scalars['JSON']['output']>;
  /** custom workspace_object */
  invoiceReady?: Maybe<Scalars['JSON']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isPartial: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organizationCountry?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  organizationVatId?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  partnerBankName?: Maybe<Scalars['String']['output']>;
  partnerBic?: Maybe<Scalars['String']['output']>;
  partnerCountry?: Maybe<Scalars['String']['output']>;
  partnerIban?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  partnerLegalName?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerPayoutTransferType?: Maybe<Scalars['String']['output']>;
  partnerRank?: Maybe<Scalars['Float']['output']>;
  /** _allow_array */
  partnerSegments?: Maybe<Array<Scalars['Int']['output']>>;
  partnerState?: Maybe<Scalars['String']['output']>;
  paymentDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentDueDays?: Maybe<Scalars['Int']['output']>;
  /** custom workspace_object */
  payouts?: Maybe<Array<WorkspacesIncomingInvoicePayout>>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  poComment?: Maybe<Scalars['String']['output']>;
  poConformityCheck?: Maybe<Scalars['String']['output']>;
  poFullyPaidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  poLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  poPayouts?: Maybe<Array<WorkspacesIncomingInvoicePayout>>;
  poState?: Maybe<Scalars['String']['output']>;
  poValueCents?: Maybe<Scalars['BigInt']['output']>;
  poValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  poValueMoney: Money;
  podId?: Maybe<Scalars['Int']['output']>;
  prVatPayer?: Maybe<Scalars['Boolean']['output']>;
  preparedByPartner?: Maybe<Scalars['String']['output']>;
  preparedByPartnerAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  providerOrderId: Scalars['BigInt']['output'];
  providerPartnerSuccessManagerId?: Maybe<Scalars['BigInt']['output']>;
  providerPartnerSuccessManagerName?: Maybe<Scalars['String']['output']>;
  /** workspace_object */
  refInvoice?: Maybe<RefInvoice>;
  /** custom workspace_object */
  refunds?: Maybe<Array<WorkspacesIncomingInvoicePayout>>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** _allow_array */
  relatedShippings?: Maybe<Array<Scalars['BigInt']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sachkontoNumber?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  selfBilling?: Maybe<Scalars['Boolean']['output']>;
  shippingDestination?: Maybe<Scalars['String']['output']>;
  shippingDirection?: Maybe<Scalars['String']['output']>;
  shippingIsExport?: Maybe<Scalars['Boolean']['output']>;
  shippingIsImport?: Maybe<Scalars['Boolean']['output']>;
  shippingIsImportAndExport?: Maybe<Scalars['Boolean']['output']>;
  shippingNoInvoiceRequired?: Maybe<Scalars['Boolean']['output']>;
  shippingOrigin?: Maybe<Scalars['String']['output']>;
  shippingState?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  techVerdicts?: Maybe<Array<Scalars['String']['output']>>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalAmountBruttoCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  totalAmountBruttoMoney: Money;
  totalAmountNettoCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  totalAmountNettoMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validity?: Maybe<Scalars['String']['output']>;
  vatAmountCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  vatAmountMoney: Money;
  vatAvg?: Maybe<Scalars['Float']['output']>;
  vatPdfCorrectionRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkspacesIncomingInvoicePayout = {
  __typename?: 'WorkspacesIncomingInvoicePayout';
  amountMoney: Money;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isRefund: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesIncomingInvoicesCollection = {
  __typename?: 'WorkspacesIncomingInvoicesCollection';
  objects: Array<WorkspacesIncomingInvoice>;
  total: Scalars['Int']['output'];
};

/** Export column settings */
export type WorkspacesInputsExportColumnType = {
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Attributes for paginating workspaces */
export type WorkspacesInputsGenericPaginationType = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

/** Attributes for sorting workspaces records */
export type WorkspacesInputsGenericSortingType = {
  direction?: InputMaybe<SortDirectionEnum>;
  sortBy: Scalars['String']['input'];
};

export type WorkspacesIntacctEvent = {
  __typename?: 'WorkspacesIntacctEvent';
  action: Scalars['String']['output'];
  billingAccountId?: Maybe<Scalars['BigInt']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** custom workspace_object */
  extraData: Scalars['JSON']['output'];
  id: Scalars['BigInt']['output'];
  /** custom workspace_object */
  payload: Scalars['JSON']['output'];
  providerId?: Maybe<Scalars['BigInt']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  requestSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom workspace_object */
  responses: Array<Scalars['JSON']['output']>;
  retryLeftCount: Scalars['BigInt']['output'];
  sourceId: Scalars['BigInt']['output'];
  sourceType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['BigInt']['output'];
};

export type WorkspacesIntacctEventsCollection = {
  __typename?: 'WorkspacesIntacctEventsCollection';
  objects: Array<WorkspacesIntacctEvent>;
  total: Scalars['Int']['output'];
};

export type WorkspacesJob = {
  __typename?: 'WorkspacesJob';
  /** custom workspace_object */
  acceptedOffer?: Maybe<WorkspacesAcceptedJobOffer>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  customerLotsValueCents: Scalars['BigInt']['output'];
  customerLotsValueCurrency: Scalars['String']['output'];
  /** custom workspace_object */
  customerLotsValueMoney: Money;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  /** custom */
  offersCountActionable?: Maybe<Scalars['Int']['output']>;
  /** custom */
  offersCountTotal?: Maybe<Scalars['Int']['output']>;
  /** custom */
  offersCountViewed?: Maybe<Scalars['Int']['output']>;
  /** workspace_object */
  organization?: Maybe<WorkspacesJobOrganization>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** workspace_object */
  owner?: Maybe<WorkspacesJobUser>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** custom workspace_object */
  providerOrder?: Maybe<WorkspacesJobProviderOrder>;
  publicationEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publicationStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom */
  responsesApplication?: Maybe<Scalars['Int']['output']>;
  /** custom */
  responsesCounteroffer?: Maybe<Scalars['Int']['output']>;
  /** custom */
  responsesIrrelevant?: Maybe<Scalars['Int']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  /** _allow_array */
  tags?: Maybe<Array<Scalars['Int']['output']>>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  valueCents: Scalars['BigInt']['output'];
  valueCurrency: Scalars['String']['output'];
  /** custom workspace_object */
  valueMoney: Money;
};

export type WorkspacesJobOffer = {
  __typename?: 'WorkspacesJobOffer';
  allowAutoConfirmation?: Maybe<Scalars['Boolean']['output']>;
  allowCounterofferFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  allowDirectShipping?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  bonusAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  bonusCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  bonusMoney: Money;
  claimsState?: Maybe<Scalars['String']['output']>;
  counterofferLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  counterofferValueCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  counterofferValueMoney: Money;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dapCostsApproxCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  dapCostsApproxMoney: Money;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  decidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  decidedBy?: Maybe<Scalars['Int']['output']>;
  decisionComment?: Maybe<Scalars['String']['output']>;
  decisionRefusalReason?: Maybe<Scalars['String']['output']>;
  decisionState?: Maybe<Scalars['String']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isUrgent: Scalars['Boolean']['output'];
  jobCustomerLotsValueCents?: Maybe<Scalars['BigInt']['output']>;
  jobCustomerLotsValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  jobCustomerLotsValueMoney: Money;
  jobId: Scalars['BigInt']['output'];
  jobOwnerId?: Maybe<Scalars['BigInt']['output']>;
  jobState?: Maybe<Scalars['String']['output']>;
  leadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  logisticCostEstCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  logisticCostEstMoney: Money;
  marginForecast?: Maybe<Scalars['Float']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  providerAne?: Maybe<Scalars['Float']['output']>;
  providerCancellationRatio?: Maybe<Scalars['Float']['output']>;
  providerClaimRatio?: Maybe<Scalars['Float']['output']>;
  providerCountry?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['BigInt']['output'];
  providerLastVisitAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerOrderId?: Maybe<Scalars['Int']['output']>;
  providerPartnerNetworkManagerId?: Maybe<Scalars['BigInt']['output']>;
  providerPartnerNetworkManagerName?: Maybe<Scalars['String']['output']>;
  providerPoCountDone: Scalars['Int']['output'];
  providerQuality?: Maybe<Scalars['Int']['output']>;
  providerRank?: Maybe<Scalars['Float']['output']>;
  providerRegion?: Maybe<Scalars['String']['output']>;
  providerShippedOrdersCount?: Maybe<Scalars['Int']['output']>;
  providerState?: Maybe<Scalars['String']['output']>;
  providerTiming?: Maybe<Scalars['Int']['output']>;
  providerTimingRatio?: Maybe<Scalars['Float']['output']>;
  publicComment?: Maybe<Scalars['String']['output']>;
  publicationEnd: Scalars['ISO8601DateTime']['output'];
  publicationStart: Scalars['ISO8601DateTime']['output'];
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  respondedBy?: Maybe<Scalars['Int']['output']>;
  responseComment?: Maybe<Scalars['String']['output']>;
  responseRefusalReason?: Maybe<Scalars['String']['output']>;
  responseState?: Maybe<Scalars['String']['output']>;
  responseStateSorted?: Maybe<Scalars['Int']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  showPositionPrices?: Maybe<Scalars['Boolean']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalPoInProgress?: Maybe<Scalars['Int']['output']>;
  /** custom workspace_object */
  totalPriceAfterLogistics: WorkspacesJobOffersTotalPriceType;
  /** custom workspace_object */
  totalPriceBeforeLogistics: WorkspacesJobOffersTotalPriceType;
  totalValueForAllPoInProgress?: Maybe<Scalars['Float']['output']>;
  /** custom workspace_object */
  totalValueMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  valueCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  valueMoney: Money;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zendeskTicketId?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesJobOffersCollection = {
  __typename?: 'WorkspacesJobOffersCollection';
  objects: Array<WorkspacesJobOffer>;
  total: Scalars['Int']['output'];
};

export type WorkspacesJobOffersTotalPriceType = {
  __typename?: 'WorkspacesJobOffersTotalPriceType';
  counterofferPriceMargin?: Maybe<Scalars['Float']['output']>;
  counterofferPriceMoney: Money;
  offerPriceMargin?: Maybe<Scalars['Float']['output']>;
  offerPriceMoney: Money;
};

export type WorkspacesJobOrganization = {
  __typename?: 'WorkspacesJobOrganization';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerOrderGrade?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesJobProviderOrder = {
  __typename?: 'WorkspacesJobProviderOrder';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  partsValueNetto?: Maybe<Money>;
  servicesValueNetto?: Maybe<Money>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesJobUser = {
  __typename?: 'WorkspacesJobUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkspacesJobsCollection = {
  __typename?: 'WorkspacesJobsCollection';
  objects: Array<WorkspacesJob>;
  total: Scalars['Int']['output'];
};

export type WorkspacesLogisticInvoice = {
  __typename?: 'WorkspacesLogisticInvoice';
  account58000AddCostsCents?: Maybe<Scalars['BigInt']['output']>;
  account58000AddCostsCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  account58000AddCostsMoney: Money;
  account58400CustomsCents?: Maybe<Scalars['BigInt']['output']>;
  account58400CustomsCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  account58400CustomsMoney: Money;
  account58401ServicesCents?: Maybe<Scalars['BigInt']['output']>;
  account58401ServicesCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  account58401ServicesMoney: Money;
  account59040FreightCents?: Maybe<Scalars['BigInt']['output']>;
  account59040FreightCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  account59040FreightMoney: Money;
  accountId?: Maybe<Scalars['String']['output']>;
  amountBruttoCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  amountBruttoMoney: Money;
  amountNettoCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  amountNettoMoney: Money;
  billingAccountDirectDebit?: Maybe<Scalars['Boolean']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdById?: Maybe<Scalars['BigInt']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  creditNote: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  financeCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  financeCheckedByName?: Maybe<Scalars['String']['output']>;
  fullyAllocated: Scalars['Boolean']['output'];
  hasLogisticPayouts: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  isImported: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  logisticOperatorName?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  operationCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  operationCheckedByName?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  parentInvoiceNumber?: Maybe<Scalars['String']['output']>;
  paymentDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedById?: Maybe<Scalars['BigInt']['output']>;
  publishedByName?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom workspace_object */
  relatedShippings?: Maybe<Array<LogisticInvoiceRelatedShipping>>;
  state: Scalars['String']['output'];
};

export type WorkspacesLogisticInvoicesCollection = {
  __typename?: 'WorkspacesLogisticInvoicesCollection';
  objects: Array<WorkspacesLogisticInvoice>;
  total: Scalars['Int']['output'];
};

export type WorkspacesMessage = {
  __typename?: 'WorkspacesMessage';
  /** _allow_array */
  assigneeNames?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  assigneePods?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  assignees?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  authorId?: Maybe<Scalars['BigInt']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  authorProviderId?: Maybe<Scalars['BigInt']['output']>;
  authorType?: Maybe<MessagesWorkspaceAuthorTypeEnum>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  ownerIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  ownerNames?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  ownerTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** custom */
  parentId?: Maybe<Scalars['BigInt']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  process?: Maybe<Array<Scalars['String']['output']>>;
  providerId?: Maybe<Scalars['BigInt']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  taskCompletedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  taskCompletedBy?: Maybe<Scalars['BigInt']['output']>;
  taskDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  taskPriority?: Maybe<Scalars['String']['output']>;
  taskSetAt?: Maybe<Scalars['ISO8601Date']['output']>;
  taskStatus?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  unread?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkspacesMessagesCollection = {
  __typename?: 'WorkspacesMessagesCollection';
  objects: Array<WorkspacesMessage>;
  total: Scalars['Int']['output'];
};

export type WorkspacesOrganization = {
  __typename?: 'WorkspacesOrganization';
  claimRate?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerOrderGrade?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  dealsLastCreated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealsLastId?: Maybe<Scalars['Int']['output']>;
  dealsLastPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealsTotal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['BigInt']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  kamId?: Maybe<Scalars['Int']['output']>;
  kamName?: Maybe<Scalars['String']['output']>;
  lastPersonEmail?: Maybe<Scalars['String']['output']>;
  lastPersonId?: Maybe<Scalars['Int']['output']>;
  lastPersonLanguage?: Maybe<Scalars['String']['output']>;
  lastPersonName?: Maybe<Scalars['String']['output']>;
  lastPersonPhone?: Maybe<Scalars['String']['output']>;
  lastPersonPipedriveId?: Maybe<Scalars['Int']['output']>;
  movedFromRegion?: Maybe<CustomerSourceRegionEnum>;
  name: Scalars['String']['output'];
  /** custom */
  number: Scalars['String']['output'];
  openClaims?: Maybe<Scalars['Int']['output']>;
  ordersBookedRevenueCents?: Maybe<Scalars['BigInt']['output']>;
  ordersBookedRevenueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  ordersBookedRevenueMoney: Money;
  ordersLastCreated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ordersLastId?: Maybe<Scalars['Int']['output']>;
  ordersLastPipedriveId?: Maybe<Scalars['Int']['output']>;
  ordersTotal?: Maybe<Scalars['Int']['output']>;
  personsTotal?: Maybe<Scalars['Int']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  teamspaceIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesOrganizationBalance = {
  __typename?: 'WorkspacesOrganizationBalance';
  balanceBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  balanceBruttoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  balanceBruttoMoney: Money;
  currency?: Maybe<Scalars['String']['output']>;
  currentDueCents?: Maybe<Scalars['BigInt']['output']>;
  currentDueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  currentDueMoney: Money;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['BigInt']['output'];
  invoicedBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  invoicedBruttoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  invoicedBruttoMoney: Money;
  organizationCountry?: Maybe<Scalars['String']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationPmId?: Maybe<Scalars['Int']['output']>;
  organizationPmName?: Maybe<Scalars['String']['output']>;
  overdueAbove30DaysCents?: Maybe<Scalars['BigInt']['output']>;
  overdueAbove30DaysCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  overdueAbove30DaysMoney: Money;
  overdueBelow30DaysCents?: Maybe<Scalars['BigInt']['output']>;
  overdueBelow30DaysCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  overdueBelow30DaysMoney: Money;
  overdueBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  overdueBruttoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  overdueBruttoMoney: Money;
  paidBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  paidBruttoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  paidBruttoMoney: Money;
  prepaymentsCents?: Maybe<Scalars['BigInt']['output']>;
  prepaymentsCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  prepaymentsMoney: Money;
};

export type WorkspacesOrganizationBalancesCollection = {
  __typename?: 'WorkspacesOrganizationBalancesCollection';
  objects: Array<WorkspacesOrganizationBalance>;
  total: Scalars['Int']['output'];
};

export type WorkspacesOrganizationBalancesTotalAmounts = {
  __typename?: 'WorkspacesOrganizationBalancesTotalAmounts';
  totalBalanceBrutto: Money;
  totalCurrentDue: Money;
  totalInvoicedBrutto: Money;
  totalOverdueBrutto: Money;
  totalPaidBrutto: Money;
  totalPrepayments: Money;
};

export type WorkspacesOrganizationsCollection = {
  __typename?: 'WorkspacesOrganizationsCollection';
  objects: Array<WorkspacesOrganization>;
  total: Scalars['Int']['output'];
};

export type WorkspacesOutcomingInvoice = {
  __typename?: 'WorkspacesOutcomingInvoice';
  accrualAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  autoCreatedById?: Maybe<Scalars['BigInt']['output']>;
  autoPublished: Scalars['Boolean']['output'];
  baAccountType?: Maybe<Scalars['String']['output']>;
  baCountry?: Maybe<Scalars['String']['output']>;
  baId?: Maybe<Scalars['Int']['output']>;
  baIntacctId?: Maybe<Scalars['String']['output']>;
  baName?: Maybe<Scalars['String']['output']>;
  baNameLower?: Maybe<Scalars['String']['output']>;
  baTaxId?: Maybe<Scalars['String']['output']>;
  baVatId?: Maybe<Scalars['String']['output']>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  cachedPersonEmail?: Maybe<Scalars['String']['output']>;
  cachedPersonName?: Maybe<Scalars['String']['output']>;
  cachedPersonPhone?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  creditNote: Scalars['Boolean']['output'];
  creditNoteReason?: Maybe<OutcomingInvoicesCreditNoteReasonEnumType>;
  currency?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  datevComment?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasUncompletedAccrualRequestTask: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  innerComment?: Maybe<Scalars['String']['output']>;
  intacctComment?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  invoiceBalanceCents?: Maybe<Scalars['BigInt']['output']>;
  invoiceBalanceCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  invoiceBalanceMoney: Money;
  invoiceCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoiceCheckedBy?: Maybe<Scalars['String']['output']>;
  invoiceNeedFixAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoiceNeedFixBy?: Maybe<Scalars['String']['output']>;
  invoiceReadyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoiceReadyBy?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isStorno: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  orderConfirmationTotalAmountBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  orderConfirmationTotalAmountBruttoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  orderConfirmationTotalAmountBruttoMoney: Money;
  orderConfirmationTotalAmountNettoCents?: Maybe<Scalars['BigInt']['output']>;
  orderConfirmationTotalAmountNettoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  orderConfirmationTotalAmountNettoMoney: Money;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentTermsDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentTermsType?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  positionsDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  purchaseOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  refPositionsSources?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  rejectedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  sachkontoNumber?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sendReminders?: Maybe<Scalars['Boolean']['output']>;
  state: Scalars['String']['output'];
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  toBePaidAmountCents?: Maybe<Scalars['BigInt']['output']>;
  toBePaidAmountCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  toBePaidAmountMoney: Money;
  totalAmountBruttoCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  totalAmountBruttoMoney: Money;
  totalAmountNettoCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  totalAmountNettoMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  vatAmountCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  vatAmountMoney: Money;
  vatAvg?: Maybe<Scalars['Float']['output']>;
};

export type WorkspacesOutcomingInvoiceTotalAmounts = {
  __typename?: 'WorkspacesOutcomingInvoiceTotalAmounts';
  totalAmountBrutto: Money;
  totalAmountNetto: Money;
};

export type WorkspacesOutcomingInvoicesCollection = {
  __typename?: 'WorkspacesOutcomingInvoicesCollection';
  objects: Array<WorkspacesOutcomingInvoice>;
  total: Scalars['Int']['output'];
};

export type WorkspacesPayment = {
  __typename?: 'WorkspacesPayment';
  amountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  amountBrutLeftCents?: Maybe<Scalars['BigInt']['output']>;
  amountBrutLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  amountBrutLeftMoney: Money;
  /** custom workspace_object */
  amountBrutMoney: Money;
  amountFeeCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  amountFeeMoney: Money;
  amountNetCents?: Maybe<Scalars['BigInt']['output']>;
  amountNetLeftCents?: Maybe<Scalars['BigInt']['output']>;
  amountNetLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  amountNetLeftMoney: Money;
  /** custom workspace_object */
  amountNetMoney: Money;
  amountReceivedCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  amountReceivedMoney: Money;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingAddressCompanyName?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedByUsersName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerIntacctId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealPmEmail?: Maybe<Scalars['String']['output']>;
  dealPmName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  intacctComment?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isRefund: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentBalanceCents?: Maybe<Scalars['BigInt']['output']>;
  paymentBalanceCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  paymentBalanceMoney: Money;
  paymentMethodName?: Maybe<Scalars['String']['output']>;
  paymentMethodOrderId?: Maybe<Scalars['String']['output']>;
  paymentMethodTransactionId?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  refAmountBrutLeftCents?: Maybe<Scalars['BigInt']['output']>;
  refAmountBrutLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refAmountBrutLeftMoney: Money;
  refAmountNetLeftCents?: Maybe<Scalars['BigInt']['output']>;
  refAmountNetLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refAmountNetLeftMoney: Money;
  refNumber?: Maybe<Scalars['String']['output']>;
  refPaymentMethodName?: Maybe<Scalars['String']['output']>;
  refPaymentMethodOrderId?: Maybe<Scalars['String']['output']>;
  refPaymentMethodTransactionId?: Maybe<Scalars['String']['output']>;
  refRefundedBrutCents?: Maybe<Scalars['BigInt']['output']>;
  refRefundedBrutCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refRefundedBrutMoney: Money;
  refRefundedNetCents?: Maybe<Scalars['BigInt']['output']>;
  refRefundedNetCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refRefundedNetMoney: Money;
  refundedBrutCents?: Maybe<Scalars['BigInt']['output']>;
  refundedBrutCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refundedBrutMoney: Money;
  refundedNetCents?: Maybe<Scalars['BigInt']['output']>;
  refundedNetCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refundedNetMoney: Money;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  stripePayoutEffectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601Date']['output'];
  vatCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  vatMoney: Money;
  vatPercent?: Maybe<Scalars['Float']['output']>;
};

export type WorkspacesPaymentsCollection = {
  __typename?: 'WorkspacesPaymentsCollection';
  objects: Array<WorkspacesPayment>;
  total: Scalars['Int']['output'];
};

export type WorkspacesPayout = {
  __typename?: 'WorkspacesPayout';
  /** workspace_object */
  activeChangeRequest?: Maybe<WorkspacesProviderChangeRequest>;
  amountCents: Scalars['BigInt']['output'];
  /** custom workspace_object */
  amountMoney: Money;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** workspace_object */
  approvedBy?: Maybe<WorkspacesPayoutUser>;
  approvedById?: Maybe<Scalars['BigInt']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fastPay: Scalars['Boolean']['output'];
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  instantPay: Scalars['Boolean']['output'];
  intacctComment?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  invoiceDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoiceHoldUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isRefund: Scalars['Boolean']['output'];
  methodId?: Maybe<Scalars['BigInt']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  partnerLegalNameLower?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  partnerSegments?: Maybe<Array<Scalars['Int']['output']>>;
  paymentDetails?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  prepayment: Scalars['Boolean']['output'];
  /** workspace_object */
  provider?: Maybe<WorkspacesPayoutProvider>;
  providerIban?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['BigInt']['output'];
  providerOrderNumber?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  reference?: Maybe<Scalars['JSON']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['BigInt']['output'];
  sourceType: Scalars['String']['output'];
  state: Scalars['String']['output'];
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesPayoutProvider = {
  __typename?: 'WorkspacesPayoutProvider';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payoutTransferType?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesPayoutTotalAmounts = {
  __typename?: 'WorkspacesPayoutTotalAmounts';
  totalAmount: Money;
};

export type WorkspacesPayoutUpdatedUser = {
  __typename?: 'WorkspacesPayoutUpdatedUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkspacesPayoutUser = {
  __typename?: 'WorkspacesPayoutUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkspacesPayoutsCollection = {
  __typename?: 'WorkspacesPayoutsCollection';
  objects: Array<WorkspacesPayout>;
  total: Scalars['Int']['output'];
};

export type WorkspacesPerson = {
  __typename?: 'WorkspacesPerson';
  billingAccountAddress?: Maybe<Scalars['String']['output']>;
  billingAccountCity?: Maybe<Scalars['String']['output']>;
  billingAccountCountry?: Maybe<Scalars['String']['output']>;
  billingAccountJoinedId?: Maybe<Scalars['Int']['output']>;
  billingAccountName?: Maybe<Scalars['String']['output']>;
  billingAccountTaxId?: Maybe<Scalars['String']['output']>;
  billingAccountType?: Maybe<Scalars['String']['output']>;
  billingAccountVatId?: Maybe<Scalars['String']['output']>;
  billingAccountVatValidationStatus?: Maybe<Scalars['String']['output']>;
  billingAccountZip?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  claimRate?: Maybe<Scalars['Float']['output']>;
  contactCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contactLastVisitedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contactVerifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealsLastAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealsLastId?: Maybe<Scalars['Int']['output']>;
  dealsLastPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealsTotal: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  /** _allow_array */
  invoiceEmails?: Maybe<Array<Scalars['String']['output']>>;
  isRobot: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  mailingSuspendedTill?: Maybe<Scalars['ISO8601Date']['output']>;
  mailingsSubscription?: Maybe<Scalars['String']['output']>;
  movedFromRegion?: Maybe<CustomerSourceRegionEnum>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  nps?: Maybe<Scalars['String']['output']>;
  openClaims?: Maybe<Scalars['Int']['output']>;
  ordersLastAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ordersLastId?: Maybe<Scalars['Int']['output']>;
  ordersLastPipedriveId?: Maybe<Scalars['Int']['output']>;
  ordersTotal: Scalars['Int']['output'];
  ordersTotalValueCents?: Maybe<Scalars['BigInt']['output']>;
  ordersTotalValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  ordersTotalValueMoney: Money;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationIndustry?: Maybe<Scalars['String']['output']>;
  organizationJoinedId?: Maybe<Scalars['Int']['output']>;
  organizationKamId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  shippingAddressCity?: Maybe<Scalars['String']['output']>;
  shippingAddressCompanyName?: Maybe<Scalars['String']['output']>;
  shippingAddressContactName?: Maybe<Scalars['String']['output']>;
  shippingAddressContactPhone?: Maybe<Scalars['String']['output']>;
  shippingAddressCountry?: Maybe<Scalars['String']['output']>;
  shippingAddressId?: Maybe<Scalars['Int']['output']>;
  shippingAddressLine?: Maybe<Scalars['String']['output']>;
  shippingAddressZip?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  teamspaceData?: Maybe<Scalars['JSON']['output']>;
  /** _allow_array */
  teamspaceIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  teamspaceNames?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  teamspaceRoles?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesPersonsCollection = {
  __typename?: 'WorkspacesPersonsCollection';
  objects: Array<WorkspacesPerson>;
  total: Scalars['Int']['output'];
};

export type WorkspacesProductionScheduleItem = {
  __typename?: 'WorkspacesProductionScheduleItem';
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvedById?: Maybe<Scalars['BigInt']['output']>;
  approvedByName?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId: Scalars['BigInt']['output'];
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  providerCountry?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['BigInt']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerOrderAllowDirectShipping?: Maybe<Scalars['Boolean']['output']>;
  providerOrderConformityCheck?: Maybe<Scalars['String']['output']>;
  providerOrderDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderFullyPaidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderId: Scalars['BigInt']['output'];
  providerOrderIssueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  providerOrderNumber?: Maybe<Scalars['String']['output']>;
  providerOrderState?: Maybe<Scalars['String']['output']>;
  providerOrderTotalValueNettoCents?: Maybe<Scalars['BigInt']['output']>;
  providerOrderTotalValueNettoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  providerOrderTotalValueNettoMoney: Money;
  providerState?: Maybe<Scalars['String']['output']>;
  providerTotalRank?: Maybe<Scalars['Float']['output']>;
  respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  respondedByProviderId?: Maybe<Scalars['BigInt']['output']>;
  respondedByProviderName?: Maybe<Scalars['String']['output']>;
  respondedByUserId?: Maybe<Scalars['BigInt']['output']>;
  respondedByUserName?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  stageDate?: Maybe<Scalars['ISO8601Date']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  stageNameCustom?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesProductionScheduleItemsCollection = {
  __typename?: 'WorkspacesProductionScheduleItemsCollection';
  objects: Array<WorkspacesProductionScheduleItem>;
  total: Scalars['Int']['output'];
};

export type WorkspacesProvider = {
  __typename?: 'WorkspacesProvider';
  acceptSelfBilling?: Maybe<Scalars['Boolean']['output']>;
  /** workspace_object */
  activeChangeRequest?: Maybe<WorkspacesProviderChangeRequest>;
  allowAutoacceptOffers?: Maybe<Scalars['Boolean']['output']>;
  allowAutoacceptOffersFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  allowDirectshipOrders?: Maybe<Scalars['Boolean']['output']>;
  allowDirectshipOrdersFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  /** _allow_array */
  approvedTags?: Maybe<Array<Scalars['Int']['output']>>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  billingAddressValue?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  cancelRatio?: Maybe<Scalars['Float']['output']>;
  claimRank?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  communicationRank?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  daysAwayFromPa?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  financeCheckAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** workspace_object */
  financeCheckBy?: Maybe<WorkspacesProviderUser>;
  financeCheckById?: Maybe<Scalars['BigInt']['output']>;
  freeCapacity: Scalars['Boolean']['output'];
  freeCapacityFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['BigInt']['output'];
  intacctId?: Maybe<Scalars['String']['output']>;
  lastVisitAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  limitsComment?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onImprovement: Scalars['Boolean']['output'];
  onImprovementComment?: Maybe<Scalars['String']['output']>;
  onImprovementFreezeUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  onImprovementStartedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  packingRank?: Maybe<Scalars['Float']['output']>;
  partnerNetworkManagerId?: Maybe<Scalars['BigInt']['output']>;
  partnerNetworkManagerName?: Maybe<Scalars['String']['output']>;
  partnerSuccessManagerId?: Maybe<Scalars['BigInt']['output']>;
  partnerSuccessManagerName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  poCountCanceled?: Maybe<Scalars['Int']['output']>;
  poCountConformityIssues?: Maybe<Scalars['Int']['output']>;
  poCountDone?: Maybe<Scalars['Int']['output']>;
  poCountInProgress?: Maybe<Scalars['Int']['output']>;
  poCountLastMonth?: Maybe<Scalars['Int']['output']>;
  poFirstAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  poLastAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  poNumberLimit?: Maybe<Scalars['Int']['output']>;
  poNumberLimitFreezeUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  poValueLimitCents?: Maybe<Scalars['BigInt']['output']>;
  poValueLimitFreezeUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom workspace_object */
  poValueLimitMoney: Money;
  /** workspace_object */
  primaryContact?: Maybe<WorkspacesProviderPrimaryContact>;
  primaryContactId?: Maybe<Scalars['Int']['output']>;
  qualityRank?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingAddressValue?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCountry?: Maybe<Scalars['String']['output']>;
  shippingZip?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  /** _allow_array */
  tagsCertifications?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsIndustries?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsMaterials?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsMethodFeatures?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsMethods?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsQualities?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsRestrictedMethods?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsSegments?: Maybe<Array<Scalars['Int']['output']>>;
  timingRank?: Maybe<Scalars['Float']['output']>;
  todayProductionHoliday: Scalars['Boolean']['output'];
  todayPublicHoliday: Scalars['Boolean']['output'];
  totalRank?: Maybe<Scalars['Float']['output']>;
  updatedAfterRegistered?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesProviderChangeRequest = {
  __typename?: 'WorkspacesProviderChangeRequest';
  id: Scalars['ID']['output'];
};

export type WorkspacesProviderOrder = {
  __typename?: 'WorkspacesProviderOrder';
  allowDirectShipping?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  conformityCheck?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  creditNoteRequestedAmountCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  creditNoteRequestedAmountMoney: Money;
  creditNoteRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creditNoteRequestedById?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['ISO8601Date']['output']>;
  deadlineExceedsDeal?: Maybe<Scalars['Boolean']['output']>;
  deadlineInitial?: Maybe<Scalars['ISO8601Date']['output']>;
  deadlineUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deadlineUpdatedById?: Maybe<Scalars['Int']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealDeadlineAlarm?: Maybe<Scalars['Boolean']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  euCustoms?: Maybe<Scalars['Boolean']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  fullyPaidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  hasInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasProductionSchedule: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** custom workspace_object */
  incomingInvoices?: Maybe<Array<WorkspacesProviderOrderIncomingInvoice>>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  lastComment?: Maybe<Scalars['String']['output']>;
  lastPinnedMessageContent?: Maybe<Scalars['String']['output']>;
  listed?: Maybe<Scalars['Boolean']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  /** custom */
  myLastComment?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  partsTagsMethodFeatures?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  partsTagsMethods?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  partsTagsMethodsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  partsValueNettoCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  partsValueNettoMoney: Money;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  pnmEscalation: Scalars['Boolean']['output'];
  podId?: Maybe<Scalars['Int']['output']>;
  providerAcceptSelfBilling?: Maybe<Scalars['Boolean']['output']>;
  providerCountry?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['BigInt']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerOnImprovement?: Maybe<Scalars['Boolean']['output']>;
  providerPartnerNetworkManagerId?: Maybe<Scalars['BigInt']['output']>;
  providerPartnerNetworkManagerName?: Maybe<Scalars['String']['output']>;
  providerPartnerSuccessManagerId?: Maybe<Scalars['BigInt']['output']>;
  providerPartnerSuccessManagerName?: Maybe<Scalars['String']['output']>;
  providerPrimaryEmail?: Maybe<Scalars['String']['output']>;
  providerRegion?: Maybe<Scalars['String']['output']>;
  providerState?: Maybe<Scalars['String']['output']>;
  providerTotalRank?: Maybe<Scalars['Float']['output']>;
  publicComment?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  requiredDocuments: Array<RequiredDocumentsTypeEnumType>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesConfirmationStatusCombined?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  samplesPoType?: Maybe<Scalars['String']['output']>;
  secondaryProduction?: Maybe<Scalars['Boolean']['output']>;
  secondaryProductionReason?: Maybe<Scalars['String']['output']>;
  servicesValueNettoCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  servicesValueNettoMoney: Money;
  shipmentDateRevisedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingCreationRestricted: Scalars['Boolean']['output'];
  /** custom workspace_object */
  shippings?: Maybe<Array<WorkspacesProviderOrderShipping>>;
  state?: Maybe<Scalars['String']['output']>;
  stateLastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalValueNettoCents?: Maybe<Scalars['BigInt']['output']>;
  totalValueNettoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalValueNettoMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type WorkspacesProviderOrderIncomingInvoice = {
  __typename?: 'WorkspacesProviderOrderIncomingInvoice';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditNote: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesProviderOrderShipping = {
  __typename?: 'WorkspacesProviderOrderShipping';
  createdAt: Scalars['ISO8601DateTime']['output'];
  direction?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesProviderOrdersCollection = {
  __typename?: 'WorkspacesProviderOrdersCollection';
  objects: Array<WorkspacesProviderOrder>;
  total: Scalars['Int']['output'];
};

export type WorkspacesProviderPrimaryContact = {
  __typename?: 'WorkspacesProviderPrimaryContact';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesProviderUser = {
  __typename?: 'WorkspacesProviderUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesProvidersCollection = {
  __typename?: 'WorkspacesProvidersCollection';
  objects: Array<WorkspacesProvider>;
  total: Scalars['Int']['output'];
};

export type WorkspacesQualityControl = {
  __typename?: 'WorkspacesQualityControl';
  ageHours: Scalars['Int']['output'];
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  businessVerdicts?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  businessVerdictsBy?: Maybe<Array<Scalars['String']['output']>>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  customerGrade?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  euCustoms: Scalars['Boolean']['output'];
  /** _allow_array */
  eventTypes?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** custom _allow_array */
  followingObjects?: Maybe<Array<Scalars['String']['output']>>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** custom */
  hasClaims?: Maybe<Scalars['Boolean']['output']>;
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  /** custom */
  hasQcIssues?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['BigInt']['output']>;
  originNumber?: Maybe<Scalars['String']['output']>;
  originShippingBruttoSum?: Maybe<Scalars['Float']['output']>;
  originShippingDeliveryType?: Maybe<Scalars['String']['output']>;
  originShippingDirection?: Maybe<ShippingDirectionEnum>;
  /** _allow_array */
  originShippingSize?: Maybe<Array<Scalars['String']['output']>>;
  originType?: Maybe<Scalars['String']['output']>;
  partsOnly3d?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  partsProcesses?: Maybe<Array<Scalars['String']['output']>>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  positionsCount?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  providerId?: Maybe<Scalars['BigInt']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerPartnerNetworkManagerId?: Maybe<Scalars['BigInt']['output']>;
  providerPartnerNetworkManagerName?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  providerVqcTags?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** custom */
  relatedPoQcReportRequired?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  relatedProviderOrders?: Maybe<Array<Scalars['Int']['output']>>;
  reportComment?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  state: Scalars['String']['output'];
  /** _allow_array */
  techVerdicts?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  techVerdictsBy?: Maybe<Array<Scalars['String']['output']>>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalCustomerPriceCents?: Maybe<Scalars['BigInt']['output']>;
  totalCustomerPriceCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalCustomerPriceMoney: Money;
  totalProviderPriceCents?: Maybe<Scalars['BigInt']['output']>;
  totalProviderPriceCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalProviderPriceMoney: Money;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601Date']['output'];
};

export type WorkspacesQualityControlsCollection = {
  __typename?: 'WorkspacesQualityControlsCollection';
  objects: Array<WorkspacesQualityControl>;
  total: Scalars['Int']['output'];
};

export type WorkspacesRefund = {
  __typename?: 'WorkspacesRefund';
  amountBrutCents?: Maybe<Scalars['BigInt']['output']>;
  /** custom workspace_object */
  amountBrutMoney: Money;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedByUsersName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealPmEmail?: Maybe<Scalars['String']['output']>;
  dealPmName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  intacctComment?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentMethodName?: Maybe<Scalars['String']['output']>;
  paymentMethodOrderId?: Maybe<Scalars['String']['output']>;
  paymentMethodTransactionId?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  refAmountBrutLeftCents?: Maybe<Scalars['BigInt']['output']>;
  refAmountBrutLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refAmountBrutLeftMoney: Money;
  refAmountNetLeftCents?: Maybe<Scalars['BigInt']['output']>;
  refAmountNetLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refAmountNetLeftMoney: Money;
  refPaymentMethodName?: Maybe<Scalars['String']['output']>;
  refPaymentMethodOrderId?: Maybe<Scalars['String']['output']>;
  refPaymentMethodTransactionId?: Maybe<Scalars['String']['output']>;
  refRefundedBrutCents?: Maybe<Scalars['BigInt']['output']>;
  refRefundedBrutCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refRefundedBrutMoney: Money;
  refRefundedNetCents?: Maybe<Scalars['BigInt']['output']>;
  refRefundedNetCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  refRefundedNetMoney: Money;
  /** custom workspace_object */
  reference?: Maybe<Scalars['JSON']['output']>;
  refundMethodName?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601Date']['output'];
};

export type WorkspacesRefundsCollection = {
  __typename?: 'WorkspacesRefundsCollection';
  objects: Array<WorkspacesRefund>;
  total: Scalars['Int']['output'];
};

export type WorkspacesRfq = {
  __typename?: 'WorkspacesRfq';
  allPartsCleaned: Scalars['Boolean']['output'];
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  daysAwayFromRfq?: Maybe<Scalars['Int']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  enquiryId: Scalars['BigInt']['output'];
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  interestedResponsesCount: Scalars['Int']['output'];
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  needInfo: Scalars['Boolean']['output'];
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  publicationEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publicationStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rejectedResponsesCount: Scalars['Int']['output'];
  salesPersonId?: Maybe<Scalars['BigInt']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  submittedResponsesCount: Scalars['Int']['output'];
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesRfqOffer = {
  __typename?: 'WorkspacesRfqOffer';
  /** custom workspace_object */
  attachedFiles?: Maybe<Array<AttachedFile>>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId: Scalars['BigInt']['output'];
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealNumber: Scalars['String']['output'];
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  decidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  decisionState: Scalars['String']['output'];
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isPreferred: Scalars['Boolean']['output'];
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  overallStage?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  productionStage?: Maybe<Scalars['String']['output']>;
  productionStageOrdered: Scalars['String']['output'];
  providerAne?: Maybe<Scalars['Float']['output']>;
  providerCancellationRatio?: Maybe<Scalars['Float']['output']>;
  providerClaimRatio?: Maybe<Scalars['Float']['output']>;
  providerCountry?: Maybe<Scalars['String']['output']>;
  providerDaysAwayFromPa?: Maybe<Scalars['Int']['output']>;
  providerId: Scalars['BigInt']['output'];
  providerName?: Maybe<Scalars['String']['output']>;
  providerQuality?: Maybe<Scalars['Int']['output']>;
  providerRank?: Maybe<Scalars['Float']['output']>;
  providerState?: Maybe<Scalars['String']['output']>;
  providerTiming?: Maybe<Scalars['Int']['output']>;
  providerTimingRatio?: Maybe<Scalars['Float']['output']>;
  qualifiedViewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  responseRefusalReason?: Maybe<Scalars['String']['output']>;
  responseState: Scalars['String']['output'];
  responseStateSorted?: Maybe<Scalars['Int']['output']>;
  rfqId: Scalars['BigInt']['output'];
  rfqNumber: Scalars['String']['output'];
  rfqOwnerId?: Maybe<Scalars['BigInt']['output']>;
  rfqOwnerName?: Maybe<Scalars['String']['output']>;
  rfqState?: Maybe<Scalars['String']['output']>;
  salesPersonId?: Maybe<Scalars['BigInt']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type WorkspacesRfqOffersCollection = {
  __typename?: 'WorkspacesRfqOffersCollection';
  objects: Array<WorkspacesRfqOffer>;
  total: Scalars['Int']['output'];
};

export type WorkspacesRfqPartner = {
  __typename?: 'WorkspacesRfqPartner';
  averageOpenTimeForLast30days?: Maybe<Scalars['Int']['output']>;
  averageResponseTimeForLast30days?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  daysAwayFromPa?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  lastVisitAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  poPartsValueNettoCents?: Maybe<Scalars['BigInt']['output']>;
  poPartsValueNettoCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  poPartsValueNettoMoney: Money;
  primaryContactEmail?: Maybe<Scalars['String']['output']>;
  primaryContactFirstName?: Maybe<Scalars['String']['output']>;
  primaryContactId?: Maybe<Scalars['BigInt']['output']>;
  primaryContactLastName?: Maybe<Scalars['String']['output']>;
  primaryContactPhone?: Maybe<Scalars['String']['output']>;
  qualityRank?: Maybe<Scalars['Float']['output']>;
  requestsForLast90days?: Maybe<Scalars['Int']['output']>;
  responsesForLast90days?: Maybe<Scalars['Int']['output']>;
  responsesPercentForLast90days?: Maybe<Scalars['Float']['output']>;
  rfqSentLast3days?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  /** _allow_array */
  tagsCertifications?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsMaterials?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsMethodFeatures?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsMethods?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  tagsSegments?: Maybe<Array<Scalars['Int']['output']>>;
  totalRank?: Maybe<Scalars['Float']['output']>;
};

export type WorkspacesRfqPartnersCollection = {
  __typename?: 'WorkspacesRfqPartnersCollection';
  objects: Array<WorkspacesRfqPartner>;
  total: Scalars['Int']['output'];
};

export type WorkspacesRfqsCollection = {
  __typename?: 'WorkspacesRfqsCollection';
  objects: Array<WorkspacesRfq>;
  total: Scalars['Int']['output'];
};

export type WorkspacesShipping = {
  __typename?: 'WorkspacesShipping';
  actualDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  actualShipmentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  bruttoSum?: Maybe<Scalars['Float']['output']>;
  /** _allow_array */
  businessVerdicts?: Maybe<Array<Scalars['String']['output']>>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  customerGrade?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerNotes?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  customsClearanceStatus: ShippingCustomsClearanceStatusEnum;
  customsClearanceStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customsDocumentsStatus: Scalars['String']['output'];
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  deliveryBasis?: Maybe<Scalars['String']['output']>;
  deliveryNoteComment?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  destinationAddress?: Maybe<WorkspacesShippingAddressType>;
  destinationCountry?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  /** custom */
  dueIn?: Maybe<Scalars['Int']['output']>;
  euCustoms?: Maybe<Scalars['Boolean']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expectedShipmentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  expectedShipmentTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** custom _allow_array */
  followingObjects?: Maybe<Array<Scalars['String']['output']>>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  hasInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasProofOfDelivery?: Maybe<Scalars['Boolean']['output']>;
  hasPublishedInvoice: Scalars['Boolean']['output'];
  hasShippingLabel?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  height?: Maybe<Array<Scalars['Float']['output']>>;
  holdUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  /** custom */
  hsCodesState?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  /** custom */
  invoicesState?: Maybe<Scalars['String']['output']>;
  isExport: Scalars['Boolean']['output'];
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isImport: Scalars['Boolean']['output'];
  isImportAndExport: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  labelsAttached: Scalars['Boolean']['output'];
  /** _allow_array */
  length?: Maybe<Array<Scalars['Float']['output']>>;
  logisticAggregator?: Maybe<Scalars['String']['output']>;
  logisticOperator?: Maybe<Scalars['String']['output']>;
  masterShippingDirection?: Maybe<Scalars['String']['output']>;
  masterShippingId?: Maybe<Scalars['BigInt']['output']>;
  masterShippingNumber?: Maybe<Scalars['String']['output']>;
  masterShippingState?: Maybe<Scalars['String']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  noInvoiceRequired: Scalars['Boolean']['output'];
  ocInternalComment?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  ocShippingAddress?: Maybe<WorkspacesShippingOrderConfirmationAddressType>;
  orderConfirmationAmountCents?: Maybe<Scalars['BigInt']['output']>;
  orderConfirmationAmountCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  orderConfirmationAmountMoney: Money;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** workspace_object */
  owner?: Maybe<WorkspacesShippingUser>;
  packagesCount?: Maybe<Scalars['Int']['output']>;
  personDefaultShippingAddress?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personLocale?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  productionMethodsHighLevel?: Maybe<Array<Scalars['BigInt']['output']>>;
  receivedProcessingStatus?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  relatedProviderOrders?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  relatedProviders?: Maybe<Array<Scalars['Int']['output']>>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  /** custom */
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  shippingAlertAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shippingAlertMessage?: Maybe<Scalars['String']['output']>;
  shippingCostCents?: Maybe<Scalars['BigInt']['output']>;
  shippingCostCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  shippingCostMoney: Money;
  /** custom workspace_object */
  shippingParameters?: Maybe<Array<WorkspacesShippingParametersType>>;
  /** custom workspace_object */
  sourceAddress?: Maybe<WorkspacesShippingAddressType>;
  sourceCountry?: Maybe<Scalars['String']['output']>;
  /** custom _allow_array */
  sourceObjects?: Maybe<Array<Scalars['String']['output']>>;
  state: Scalars['String']['output'];
  stateOrdered: Scalars['String']['output'];
  /** _allow_array */
  techVerdicts?: Maybe<Array<Scalars['String']['output']>>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  totalCustomerPriceCents?: Maybe<Scalars['BigInt']['output']>;
  totalCustomerPriceCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalCustomerPriceMoney: Money;
  totalProviderPriceCents?: Maybe<Scalars['BigInt']['output']>;
  totalProviderPriceCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  totalProviderPriceMoney: Money;
  /** custom */
  trackingLink?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** _allow_array */
  width?: Maybe<Array<Scalars['Float']['output']>>;
};

export type WorkspacesShippingAddress = {
  __typename?: 'WorkspacesShippingAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['BigInt']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['Int']['output'];
  sourceType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesShippingAddressType = {
  __typename?: 'WorkspacesShippingAddressType';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesShippingAddressesCollection = {
  __typename?: 'WorkspacesShippingAddressesCollection';
  objects: Array<WorkspacesShippingAddress>;
  total: Scalars['Int']['output'];
};

export type WorkspacesShippingOrderConfirmationAddressType = {
  __typename?: 'WorkspacesShippingOrderConfirmationAddressType';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  internalComment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesShippingParametersType = {
  __typename?: 'WorkspacesShippingParametersType';
  brutto?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type WorkspacesShippingUser = {
  __typename?: 'WorkspacesShippingUser';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesShippingsCollection = {
  __typename?: 'WorkspacesShippingsCollection';
  objects: Array<WorkspacesShipping>;
  total: Scalars['Int']['output'];
};

export type WorkspacesStorage = {
  __typename?: 'WorkspacesStorage';
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  customerGrade?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerPriceLeftCents?: Maybe<Scalars['BigInt']['output']>;
  customerPriceLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  customerPriceLeftMoney: Money;
  customerType?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasPrequote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  euCustoms?: Maybe<Scalars['Boolean']['output']>;
  /** custom _allow_array */
  followingObjects: Array<Scalars['String']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  hasExpressParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  internalComment?: Maybe<Scalars['String']['output']>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  measurementProtocolNeeded?: Maybe<Scalars['Boolean']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** custom _allow_array */
  parentObjects: Array<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  processingState?: Maybe<Scalars['String']['output']>;
  providerPriceLeftCents?: Maybe<Scalars['BigInt']['output']>;
  providerPriceLeftCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  providerPriceLeftMoney: Money;
  /** _allow_array */
  relatedProviderOrders: Array<Scalars['Int']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  samplesNeeded?: Maybe<Scalars['Boolean']['output']>;
  storageType?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  updatedAt: Scalars['ISO8601Date']['output'];
};

export type WorkspacesStoragesCollection = {
  __typename?: 'WorkspacesStoragesCollection';
  objects: Array<WorkspacesStorage>;
  total: Scalars['Int']['output'];
};

export type WorkspacesSubscription = {
  __typename?: 'WorkspacesSubscription';
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  /** custom */
  currentUserSubscribed?: Maybe<Scalars['Boolean']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerWaits?: Maybe<Scalars['Boolean']['output']>;
  customerWaitsFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealHasOwner?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  deputyPmId?: Maybe<Scalars['BigInt']['output']>;
  deputyPmName?: Maybe<Scalars['String']['output']>;
  externalOwnerName?: Maybe<Scalars['String']['output']>;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isFullyInvoiced: Scalars['Boolean']['output'];
  isFullyShipped: Scalars['Boolean']['output'];
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  isPersonDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastMessageAuthorId?: Maybe<Scalars['BigInt']['output']>;
  lastMessageAuthorType?: Maybe<Scalars['String']['output']>;
  lastMessageContent?: Maybe<Scalars['String']['output']>;
  lastPersonMessageAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  /** custom */
  parentId?: Maybe<Scalars['BigInt']['output']>;
  partnerWaits?: Maybe<Scalars['Boolean']['output']>;
  partnerWaitsFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personGeneral?: Maybe<Scalars['Boolean']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personLanguage?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sourceHasOwner?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  subscriberId?: Maybe<Scalars['BigInt']['output']>;
  subscriberType?: Maybe<Scalars['String']['output']>;
  supportRepliedLast: Scalars['Boolean']['output'];
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
  userRepliedLast: Scalars['Boolean']['output'];
  xometryOwnerId?: Maybe<Scalars['BigInt']['output']>;
  xometryOwnerName?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesSubscriptionsCollection = {
  __typename?: 'WorkspacesSubscriptionsCollection';
  objects: Array<WorkspacesSubscription>;
  total: Scalars['Int']['output'];
};

export type WorkspacesTask = {
  __typename?: 'WorkspacesTask';
  /** _allow_array */
  assigneePods?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  assignees?: Maybe<Array<Scalars['Int']['output']>>;
  /** _allow_array */
  auditState?: Maybe<Array<Scalars['String']['output']>>;
  authorId?: Maybe<Scalars['BigInt']['output']>;
  authorType?: Maybe<Scalars['String']['output']>;
  billingAccountId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  claimsState?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  customerGrade?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrderCode?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  dealCustomerOrderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  dealGrade?: Maybe<Scalars['String']['output']>;
  dealHasNoquote?: Maybe<Scalars['Boolean']['output']>;
  dealId?: Maybe<Scalars['BigInt']['output']>;
  dealIsBigOrHeavy: Scalars['Boolean']['output'];
  dealLeadtime?: Maybe<Scalars['ISO8601Date']['output']>;
  dealManualProcessingComment?: Maybe<Scalars['String']['output']>;
  dealOverallStage?: Maybe<Scalars['String']['output']>;
  dealPipedriveId?: Maybe<Scalars['Int']['output']>;
  dealPipedriveStatusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealPipedriveStatusUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  dealPipedriveStatusUpdatedByName?: Maybe<Scalars['String']['output']>;
  dealProductionCompleted: Scalars['Boolean']['output'];
  dealProductionStage?: Maybe<Scalars['String']['output']>;
  dealProductionStageOrdered: Scalars['String']['output'];
  dealReasonOfLose?: Maybe<Scalars['String']['output']>;
  dealValueCents?: Maybe<Scalars['BigInt']['output']>;
  dealValueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  dealValueMoney: Money;
  frameworkAgreement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  importantDeal?: Maybe<Scalars['Boolean']['output']>;
  /** _allow_array */
  intercompanyRoles?: Maybe<Array<Scalars['String']['output']>>;
  isForSoftwareTesting?: Maybe<Scalars['Boolean']['output']>;
  isHighValue: Scalars['Boolean']['output'];
  isHighVolume: Scalars['Boolean']['output'];
  isNpg?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isOnHoldUpdatedById?: Maybe<Scalars['BigInt']['output']>;
  isOnHoldUpdatedByName?: Maybe<Scalars['String']['output']>;
  organizationGrade?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['BigInt']['output']>;
  organizationKamId?: Maybe<Scalars['Int']['output']>;
  organizationKamName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPipedriveId?: Maybe<Scalars['Int']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['BigInt']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personNotes?: Maybe<Scalars['String']['output']>;
  personPhone?: Maybe<Scalars['String']['output']>;
  personPipedriveId?: Maybe<Scalars['Int']['output']>;
  pmId?: Maybe<Scalars['BigInt']['output']>;
  pmName?: Maybe<Scalars['String']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  process?: Maybe<Array<Scalars['String']['output']>>;
  /** _allow_array */
  productionMethodsHighLevel?: Maybe<Array<Scalars['Int']['output']>>;
  salesPersonId?: Maybe<Scalars['Int']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  /** _allow_array */
  subscribers?: Maybe<Array<Scalars['Int']['output']>>;
  taskCompletedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  taskCompletedBy?: Maybe<Scalars['BigInt']['output']>;
  taskDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  taskPriority?: Maybe<Scalars['String']['output']>;
  taskSetAt?: Maybe<Scalars['ISO8601Date']['output']>;
  taskStatus?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
  testDeal?: Maybe<Scalars['Boolean']['output']>;
  transportMode?: Maybe<DealsTransportModeEnumType>;
};

export type WorkspacesTasksCollection = {
  __typename?: 'WorkspacesTasksCollection';
  objects: Array<WorkspacesTask>;
  total: Scalars['Int']['output'];
};

export type WorkspacesTeamspace = {
  __typename?: 'WorkspacesTeamspace';
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealsCount?: Maybe<Scalars['Int']['output']>;
  dealsLastCreated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dealsLastId?: Maybe<Scalars['BigInt']['output']>;
  dealsLastNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  inactiveMembersCount?: Maybe<Scalars['Int']['output']>;
  isForSoftwareTesting: Scalars['Boolean']['output'];
  memberCount?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  memberIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  name: Scalars['String']['output'];
  ordersBookedRevenueCents?: Maybe<Scalars['BigInt']['output']>;
  ordersBookedRevenueCurrency?: Maybe<Scalars['String']['output']>;
  /** custom workspace_object */
  ordersBookedRevenueMoney: Money;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  ordersLastId?: Maybe<Scalars['BigInt']['output']>;
  ordersLastNumber?: Maybe<Scalars['String']['output']>;
  ordersLastOrdered?: Maybe<Scalars['ISO8601DateTime']['output']>;
  otherOrganizations?: Maybe<Scalars['JSON']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerOrganizationId?: Maybe<Scalars['BigInt']['output']>;
  ownerOrganizationName?: Maybe<Scalars['String']['output']>;
};

export type WorkspacesTeamspacesCollection = {
  __typename?: 'WorkspacesTeamspacesCollection';
  objects: Array<WorkspacesTeamspace>;
  total: Scalars['Int']['output'];
};

export type WorkspacesTotalAmounts = {
  __typename?: 'WorkspacesTotalAmounts';
  totalAmountBrutto: Money;
  totalAmountNetto: Money;
};

export type WorkspacesUpdatedBankPayment = {
  __typename?: 'WorkspacesUpdatedBankPayment';
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** workspace_object */
  approvedBy?: Maybe<WorkspacesPayoutUpdatedUser>;
  counterparty?: Maybe<Scalars['JSON']['output']>;
  counterpartyId?: Maybe<Scalars['ID']['output']>;
  counterpartyType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  issuedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** workspace_object custom */
  logisticPayouts: Array<WorkspacesBankPaymentLogisticPayout>;
  outlyingTransactionType?: Maybe<Scalars['String']['output']>;
  /** workspace_object custom */
  payments?: Maybe<Array<WorkspacesBankPaymentUpdatedPayment>>;
  /** workspace_object custom */
  payouts?: Maybe<Array<WorkspacesBankPaymentUpdatedPayout>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WorkspacesUser = {
  __typename?: 'WorkspacesUser';
  absentFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  absentTill?: Maybe<Scalars['ISO8601Date']['output']>;
  active: Scalars['Boolean']['output'];
  avatarPath?: Maybe<Scalars['String']['output']>;
  avatarPathPreview?: Maybe<Scalars['String']['output']>;
  /** custom */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** custom */
  avatarUrlPreview?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  couponLimit: Scalars['Int']['output'];
  currentDeputyName?: Maybe<Scalars['String']['output']>;
  currentDeputyUserId?: Maybe<Scalars['BigInt']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  isRobot: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['BigInt']['output']>;
  podId?: Maybe<Scalars['Int']['output']>;
  /** _allow_array */
  teamIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** _allow_array */
  teamMemberships?: Maybe<Array<Scalars['String']['output']>>;
};

export type WorkspacesUsersCollection = {
  __typename?: 'WorkspacesUsersCollection';
  objects: Array<WorkspacesUser>;
  total: Scalars['Int']['output'];
};

export type XometryBankAccount = {
  __typename?: 'XometryBankAccount';
  balance?: Maybe<Scalars['Float']['output']>;
};

export type XometryVatNumber = {
  __typename?: 'XometryVatNumber';
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  reverseCharge?: Maybe<Scalars['Boolean']['output']>;
  reverseChargeRemark?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type ZipState = {
  __typename?: 'ZipState';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zipState: ZipStateEnumType;
};

export enum ZipStateEnumType {
  /** completed */
  Completed = 'completed',
  /** failed */
  Failed = 'failed',
  /** in_progress */
  InProgress = 'in_progress',
  /** not_requested */
  NotRequested = 'not_requested'
}

export enum ZipStateIntacctEnumType {
  /** completed */
  Completed = 'completed',
  /** failed */
  Failed = 'failed',
  /** in_progress */
  InProgress = 'in_progress',
  /** not_requested */
  NotRequested = 'not_requested'
}

/** Autogenerated input type of outcomingInvoicesReject */
export type OutcomingInvoicesRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rejectedAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of outcomingInvoicesReject. */
export type OutcomingInvoicesRejectPayload = {
  __typename?: 'outcomingInvoicesRejectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invoice: OutcomingInvoice;
};

/** Autogenerated input type of personsSendNewRegionVerify */
export type PersonsSendNewRegionVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of personsSendNewRegionVerify. */
export type PersonsSendNewRegionVerifyPayload = {
  __typename?: 'personsSendNewRegionVerifyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of salesPersonsBulkUpdateRfqStatus */
export type SalesPersonsBulkUpdateRfqStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partIds: Array<Scalars['ID']['input']>;
  rfqIsUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  rfqStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of salesPersonsBulkUpdateRfqStatus. */
export type SalesPersonsBulkUpdateRfqStatusPayload = {
  __typename?: 'salesPersonsBulkUpdateRfqStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enquiry: Enquiry;
};
